import { c as commonjsGlobal, g as getDefaultExportFromCjs, a as container, U as UiEventEmitter, S as SequenceBuilder, I as ItemsBuilder } from './inversify.config-BUYxyzIu.js';
import { DefaultInteractionResolver } from './DefaultInteractionResolver.js';
import { CommandsHandler } from './CommandsHandler.js';
import { CommandHandler } from './CommandHandler.js';
import { HitRegionInitializer } from './HitRegionInitializer.js';
import { HitRegionFilter } from './HitRegionFilter.js';
import { Intersection } from './Intersection.js';
import { VisibilityValidator } from './VisibilityValidator.js';
import { CategoryValidator } from './CategoryValidator.js';
import { ObjectsInRooms, GameEventEmitter, CharacterInRoom, CharacterPosture, Inventory, TextModel } from '@kiigame/kgae_ts';
export { EventEmitter } from '@kiigame/kgae_ts';
import { ImagePreparer } from './ImagePreparer.js';
import { FurnitureBuilder } from './FurnitureBuilder.js';

var lib = {exports: {}};

var _FullInternals = {};

var _CoreInternals = {};

var Global = {};

var hasRequiredGlobal;

function requireGlobal () {
	if (hasRequiredGlobal) return Global;
	hasRequiredGlobal = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports._registerNode = exports._NODES_REGISTRY = exports.Konva = exports.glob = exports._parseUA = void 0;
		var PI_OVER_180 = Math.PI / 180;
		function detectBrowser() {
		    return (typeof window !== 'undefined' &&
		        ({}.toString.call(window) === '[object Window]' ||
		            {}.toString.call(window) === '[object global]'));
		}
		var _detectIE = function (ua) {
		    var msie = ua.indexOf('msie ');
		    if (msie > 0) {
		        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		    }
		    var trident = ua.indexOf('trident/');
		    if (trident > 0) {
		        var rv = ua.indexOf('rv:');
		        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		    }
		    var edge = ua.indexOf('edge/');
		    if (edge > 0) {
		        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		    }
		    return false;
		};
		var _parseUA = function (userAgent) {
		    var ua = userAgent.toLowerCase(), match = /(chrome)[ /]([\w.]+)/.exec(ua) ||
		        /(webkit)[ /]([\w.]+)/.exec(ua) ||
		        /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) ||
		        /(msie) ([\w.]+)/.exec(ua) ||
		        (ua.indexOf('compatible') < 0 &&
		            /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
		        [], mobile = !!userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i), ieMobile = !!userAgent.match(/IEMobile/i);
		    return {
		        browser: match[1] || '',
		        version: match[2] || '0',
		        isIE: _detectIE(ua),
		        mobile: mobile,
		        ieMobile: ieMobile
		    };
		};
		exports._parseUA = _parseUA;
		exports.glob = typeof commonjsGlobal !== 'undefined'
		    ? commonjsGlobal
		    : typeof window !== 'undefined'
		        ? window
		        : typeof WorkerGlobalScope !== 'undefined'
		            ? self
		            : {};
		exports.Konva = {
		    _global: exports.glob,
		    version: '7.2.5',
		    isBrowser: detectBrowser(),
		    isUnminified: /param/.test(function (param) { }.toString()),
		    dblClickWindow: 400,
		    getAngle: function (angle) {
		        return exports.Konva.angleDeg ? angle * PI_OVER_180 : angle;
		    },
		    enableTrace: false,
		    _pointerEventsEnabled: false,
		    hitOnDragEnabled: false,
		    captureTouchEventsEnabled: false,
		    listenClickTap: false,
		    inDblClickWindow: false,
		    pixelRatio: undefined,
		    dragDistance: 3,
		    angleDeg: true,
		    showWarnings: true,
		    dragButtons: [0, 1],
		    isDragging: function () {
		        return exports.Konva['DD'].isDragging;
		    },
		    isDragReady: function () {
		        return !!exports.Konva['DD'].node;
		    },
		    UA: exports._parseUA((exports.glob.navigator && exports.glob.navigator.userAgent) || ''),
		    document: exports.glob.document,
		    _injectGlobal: function (Konva) {
		        exports.glob.Konva = Konva;
		    },
		    _parseUA: exports._parseUA
		};
		exports._NODES_REGISTRY = {};
		var _registerNode = function (NodeClass) {
		    exports._NODES_REGISTRY[NodeClass.prototype.getClassName()] = NodeClass;
		    exports.Konva[NodeClass.prototype.getClassName()] = NodeClass;
		};
		exports._registerNode = _registerNode; 
	} (Global));
	return Global;
}

var Util = {};

var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return Util;
	hasRequiredUtil = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Util = exports.Transform = exports.Collection = void 0;
		var Global_1 = requireGlobal();
		var Collection = (function () {
		    function Collection() {
		    }
		    Collection.toCollection = function (arr) {
		        var collection = new Collection(), len = arr.length, n;
		        for (n = 0; n < len; n++) {
		            collection.push(arr[n]);
		        }
		        return collection;
		    };
		    Collection._mapMethod = function (methodName) {
		        Collection.prototype[methodName] = function () {
		            var len = this.length, i;
		            var args = [].slice.call(arguments);
		            for (i = 0; i < len; i++) {
		                this[i][methodName].apply(this[i], args);
		            }
		            return this;
		        };
		    };
		    Collection.mapMethods = function (constructor) {
		        var prot = constructor.prototype;
		        for (var methodName in prot) {
		            Collection._mapMethod(methodName);
		        }
		    };
		    return Collection;
		}());
		exports.Collection = Collection;
		Collection.prototype = [];
		Collection.prototype.each = function (func) {
		    for (var n = 0; n < this.length; n++) {
		        func(this[n], n);
		    }
		};
		Collection.prototype.toArray = function () {
		    var arr = [], len = this.length, n;
		    for (n = 0; n < len; n++) {
		        arr.push(this[n]);
		    }
		    return arr;
		};
		var Transform = (function () {
		    function Transform(m) {
		        if (m === void 0) { m = [1, 0, 0, 1, 0, 0]; }
		        this.dirty = false;
		        this.m = (m && m.slice()) || [1, 0, 0, 1, 0, 0];
		    }
		    Transform.prototype.reset = function () {
		        this.m[0] = 1;
		        this.m[1] = 0;
		        this.m[2] = 0;
		        this.m[3] = 1;
		        this.m[4] = 0;
		        this.m[5] = 0;
		    };
		    Transform.prototype.copy = function () {
		        return new Transform(this.m);
		    };
		    Transform.prototype.copyInto = function (tr) {
		        tr.m[0] = this.m[0];
		        tr.m[1] = this.m[1];
		        tr.m[2] = this.m[2];
		        tr.m[3] = this.m[3];
		        tr.m[4] = this.m[4];
		        tr.m[5] = this.m[5];
		    };
		    Transform.prototype.point = function (point) {
		        var m = this.m;
		        return {
		            x: m[0] * point.x + m[2] * point.y + m[4],
		            y: m[1] * point.x + m[3] * point.y + m[5],
		        };
		    };
		    Transform.prototype.translate = function (x, y) {
		        this.m[4] += this.m[0] * x + this.m[2] * y;
		        this.m[5] += this.m[1] * x + this.m[3] * y;
		        return this;
		    };
		    Transform.prototype.scale = function (sx, sy) {
		        this.m[0] *= sx;
		        this.m[1] *= sx;
		        this.m[2] *= sy;
		        this.m[3] *= sy;
		        return this;
		    };
		    Transform.prototype.rotate = function (rad) {
		        var c = Math.cos(rad);
		        var s = Math.sin(rad);
		        var m11 = this.m[0] * c + this.m[2] * s;
		        var m12 = this.m[1] * c + this.m[3] * s;
		        var m21 = this.m[0] * -s + this.m[2] * c;
		        var m22 = this.m[1] * -s + this.m[3] * c;
		        this.m[0] = m11;
		        this.m[1] = m12;
		        this.m[2] = m21;
		        this.m[3] = m22;
		        return this;
		    };
		    Transform.prototype.getTranslation = function () {
		        return {
		            x: this.m[4],
		            y: this.m[5],
		        };
		    };
		    Transform.prototype.skew = function (sx, sy) {
		        var m11 = this.m[0] + this.m[2] * sy;
		        var m12 = this.m[1] + this.m[3] * sy;
		        var m21 = this.m[2] + this.m[0] * sx;
		        var m22 = this.m[3] + this.m[1] * sx;
		        this.m[0] = m11;
		        this.m[1] = m12;
		        this.m[2] = m21;
		        this.m[3] = m22;
		        return this;
		    };
		    Transform.prototype.multiply = function (matrix) {
		        var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
		        var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
		        var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
		        var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
		        var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
		        var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
		        this.m[0] = m11;
		        this.m[1] = m12;
		        this.m[2] = m21;
		        this.m[3] = m22;
		        this.m[4] = dx;
		        this.m[5] = dy;
		        return this;
		    };
		    Transform.prototype.invert = function () {
		        var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
		        var m0 = this.m[3] * d;
		        var m1 = -this.m[1] * d;
		        var m2 = -this.m[2] * d;
		        var m3 = this.m[0] * d;
		        var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
		        var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
		        this.m[0] = m0;
		        this.m[1] = m1;
		        this.m[2] = m2;
		        this.m[3] = m3;
		        this.m[4] = m4;
		        this.m[5] = m5;
		        return this;
		    };
		    Transform.prototype.getMatrix = function () {
		        return this.m;
		    };
		    Transform.prototype.setAbsolutePosition = function (x, y) {
		        var m0 = this.m[0], m1 = this.m[1], m2 = this.m[2], m3 = this.m[3], m4 = this.m[4], m5 = this.m[5], yt = (m0 * (y - m5) - m1 * (x - m4)) / (m0 * m3 - m1 * m2), xt = (x - m4 - m2 * yt) / m0;
		        return this.translate(xt, yt);
		    };
		    Transform.prototype.decompose = function () {
		        var a = this.m[0];
		        var b = this.m[1];
		        var c = this.m[2];
		        var d = this.m[3];
		        var e = this.m[4];
		        var f = this.m[5];
		        var delta = a * d - b * c;
		        var result = {
		            x: e,
		            y: f,
		            rotation: 0,
		            scaleX: 0,
		            scaleY: 0,
		            skewX: 0,
		            skewY: 0,
		        };
		        if (a != 0 || b != 0) {
		            var r = Math.sqrt(a * a + b * b);
		            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
		            result.scaleX = r;
		            result.scaleY = delta / r;
		            result.skewX = (a * c + b * d) / delta;
		            result.skewY = 0;
		        }
		        else if (c != 0 || d != 0) {
		            var s = Math.sqrt(c * c + d * d);
		            result.rotation =
		                Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
		            result.scaleX = delta / s;
		            result.scaleY = s;
		            result.skewX = 0;
		            result.skewY = (a * c + b * d) / delta;
		        }
		        else ;
		        result.rotation = exports.Util._getRotation(result.rotation);
		        return result;
		    };
		    return Transform;
		}());
		exports.Transform = Transform;
		var OBJECT_ARRAY = '[object Array]', OBJECT_NUMBER = '[object Number]', OBJECT_STRING = '[object String]', OBJECT_BOOLEAN = '[object Boolean]', PI_OVER_DEG180 = Math.PI / 180, DEG180_OVER_PI = 180 / Math.PI, HASH = '#', EMPTY_STRING = '', ZERO = '0', KONVA_WARNING = 'Konva warning: ', KONVA_ERROR = 'Konva error: ', RGB_PAREN = 'rgb(', COLORS = {
		    aliceblue: [240, 248, 255],
		    antiquewhite: [250, 235, 215],
		    aqua: [0, 255, 255],
		    aquamarine: [127, 255, 212],
		    azure: [240, 255, 255],
		    beige: [245, 245, 220],
		    bisque: [255, 228, 196],
		    black: [0, 0, 0],
		    blanchedalmond: [255, 235, 205],
		    blue: [0, 0, 255],
		    blueviolet: [138, 43, 226],
		    brown: [165, 42, 42],
		    burlywood: [222, 184, 135],
		    cadetblue: [95, 158, 160],
		    chartreuse: [127, 255, 0],
		    chocolate: [210, 105, 30],
		    coral: [255, 127, 80],
		    cornflowerblue: [100, 149, 237],
		    cornsilk: [255, 248, 220],
		    crimson: [220, 20, 60],
		    cyan: [0, 255, 255],
		    darkblue: [0, 0, 139],
		    darkcyan: [0, 139, 139],
		    darkgoldenrod: [184, 132, 11],
		    darkgray: [169, 169, 169],
		    darkgreen: [0, 100, 0],
		    darkgrey: [169, 169, 169],
		    darkkhaki: [189, 183, 107],
		    darkmagenta: [139, 0, 139],
		    darkolivegreen: [85, 107, 47],
		    darkorange: [255, 140, 0],
		    darkorchid: [153, 50, 204],
		    darkred: [139, 0, 0],
		    darksalmon: [233, 150, 122],
		    darkseagreen: [143, 188, 143],
		    darkslateblue: [72, 61, 139],
		    darkslategray: [47, 79, 79],
		    darkslategrey: [47, 79, 79],
		    darkturquoise: [0, 206, 209],
		    darkviolet: [148, 0, 211],
		    deeppink: [255, 20, 147],
		    deepskyblue: [0, 191, 255],
		    dimgray: [105, 105, 105],
		    dimgrey: [105, 105, 105],
		    dodgerblue: [30, 144, 255],
		    firebrick: [178, 34, 34],
		    floralwhite: [255, 255, 240],
		    forestgreen: [34, 139, 34],
		    fuchsia: [255, 0, 255],
		    gainsboro: [220, 220, 220],
		    ghostwhite: [248, 248, 255],
		    gold: [255, 215, 0],
		    goldenrod: [218, 165, 32],
		    gray: [128, 128, 128],
		    green: [0, 128, 0],
		    greenyellow: [173, 255, 47],
		    grey: [128, 128, 128],
		    honeydew: [240, 255, 240],
		    hotpink: [255, 105, 180],
		    indianred: [205, 92, 92],
		    indigo: [75, 0, 130],
		    ivory: [255, 255, 240],
		    khaki: [240, 230, 140],
		    lavender: [230, 230, 250],
		    lavenderblush: [255, 240, 245],
		    lawngreen: [124, 252, 0],
		    lemonchiffon: [255, 250, 205],
		    lightblue: [173, 216, 230],
		    lightcoral: [240, 128, 128],
		    lightcyan: [224, 255, 255],
		    lightgoldenrodyellow: [250, 250, 210],
		    lightgray: [211, 211, 211],
		    lightgreen: [144, 238, 144],
		    lightgrey: [211, 211, 211],
		    lightpink: [255, 182, 193],
		    lightsalmon: [255, 160, 122],
		    lightseagreen: [32, 178, 170],
		    lightskyblue: [135, 206, 250],
		    lightslategray: [119, 136, 153],
		    lightslategrey: [119, 136, 153],
		    lightsteelblue: [176, 196, 222],
		    lightyellow: [255, 255, 224],
		    lime: [0, 255, 0],
		    limegreen: [50, 205, 50],
		    linen: [250, 240, 230],
		    magenta: [255, 0, 255],
		    maroon: [128, 0, 0],
		    mediumaquamarine: [102, 205, 170],
		    mediumblue: [0, 0, 205],
		    mediumorchid: [186, 85, 211],
		    mediumpurple: [147, 112, 219],
		    mediumseagreen: [60, 179, 113],
		    mediumslateblue: [123, 104, 238],
		    mediumspringgreen: [0, 250, 154],
		    mediumturquoise: [72, 209, 204],
		    mediumvioletred: [199, 21, 133],
		    midnightblue: [25, 25, 112],
		    mintcream: [245, 255, 250],
		    mistyrose: [255, 228, 225],
		    moccasin: [255, 228, 181],
		    navajowhite: [255, 222, 173],
		    navy: [0, 0, 128],
		    oldlace: [253, 245, 230],
		    olive: [128, 128, 0],
		    olivedrab: [107, 142, 35],
		    orange: [255, 165, 0],
		    orangered: [255, 69, 0],
		    orchid: [218, 112, 214],
		    palegoldenrod: [238, 232, 170],
		    palegreen: [152, 251, 152],
		    paleturquoise: [175, 238, 238],
		    palevioletred: [219, 112, 147],
		    papayawhip: [255, 239, 213],
		    peachpuff: [255, 218, 185],
		    peru: [205, 133, 63],
		    pink: [255, 192, 203],
		    plum: [221, 160, 203],
		    powderblue: [176, 224, 230],
		    purple: [128, 0, 128],
		    rebeccapurple: [102, 51, 153],
		    red: [255, 0, 0],
		    rosybrown: [188, 143, 143],
		    royalblue: [65, 105, 225],
		    saddlebrown: [139, 69, 19],
		    salmon: [250, 128, 114],
		    sandybrown: [244, 164, 96],
		    seagreen: [46, 139, 87],
		    seashell: [255, 245, 238],
		    sienna: [160, 82, 45],
		    silver: [192, 192, 192],
		    skyblue: [135, 206, 235],
		    slateblue: [106, 90, 205],
		    slategray: [119, 128, 144],
		    slategrey: [119, 128, 144],
		    snow: [255, 255, 250],
		    springgreen: [0, 255, 127],
		    steelblue: [70, 130, 180],
		    tan: [210, 180, 140],
		    teal: [0, 128, 128],
		    thistle: [216, 191, 216],
		    transparent: [255, 255, 255, 0],
		    tomato: [255, 99, 71],
		    turquoise: [64, 224, 208],
		    violet: [238, 130, 238],
		    wheat: [245, 222, 179],
		    white: [255, 255, 255],
		    whitesmoke: [245, 245, 245],
		    yellow: [255, 255, 0],
		    yellowgreen: [154, 205, 5],
		}, RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, animQueue = [];
		exports.Util = {
		    _isElement: function (obj) {
		        return !!(obj && obj.nodeType == 1);
		    },
		    _isFunction: function (obj) {
		        return !!(obj && obj.constructor && obj.call && obj.apply);
		    },
		    _isPlainObject: function (obj) {
		        return !!obj && obj.constructor === Object;
		    },
		    _isArray: function (obj) {
		        return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
		    },
		    _isNumber: function (obj) {
		        return (Object.prototype.toString.call(obj) === OBJECT_NUMBER &&
		            !isNaN(obj) &&
		            isFinite(obj));
		    },
		    _isString: function (obj) {
		        return Object.prototype.toString.call(obj) === OBJECT_STRING;
		    },
		    _isBoolean: function (obj) {
		        return Object.prototype.toString.call(obj) === OBJECT_BOOLEAN;
		    },
		    isObject: function (val) {
		        return val instanceof Object;
		    },
		    isValidSelector: function (selector) {
		        if (typeof selector !== 'string') {
		            return false;
		        }
		        var firstChar = selector[0];
		        return (firstChar === '#' ||
		            firstChar === '.' ||
		            firstChar === firstChar.toUpperCase());
		    },
		    _sign: function (number) {
		        if (number === 0) {
		            return 1;
		        }
		        if (number > 0) {
		            return 1;
		        }
		        else {
		            return -1;
		        }
		    },
		    requestAnimFrame: function (callback) {
		        animQueue.push(callback);
		        if (animQueue.length === 1) {
		            requestAnimationFrame(function () {
		                var queue = animQueue;
		                animQueue = [];
		                queue.forEach(function (cb) {
		                    cb();
		                });
		            });
		        }
		    },
		    createCanvasElement: function () {
		        var canvas = document.createElement('canvas');
		        try {
		            canvas.style = canvas.style || {};
		        }
		        catch (e) { }
		        return canvas;
		    },
		    createImageElement: function () {
		        return document.createElement('img');
		    },
		    _isInDocument: function (el) {
		        while ((el = el.parentNode)) {
		            if (el == document) {
		                return true;
		            }
		        }
		        return false;
		    },
		    _simplifyArray: function (arr) {
		        var retArr = [], len = arr.length, util = exports.Util, n, val;
		        for (n = 0; n < len; n++) {
		            val = arr[n];
		            if (util._isNumber(val)) {
		                val = Math.round(val * 1000) / 1000;
		            }
		            else if (!util._isString(val)) {
		                val = val.toString();
		            }
		            retArr.push(val);
		        }
		        return retArr;
		    },
		    _urlToImage: function (url, callback) {
		        var imageObj = new Global_1.glob.Image();
		        imageObj.onload = function () {
		            callback(imageObj);
		        };
		        imageObj.src = url;
		    },
		    _rgbToHex: function (r, g, b) {
		        return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
		    },
		    _hexToRgb: function (hex) {
		        hex = hex.replace(HASH, EMPTY_STRING);
		        var bigint = parseInt(hex, 16);
		        return {
		            r: (bigint >> 16) & 255,
		            g: (bigint >> 8) & 255,
		            b: bigint & 255,
		        };
		    },
		    getRandomColor: function () {
		        var randColor = ((Math.random() * 0xffffff) << 0).toString(16);
		        while (randColor.length < 6) {
		            randColor = ZERO + randColor;
		        }
		        return HASH + randColor;
		    },
		    get: function (val, def) {
		        if (val === undefined) {
		            return def;
		        }
		        else {
		            return val;
		        }
		    },
		    getRGB: function (color) {
		        var rgb;
		        if (color in COLORS) {
		            rgb = COLORS[color];
		            return {
		                r: rgb[0],
		                g: rgb[1],
		                b: rgb[2],
		            };
		        }
		        else if (color[0] === HASH) {
		            return this._hexToRgb(color.substring(1));
		        }
		        else if (color.substr(0, 4) === RGB_PAREN) {
		            rgb = RGB_REGEX.exec(color.replace(/ /g, ''));
		            return {
		                r: parseInt(rgb[1], 10),
		                g: parseInt(rgb[2], 10),
		                b: parseInt(rgb[3], 10),
		            };
		        }
		        else {
		            return {
		                r: 0,
		                g: 0,
		                b: 0,
		            };
		        }
		    },
		    colorToRGBA: function (str) {
		        str = str || 'black';
		        return (exports.Util._namedColorToRBA(str) ||
		            exports.Util._hex3ColorToRGBA(str) ||
		            exports.Util._hex6ColorToRGBA(str) ||
		            exports.Util._rgbColorToRGBA(str) ||
		            exports.Util._rgbaColorToRGBA(str) ||
		            exports.Util._hslColorToRGBA(str));
		    },
		    _namedColorToRBA: function (str) {
		        var c = COLORS[str.toLowerCase()];
		        if (!c) {
		            return null;
		        }
		        return {
		            r: c[0],
		            g: c[1],
		            b: c[2],
		            a: 1,
		        };
		    },
		    _rgbColorToRGBA: function (str) {
		        if (str.indexOf('rgb(') === 0) {
		            str = str.match(/rgb\(([^)]+)\)/)[1];
		            var parts = str.split(/ *, */).map(Number);
		            return {
		                r: parts[0],
		                g: parts[1],
		                b: parts[2],
		                a: 1,
		            };
		        }
		    },
		    _rgbaColorToRGBA: function (str) {
		        if (str.indexOf('rgba(') === 0) {
		            str = str.match(/rgba\(([^)]+)\)/)[1];
		            var parts = str.split(/ *, */).map(Number);
		            return {
		                r: parts[0],
		                g: parts[1],
		                b: parts[2],
		                a: parts[3],
		            };
		        }
		    },
		    _hex6ColorToRGBA: function (str) {
		        if (str[0] === '#' && str.length === 7) {
		            return {
		                r: parseInt(str.slice(1, 3), 16),
		                g: parseInt(str.slice(3, 5), 16),
		                b: parseInt(str.slice(5, 7), 16),
		                a: 1,
		            };
		        }
		    },
		    _hex3ColorToRGBA: function (str) {
		        if (str[0] === '#' && str.length === 4) {
		            return {
		                r: parseInt(str[1] + str[1], 16),
		                g: parseInt(str[2] + str[2], 16),
		                b: parseInt(str[3] + str[3], 16),
		                a: 1,
		            };
		        }
		    },
		    _hslColorToRGBA: function (str) {
		        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
		            var _a = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str); _a[0]; var hsl = _a.slice(1);
		            var h = Number(hsl[0]) / 360;
		            var s = Number(hsl[1]) / 100;
		            var l = Number(hsl[2]) / 100;
		            var t2 = void 0;
		            var t3 = void 0;
		            var val = void 0;
		            if (s === 0) {
		                val = l * 255;
		                return {
		                    r: Math.round(val),
		                    g: Math.round(val),
		                    b: Math.round(val),
		                    a: 1,
		                };
		            }
		            if (l < 0.5) {
		                t2 = l * (1 + s);
		            }
		            else {
		                t2 = l + s - l * s;
		            }
		            var t1 = 2 * l - t2;
		            var rgb = [0, 0, 0];
		            for (var i = 0; i < 3; i++) {
		                t3 = h + (1 / 3) * -(i - 1);
		                if (t3 < 0) {
		                    t3++;
		                }
		                if (t3 > 1) {
		                    t3--;
		                }
		                if (6 * t3 < 1) {
		                    val = t1 + (t2 - t1) * 6 * t3;
		                }
		                else if (2 * t3 < 1) {
		                    val = t2;
		                }
		                else if (3 * t3 < 2) {
		                    val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		                }
		                else {
		                    val = t1;
		                }
		                rgb[i] = val * 255;
		            }
		            return {
		                r: Math.round(rgb[0]),
		                g: Math.round(rgb[1]),
		                b: Math.round(rgb[2]),
		                a: 1,
		            };
		        }
		    },
		    haveIntersection: function (r1, r2) {
		        return !(r2.x > r1.x + r1.width ||
		            r2.x + r2.width < r1.x ||
		            r2.y > r1.y + r1.height ||
		            r2.y + r2.height < r1.y);
		    },
		    cloneObject: function (obj) {
		        var retObj = {};
		        for (var key in obj) {
		            if (this._isPlainObject(obj[key])) {
		                retObj[key] = this.cloneObject(obj[key]);
		            }
		            else if (this._isArray(obj[key])) {
		                retObj[key] = this.cloneArray(obj[key]);
		            }
		            else {
		                retObj[key] = obj[key];
		            }
		        }
		        return retObj;
		    },
		    cloneArray: function (arr) {
		        return arr.slice(0);
		    },
		    _degToRad: function (deg) {
		        return deg * PI_OVER_DEG180;
		    },
		    _radToDeg: function (rad) {
		        return rad * DEG180_OVER_PI;
		    },
		    _getRotation: function (radians) {
		        return Global_1.Konva.angleDeg ? exports.Util._radToDeg(radians) : radians;
		    },
		    _capitalize: function (str) {
		        return str.charAt(0).toUpperCase() + str.slice(1);
		    },
		    throw: function (str) {
		        throw new Error(KONVA_ERROR + str);
		    },
		    error: function (str) {
		        console.error(KONVA_ERROR + str);
		    },
		    warn: function (str) {
		        if (!Global_1.Konva.showWarnings) {
		            return;
		        }
		        console.warn(KONVA_WARNING + str);
		    },
		    extend: function (child, parent) {
		        function Ctor() {
		            this.constructor = child;
		        }
		        Ctor.prototype = parent.prototype;
		        var oldProto = child.prototype;
		        child.prototype = new Ctor();
		        for (var key in oldProto) {
		            if (oldProto.hasOwnProperty(key)) {
		                child.prototype[key] = oldProto[key];
		            }
		        }
		        child.__super__ = parent.prototype;
		        child.super = parent;
		    },
		    _getControlPoints: function (x0, y0, x1, y1, x2, y2, t) {
		        var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = (t * d01) / (d01 + d12), fb = (t * d12) / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
		        return [p1x, p1y, p2x, p2y];
		    },
		    _expandPoints: function (p, tension) {
		        var len = p.length, allPoints = [], n, cp;
		        for (n = 2; n < len - 2; n += 2) {
		            cp = exports.Util._getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
		            if (isNaN(cp[0])) {
		                continue;
		            }
		            allPoints.push(cp[0]);
		            allPoints.push(cp[1]);
		            allPoints.push(p[n]);
		            allPoints.push(p[n + 1]);
		            allPoints.push(cp[2]);
		            allPoints.push(cp[3]);
		        }
		        return allPoints;
		    },
		    each: function (obj, func) {
		        for (var key in obj) {
		            func(key, obj[key]);
		        }
		    },
		    _inRange: function (val, left, right) {
		        return left <= val && val < right;
		    },
		    _getProjectionToSegment: function (x1, y1, x2, y2, x3, y3) {
		        var x, y, dist;
		        var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
		        if (pd2 == 0) {
		            x = x1;
		            y = y1;
		            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
		        }
		        else {
		            var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
		            if (u < 0) {
		                x = x1;
		                y = y1;
		                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
		            }
		            else if (u > 1.0) {
		                x = x2;
		                y = y2;
		                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
		            }
		            else {
		                x = x1 + u * (x2 - x1);
		                y = y1 + u * (y2 - y1);
		                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
		            }
		        }
		        return [x, y, dist];
		    },
		    _getProjectionToLine: function (pt, line, isClosed) {
		        var pc = exports.Util.cloneObject(pt);
		        var dist = Number.MAX_VALUE;
		        line.forEach(function (p1, i) {
		            if (!isClosed && i === line.length - 1) {
		                return;
		            }
		            var p2 = line[(i + 1) % line.length];
		            var proj = exports.Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
		            var px = proj[0], py = proj[1], pdist = proj[2];
		            if (pdist < dist) {
		                pc.x = px;
		                pc.y = py;
		                dist = pdist;
		            }
		        });
		        return pc;
		    },
		    _prepareArrayForTween: function (startArray, endArray, isClosed) {
		        var n, start = [], end = [];
		        if (startArray.length > endArray.length) {
		            var temp = endArray;
		            endArray = startArray;
		            startArray = temp;
		        }
		        for (n = 0; n < startArray.length; n += 2) {
		            start.push({
		                x: startArray[n],
		                y: startArray[n + 1],
		            });
		        }
		        for (n = 0; n < endArray.length; n += 2) {
		            end.push({
		                x: endArray[n],
		                y: endArray[n + 1],
		            });
		        }
		        var newStart = [];
		        end.forEach(function (point) {
		            var pr = exports.Util._getProjectionToLine(point, start, isClosed);
		            newStart.push(pr.x);
		            newStart.push(pr.y);
		        });
		        return newStart;
		    },
		    _prepareToStringify: function (obj) {
		        var desc;
		        obj.visitedByCircularReferenceRemoval = true;
		        for (var key in obj) {
		            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) {
		                continue;
		            }
		            desc = Object.getOwnPropertyDescriptor(obj, key);
		            if (obj[key].visitedByCircularReferenceRemoval ||
		                exports.Util._isElement(obj[key])) {
		                if (desc.configurable) {
		                    delete obj[key];
		                }
		                else {
		                    return null;
		                }
		            }
		            else if (exports.Util._prepareToStringify(obj[key]) === null) {
		                if (desc.configurable) {
		                    delete obj[key];
		                }
		                else {
		                    return null;
		                }
		            }
		        }
		        delete obj.visitedByCircularReferenceRemoval;
		        return obj;
		    },
		    _assign: function (target, source) {
		        for (var key in source) {
		            target[key] = source[key];
		        }
		        return target;
		    },
		    _getFirstPointerId: function (evt) {
		        if (!evt.touches) {
		            return 999;
		        }
		        else {
		            return evt.changedTouches[0].identifier;
		        }
		    },
		}; 
	} (Util));
	return Util;
}

var Node = {};

var Factory = {};

var Validators = {};

var hasRequiredValidators;

function requireValidators () {
	if (hasRequiredValidators) return Validators;
	hasRequiredValidators = 1;
	Object.defineProperty(Validators, "__esModule", { value: true });
	Validators.getComponentValidator = Validators.getBooleanValidator = Validators.getNumberArrayValidator = Validators.getFunctionValidator = Validators.getStringOrGradientValidator = Validators.getStringValidator = Validators.getNumberOrAutoValidator = Validators.getNumberOrArrayOfNumbersValidator = Validators.getNumberValidator = Validators.alphaComponent = Validators.RGBComponent = void 0;
	var Global_1 = requireGlobal();
	var Util_1 = requireUtil();
	function _formatValue(val) {
	    if (Util_1.Util._isString(val)) {
	        return '"' + val + '"';
	    }
	    if (Object.prototype.toString.call(val) === '[object Number]') {
	        return val;
	    }
	    if (Util_1.Util._isBoolean(val)) {
	        return val;
	    }
	    return Object.prototype.toString.call(val);
	}
	function RGBComponent(val) {
	    if (val > 255) {
	        return 255;
	    }
	    else if (val < 0) {
	        return 0;
	    }
	    return Math.round(val);
	}
	Validators.RGBComponent = RGBComponent;
	function alphaComponent(val) {
	    if (val > 1) {
	        return 1;
	    }
	    else if (val < 0.0001) {
	        return 0.0001;
	    }
	    return val;
	}
	Validators.alphaComponent = alphaComponent;
	function getNumberValidator() {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            if (!Util_1.Util._isNumber(val)) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be a number.');
	            }
	            return val;
	        };
	    }
	}
	Validators.getNumberValidator = getNumberValidator;
	function getNumberOrArrayOfNumbersValidator(noOfElements) {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            var isNumber = Util_1.Util._isNumber(val);
	            var isValidArray = Util_1.Util._isArray(val) && val.length == noOfElements;
	            if (!isNumber && !isValidArray) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be a number or Array<number>(' + noOfElements + ')');
	            }
	            return val;
	        };
	    }
	}
	Validators.getNumberOrArrayOfNumbersValidator = getNumberOrArrayOfNumbersValidator;
	function getNumberOrAutoValidator() {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            var isNumber = Util_1.Util._isNumber(val);
	            var isAuto = val === 'auto';
	            if (!(isNumber || isAuto)) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be a number or "auto".');
	            }
	            return val;
	        };
	    }
	}
	Validators.getNumberOrAutoValidator = getNumberOrAutoValidator;
	function getStringValidator() {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            if (!Util_1.Util._isString(val)) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be a string.');
	            }
	            return val;
	        };
	    }
	}
	Validators.getStringValidator = getStringValidator;
	function getStringOrGradientValidator() {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            var isString = Util_1.Util._isString(val);
	            var isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]';
	            if (!(isString || isGradient)) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be a string or a native gradient.');
	            }
	            return val;
	        };
	    }
	}
	Validators.getStringOrGradientValidator = getStringOrGradientValidator;
	function getFunctionValidator() {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            if (!Util_1.Util._isFunction(val)) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be a function.');
	            }
	            return val;
	        };
	    }
	}
	Validators.getFunctionValidator = getFunctionValidator;
	function getNumberArrayValidator() {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            if (!Util_1.Util._isArray(val)) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be a array of numbers.');
	            }
	            else {
	                val.forEach(function (item) {
	                    if (!Util_1.Util._isNumber(item)) {
	                        Util_1.Util.warn('"' +
	                            attr +
	                            '" attribute has non numeric element ' +
	                            item +
	                            '. Make sure that all elements are numbers.');
	                    }
	                });
	            }
	            return val;
	        };
	    }
	}
	Validators.getNumberArrayValidator = getNumberArrayValidator;
	function getBooleanValidator() {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            var isBool = val === true || val === false;
	            if (!isBool) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be a boolean.');
	            }
	            return val;
	        };
	    }
	}
	Validators.getBooleanValidator = getBooleanValidator;
	function getComponentValidator(components) {
	    if (Global_1.Konva.isUnminified) {
	        return function (val, attr) {
	            if (!Util_1.Util.isObject(val)) {
	                Util_1.Util.warn(_formatValue(val) +
	                    ' is a not valid value for "' +
	                    attr +
	                    '" attribute. The value should be an object with properties ' +
	                    components);
	            }
	            return val;
	        };
	    }
	}
	Validators.getComponentValidator = getComponentValidator;
	return Validators;
}

var hasRequiredFactory;

function requireFactory () {
	if (hasRequiredFactory) return Factory;
	hasRequiredFactory = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Factory = void 0;
		var Util_1 = requireUtil();
		var Validators_1 = requireValidators();
		var GET = 'get', SET = 'set';
		exports.Factory = {
		    addGetterSetter: function (constructor, attr, def, validator, after) {
		        exports.Factory.addGetter(constructor, attr, def);
		        exports.Factory.addSetter(constructor, attr, validator, after);
		        exports.Factory.addOverloadedGetterSetter(constructor, attr);
		    },
		    addGetter: function (constructor, attr, def) {
		        var method = GET + Util_1.Util._capitalize(attr);
		        constructor.prototype[method] =
		            constructor.prototype[method] ||
		                function () {
		                    var val = this.attrs[attr];
		                    return val === undefined ? def : val;
		                };
		    },
		    addSetter: function (constructor, attr, validator, after) {
		        var method = SET + Util_1.Util._capitalize(attr);
		        if (!constructor.prototype[method]) {
		            exports.Factory.overWriteSetter(constructor, attr, validator, after);
		        }
		    },
		    overWriteSetter: function (constructor, attr, validator, after) {
		        var method = SET + Util_1.Util._capitalize(attr);
		        constructor.prototype[method] = function (val) {
		            if (validator && val !== undefined && val !== null) {
		                val = validator.call(this, val, attr);
		            }
		            this._setAttr(attr, val);
		            if (after) {
		                after.call(this);
		            }
		            return this;
		        };
		    },
		    addComponentsGetterSetter: function (constructor, attr, components, validator, after) {
		        var len = components.length, capitalize = Util_1.Util._capitalize, getter = GET + capitalize(attr), setter = SET + capitalize(attr), n, component;
		        constructor.prototype[getter] = function () {
		            var ret = {};
		            for (n = 0; n < len; n++) {
		                component = components[n];
		                ret[component] = this.getAttr(attr + capitalize(component));
		            }
		            return ret;
		        };
		        var basicValidator = Validators_1.getComponentValidator(components);
		        constructor.prototype[setter] = function (val) {
		            var oldVal = this.attrs[attr], key;
		            if (validator) {
		                val = validator.call(this, val);
		            }
		            if (basicValidator) {
		                basicValidator.call(this, val, attr);
		            }
		            for (key in val) {
		                if (!val.hasOwnProperty(key)) {
		                    continue;
		                }
		                this._setAttr(attr + capitalize(key), val[key]);
		            }
		            this._fireChangeEvent(attr, oldVal, val);
		            if (after) {
		                after.call(this);
		            }
		            return this;
		        };
		        exports.Factory.addOverloadedGetterSetter(constructor, attr);
		    },
		    addOverloadedGetterSetter: function (constructor, attr) {
		        var capitalizedAttr = Util_1.Util._capitalize(attr), setter = SET + capitalizedAttr, getter = GET + capitalizedAttr;
		        constructor.prototype[attr] = function () {
		            if (arguments.length) {
		                this[setter](arguments[0]);
		                return this;
		            }
		            return this[getter]();
		        };
		    },
		    addDeprecatedGetterSetter: function (constructor, attr, def, validator) {
		        Util_1.Util.error('Adding deprecated ' + attr);
		        var method = GET + Util_1.Util._capitalize(attr);
		        var message = attr +
		            ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
		        constructor.prototype[method] = function () {
		            Util_1.Util.error(message);
		            var val = this.attrs[attr];
		            return val === undefined ? def : val;
		        };
		        exports.Factory.addSetter(constructor, attr, validator, function () {
		            Util_1.Util.error(message);
		        });
		        exports.Factory.addOverloadedGetterSetter(constructor, attr);
		    },
		    backCompat: function (constructor, methods) {
		        Util_1.Util.each(methods, function (oldMethodName, newMethodName) {
		            var method = constructor.prototype[newMethodName];
		            var oldGetter = GET + Util_1.Util._capitalize(oldMethodName);
		            var oldSetter = SET + Util_1.Util._capitalize(oldMethodName);
		            function deprecated() {
		                method.apply(this, arguments);
		                Util_1.Util.error('"' +
		                    oldMethodName +
		                    '" method is deprecated and will be removed soon. Use ""' +
		                    newMethodName +
		                    '" instead.');
		            }
		            constructor.prototype[oldMethodName] = deprecated;
		            constructor.prototype[oldGetter] = deprecated;
		            constructor.prototype[oldSetter] = deprecated;
		        });
		    },
		    afterSetFilter: function () {
		        this._filterUpToDate = false;
		    },
		}; 
	} (Factory));
	return Factory;
}

var Canvas = {};

var Context = {};

var hasRequiredContext;

function requireContext () {
	if (hasRequiredContext) return Context;
	hasRequiredContext = 1;
	var __extends = (Context && Context.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Context, "__esModule", { value: true });
	Context.HitContext = Context.SceneContext = Context.Context = void 0;
	var Util_1 = requireUtil();
	var Global_1 = requireGlobal();
	var COMMA = ',', OPEN_PAREN = '(', CLOSE_PAREN = ')', OPEN_PAREN_BRACKET = '([', CLOSE_BRACKET_PAREN = '])', SEMICOLON = ';', DOUBLE_PAREN = '()', EQUALS = '=', CONTEXT_METHODS = [
	    'arc',
	    'arcTo',
	    'beginPath',
	    'bezierCurveTo',
	    'clearRect',
	    'clip',
	    'closePath',
	    'createLinearGradient',
	    'createPattern',
	    'createRadialGradient',
	    'drawImage',
	    'ellipse',
	    'fill',
	    'fillText',
	    'getImageData',
	    'createImageData',
	    'lineTo',
	    'moveTo',
	    'putImageData',
	    'quadraticCurveTo',
	    'rect',
	    'restore',
	    'rotate',
	    'save',
	    'scale',
	    'setLineDash',
	    'setTransform',
	    'stroke',
	    'strokeText',
	    'transform',
	    'translate',
	];
	var CONTEXT_PROPERTIES = [
	    'fillStyle',
	    'strokeStyle',
	    'shadowColor',
	    'shadowBlur',
	    'shadowOffsetX',
	    'shadowOffsetY',
	    'lineCap',
	    'lineDashOffset',
	    'lineJoin',
	    'lineWidth',
	    'miterLimit',
	    'font',
	    'textAlign',
	    'textBaseline',
	    'globalAlpha',
	    'globalCompositeOperation',
	    'imageSmoothingEnabled',
	];
	var traceArrMax = 100;
	var Context$1 = (function () {
	    function Context(canvas) {
	        this.canvas = canvas;
	        this._context = canvas._canvas.getContext('2d');
	        if (Global_1.Konva.enableTrace) {
	            this.traceArr = [];
	            this._enableTrace();
	        }
	    }
	    Context.prototype.fillShape = function (shape) {
	        if (shape.fillEnabled()) {
	            this._fill(shape);
	        }
	    };
	    Context.prototype._fill = function (shape) {
	    };
	    Context.prototype.strokeShape = function (shape) {
	        if (shape.hasStroke()) {
	            this._stroke(shape);
	        }
	    };
	    Context.prototype._stroke = function (shape) {
	    };
	    Context.prototype.fillStrokeShape = function (shape) {
	        if (shape.attrs.fillAfterStrokeEnabled) {
	            this.strokeShape(shape);
	            this.fillShape(shape);
	        }
	        else {
	            this.fillShape(shape);
	            this.strokeShape(shape);
	        }
	    };
	    Context.prototype.getTrace = function (relaxed) {
	        var traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
	        for (n = 0; n < len; n++) {
	            trace = traceArr[n];
	            method = trace.method;
	            if (method) {
	                args = trace.args;
	                str += method;
	                if (relaxed) {
	                    str += DOUBLE_PAREN;
	                }
	                else {
	                    if (Util_1.Util._isArray(args[0])) {
	                        str += OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
	                    }
	                    else {
	                        str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
	                    }
	                }
	            }
	            else {
	                str += trace.property;
	                if (!relaxed) {
	                    str += EQUALS + trace.val;
	                }
	            }
	            str += SEMICOLON;
	        }
	        return str;
	    };
	    Context.prototype.clearTrace = function () {
	        this.traceArr = [];
	    };
	    Context.prototype._trace = function (str) {
	        var traceArr = this.traceArr, len;
	        traceArr.push(str);
	        len = traceArr.length;
	        if (len >= traceArrMax) {
	            traceArr.shift();
	        }
	    };
	    Context.prototype.reset = function () {
	        var pixelRatio = this.getCanvas().getPixelRatio();
	        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
	    };
	    Context.prototype.getCanvas = function () {
	        return this.canvas;
	    };
	    Context.prototype.clear = function (bounds) {
	        var canvas = this.getCanvas();
	        if (bounds) {
	            this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
	        }
	        else {
	            this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
	        }
	    };
	    Context.prototype._applyLineCap = function (shape) {
	        var lineCap = shape.getLineCap();
	        if (lineCap) {
	            this.setAttr('lineCap', lineCap);
	        }
	    };
	    Context.prototype._applyOpacity = function (shape) {
	        var absOpacity = shape.getAbsoluteOpacity();
	        if (absOpacity !== 1) {
	            this.setAttr('globalAlpha', absOpacity);
	        }
	    };
	    Context.prototype._applyLineJoin = function (shape) {
	        var lineJoin = shape.attrs.lineJoin;
	        if (lineJoin) {
	            this.setAttr('lineJoin', lineJoin);
	        }
	    };
	    Context.prototype.setAttr = function (attr, val) {
	        this._context[attr] = val;
	    };
	    Context.prototype.arc = function (a0, a1, a2, a3, a4, a5) {
	        this._context.arc(a0, a1, a2, a3, a4, a5);
	    };
	    Context.prototype.arcTo = function (a0, a1, a2, a3, a4) {
	        this._context.arcTo(a0, a1, a2, a3, a4);
	    };
	    Context.prototype.beginPath = function () {
	        this._context.beginPath();
	    };
	    Context.prototype.bezierCurveTo = function (a0, a1, a2, a3, a4, a5) {
	        this._context.bezierCurveTo(a0, a1, a2, a3, a4, a5);
	    };
	    Context.prototype.clearRect = function (a0, a1, a2, a3) {
	        this._context.clearRect(a0, a1, a2, a3);
	    };
	    Context.prototype.clip = function () {
	        this._context.clip();
	    };
	    Context.prototype.closePath = function () {
	        this._context.closePath();
	    };
	    Context.prototype.createImageData = function (a0, a1) {
	        var a = arguments;
	        if (a.length === 2) {
	            return this._context.createImageData(a0, a1);
	        }
	        else if (a.length === 1) {
	            return this._context.createImageData(a0);
	        }
	    };
	    Context.prototype.createLinearGradient = function (a0, a1, a2, a3) {
	        return this._context.createLinearGradient(a0, a1, a2, a3);
	    };
	    Context.prototype.createPattern = function (a0, a1) {
	        return this._context.createPattern(a0, a1);
	    };
	    Context.prototype.createRadialGradient = function (a0, a1, a2, a3, a4, a5) {
	        return this._context.createRadialGradient(a0, a1, a2, a3, a4, a5);
	    };
	    Context.prototype.drawImage = function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	        var a = arguments, _context = this._context;
	        if (a.length === 3) {
	            _context.drawImage(a0, a1, a2);
	        }
	        else if (a.length === 5) {
	            _context.drawImage(a0, a1, a2, a3, a4);
	        }
	        else if (a.length === 9) {
	            _context.drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8);
	        }
	    };
	    Context.prototype.ellipse = function (a0, a1, a2, a3, a4, a5, a6, a7) {
	        this._context.ellipse(a0, a1, a2, a3, a4, a5, a6, a7);
	    };
	    Context.prototype.isPointInPath = function (x, y) {
	        return this._context.isPointInPath(x, y);
	    };
	    Context.prototype.fill = function () {
	        this._context.fill();
	    };
	    Context.prototype.fillRect = function (x, y, width, height) {
	        this._context.fillRect(x, y, width, height);
	    };
	    Context.prototype.strokeRect = function (x, y, width, height) {
	        this._context.strokeRect(x, y, width, height);
	    };
	    Context.prototype.fillText = function (a0, a1, a2) {
	        this._context.fillText(a0, a1, a2);
	    };
	    Context.prototype.measureText = function (text) {
	        return this._context.measureText(text);
	    };
	    Context.prototype.getImageData = function (a0, a1, a2, a3) {
	        return this._context.getImageData(a0, a1, a2, a3);
	    };
	    Context.prototype.lineTo = function (a0, a1) {
	        this._context.lineTo(a0, a1);
	    };
	    Context.prototype.moveTo = function (a0, a1) {
	        this._context.moveTo(a0, a1);
	    };
	    Context.prototype.rect = function (a0, a1, a2, a3) {
	        this._context.rect(a0, a1, a2, a3);
	    };
	    Context.prototype.putImageData = function (a0, a1, a2) {
	        this._context.putImageData(a0, a1, a2);
	    };
	    Context.prototype.quadraticCurveTo = function (a0, a1, a2, a3) {
	        this._context.quadraticCurveTo(a0, a1, a2, a3);
	    };
	    Context.prototype.restore = function () {
	        this._context.restore();
	    };
	    Context.prototype.rotate = function (a0) {
	        this._context.rotate(a0);
	    };
	    Context.prototype.save = function () {
	        this._context.save();
	    };
	    Context.prototype.scale = function (a0, a1) {
	        this._context.scale(a0, a1);
	    };
	    Context.prototype.setLineDash = function (a0) {
	        if (this._context.setLineDash) {
	            this._context.setLineDash(a0);
	        }
	        else if ('mozDash' in this._context) {
	            this._context['mozDash'] = a0;
	        }
	        else if ('webkitLineDash' in this._context) {
	            this._context['webkitLineDash'] = a0;
	        }
	    };
	    Context.prototype.getLineDash = function () {
	        return this._context.getLineDash();
	    };
	    Context.prototype.setTransform = function (a0, a1, a2, a3, a4, a5) {
	        this._context.setTransform(a0, a1, a2, a3, a4, a5);
	    };
	    Context.prototype.stroke = function () {
	        this._context.stroke();
	    };
	    Context.prototype.strokeText = function (a0, a1, a2, a3) {
	        this._context.strokeText(a0, a1, a2, a3);
	    };
	    Context.prototype.transform = function (a0, a1, a2, a3, a4, a5) {
	        this._context.transform(a0, a1, a2, a3, a4, a5);
	    };
	    Context.prototype.translate = function (a0, a1) {
	        this._context.translate(a0, a1);
	    };
	    Context.prototype._enableTrace = function () {
	        var that = this, len = CONTEXT_METHODS.length, _simplifyArray = Util_1.Util._simplifyArray, origSetter = this.setAttr, n, args;
	        var func = function (methodName) {
	            var origMethod = that[methodName], ret;
	            that[methodName] = function () {
	                args = _simplifyArray(Array.prototype.slice.call(arguments, 0));
	                ret = origMethod.apply(that, arguments);
	                that._trace({
	                    method: methodName,
	                    args: args,
	                });
	                return ret;
	            };
	        };
	        for (n = 0; n < len; n++) {
	            func(CONTEXT_METHODS[n]);
	        }
	        that.setAttr = function () {
	            origSetter.apply(that, arguments);
	            var prop = arguments[0];
	            var val = arguments[1];
	            if (prop === 'shadowOffsetX' ||
	                prop === 'shadowOffsetY' ||
	                prop === 'shadowBlur') {
	                val = val / this.canvas.getPixelRatio();
	            }
	            that._trace({
	                property: prop,
	                val: val,
	            });
	        };
	    };
	    Context.prototype._applyGlobalCompositeOperation = function (node) {
	        var globalCompositeOperation = node.getGlobalCompositeOperation();
	        if (globalCompositeOperation !== 'source-over') {
	            this.setAttr('globalCompositeOperation', globalCompositeOperation);
	        }
	    };
	    return Context;
	}());
	Context.Context = Context$1;
	CONTEXT_PROPERTIES.forEach(function (prop) {
	    Object.defineProperty(Context$1.prototype, prop, {
	        get: function () {
	            return this._context[prop];
	        },
	        set: function (val) {
	            this._context[prop] = val;
	        },
	    });
	});
	var SceneContext = (function (_super) {
	    __extends(SceneContext, _super);
	    function SceneContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SceneContext.prototype._fillColor = function (shape) {
	        var fill = shape.fill();
	        this.setAttr('fillStyle', fill);
	        shape._fillFunc(this);
	    };
	    SceneContext.prototype._fillPattern = function (shape) {
	        var fillPatternX = shape.getFillPatternX(), fillPatternY = shape.getFillPatternY(), fillPatternRotation = Global_1.Konva.getAngle(shape.getFillPatternRotation()), fillPatternOffsetX = shape.getFillPatternOffsetX(), fillPatternOffsetY = shape.getFillPatternOffsetY(); shape.getFillPatternScaleX(); shape.getFillPatternScaleY();
	        if (fillPatternX || fillPatternY) {
	            this.translate(fillPatternX || 0, fillPatternY || 0);
	        }
	        if (fillPatternRotation) {
	            this.rotate(fillPatternRotation);
	        }
	        if (fillPatternOffsetX || fillPatternOffsetY) {
	            this.translate(-1 * fillPatternOffsetX, -1 * fillPatternOffsetY);
	        }
	        this.setAttr('fillStyle', shape._getFillPattern());
	        shape._fillFunc(this);
	    };
	    SceneContext.prototype._fillLinearGradient = function (shape) {
	        var grd = shape._getLinearGradient();
	        if (grd) {
	            this.setAttr('fillStyle', grd);
	            shape._fillFunc(this);
	        }
	    };
	    SceneContext.prototype._fillRadialGradient = function (shape) {
	        var grd = shape._getRadialGradient();
	        if (grd) {
	            this.setAttr('fillStyle', grd);
	            shape._fillFunc(this);
	        }
	    };
	    SceneContext.prototype._fill = function (shape) {
	        var hasColor = shape.fill(), fillPriority = shape.getFillPriority();
	        if (hasColor && fillPriority === 'color') {
	            this._fillColor(shape);
	            return;
	        }
	        var hasPattern = shape.getFillPatternImage();
	        if (hasPattern && fillPriority === 'pattern') {
	            this._fillPattern(shape);
	            return;
	        }
	        var hasLinearGradient = shape.getFillLinearGradientColorStops();
	        if (hasLinearGradient && fillPriority === 'linear-gradient') {
	            this._fillLinearGradient(shape);
	            return;
	        }
	        var hasRadialGradient = shape.getFillRadialGradientColorStops();
	        if (hasRadialGradient && fillPriority === 'radial-gradient') {
	            this._fillRadialGradient(shape);
	            return;
	        }
	        if (hasColor) {
	            this._fillColor(shape);
	        }
	        else if (hasPattern) {
	            this._fillPattern(shape);
	        }
	        else if (hasLinearGradient) {
	            this._fillLinearGradient(shape);
	        }
	        else if (hasRadialGradient) {
	            this._fillRadialGradient(shape);
	        }
	    };
	    SceneContext.prototype._strokeLinearGradient = function (shape) {
	        var start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
	        if (colorStops) {
	            for (var n = 0; n < colorStops.length; n += 2) {
	                grd.addColorStop(colorStops[n], colorStops[n + 1]);
	            }
	            this.setAttr('strokeStyle', grd);
	        }
	    };
	    SceneContext.prototype._stroke = function (shape) {
	        var dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
	        if (shape.hasStroke()) {
	            if (!strokeScaleEnabled) {
	                this.save();
	                var pixelRatio = this.getCanvas().getPixelRatio();
	                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
	            }
	            this._applyLineCap(shape);
	            if (dash && shape.dashEnabled()) {
	                this.setLineDash(dash);
	                this.setAttr('lineDashOffset', shape.dashOffset());
	            }
	            this.setAttr('lineWidth', shape.strokeWidth());
	            if (!shape.getShadowForStrokeEnabled()) {
	                this.setAttr('shadowColor', 'rgba(0,0,0,0)');
	            }
	            var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
	            if (hasLinearGradient) {
	                this._strokeLinearGradient(shape);
	            }
	            else {
	                this.setAttr('strokeStyle', shape.stroke());
	            }
	            shape._strokeFunc(this);
	            if (!strokeScaleEnabled) {
	                this.restore();
	            }
	        }
	    };
	    SceneContext.prototype._applyShadow = function (shape) {
	        var util = Util_1.Util, color = util.get(shape.getShadowRGBA(), 'black'), blur = util.get(shape.getShadowBlur(), 5), offset = util.get(shape.getShadowOffset(), {
	            x: 0,
	            y: 0,
	        }), scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
	        this.setAttr('shadowColor', color);
	        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
	        this.setAttr('shadowOffsetX', offset.x * scaleX);
	        this.setAttr('shadowOffsetY', offset.y * scaleY);
	    };
	    return SceneContext;
	}(Context$1));
	Context.SceneContext = SceneContext;
	var HitContext = (function (_super) {
	    __extends(HitContext, _super);
	    function HitContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    HitContext.prototype._fill = function (shape) {
	        this.save();
	        this.setAttr('fillStyle', shape.colorKey);
	        shape._fillFuncHit(this);
	        this.restore();
	    };
	    HitContext.prototype.strokeShape = function (shape) {
	        if (shape.hasHitStroke()) {
	            this._stroke(shape);
	        }
	    };
	    HitContext.prototype._stroke = function (shape) {
	        if (shape.hasHitStroke()) {
	            var strokeScaleEnabled = shape.getStrokeScaleEnabled();
	            if (!strokeScaleEnabled) {
	                this.save();
	                var pixelRatio = this.getCanvas().getPixelRatio();
	                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
	            }
	            this._applyLineCap(shape);
	            var hitStrokeWidth = shape.hitStrokeWidth();
	            var strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
	            this.setAttr('lineWidth', strokeWidth);
	            this.setAttr('strokeStyle', shape.colorKey);
	            shape._strokeFuncHit(this);
	            if (!strokeScaleEnabled) {
	                this.restore();
	            }
	        }
	    };
	    return HitContext;
	}(Context$1));
	Context.HitContext = HitContext;
	return Context;
}

var hasRequiredCanvas;

function requireCanvas () {
	if (hasRequiredCanvas) return Canvas;
	hasRequiredCanvas = 1;
	var __extends = (Canvas && Canvas.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Canvas, "__esModule", { value: true });
	Canvas.HitCanvas = Canvas.SceneCanvas = Canvas.Canvas = void 0;
	var Util_1 = requireUtil();
	var Context_1 = requireContext();
	var Global_1 = requireGlobal();
	var Factory_1 = requireFactory();
	var Validators_1 = requireValidators();
	var _pixelRatio;
	function getDevicePixelRatio() {
	    if (_pixelRatio) {
	        return _pixelRatio;
	    }
	    var canvas = Util_1.Util.createCanvasElement();
	    var context = canvas.getContext('2d');
	    _pixelRatio = (function () {
	        var devicePixelRatio = Global_1.Konva._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio ||
	            context.mozBackingStorePixelRatio ||
	            context.msBackingStorePixelRatio ||
	            context.oBackingStorePixelRatio ||
	            context.backingStorePixelRatio ||
	            1;
	        return devicePixelRatio / backingStoreRatio;
	    })();
	    return _pixelRatio;
	}
	var Canvas$1 = (function () {
	    function Canvas(config) {
	        this.pixelRatio = 1;
	        this.width = 0;
	        this.height = 0;
	        this.isCache = false;
	        var conf = config || {};
	        var pixelRatio = conf.pixelRatio || Global_1.Konva.pixelRatio || getDevicePixelRatio();
	        this.pixelRatio = pixelRatio;
	        this._canvas = Util_1.Util.createCanvasElement();
	        this._canvas.style.padding = '0';
	        this._canvas.style.margin = '0';
	        this._canvas.style.border = '0';
	        this._canvas.style.background = 'transparent';
	        this._canvas.style.position = 'absolute';
	        this._canvas.style.top = '0';
	        this._canvas.style.left = '0';
	    }
	    Canvas.prototype.getContext = function () {
	        return this.context;
	    };
	    Canvas.prototype.getPixelRatio = function () {
	        return this.pixelRatio;
	    };
	    Canvas.prototype.setPixelRatio = function (pixelRatio) {
	        var previousRatio = this.pixelRatio;
	        this.pixelRatio = pixelRatio;
	        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
	    };
	    Canvas.prototype.setWidth = function (width) {
	        this.width = this._canvas.width = width * this.pixelRatio;
	        this._canvas.style.width = width + 'px';
	        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
	        _context.scale(pixelRatio, pixelRatio);
	    };
	    Canvas.prototype.setHeight = function (height) {
	        this.height = this._canvas.height = height * this.pixelRatio;
	        this._canvas.style.height = height + 'px';
	        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
	        _context.scale(pixelRatio, pixelRatio);
	    };
	    Canvas.prototype.getWidth = function () {
	        return this.width;
	    };
	    Canvas.prototype.getHeight = function () {
	        return this.height;
	    };
	    Canvas.prototype.setSize = function (width, height) {
	        this.setWidth(width || 0);
	        this.setHeight(height || 0);
	    };
	    Canvas.prototype.toDataURL = function (mimeType, quality) {
	        try {
	            return this._canvas.toDataURL(mimeType, quality);
	        }
	        catch (e) {
	            try {
	                return this._canvas.toDataURL();
	            }
	            catch (err) {
	                Util_1.Util.error('Unable to get data URL. ' +
	                    err.message +
	                    ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
	                return '';
	            }
	        }
	    };
	    return Canvas;
	}());
	Canvas.Canvas = Canvas$1;
	Factory_1.Factory.addGetterSetter(Canvas$1, 'pixelRatio', undefined, Validators_1.getNumberValidator());
	var SceneCanvas = (function (_super) {
	    __extends(SceneCanvas, _super);
	    function SceneCanvas(config) {
	        if (config === void 0) { config = { width: 0, height: 0 }; }
	        var _this = _super.call(this, config) || this;
	        _this.context = new Context_1.SceneContext(_this);
	        _this.setSize(config.width, config.height);
	        return _this;
	    }
	    return SceneCanvas;
	}(Canvas$1));
	Canvas.SceneCanvas = SceneCanvas;
	var HitCanvas = (function (_super) {
	    __extends(HitCanvas, _super);
	    function HitCanvas(config) {
	        if (config === void 0) { config = { width: 0, height: 0 }; }
	        var _this = _super.call(this, config) || this;
	        _this.hitCanvas = true;
	        _this.context = new Context_1.HitContext(_this);
	        _this.setSize(config.width, config.height);
	        return _this;
	    }
	    return HitCanvas;
	}(Canvas$1));
	Canvas.HitCanvas = HitCanvas;
	return Canvas;
}

var DragAndDrop = {};

var hasRequiredDragAndDrop;

function requireDragAndDrop () {
	if (hasRequiredDragAndDrop) return DragAndDrop;
	hasRequiredDragAndDrop = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.DD = void 0;
		var Global_1 = requireGlobal();
		var Util_1 = requireUtil();
		exports.DD = {
		    get isDragging() {
		        var flag = false;
		        exports.DD._dragElements.forEach(function (elem) {
		            if (elem.dragStatus === 'dragging') {
		                flag = true;
		            }
		        });
		        return flag;
		    },
		    justDragged: false,
		    get node() {
		        var node;
		        exports.DD._dragElements.forEach(function (elem) {
		            node = elem.node;
		        });
		        return node;
		    },
		    _dragElements: new Map(),
		    _drag: function (evt) {
		        var nodesToFireEvents = [];
		        exports.DD._dragElements.forEach(function (elem, key) {
		            var node = elem.node;
		            var stage = node.getStage();
		            stage.setPointersPositions(evt);
		            if (elem.pointerId === undefined) {
		                elem.pointerId = Util_1.Util._getFirstPointerId(evt);
		            }
		            var pos = stage._changedPointerPositions.find(function (pos) { return pos.id === elem.pointerId; });
		            if (!pos) {
		                return;
		            }
		            if (elem.dragStatus !== 'dragging') {
		                var dragDistance = node.dragDistance();
		                var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
		                if (distance < dragDistance) {
		                    return;
		                }
		                node.startDrag({ evt: evt });
		                if (!node.isDragging()) {
		                    return;
		                }
		            }
		            node._setDragPosition(evt, elem);
		            nodesToFireEvents.push(node);
		        });
		        nodesToFireEvents.forEach(function (node) {
		            node.fire('dragmove', {
		                type: 'dragmove',
		                target: node,
		                evt: evt,
		            }, true);
		        });
		    },
		    _endDragBefore: function (evt) {
		        exports.DD._dragElements.forEach(function (elem, key) {
		            var node = elem.node;
		            var stage = node.getStage();
		            if (evt) {
		                stage.setPointersPositions(evt);
		            }
		            var pos = stage._changedPointerPositions.find(function (pos) { return pos.id === elem.pointerId; });
		            if (!pos) {
		                return;
		            }
		            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
		                exports.DD.justDragged = true;
		                Global_1.Konva.listenClickTap = false;
		                elem.dragStatus = 'stopped';
		            }
		            var drawNode = elem.node.getLayer() ||
		                (elem.node instanceof Global_1.Konva['Stage'] && elem.node);
		            if (drawNode) {
		                drawNode.batchDraw();
		            }
		        });
		    },
		    _endDragAfter: function (evt) {
		        exports.DD._dragElements.forEach(function (elem, key) {
		            if (elem.dragStatus === 'stopped') {
		                elem.node.fire('dragend', {
		                    type: 'dragend',
		                    target: elem.node,
		                    evt: evt,
		                }, true);
		            }
		            if (elem.dragStatus !== 'dragging') {
		                exports.DD._dragElements.delete(key);
		            }
		        });
		    },
		};
		if (Global_1.Konva.isBrowser) {
		    window.addEventListener('mouseup', exports.DD._endDragBefore, true);
		    window.addEventListener('touchend', exports.DD._endDragBefore, true);
		    window.addEventListener('mousemove', exports.DD._drag);
		    window.addEventListener('touchmove', exports.DD._drag);
		    window.addEventListener('mouseup', exports.DD._endDragAfter, false);
		    window.addEventListener('touchend', exports.DD._endDragAfter, false);
		} 
	} (DragAndDrop));
	return DragAndDrop;
}

var hasRequiredNode;

function requireNode () {
	if (hasRequiredNode) return Node;
	hasRequiredNode = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Node = exports._removeName = exports._addName = exports._removeId = exports.names = exports.ids = void 0;
		var Util_1 = requireUtil();
		var Factory_1 = requireFactory();
		var Canvas_1 = requireCanvas();
		var Global_1 = requireGlobal();
		var DragAndDrop_1 = requireDragAndDrop();
		var Validators_1 = requireValidators();
		exports.ids = {};
		exports.names = {};
		var _addId = function (node, id) {
		    if (!id) {
		        return;
		    }
		    exports.ids[id] = node;
		};
		var _removeId = function (id, node) {
		    if (!id) {
		        return;
		    }
		    if (exports.ids[id] !== node) {
		        return;
		    }
		    delete exports.ids[id];
		};
		exports._removeId = _removeId;
		var _addName = function (node, name) {
		    if (name) {
		        if (!exports.names[name]) {
		            exports.names[name] = [];
		        }
		        exports.names[name].push(node);
		    }
		};
		exports._addName = _addName;
		var _removeName = function (name, _id) {
		    if (!name) {
		        return;
		    }
		    var nodes = exports.names[name];
		    if (!nodes) {
		        return;
		    }
		    for (var n = 0; n < nodes.length; n++) {
		        var no = nodes[n];
		        if (no._id === _id) {
		            nodes.splice(n, 1);
		        }
		    }
		    if (nodes.length === 0) {
		        delete exports.names[name];
		    }
		};
		exports._removeName = _removeName;
		var ABSOLUTE_OPACITY = 'absoluteOpacity', ALL_LISTENERS = 'allEventListeners', ABSOLUTE_TRANSFORM = 'absoluteTransform', ABSOLUTE_SCALE = 'absoluteScale', CANVAS = 'canvas', CHANGE = 'Change', CHILDREN = 'children', KONVA = 'konva', LISTENING = 'listening', MOUSEENTER = 'mouseenter', MOUSELEAVE = 'mouseleave', NAME = 'name', SET = 'set', SHAPE = 'Shape', SPACE = ' ', STAGE = 'stage', TRANSFORM = 'transform', UPPER_STAGE = 'Stage', VISIBLE = 'visible', TRANSFORM_CHANGE_STR = [
		    'xChange.konva',
		    'yChange.konva',
		    'scaleXChange.konva',
		    'scaleYChange.konva',
		    'skewXChange.konva',
		    'skewYChange.konva',
		    'rotationChange.konva',
		    'offsetXChange.konva',
		    'offsetYChange.konva',
		    'transformsEnabledChange.konva',
		].join(SPACE);
		var emptyChildren = new Util_1.Collection();
		var idCounter = 1;
		var Node = (function () {
		    function Node(config) {
		        this._id = idCounter++;
		        this.eventListeners = {};
		        this.attrs = {};
		        this.index = 0;
		        this._allEventListeners = null;
		        this.parent = null;
		        this._cache = new Map();
		        this._attachedDepsListeners = new Map();
		        this._lastPos = null;
		        this._batchingTransformChange = false;
		        this._needClearTransformCache = false;
		        this._filterUpToDate = false;
		        this._isUnderCache = false;
		        this.children = emptyChildren;
		        this._dragEventId = null;
		        this._shouldFireChangeEvents = false;
		        this.setAttrs(config);
		        this._shouldFireChangeEvents = true;
		    }
		    Node.prototype.hasChildren = function () {
		        return false;
		    };
		    Node.prototype.getChildren = function () {
		        return emptyChildren;
		    };
		    Node.prototype._clearCache = function (attr) {
		        if ((attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM) &&
		            this._cache.get(attr)) {
		            this._cache.get(attr).dirty = true;
		        }
		        else if (attr) {
		            this._cache.delete(attr);
		        }
		        else {
		            this._cache.clear();
		        }
		    };
		    Node.prototype._getCache = function (attr, privateGetter) {
		        var cache = this._cache.get(attr);
		        var isTransform = attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM;
		        var invalid = cache === undefined || (isTransform && cache.dirty === true);
		        if (invalid) {
		            cache = privateGetter.call(this);
		            this._cache.set(attr, cache);
		        }
		        return cache;
		    };
		    Node.prototype._calculate = function (name, deps, getter) {
		        var _this = this;
		        if (!this._attachedDepsListeners.get(name)) {
		            var depsString = deps.map(function (dep) { return dep + 'Change.konva'; }).join(SPACE);
		            this.on(depsString, function () {
		                _this._clearCache(name);
		            });
		            this._attachedDepsListeners.set(name, true);
		        }
		        return this._getCache(name, getter);
		    };
		    Node.prototype._getCanvasCache = function () {
		        return this._cache.get(CANVAS);
		    };
		    Node.prototype._clearSelfAndDescendantCache = function (attr, forceEvent) {
		        this._clearCache(attr);
		        if (forceEvent && attr === ABSOLUTE_TRANSFORM) {
		            this.fire('_clearTransformCache');
		        }
		        if (this.isCached()) {
		            return;
		        }
		        if (this.children) {
		            this.children.each(function (node) {
		                node._clearSelfAndDescendantCache(attr, true);
		            });
		        }
		    };
		    Node.prototype.clearCache = function () {
		        this._cache.delete(CANVAS);
		        this._clearSelfAndDescendantCache();
		        return this;
		    };
		    Node.prototype.cache = function (config) {
		        var conf = config || {};
		        var rect = {};
		        if (conf.x === undefined ||
		            conf.y === undefined ||
		            conf.width === undefined ||
		            conf.height === undefined) {
		            rect = this.getClientRect({
		                skipTransform: true,
		                relativeTo: this.getParent(),
		            });
		        }
		        var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? rect.x : conf.x, y = conf.y === undefined ? rect.y : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false;
		        if (!width || !height) {
		            Util_1.Util.error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
		            return;
		        }
		        width += offset * 2;
		        height += offset * 2;
		        x -= offset;
		        y -= offset;
		        var cachedSceneCanvas = new Canvas_1.SceneCanvas({
		            pixelRatio: pixelRatio,
		            width: width,
		            height: height,
		        }), cachedFilterCanvas = new Canvas_1.SceneCanvas({
		            pixelRatio: pixelRatio,
		            width: 0,
		            height: 0,
		        }), cachedHitCanvas = new Canvas_1.HitCanvas({
		            pixelRatio: 1,
		            width: width,
		            height: height,
		        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
		        cachedHitCanvas.isCache = true;
		        cachedSceneCanvas.isCache = true;
		        this._cache.delete('canvas');
		        this._filterUpToDate = false;
		        if (conf.imageSmoothingEnabled === false) {
		            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
		            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
		        }
		        sceneContext.save();
		        hitContext.save();
		        sceneContext.translate(-x, -y);
		        hitContext.translate(-x, -y);
		        this._isUnderCache = true;
		        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
		        this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
		        this.drawScene(cachedSceneCanvas, this);
		        this.drawHit(cachedHitCanvas, this);
		        this._isUnderCache = false;
		        sceneContext.restore();
		        hitContext.restore();
		        if (drawBorder) {
		            sceneContext.save();
		            sceneContext.beginPath();
		            sceneContext.rect(0, 0, width, height);
		            sceneContext.closePath();
		            sceneContext.setAttr('strokeStyle', 'red');
		            sceneContext.setAttr('lineWidth', 5);
		            sceneContext.stroke();
		            sceneContext.restore();
		        }
		        this._cache.set(CANVAS, {
		            scene: cachedSceneCanvas,
		            filter: cachedFilterCanvas,
		            hit: cachedHitCanvas,
		            x: x,
		            y: y,
		        });
		        return this;
		    };
		    Node.prototype.isCached = function () {
		        return this._cache.has('canvas');
		    };
		    Node.prototype.getClientRect = function (config) {
		        throw new Error('abstract "getClientRect" method call');
		    };
		    Node.prototype._transformedRect = function (rect, top) {
		        var points = [
		            { x: rect.x, y: rect.y },
		            { x: rect.x + rect.width, y: rect.y },
		            { x: rect.x + rect.width, y: rect.y + rect.height },
		            { x: rect.x, y: rect.y + rect.height },
		        ];
		        var minX, minY, maxX, maxY;
		        var trans = this.getAbsoluteTransform(top);
		        points.forEach(function (point) {
		            var transformed = trans.point(point);
		            if (minX === undefined) {
		                minX = maxX = transformed.x;
		                minY = maxY = transformed.y;
		            }
		            minX = Math.min(minX, transformed.x);
		            minY = Math.min(minY, transformed.y);
		            maxX = Math.max(maxX, transformed.x);
		            maxY = Math.max(maxY, transformed.y);
		        });
		        return {
		            x: minX,
		            y: minY,
		            width: maxX - minX,
		            height: maxY - minY,
		        };
		    };
		    Node.prototype._drawCachedSceneCanvas = function (context) {
		        context.save();
		        context._applyOpacity(this);
		        context._applyGlobalCompositeOperation(this);
		        var canvasCache = this._getCanvasCache();
		        context.translate(canvasCache.x, canvasCache.y);
		        var cacheCanvas = this._getCachedSceneCanvas();
		        var ratio = cacheCanvas.pixelRatio;
		        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
		        context.restore();
		    };
		    Node.prototype._drawCachedHitCanvas = function (context) {
		        var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
		        context.save();
		        context.translate(canvasCache.x, canvasCache.y);
		        context.drawImage(hitCanvas._canvas, 0, 0);
		        context.restore();
		    };
		    Node.prototype._getCachedSceneCanvas = function () {
		        var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
		        if (filters) {
		            if (!this._filterUpToDate) {
		                var ratio = sceneCanvas.pixelRatio;
		                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
		                try {
		                    len = filters.length;
		                    filterContext.clear();
		                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
		                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
		                    for (n = 0; n < len; n++) {
		                        filter = filters[n];
		                        if (typeof filter !== 'function') {
		                            Util_1.Util.error('Filter should be type of function, but got ' +
		                                typeof filter +
		                                ' instead. Please check correct filters');
		                            continue;
		                        }
		                        filter.call(this, imageData);
		                        filterContext.putImageData(imageData, 0, 0);
		                    }
		                }
		                catch (e) {
		                    Util_1.Util.error('Unable to apply filter. ' +
		                        e.message +
		                        ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
		                }
		                this._filterUpToDate = true;
		            }
		            return filterCanvas;
		        }
		        return sceneCanvas;
		    };
		    Node.prototype.on = function (evtStr, handler) {
		        this._cache && this._cache.delete(ALL_LISTENERS);
		        if (arguments.length === 3) {
		            return this._delegate.apply(this, arguments);
		        }
		        var events = evtStr.split(SPACE), len = events.length, n, event, parts, baseEvent, name;
		        for (n = 0; n < len; n++) {
		            event = events[n];
		            parts = event.split('.');
		            baseEvent = parts[0];
		            name = parts[1] || '';
		            if (!this.eventListeners[baseEvent]) {
		                this.eventListeners[baseEvent] = [];
		            }
		            this.eventListeners[baseEvent].push({
		                name: name,
		                handler: handler,
		            });
		        }
		        return this;
		    };
		    Node.prototype.off = function (evtStr, callback) {
		        var events = (evtStr || '').split(SPACE), len = events.length, n, t, event, parts, baseEvent, name;
		        this._cache && this._cache.delete(ALL_LISTENERS);
		        if (!evtStr) {
		            for (t in this.eventListeners) {
		                this._off(t);
		            }
		        }
		        for (n = 0; n < len; n++) {
		            event = events[n];
		            parts = event.split('.');
		            baseEvent = parts[0];
		            name = parts[1];
		            if (baseEvent) {
		                if (this.eventListeners[baseEvent]) {
		                    this._off(baseEvent, name, callback);
		                }
		            }
		            else {
		                for (t in this.eventListeners) {
		                    this._off(t, name, callback);
		                }
		            }
		        }
		        return this;
		    };
		    Node.prototype.dispatchEvent = function (evt) {
		        var e = {
		            target: this,
		            type: evt.type,
		            evt: evt,
		        };
		        this.fire(evt.type, e);
		        return this;
		    };
		    Node.prototype.addEventListener = function (type, handler) {
		        this.on(type, function (evt) {
		            handler.call(this, evt.evt);
		        });
		        return this;
		    };
		    Node.prototype.removeEventListener = function (type) {
		        this.off(type);
		        return this;
		    };
		    Node.prototype._delegate = function (event, selector, handler) {
		        var stopNode = this;
		        this.on(event, function (evt) {
		            var targets = evt.target.findAncestors(selector, true, stopNode);
		            for (var i = 0; i < targets.length; i++) {
		                evt = Util_1.Util.cloneObject(evt);
		                evt.currentTarget = targets[i];
		                handler.call(targets[i], evt);
		            }
		        });
		    };
		    Node.prototype.remove = function () {
		        if (this.isDragging()) {
		            this.stopDrag();
		        }
		        DragAndDrop_1.DD._dragElements.delete(this._id);
		        this._remove();
		        return this;
		    };
		    Node.prototype._clearCaches = function () {
		        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
		        this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
		        this._clearSelfAndDescendantCache(STAGE);
		        this._clearSelfAndDescendantCache(VISIBLE);
		        this._clearSelfAndDescendantCache(LISTENING);
		    };
		    Node.prototype._remove = function () {
		        this._clearCaches();
		        var parent = this.getParent();
		        if (parent && parent.children) {
		            parent.children.splice(this.index, 1);
		            parent._setChildrenIndices();
		            this.parent = null;
		        }
		    };
		    Node.prototype.destroy = function () {
		        exports._removeId(this.id(), this);
		        var names = (this.name() || '').split(/\s/g);
		        for (var i = 0; i < names.length; i++) {
		            var subname = names[i];
		            exports._removeName(subname, this._id);
		        }
		        this.remove();
		        return this;
		    };
		    Node.prototype.getAttr = function (attr) {
		        var method = 'get' + Util_1.Util._capitalize(attr);
		        if (Util_1.Util._isFunction(this[method])) {
		            return this[method]();
		        }
		        return this.attrs[attr];
		    };
		    Node.prototype.getAncestors = function () {
		        var parent = this.getParent(), ancestors = new Util_1.Collection();
		        while (parent) {
		            ancestors.push(parent);
		            parent = parent.getParent();
		        }
		        return ancestors;
		    };
		    Node.prototype.getAttrs = function () {
		        return this.attrs || {};
		    };
		    Node.prototype.setAttrs = function (config) {
		        var _this = this;
		        this._batchTransformChanges(function () {
		            var key, method;
		            if (!config) {
		                return _this;
		            }
		            for (key in config) {
		                if (key === CHILDREN) {
		                    continue;
		                }
		                method = SET + Util_1.Util._capitalize(key);
		                if (Util_1.Util._isFunction(_this[method])) {
		                    _this[method](config[key]);
		                }
		                else {
		                    _this._setAttr(key, config[key]);
		                }
		            }
		        });
		        return this;
		    };
		    Node.prototype.isListening = function () {
		        return this._getCache(LISTENING, this._isListening);
		    };
		    Node.prototype._isListening = function (relativeTo) {
		        var listening = this.listening();
		        if (!listening) {
		            return false;
		        }
		        var parent = this.getParent();
		        if (parent && parent !== relativeTo && this !== relativeTo) {
		            return parent._isListening(relativeTo);
		        }
		        else {
		            return true;
		        }
		    };
		    Node.prototype.isVisible = function () {
		        return this._getCache(VISIBLE, this._isVisible);
		    };
		    Node.prototype._isVisible = function (relativeTo) {
		        var visible = this.visible();
		        if (!visible) {
		            return false;
		        }
		        var parent = this.getParent();
		        if (parent && parent !== relativeTo && this !== relativeTo) {
		            return parent._isVisible(relativeTo);
		        }
		        else {
		            return true;
		        }
		    };
		    Node.prototype.shouldDrawHit = function (top, skipDragCheck) {
		        if (skipDragCheck === void 0) { skipDragCheck = false; }
		        if (top) {
		            return this._isVisible(top) && this._isListening(top);
		        }
		        var layer = this.getLayer();
		        var layerUnderDrag = false;
		        DragAndDrop_1.DD._dragElements.forEach(function (elem) {
		            if (elem.dragStatus !== 'dragging') {
		                return;
		            }
		            else if (elem.node.nodeType === 'Stage') {
		                layerUnderDrag = true;
		            }
		            else if (elem.node.getLayer() === layer) {
		                layerUnderDrag = true;
		            }
		        });
		        var dragSkip = !skipDragCheck && !Global_1.Konva.hitOnDragEnabled && layerUnderDrag;
		        return this.isListening() && this.isVisible() && !dragSkip;
		    };
		    Node.prototype.show = function () {
		        this.visible(true);
		        return this;
		    };
		    Node.prototype.hide = function () {
		        this.visible(false);
		        return this;
		    };
		    Node.prototype.getZIndex = function () {
		        return this.index || 0;
		    };
		    Node.prototype.getAbsoluteZIndex = function () {
		        var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
		        function addChildren(children) {
		            nodes = [];
		            len = children.length;
		            for (n = 0; n < len; n++) {
		                child = children[n];
		                index++;
		                if (child.nodeType !== SHAPE) {
		                    nodes = nodes.concat(child.getChildren().toArray());
		                }
		                if (child._id === that._id) {
		                    n = len;
		                }
		            }
		            if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
		                addChildren(nodes);
		            }
		        }
		        if (that.nodeType !== UPPER_STAGE) {
		            addChildren(that.getStage().getChildren());
		        }
		        return index;
		    };
		    Node.prototype.getDepth = function () {
		        var depth = 0, parent = this.parent;
		        while (parent) {
		            depth++;
		            parent = parent.parent;
		        }
		        return depth;
		    };
		    Node.prototype._batchTransformChanges = function (func) {
		        this._batchingTransformChange = true;
		        func();
		        this._batchingTransformChange = false;
		        if (this._needClearTransformCache) {
		            this._clearCache(TRANSFORM);
		            this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM, true);
		        }
		        this._needClearTransformCache = false;
		    };
		    Node.prototype.setPosition = function (pos) {
		        var _this = this;
		        this._batchTransformChanges(function () {
		            _this.x(pos.x);
		            _this.y(pos.y);
		        });
		        return this;
		    };
		    Node.prototype.getPosition = function () {
		        return {
		            x: this.x(),
		            y: this.y(),
		        };
		    };
		    Node.prototype.getAbsolutePosition = function (top) {
		        var haveCachedParent = false;
		        var parent = this.parent;
		        while (parent) {
		            if (parent.isCached()) {
		                haveCachedParent = true;
		                break;
		            }
		            parent = parent.parent;
		        }
		        if (haveCachedParent && !top) {
		            top = true;
		        }
		        var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new Util_1.Transform(), offset = this.offset();
		        absoluteTransform.m = absoluteMatrix.slice();
		        absoluteTransform.translate(offset.x, offset.y);
		        return absoluteTransform.getTranslation();
		    };
		    Node.prototype.setAbsolutePosition = function (pos) {
		        var origTrans = this._clearTransform();
		        this.attrs.x = origTrans.x;
		        this.attrs.y = origTrans.y;
		        delete origTrans.x;
		        delete origTrans.y;
		        this._clearCache(TRANSFORM);
		        var it = this._getAbsoluteTransform().copy();
		        it.invert();
		        it.translate(pos.x, pos.y);
		        pos = {
		            x: this.attrs.x + it.getTranslation().x,
		            y: this.attrs.y + it.getTranslation().y,
		        };
		        this._setTransform(origTrans);
		        this.setPosition({ x: pos.x, y: pos.y });
		        this._clearCache(TRANSFORM);
		        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		        return this;
		    };
		    Node.prototype._setTransform = function (trans) {
		        var key;
		        for (key in trans) {
		            this.attrs[key] = trans[key];
		        }
		    };
		    Node.prototype._clearTransform = function () {
		        var trans = {
		            x: this.x(),
		            y: this.y(),
		            rotation: this.rotation(),
		            scaleX: this.scaleX(),
		            scaleY: this.scaleY(),
		            offsetX: this.offsetX(),
		            offsetY: this.offsetY(),
		            skewX: this.skewX(),
		            skewY: this.skewY(),
		        };
		        this.attrs.x = 0;
		        this.attrs.y = 0;
		        this.attrs.rotation = 0;
		        this.attrs.scaleX = 1;
		        this.attrs.scaleY = 1;
		        this.attrs.offsetX = 0;
		        this.attrs.offsetY = 0;
		        this.attrs.skewX = 0;
		        this.attrs.skewY = 0;
		        return trans;
		    };
		    Node.prototype.move = function (change) {
		        var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
		        if (changeX !== undefined) {
		            x += changeX;
		        }
		        if (changeY !== undefined) {
		            y += changeY;
		        }
		        this.setPosition({ x: x, y: y });
		        return this;
		    };
		    Node.prototype._eachAncestorReverse = function (func, top) {
		        var family = [], parent = this.getParent(), len, n;
		        if (top && top._id === this._id) {
		            return;
		        }
		        family.unshift(this);
		        while (parent && (!top || parent._id !== top._id)) {
		            family.unshift(parent);
		            parent = parent.parent;
		        }
		        len = family.length;
		        for (n = 0; n < len; n++) {
		            func(family[n]);
		        }
		    };
		    Node.prototype.rotate = function (theta) {
		        this.rotation(this.rotation() + theta);
		        return this;
		    };
		    Node.prototype.moveToTop = function () {
		        if (!this.parent) {
		            Util_1.Util.warn('Node has no parent. moveToTop function is ignored.');
		            return false;
		        }
		        var index = this.index;
		        this.parent.children.splice(index, 1);
		        this.parent.children.push(this);
		        this.parent._setChildrenIndices();
		        return true;
		    };
		    Node.prototype.moveUp = function () {
		        if (!this.parent) {
		            Util_1.Util.warn('Node has no parent. moveUp function is ignored.');
		            return false;
		        }
		        var index = this.index, len = this.parent.getChildren().length;
		        if (index < len - 1) {
		            this.parent.children.splice(index, 1);
		            this.parent.children.splice(index + 1, 0, this);
		            this.parent._setChildrenIndices();
		            return true;
		        }
		        return false;
		    };
		    Node.prototype.moveDown = function () {
		        if (!this.parent) {
		            Util_1.Util.warn('Node has no parent. moveDown function is ignored.');
		            return false;
		        }
		        var index = this.index;
		        if (index > 0) {
		            this.parent.children.splice(index, 1);
		            this.parent.children.splice(index - 1, 0, this);
		            this.parent._setChildrenIndices();
		            return true;
		        }
		        return false;
		    };
		    Node.prototype.moveToBottom = function () {
		        if (!this.parent) {
		            Util_1.Util.warn('Node has no parent. moveToBottom function is ignored.');
		            return false;
		        }
		        var index = this.index;
		        if (index > 0) {
		            this.parent.children.splice(index, 1);
		            this.parent.children.unshift(this);
		            this.parent._setChildrenIndices();
		            return true;
		        }
		        return false;
		    };
		    Node.prototype.setZIndex = function (zIndex) {
		        if (!this.parent) {
		            Util_1.Util.warn('Node has no parent. zIndex parameter is ignored.');
		            return this;
		        }
		        if (zIndex < 0 || zIndex >= this.parent.children.length) {
		            Util_1.Util.warn('Unexpected value ' +
		                zIndex +
		                ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' +
		                (this.parent.children.length - 1) +
		                '.');
		        }
		        var index = this.index;
		        this.parent.children.splice(index, 1);
		        this.parent.children.splice(zIndex, 0, this);
		        this.parent._setChildrenIndices();
		        return this;
		    };
		    Node.prototype.getAbsoluteOpacity = function () {
		        return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
		    };
		    Node.prototype._getAbsoluteOpacity = function () {
		        var absOpacity = this.opacity();
		        var parent = this.getParent();
		        if (parent && !parent._isUnderCache) {
		            absOpacity *= parent.getAbsoluteOpacity();
		        }
		        return absOpacity;
		    };
		    Node.prototype.moveTo = function (newContainer) {
		        if (this.getParent() !== newContainer) {
		            this._remove();
		            newContainer.add(this);
		        }
		        return this;
		    };
		    Node.prototype.toObject = function () {
		        var obj = {}, attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
		        obj.attrs = {};
		        for (key in attrs) {
		            val = attrs[key];
		            nonPlainObject =
		                Util_1.Util.isObject(val) && !Util_1.Util._isPlainObject(val) && !Util_1.Util._isArray(val);
		            if (nonPlainObject) {
		                continue;
		            }
		            getter = typeof this[key] === 'function' && this[key];
		            delete attrs[key];
		            defaultValue = getter ? getter.call(this) : null;
		            attrs[key] = val;
		            if (defaultValue !== val) {
		                obj.attrs[key] = val;
		            }
		        }
		        obj.className = this.getClassName();
		        return Util_1.Util._prepareToStringify(obj);
		    };
		    Node.prototype.toJSON = function () {
		        return JSON.stringify(this.toObject());
		    };
		    Node.prototype.getParent = function () {
		        return this.parent;
		    };
		    Node.prototype.findAncestors = function (selector, includeSelf, stopNode) {
		        var res = [];
		        if (includeSelf && this._isMatch(selector)) {
		            res.push(this);
		        }
		        var ancestor = this.parent;
		        while (ancestor) {
		            if (ancestor === stopNode) {
		                return res;
		            }
		            if (ancestor._isMatch(selector)) {
		                res.push(ancestor);
		            }
		            ancestor = ancestor.parent;
		        }
		        return res;
		    };
		    Node.prototype.isAncestorOf = function (node) {
		        return false;
		    };
		    Node.prototype.findAncestor = function (selector, includeSelf, stopNode) {
		        return this.findAncestors(selector, includeSelf, stopNode)[0];
		    };
		    Node.prototype._isMatch = function (selector) {
		        if (!selector) {
		            return false;
		        }
		        if (typeof selector === 'function') {
		            return selector(this);
		        }
		        var selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
		        for (n = 0; n < len; n++) {
		            sel = selectorArr[n];
		            if (!Util_1.Util.isValidSelector(sel)) {
		                Util_1.Util.warn('Selector "' +
		                    sel +
		                    '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
		                Util_1.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
		                Util_1.Util.warn('Konva is awesome, right?');
		            }
		            if (sel.charAt(0) === '#') {
		                if (this.id() === sel.slice(1)) {
		                    return true;
		                }
		            }
		            else if (sel.charAt(0) === '.') {
		                if (this.hasName(sel.slice(1))) {
		                    return true;
		                }
		            }
		            else if (this.className === sel || this.nodeType === sel) {
		                return true;
		            }
		        }
		        return false;
		    };
		    Node.prototype.getLayer = function () {
		        var parent = this.getParent();
		        return parent ? parent.getLayer() : null;
		    };
		    Node.prototype.getStage = function () {
		        return this._getCache(STAGE, this._getStage);
		    };
		    Node.prototype._getStage = function () {
		        var parent = this.getParent();
		        if (parent) {
		            return parent.getStage();
		        }
		        else {
		            return undefined;
		        }
		    };
		    Node.prototype.fire = function (eventType, evt, bubble) {
		        if (evt === void 0) { evt = {}; }
		        evt.target = evt.target || this;
		        if (bubble) {
		            this._fireAndBubble(eventType, evt);
		        }
		        else {
		            this._fire(eventType, evt);
		        }
		        return this;
		    };
		    Node.prototype.getAbsoluteTransform = function (top) {
		        if (top) {
		            return this._getAbsoluteTransform(top);
		        }
		        else {
		            return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
		        }
		    };
		    Node.prototype._getAbsoluteTransform = function (top) {
		        var at;
		        if (top) {
		            at = new Util_1.Transform();
		            this._eachAncestorReverse(function (node) {
		                var transformsEnabled = node.transformsEnabled();
		                if (transformsEnabled === 'all') {
		                    at.multiply(node.getTransform());
		                }
		                else if (transformsEnabled === 'position') {
		                    at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
		                }
		            }, top);
		            return at;
		        }
		        else {
		            at = this._cache.get(ABSOLUTE_TRANSFORM) || new Util_1.Transform();
		            if (this.parent) {
		                this.parent.getAbsoluteTransform().copyInto(at);
		            }
		            else {
		                at.reset();
		            }
		            var transformsEnabled = this.transformsEnabled();
		            if (transformsEnabled === 'all') {
		                at.multiply(this.getTransform());
		            }
		            else if (transformsEnabled === 'position') {
		                var x = this.attrs.x || 0;
		                var y = this.attrs.y || 0;
		                var offsetX = this.attrs.offsetX || 0;
		                var offsetY = this.attrs.offsetY || 0;
		                at.translate(x - offsetX, y - offsetY);
		            }
		            at.dirty = false;
		            return at;
		        }
		    };
		    Node.prototype.getAbsoluteScale = function (top) {
		        var parent = this;
		        while (parent) {
		            if (parent._isUnderCache) {
		                top = parent;
		            }
		            parent = parent.getParent();
		        }
		        var transform = this.getAbsoluteTransform(top);
		        var attrs = transform.decompose();
		        return {
		            x: attrs.scaleX,
		            y: attrs.scaleY,
		        };
		    };
		    Node.prototype.getAbsoluteRotation = function () {
		        return this.getAbsoluteTransform().decompose().rotation;
		    };
		    Node.prototype.getTransform = function () {
		        return this._getCache(TRANSFORM, this._getTransform);
		    };
		    Node.prototype._getTransform = function () {
		        var _a, _b;
		        var m = this._cache.get(TRANSFORM) || new Util_1.Transform();
		        m.reset();
		        var x = this.x(), y = this.y(), rotation = Global_1.Konva.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
		        if (x !== 0 || y !== 0) {
		            m.translate(x, y);
		        }
		        if (rotation !== 0) {
		            m.rotate(rotation);
		        }
		        if (skewX !== 0 || skewY !== 0) {
		            m.skew(skewX, skewY);
		        }
		        if (scaleX !== 1 || scaleY !== 1) {
		            m.scale(scaleX, scaleY);
		        }
		        if (offsetX !== 0 || offsetY !== 0) {
		            m.translate(-1 * offsetX, -1 * offsetY);
		        }
		        m.dirty = false;
		        return m;
		    };
		    Node.prototype.clone = function (obj) {
		        var attrs = Util_1.Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
		        for (key in obj) {
		            attrs[key] = obj[key];
		        }
		        var node = new this.constructor(attrs);
		        for (key in this.eventListeners) {
		            allListeners = this.eventListeners[key];
		            len = allListeners.length;
		            for (n = 0; n < len; n++) {
		                listener = allListeners[n];
		                if (listener.name.indexOf(KONVA) < 0) {
		                    if (!node.eventListeners[key]) {
		                        node.eventListeners[key] = [];
		                    }
		                    node.eventListeners[key].push(listener);
		                }
		            }
		        }
		        return node;
		    };
		    Node.prototype._toKonvaCanvas = function (config) {
		        config = config || {};
		        var box = this.getClientRect();
		        var stage = this.getStage(), x = config.x !== undefined ? config.x : box.x, y = config.y !== undefined ? config.y : box.y, pixelRatio = config.pixelRatio || 1, canvas = new Canvas_1.SceneCanvas({
		            width: config.width || box.width || (stage ? stage.width() : 0),
		            height: config.height || box.height || (stage ? stage.height() : 0),
		            pixelRatio: pixelRatio,
		        }), context = canvas.getContext();
		        context.save();
		        if (x || y) {
		            context.translate(-1 * x, -1 * y);
		        }
		        this.drawScene(canvas);
		        context.restore();
		        return canvas;
		    };
		    Node.prototype.toCanvas = function (config) {
		        return this._toKonvaCanvas(config)._canvas;
		    };
		    Node.prototype.toDataURL = function (config) {
		        config = config || {};
		        var mimeType = config.mimeType || null, quality = config.quality || null;
		        var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
		        if (config.callback) {
		            config.callback(url);
		        }
		        return url;
		    };
		    Node.prototype.toImage = function (config) {
		        if (!config || !config.callback) {
		            throw 'callback required for toImage method config argument';
		        }
		        var callback = config.callback;
		        delete config.callback;
		        Util_1.Util._urlToImage(this.toDataURL(config), function (img) {
		            callback(img);
		        });
		    };
		    Node.prototype.setSize = function (size) {
		        this.width(size.width);
		        this.height(size.height);
		        return this;
		    };
		    Node.prototype.getSize = function () {
		        return {
		            width: this.width(),
		            height: this.height(),
		        };
		    };
		    Node.prototype.getClassName = function () {
		        return this.className || this.nodeType;
		    };
		    Node.prototype.getType = function () {
		        return this.nodeType;
		    };
		    Node.prototype.getDragDistance = function () {
		        if (this.attrs.dragDistance !== undefined) {
		            return this.attrs.dragDistance;
		        }
		        else if (this.parent) {
		            return this.parent.getDragDistance();
		        }
		        else {
		            return Global_1.Konva.dragDistance;
		        }
		    };
		    Node.prototype._off = function (type, name, callback) {
		        var evtListeners = this.eventListeners[type], i, evtName, handler;
		        for (i = 0; i < evtListeners.length; i++) {
		            evtName = evtListeners[i].name;
		            handler = evtListeners[i].handler;
		            if ((evtName !== 'konva' || name === 'konva') &&
		                (!name || evtName === name) &&
		                (!callback || callback === handler)) {
		                evtListeners.splice(i, 1);
		                if (evtListeners.length === 0) {
		                    delete this.eventListeners[type];
		                    break;
		                }
		                i--;
		            }
		        }
		    };
		    Node.prototype._fireChangeEvent = function (attr, oldVal, newVal) {
		        this._fire(attr + CHANGE, {
		            oldVal: oldVal,
		            newVal: newVal,
		        });
		    };
		    Node.prototype.setId = function (id) {
		        var oldId = this.id();
		        exports._removeId(oldId, this);
		        _addId(this, id);
		        this._setAttr('id', id);
		        return this;
		    };
		    Node.prototype.setName = function (name) {
		        var oldNames = (this.name() || '').split(/\s/g);
		        var newNames = (name || '').split(/\s/g);
		        var subname, i;
		        for (i = 0; i < oldNames.length; i++) {
		            subname = oldNames[i];
		            if (newNames.indexOf(subname) === -1 && subname) {
		                exports._removeName(subname, this._id);
		            }
		        }
		        for (i = 0; i < newNames.length; i++) {
		            subname = newNames[i];
		            if (oldNames.indexOf(subname) === -1 && subname) {
		                exports._addName(this, subname);
		            }
		        }
		        this._setAttr(NAME, name);
		        return this;
		    };
		    Node.prototype.addName = function (name) {
		        if (!this.hasName(name)) {
		            var oldName = this.name();
		            var newName = oldName ? oldName + ' ' + name : name;
		            this.setName(newName);
		        }
		        return this;
		    };
		    Node.prototype.hasName = function (name) {
		        if (!name) {
		            return false;
		        }
		        var fullName = this.name();
		        if (!fullName) {
		            return false;
		        }
		        var names = (fullName || '').split(/\s/g);
		        return names.indexOf(name) !== -1;
		    };
		    Node.prototype.removeName = function (name) {
		        var names = (this.name() || '').split(/\s/g);
		        var index = names.indexOf(name);
		        if (index !== -1) {
		            names.splice(index, 1);
		            this.setName(names.join(' '));
		        }
		        return this;
		    };
		    Node.prototype.setAttr = function (attr, val) {
		        var func = this[SET + Util_1.Util._capitalize(attr)];
		        if (Util_1.Util._isFunction(func)) {
		            func.call(this, val);
		        }
		        else {
		            this._setAttr(attr, val);
		        }
		        return this;
		    };
		    Node.prototype._setAttr = function (key, val, skipFire) {
		        var oldVal = this.attrs[key];
		        if (oldVal === val && !Util_1.Util.isObject(val)) {
		            return;
		        }
		        if (val === undefined || val === null) {
		            delete this.attrs[key];
		        }
		        else {
		            this.attrs[key] = val;
		        }
		        if (this._shouldFireChangeEvents) {
		            this._fireChangeEvent(key, oldVal, val);
		        }
		    };
		    Node.prototype._setComponentAttr = function (key, component, val) {
		        var oldVal;
		        if (val !== undefined) {
		            oldVal = this.attrs[key];
		            if (!oldVal) {
		                this.attrs[key] = this.getAttr(key);
		            }
		            this.attrs[key][component] = val;
		            this._fireChangeEvent(key, oldVal, val);
		        }
		    };
		    Node.prototype._fireAndBubble = function (eventType, evt, compareShape) {
		        if (evt && this.nodeType === SHAPE) {
		            evt.target = this;
		        }
		        var shouldStop = (eventType === MOUSEENTER || eventType === MOUSELEAVE) &&
		            ((compareShape &&
		                (this === compareShape ||
		                    (this.isAncestorOf && this.isAncestorOf(compareShape)))) ||
		                (this.nodeType === 'Stage' && !compareShape));
		        if (!shouldStop) {
		            this._fire(eventType, evt);
		            var stopBubble = (eventType === MOUSEENTER || eventType === MOUSELEAVE) &&
		                compareShape &&
		                compareShape.isAncestorOf &&
		                compareShape.isAncestorOf(this) &&
		                !compareShape.isAncestorOf(this.parent);
		            if (((evt && !evt.cancelBubble) || !evt) &&
		                this.parent &&
		                this.parent.isListening() &&
		                !stopBubble) {
		                if (compareShape && compareShape.parent) {
		                    this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
		                }
		                else {
		                    this._fireAndBubble.call(this.parent, eventType, evt);
		                }
		            }
		        }
		    };
		    Node.prototype._getProtoListeners = function (eventType) {
		        var listeners = this._cache.get(ALL_LISTENERS);
		        if (!listeners) {
		            listeners = {};
		            var obj = Object.getPrototypeOf(this);
		            while (obj) {
		                if (!obj.eventListeners) {
		                    obj = Object.getPrototypeOf(obj);
		                    continue;
		                }
		                for (var event in obj.eventListeners) {
		                    var newEvents = obj.eventListeners[event];
		                    var oldEvents = listeners[event] || [];
		                    listeners[event] = newEvents.concat(oldEvents);
		                }
		                obj = Object.getPrototypeOf(obj);
		            }
		            this._cache.set(ALL_LISTENERS, listeners);
		        }
		        return listeners[eventType];
		    };
		    Node.prototype._fire = function (eventType, evt) {
		        evt = evt || {};
		        evt.currentTarget = this;
		        evt.type = eventType;
		        var topListeners = this._getProtoListeners(eventType);
		        if (topListeners) {
		            for (var i = 0; i < topListeners.length; i++) {
		                topListeners[i].handler.call(this, evt);
		            }
		        }
		        var selfListeners = this.eventListeners[eventType];
		        if (selfListeners) {
		            for (var i = 0; i < selfListeners.length; i++) {
		                selfListeners[i].handler.call(this, evt);
		            }
		        }
		    };
		    Node.prototype.draw = function () {
		        this.drawScene();
		        this.drawHit();
		        return this;
		    };
		    Node.prototype._createDragElement = function (evt) {
		        var pointerId = evt ? evt.pointerId : undefined;
		        var stage = this.getStage();
		        var ap = this.getAbsolutePosition();
		        var pos = stage._getPointerById(pointerId) ||
		            stage._changedPointerPositions[0] ||
		            ap;
		        DragAndDrop_1.DD._dragElements.set(this._id, {
		            node: this,
		            startPointerPos: pos,
		            offset: {
		                x: pos.x - ap.x,
		                y: pos.y - ap.y,
		            },
		            dragStatus: 'ready',
		            pointerId: pointerId,
		        });
		    };
		    Node.prototype.startDrag = function (evt, bubbleEvent) {
		        if (bubbleEvent === void 0) { bubbleEvent = true; }
		        if (!DragAndDrop_1.DD._dragElements.has(this._id)) {
		            this._createDragElement(evt);
		        }
		        var elem = DragAndDrop_1.DD._dragElements.get(this._id);
		        elem.dragStatus = 'dragging';
		        this.fire('dragstart', {
		            type: 'dragstart',
		            target: this,
		            evt: evt && evt.evt,
		        }, bubbleEvent);
		    };
		    Node.prototype._setDragPosition = function (evt, elem) {
		        var pos = this.getStage()._getPointerById(elem.pointerId);
		        if (!pos) {
		            return;
		        }
		        var newNodePos = {
		            x: pos.x - elem.offset.x,
		            y: pos.y - elem.offset.y,
		        };
		        var dbf = this.dragBoundFunc();
		        if (dbf !== undefined) {
		            var bounded = dbf.call(this, newNodePos, evt);
		            if (!bounded) {
		                Util_1.Util.warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
		            }
		            else {
		                newNodePos = bounded;
		            }
		        }
		        if (!this._lastPos ||
		            this._lastPos.x !== newNodePos.x ||
		            this._lastPos.y !== newNodePos.y) {
		            this.setAbsolutePosition(newNodePos);
		            if (this.getLayer()) {
		                this.getLayer().batchDraw();
		            }
		            else if (this.getStage()) {
		                this.getStage().batchDraw();
		            }
		        }
		        this._lastPos = newNodePos;
		    };
		    Node.prototype.stopDrag = function (evt) {
		        var elem = DragAndDrop_1.DD._dragElements.get(this._id);
		        if (elem) {
		            elem.dragStatus = 'stopped';
		        }
		        DragAndDrop_1.DD._endDragBefore(evt);
		        DragAndDrop_1.DD._endDragAfter(evt);
		    };
		    Node.prototype.setDraggable = function (draggable) {
		        this._setAttr('draggable', draggable);
		        this._dragChange();
		    };
		    Node.prototype.isDragging = function () {
		        var elem = DragAndDrop_1.DD._dragElements.get(this._id);
		        return elem ? elem.dragStatus === 'dragging' : false;
		    };
		    Node.prototype._listenDrag = function () {
		        this._dragCleanup();
		        this.on('mousedown.konva touchstart.konva', function (evt) {
		            var _this = this;
		            var shouldCheckButton = evt.evt['button'] !== undefined;
		            var canDrag = !shouldCheckButton || Global_1.Konva.dragButtons.indexOf(evt.evt['button']) >= 0;
		            if (!canDrag) {
		                return;
		            }
		            if (this.isDragging()) {
		                return;
		            }
		            var hasDraggingChild = false;
		            DragAndDrop_1.DD._dragElements.forEach(function (elem) {
		                if (_this.isAncestorOf(elem.node)) {
		                    hasDraggingChild = true;
		                }
		            });
		            if (!hasDraggingChild) {
		                this._createDragElement(evt);
		            }
		        });
		    };
		    Node.prototype._dragChange = function () {
		        if (this.attrs.draggable) {
		            this._listenDrag();
		        }
		        else {
		            this._dragCleanup();
		            var stage = this.getStage();
		            if (!stage) {
		                return;
		            }
		            var dragElement = DragAndDrop_1.DD._dragElements.get(this._id);
		            var isDragging = dragElement && dragElement.dragStatus === 'dragging';
		            var isReady = dragElement && dragElement.dragStatus === 'ready';
		            if (isDragging) {
		                this.stopDrag();
		            }
		            else if (isReady) {
		                DragAndDrop_1.DD._dragElements.delete(this._id);
		            }
		        }
		    };
		    Node.prototype._dragCleanup = function () {
		        this.off('mousedown.konva');
		        this.off('touchstart.konva');
		    };
		    Node.create = function (data, container) {
		        if (Util_1.Util._isString(data)) {
		            data = JSON.parse(data);
		        }
		        return this._createNode(data, container);
		    };
		    Node._createNode = function (obj, container) {
		        var className = Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
		        if (container) {
		            obj.attrs.container = container;
		        }
		        if (!Global_1._NODES_REGISTRY[className]) {
		            Util_1.Util.warn('Can not find a node with class name "' +
		                className +
		                '". Fallback to "Shape".');
		            className = 'Shape';
		        }
		        var Class = Global_1._NODES_REGISTRY[className];
		        no = new Class(obj.attrs);
		        if (children) {
		            len = children.length;
		            for (n = 0; n < len; n++) {
		                no.add(Node._createNode(children[n]));
		            }
		        }
		        return no;
		    };
		    return Node;
		}());
		exports.Node = Node;
		Node.prototype.nodeType = 'Node';
		Node.prototype._attrsAffectingSize = [];
		Node.prototype.eventListeners = {};
		Node.prototype.on.call(Node.prototype, TRANSFORM_CHANGE_STR, function () {
		    if (this._batchingTransformChange) {
		        this._needClearTransformCache = true;
		        return;
		    }
		    this._clearCache(TRANSFORM);
		    this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		});
		Node.prototype.on.call(Node.prototype, 'visibleChange.konva', function () {
		    this._clearSelfAndDescendantCache(VISIBLE);
		});
		Node.prototype.on.call(Node.prototype, 'listeningChange.konva', function () {
		    this._clearSelfAndDescendantCache(LISTENING);
		});
		Node.prototype.on.call(Node.prototype, 'opacityChange.konva', function () {
		    this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
		});
		var addGetterSetter = Factory_1.Factory.addGetterSetter;
		addGetterSetter(Node, 'zIndex');
		addGetterSetter(Node, 'absolutePosition');
		addGetterSetter(Node, 'position');
		addGetterSetter(Node, 'x', 0, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'y', 0, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'globalCompositeOperation', 'source-over', Validators_1.getStringValidator());
		addGetterSetter(Node, 'opacity', 1, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'name', '', Validators_1.getStringValidator());
		addGetterSetter(Node, 'id', '', Validators_1.getStringValidator());
		addGetterSetter(Node, 'rotation', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addComponentsGetterSetter(Node, 'scale', ['x', 'y']);
		addGetterSetter(Node, 'scaleX', 1, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'scaleY', 1, Validators_1.getNumberValidator());
		Factory_1.Factory.addComponentsGetterSetter(Node, 'skew', ['x', 'y']);
		addGetterSetter(Node, 'skewX', 0, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'skewY', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addComponentsGetterSetter(Node, 'offset', ['x', 'y']);
		addGetterSetter(Node, 'offsetX', 0, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'offsetY', 0, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'dragDistance', null, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'width', 0, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'height', 0, Validators_1.getNumberValidator());
		addGetterSetter(Node, 'listening', true, Validators_1.getBooleanValidator());
		addGetterSetter(Node, 'preventDefault', true, Validators_1.getBooleanValidator());
		addGetterSetter(Node, 'filters', null, function (val) {
		    this._filterUpToDate = false;
		    return val;
		});
		addGetterSetter(Node, 'visible', true, Validators_1.getBooleanValidator());
		addGetterSetter(Node, 'transformsEnabled', 'all', Validators_1.getStringValidator());
		addGetterSetter(Node, 'size');
		addGetterSetter(Node, 'dragBoundFunc');
		addGetterSetter(Node, 'draggable', false, Validators_1.getBooleanValidator());
		Factory_1.Factory.backCompat(Node, {
		    rotateDeg: 'rotate',
		    setRotationDeg: 'setRotation',
		    getRotationDeg: 'getRotation',
		});
		Util_1.Collection.mapMethods(Node); 
	} (Node));
	return Node;
}

var Container = {};

var hasRequiredContainer;

function requireContainer () {
	if (hasRequiredContainer) return Container;
	hasRequiredContainer = 1;
	var __extends = (Container && Container.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Container, "__esModule", { value: true });
	Container.Container = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var Container$1 = (function (_super) {
	    __extends(Container, _super);
	    function Container() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.children = new Util_1.Collection();
	        return _this;
	    }
	    Container.prototype.getChildren = function (filterFunc) {
	        if (!filterFunc) {
	            return this.children;
	        }
	        var results = new Util_1.Collection();
	        this.children.each(function (child) {
	            if (filterFunc(child)) {
	                results.push(child);
	            }
	        });
	        return results;
	    };
	    Container.prototype.hasChildren = function () {
	        return this.getChildren().length > 0;
	    };
	    Container.prototype.removeChildren = function () {
	        var child;
	        for (var i = 0; i < this.children.length; i++) {
	            child = this.children[i];
	            child.parent = null;
	            child.index = 0;
	            child.remove();
	        }
	        this.children = new Util_1.Collection();
	        return this;
	    };
	    Container.prototype.destroyChildren = function () {
	        var child;
	        for (var i = 0; i < this.children.length; i++) {
	            child = this.children[i];
	            child.parent = null;
	            child.index = 0;
	            child.destroy();
	        }
	        this.children = new Util_1.Collection();
	        return this;
	    };
	    Container.prototype.add = function () {
	        var children = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            children[_i] = arguments[_i];
	        }
	        if (arguments.length > 1) {
	            for (var i = 0; i < arguments.length; i++) {
	                this.add(arguments[i]);
	            }
	            return this;
	        }
	        var child = children[0];
	        if (child.getParent()) {
	            child.moveTo(this);
	            return this;
	        }
	        var _children = this.children;
	        this._validateAdd(child);
	        child._clearCaches();
	        child.index = _children.length;
	        child.parent = this;
	        _children.push(child);
	        this._fire('add', {
	            child: child,
	        });
	        return this;
	    };
	    Container.prototype.destroy = function () {
	        if (this.hasChildren()) {
	            this.destroyChildren();
	        }
	        _super.prototype.destroy.call(this);
	        return this;
	    };
	    Container.prototype.find = function (selector) {
	        return this._generalFind(selector, false);
	    };
	    Container.prototype.get = function (selector) {
	        Util_1.Util.warn('collection.get() method is deprecated. Please use collection.find() instead.');
	        return this.find(selector);
	    };
	    Container.prototype.findOne = function (selector) {
	        var result = this._generalFind(selector, true);
	        return result.length > 0 ? result[0] : undefined;
	    };
	    Container.prototype._generalFind = function (selector, findOne) {
	        var retArr = [];
	        this._descendants(function (node) {
	            var valid = node._isMatch(selector);
	            if (valid) {
	                retArr.push(node);
	            }
	            if (valid && findOne) {
	                return true;
	            }
	            return false;
	        });
	        return Util_1.Collection.toCollection(retArr);
	    };
	    Container.prototype._descendants = function (fn) {
	        var shouldStop = false;
	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	            shouldStop = fn(child);
	            if (shouldStop) {
	                return true;
	            }
	            if (!child.hasChildren()) {
	                continue;
	            }
	            shouldStop = child._descendants(fn);
	            if (shouldStop) {
	                return true;
	            }
	        }
	        return false;
	    };
	    Container.prototype.toObject = function () {
	        var obj = Node_1.Node.prototype.toObject.call(this);
	        obj.children = [];
	        var children = this.getChildren();
	        var len = children.length;
	        for (var n = 0; n < len; n++) {
	            var child = children[n];
	            obj.children.push(child.toObject());
	        }
	        return obj;
	    };
	    Container.prototype.isAncestorOf = function (node) {
	        var parent = node.getParent();
	        while (parent) {
	            if (parent._id === this._id) {
	                return true;
	            }
	            parent = parent.getParent();
	        }
	        return false;
	    };
	    Container.prototype.clone = function (obj) {
	        var node = Node_1.Node.prototype.clone.call(this, obj);
	        this.getChildren().each(function (no) {
	            node.add(no.clone());
	        });
	        return node;
	    };
	    Container.prototype.getAllIntersections = function (pos) {
	        var arr = [];
	        this.find('Shape').each(function (shape) {
	            if (shape.isVisible() && shape.intersects(pos)) {
	                arr.push(shape);
	            }
	        });
	        return arr;
	    };
	    Container.prototype._setChildrenIndices = function () {
	        this.children.each(function (child, n) {
	            child.index = n;
	        });
	    };
	    Container.prototype.drawScene = function (can, top) {
	        var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas()), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
	        var caching = canvas && canvas.isCache;
	        if (!this.isVisible() && !caching) {
	            return this;
	        }
	        if (cachedSceneCanvas) {
	            context.save();
	            var m = this.getAbsoluteTransform(top).getMatrix();
	            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	            this._drawCachedSceneCanvas(context);
	            context.restore();
	        }
	        else {
	            this._drawChildren('drawScene', canvas, top);
	        }
	        return this;
	    };
	    Container.prototype.drawHit = function (can, top) {
	        if (!this.shouldDrawHit(top)) {
	            return this;
	        }
	        var layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
	        if (cachedHitCanvas) {
	            context.save();
	            var m = this.getAbsoluteTransform(top).getMatrix();
	            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	            this._drawCachedHitCanvas(context);
	            context.restore();
	        }
	        else {
	            this._drawChildren('drawHit', canvas, top);
	        }
	        return this;
	    };
	    Container.prototype._drawChildren = function (drawMethod, canvas, top) {
	        var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = (clipWidth && clipHeight) || clipFunc;
	        var selfCache = top === this;
	        if (hasClip) {
	            context.save();
	            var transform = this.getAbsoluteTransform(top);
	            var m = transform.getMatrix();
	            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	            context.beginPath();
	            if (clipFunc) {
	                clipFunc.call(this, context, this);
	            }
	            else {
	                var clipX = this.clipX();
	                var clipY = this.clipY();
	                context.rect(clipX, clipY, clipWidth, clipHeight);
	            }
	            context.clip();
	            m = transform.copy().invert().getMatrix();
	            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	        }
	        var hasComposition = !selfCache &&
	            this.globalCompositeOperation() !== 'source-over' &&
	            drawMethod === 'drawScene';
	        if (hasComposition) {
	            context.save();
	            context._applyGlobalCompositeOperation(this);
	        }
	        this.children.each(function (child) {
	            child[drawMethod](canvas, top);
	        });
	        if (hasComposition) {
	            context.restore();
	        }
	        if (hasClip) {
	            context.restore();
	        }
	    };
	    Container.prototype.getClientRect = function (config) {
	        config = config || {};
	        var skipTransform = config.skipTransform;
	        var relativeTo = config.relativeTo;
	        var minX, minY, maxX, maxY;
	        var selfRect = {
	            x: Infinity,
	            y: Infinity,
	            width: 0,
	            height: 0,
	        };
	        var that = this;
	        this.children.each(function (child) {
	            if (!child.visible()) {
	                return;
	            }
	            var rect = child.getClientRect({
	                relativeTo: that,
	                skipShadow: config.skipShadow,
	                skipStroke: config.skipStroke,
	            });
	            if (rect.width === 0 && rect.height === 0) {
	                return;
	            }
	            if (minX === undefined) {
	                minX = rect.x;
	                minY = rect.y;
	                maxX = rect.x + rect.width;
	                maxY = rect.y + rect.height;
	            }
	            else {
	                minX = Math.min(minX, rect.x);
	                minY = Math.min(minY, rect.y);
	                maxX = Math.max(maxX, rect.x + rect.width);
	                maxY = Math.max(maxY, rect.y + rect.height);
	            }
	        });
	        var shapes = this.find('Shape');
	        var hasVisible = false;
	        for (var i = 0; i < shapes.length; i++) {
	            var shape = shapes[i];
	            if (shape._isVisible(this)) {
	                hasVisible = true;
	                break;
	            }
	        }
	        if (hasVisible && minX !== undefined) {
	            selfRect = {
	                x: minX,
	                y: minY,
	                width: maxX - minX,
	                height: maxY - minY,
	            };
	        }
	        else {
	            selfRect = {
	                x: 0,
	                y: 0,
	                width: 0,
	                height: 0,
	            };
	        }
	        if (!skipTransform) {
	            return this._transformedRect(selfRect, relativeTo);
	        }
	        return selfRect;
	    };
	    return Container;
	}(Node_1.Node));
	Container.Container = Container$1;
	Factory_1.Factory.addComponentsGetterSetter(Container$1, 'clip', [
	    'x',
	    'y',
	    'width',
	    'height',
	]);
	Factory_1.Factory.addGetterSetter(Container$1, 'clipX', undefined, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Container$1, 'clipY', undefined, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Container$1, 'clipWidth', undefined, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Container$1, 'clipHeight', undefined, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Container$1, 'clipFunc');
	Util_1.Collection.mapMethods(Container$1);
	return Container;
}

var Stage = {};

var PointerEvents = {};

var hasRequiredPointerEvents;

function requirePointerEvents () {
	if (hasRequiredPointerEvents) return PointerEvents;
	hasRequiredPointerEvents = 1;
	Object.defineProperty(PointerEvents, "__esModule", { value: true });
	PointerEvents.releaseCapture = PointerEvents.setPointerCapture = PointerEvents.hasPointerCapture = PointerEvents.createEvent = PointerEvents.getCapturedShape = void 0;
	var Global_1 = requireGlobal();
	var Captures = new Map();
	var SUPPORT_POINTER_EVENTS = Global_1.Konva._global['PointerEvent'] !== undefined;
	function getCapturedShape(pointerId) {
	    return Captures.get(pointerId);
	}
	PointerEvents.getCapturedShape = getCapturedShape;
	function createEvent(evt) {
	    return {
	        evt: evt,
	        pointerId: evt.pointerId
	    };
	}
	PointerEvents.createEvent = createEvent;
	function hasPointerCapture(pointerId, shape) {
	    return Captures.get(pointerId) === shape;
	}
	PointerEvents.hasPointerCapture = hasPointerCapture;
	function setPointerCapture(pointerId, shape) {
	    releaseCapture(pointerId);
	    var stage = shape.getStage();
	    if (!stage)
	        return;
	    Captures.set(pointerId, shape);
	    if (SUPPORT_POINTER_EVENTS) {
	        shape._fire('gotpointercapture', createEvent(new PointerEvent('gotpointercapture')));
	    }
	}
	PointerEvents.setPointerCapture = setPointerCapture;
	function releaseCapture(pointerId, target) {
	    var shape = Captures.get(pointerId);
	    if (!shape)
	        return;
	    var stage = shape.getStage();
	    if (stage && stage.content) ;
	    Captures.delete(pointerId);
	    if (SUPPORT_POINTER_EVENTS) {
	        shape._fire('lostpointercapture', createEvent(new PointerEvent('lostpointercapture')));
	    }
	}
	PointerEvents.releaseCapture = releaseCapture;
	return PointerEvents;
}

var hasRequiredStage;

function requireStage () {
	if (hasRequiredStage) return Stage;
	hasRequiredStage = 1;
	(function (exports) {
		var __extends = (Stage && Stage.__extends) || (function () {
		    var extendStatics = function (d, b) {
		        extendStatics = Object.setPrototypeOf ||
		            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
		            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
		        return extendStatics(d, b);
		    };
		    return function (d, b) {
		        extendStatics(d, b);
		        function __() { this.constructor = d; }
		        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		    };
		})();
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Stage = exports.stages = void 0;
		var Util_1 = requireUtil();
		var Factory_1 = requireFactory();
		var Container_1 = requireContainer();
		var Global_1 = requireGlobal();
		var Canvas_1 = requireCanvas();
		var DragAndDrop_1 = requireDragAndDrop();
		var Global_2 = requireGlobal();
		var PointerEvents = requirePointerEvents();
		var STAGE = 'Stage', STRING = 'string', PX = 'px', MOUSEOUT = 'mouseout', MOUSELEAVE = 'mouseleave', MOUSEOVER = 'mouseover', MOUSEENTER = 'mouseenter', MOUSEMOVE = 'mousemove', MOUSEDOWN = 'mousedown', MOUSEUP = 'mouseup', POINTERMOVE = 'pointermove', POINTERDOWN = 'pointerdown', POINTERUP = 'pointerup', POINTERCANCEL = 'pointercancel', LOSTPOINTERCAPTURE = 'lostpointercapture', CONTEXTMENU = 'contextmenu', CLICK = 'click', DBL_CLICK = 'dblclick', TOUCHSTART = 'touchstart', TOUCHEND = 'touchend', TAP = 'tap', DBL_TAP = 'dbltap', TOUCHMOVE = 'touchmove', WHEEL = 'wheel', CONTENT_MOUSEOUT = 'contentMouseout', CONTENT_MOUSEOVER = 'contentMouseover', CONTENT_MOUSEMOVE = 'contentMousemove', CONTENT_MOUSEDOWN = 'contentMousedown', CONTENT_MOUSEUP = 'contentMouseup', CONTENT_CONTEXTMENU = 'contentContextmenu', CONTENT_CLICK = 'contentClick', CONTENT_DBL_CLICK = 'contentDblclick', CONTENT_TOUCHSTART = 'contentTouchstart', CONTENT_TOUCHEND = 'contentTouchend', CONTENT_DBL_TAP = 'contentDbltap', CONTENT_TAP = 'contentTap', CONTENT_TOUCHMOVE = 'contentTouchmove', CONTENT_WHEEL = 'contentWheel', RELATIVE = 'relative', KONVA_CONTENT = 'konvajs-content', UNDERSCORE = '_', CONTAINER = 'container', MAX_LAYERS_NUMBER = 5, EMPTY_STRING = '', EVENTS = [
		    MOUSEENTER,
		    MOUSEDOWN,
		    MOUSEMOVE,
		    MOUSEUP,
		    MOUSELEAVE,
		    TOUCHSTART,
		    TOUCHMOVE,
		    TOUCHEND,
		    MOUSEOVER,
		    WHEEL,
		    CONTEXTMENU,
		    POINTERDOWN,
		    POINTERMOVE,
		    POINTERUP,
		    POINTERCANCEL,
		    LOSTPOINTERCAPTURE,
		], eventsLength = EVENTS.length;
		function addEvent(ctx, eventName) {
		    ctx.content.addEventListener(eventName, function (evt) {
		        ctx[UNDERSCORE + eventName](evt);
		    }, false);
		}
		var NO_POINTERS_MESSAGE = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
		exports.stages = [];
		function checkNoClip(attrs) {
		    if (attrs === void 0) { attrs = {}; }
		    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) {
		        Util_1.Util.warn('Stage does not support clipping. Please use clip for Layers or Groups.');
		    }
		    return attrs;
		}
		var Stage$1 = (function (_super) {
		    __extends(Stage, _super);
		    function Stage(config) {
		        var _this = _super.call(this, checkNoClip(config)) || this;
		        _this._pointerPositions = [];
		        _this._changedPointerPositions = [];
		        _this._buildDOM();
		        _this._bindContentEvents();
		        exports.stages.push(_this);
		        _this.on('widthChange.konva heightChange.konva', _this._resizeDOM);
		        _this.on('visibleChange.konva', _this._checkVisibility);
		        _this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', function () {
		            checkNoClip(_this.attrs);
		        });
		        _this._checkVisibility();
		        return _this;
		    }
		    Stage.prototype._validateAdd = function (child) {
		        var isLayer = child.getType() === 'Layer';
		        var isFastLayer = child.getType() === 'FastLayer';
		        var valid = isLayer || isFastLayer;
		        if (!valid) {
		            Util_1.Util.throw('You may only add layers to the stage.');
		        }
		    };
		    Stage.prototype._checkVisibility = function () {
		        if (!this.content) {
		            return;
		        }
		        var style = this.visible() ? '' : 'none';
		        this.content.style.display = style;
		    };
		    Stage.prototype.setContainer = function (container) {
		        if (typeof container === STRING) {
		            if (container.charAt(0) === '.') {
		                var className = container.slice(1);
		                container = document.getElementsByClassName(className)[0];
		            }
		            else {
		                var id;
		                if (container.charAt(0) !== '#') {
		                    id = container;
		                }
		                else {
		                    id = container.slice(1);
		                }
		                container = document.getElementById(id);
		            }
		            if (!container) {
		                throw 'Can not find container in document with id ' + id;
		            }
		        }
		        this._setAttr(CONTAINER, container);
		        if (this.content) {
		            if (this.content.parentElement) {
		                this.content.parentElement.removeChild(this.content);
		            }
		            container.appendChild(this.content);
		        }
		        return this;
		    };
		    Stage.prototype.shouldDrawHit = function () {
		        return true;
		    };
		    Stage.prototype.clear = function () {
		        var layers = this.children, len = layers.length, n;
		        for (n = 0; n < len; n++) {
		            layers[n].clear();
		        }
		        return this;
		    };
		    Stage.prototype.clone = function (obj) {
		        if (!obj) {
		            obj = {};
		        }
		        obj.container = document.createElement('div');
		        return Container_1.Container.prototype.clone.call(this, obj);
		    };
		    Stage.prototype.destroy = function () {
		        _super.prototype.destroy.call(this);
		        var content = this.content;
		        if (content && Util_1.Util._isInDocument(content)) {
		            this.container().removeChild(content);
		        }
		        var index = exports.stages.indexOf(this);
		        if (index > -1) {
		            exports.stages.splice(index, 1);
		        }
		        return this;
		    };
		    Stage.prototype.getPointerPosition = function () {
		        var pos = this._pointerPositions[0] || this._changedPointerPositions[0];
		        if (!pos) {
		            Util_1.Util.warn(NO_POINTERS_MESSAGE);
		            return null;
		        }
		        return {
		            x: pos.x,
		            y: pos.y,
		        };
		    };
		    Stage.prototype._getPointerById = function (id) {
		        return this._pointerPositions.find(function (p) { return p.id === id; });
		    };
		    Stage.prototype.getPointersPositions = function () {
		        return this._pointerPositions;
		    };
		    Stage.prototype.getStage = function () {
		        return this;
		    };
		    Stage.prototype.getContent = function () {
		        return this.content;
		    };
		    Stage.prototype._toKonvaCanvas = function (config) {
		        config = config || {};
		        config.x = config.x || 0;
		        config.y = config.y || 0;
		        config.width = config.width || this.width();
		        config.height = config.height || this.height();
		        var canvas = new Canvas_1.SceneCanvas({
		            width: config.width,
		            height: config.height,
		            pixelRatio: config.pixelRatio || 1,
		        });
		        var _context = canvas.getContext()._context;
		        var layers = this.children;
		        if (config.x || config.y) {
		            _context.translate(-1 * config.x, -1 * config.y);
		        }
		        layers.each(function (layer) {
		            if (!layer.isVisible()) {
		                return;
		            }
		            var layerCanvas = layer._toKonvaCanvas(config);
		            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
		        });
		        return canvas;
		    };
		    Stage.prototype.getIntersection = function (pos, selector) {
		        if (!pos) {
		            return null;
		        }
		        var layers = this.children, len = layers.length, end = len - 1, n, shape;
		        for (n = end; n >= 0; n--) {
		            shape = layers[n].getIntersection(pos, selector);
		            if (shape) {
		                return shape;
		            }
		        }
		        return null;
		    };
		    Stage.prototype._resizeDOM = function () {
		        var width = this.width();
		        var height = this.height();
		        if (this.content) {
		            this.content.style.width = width + PX;
		            this.content.style.height = height + PX;
		        }
		        this.bufferCanvas.setSize(width, height);
		        this.bufferHitCanvas.setSize(width, height);
		        this.children.each(function (layer) {
		            layer.setSize({ width: width, height: height });
		            layer.draw();
		        });
		    };
		    Stage.prototype.add = function (layer) {
		        if (arguments.length > 1) {
		            for (var i = 0; i < arguments.length; i++) {
		                this.add(arguments[i]);
		            }
		            return this;
		        }
		        _super.prototype.add.call(this, layer);
		        var length = this.children.length;
		        if (length > MAX_LAYERS_NUMBER) {
		            Util_1.Util.warn('The stage has ' +
		                length +
		                ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
		        }
		        layer.setSize({ width: this.width(), height: this.height() });
		        layer.draw();
		        if (Global_1.Konva.isBrowser) {
		            this.content.appendChild(layer.canvas._canvas);
		        }
		        return this;
		    };
		    Stage.prototype.getParent = function () {
		        return null;
		    };
		    Stage.prototype.getLayer = function () {
		        return null;
		    };
		    Stage.prototype.hasPointerCapture = function (pointerId) {
		        return PointerEvents.hasPointerCapture(pointerId, this);
		    };
		    Stage.prototype.setPointerCapture = function (pointerId) {
		        PointerEvents.setPointerCapture(pointerId, this);
		    };
		    Stage.prototype.releaseCapture = function (pointerId) {
		        PointerEvents.releaseCapture(pointerId, this);
		    };
		    Stage.prototype.getLayers = function () {
		        return this.getChildren();
		    };
		    Stage.prototype._bindContentEvents = function () {
		        if (!Global_1.Konva.isBrowser) {
		            return;
		        }
		        for (var n = 0; n < eventsLength; n++) {
		            addEvent(this, EVENTS[n]);
		        }
		    };
		    Stage.prototype._mouseenter = function (evt) {
		        this.setPointersPositions(evt);
		        this._fire(MOUSEENTER, { evt: evt, target: this, currentTarget: this });
		    };
		    Stage.prototype._mouseover = function (evt) {
		        this.setPointersPositions(evt);
		        this._fire(CONTENT_MOUSEOVER, { evt: evt });
		        this._fire(MOUSEOVER, { evt: evt, target: this, currentTarget: this });
		    };
		    Stage.prototype._mouseleave = function (evt) {
		        var _a;
		        this.setPointersPositions(evt);
		        var targetShape = ((_a = this.targetShape) === null || _a === void 0 ? void 0 : _a.getStage()) ? this.targetShape : null;
		        var eventsEnabled = !DragAndDrop_1.DD.isDragging || Global_1.Konva.hitOnDragEnabled;
		        if (targetShape && eventsEnabled) {
		            targetShape._fireAndBubble(MOUSEOUT, { evt: evt });
		            targetShape._fireAndBubble(MOUSELEAVE, { evt: evt });
		            this._fire(MOUSELEAVE, { evt: evt, target: this, currentTarget: this });
		            this.targetShape = null;
		        }
		        else if (eventsEnabled) {
		            this._fire(MOUSELEAVE, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		            });
		            this._fire(MOUSEOUT, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		            });
		        }
		        this.pointerPos = undefined;
		        this._pointerPositions = [];
		        this._fire(CONTENT_MOUSEOUT, { evt: evt });
		    };
		    Stage.prototype._mousemove = function (evt) {
		        var _a;
		        if (Global_1.Konva.UA.ieMobile) {
		            return this._touchmove(evt);
		        }
		        this.setPointersPositions(evt);
		        var pointerId = Util_1.Util._getFirstPointerId(evt);
		        var shape;
		        var targetShape = ((_a = this.targetShape) === null || _a === void 0 ? void 0 : _a.getStage()) ? this.targetShape : null;
		        var eventsEnabled = !DragAndDrop_1.DD.isDragging || Global_1.Konva.hitOnDragEnabled;
		        if (eventsEnabled) {
		            shape = this.getIntersection(this.getPointerPosition());
		            if (shape && shape.isListening()) {
		                var differentTarget = targetShape !== shape;
		                if (eventsEnabled && differentTarget) {
		                    if (targetShape) {
		                        targetShape._fireAndBubble(MOUSEOUT, { evt: evt, pointerId: pointerId }, shape);
		                        targetShape._fireAndBubble(MOUSELEAVE, { evt: evt, pointerId: pointerId }, shape);
		                    }
		                    shape._fireAndBubble(MOUSEOVER, { evt: evt, pointerId: pointerId }, targetShape);
		                    shape._fireAndBubble(MOUSEENTER, { evt: evt, pointerId: pointerId }, targetShape);
		                    shape._fireAndBubble(MOUSEMOVE, { evt: evt, pointerId: pointerId });
		                    this.targetShape = shape;
		                }
		                else {
		                    shape._fireAndBubble(MOUSEMOVE, { evt: evt, pointerId: pointerId });
		                }
		            }
		            else {
		                if (targetShape && eventsEnabled) {
		                    targetShape._fireAndBubble(MOUSEOUT, { evt: evt, pointerId: pointerId });
		                    targetShape._fireAndBubble(MOUSELEAVE, { evt: evt, pointerId: pointerId });
		                    this._fire(MOUSEOVER, {
		                        evt: evt,
		                        target: this,
		                        currentTarget: this,
		                        pointerId: pointerId,
		                    });
		                    this.targetShape = null;
		                }
		                this._fire(MOUSEMOVE, {
		                    evt: evt,
		                    target: this,
		                    currentTarget: this,
		                    pointerId: pointerId,
		                });
		            }
		            this._fire(CONTENT_MOUSEMOVE, { evt: evt });
		        }
		        if (evt.cancelable) {
		            evt.preventDefault();
		        }
		    };
		    Stage.prototype._mousedown = function (evt) {
		        if (Global_1.Konva.UA.ieMobile) {
		            return this._touchstart(evt);
		        }
		        this.setPointersPositions(evt);
		        var pointerId = Util_1.Util._getFirstPointerId(evt);
		        var shape = this.getIntersection(this.getPointerPosition());
		        DragAndDrop_1.DD.justDragged = false;
		        Global_1.Konva.listenClickTap = true;
		        if (shape && shape.isListening()) {
		            this.clickStartShape = shape;
		            shape._fireAndBubble(MOUSEDOWN, { evt: evt, pointerId: pointerId });
		        }
		        else {
		            this._fire(MOUSEDOWN, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		                pointerId: pointerId,
		            });
		        }
		        this._fire(CONTENT_MOUSEDOWN, { evt: evt });
		    };
		    Stage.prototype._mouseup = function (evt) {
		        if (Global_1.Konva.UA.ieMobile) {
		            return this._touchend(evt);
		        }
		        this.setPointersPositions(evt);
		        var pointerId = Util_1.Util._getFirstPointerId(evt);
		        var shape = this.getIntersection(this.getPointerPosition()), clickStartShape = this.clickStartShape, clickEndShape = this.clickEndShape, fireDblClick = false;
		        if (Global_1.Konva.inDblClickWindow) {
		            fireDblClick = true;
		            clearTimeout(this.dblTimeout);
		        }
		        else if (!DragAndDrop_1.DD.justDragged) {
		            Global_1.Konva.inDblClickWindow = true;
		            clearTimeout(this.dblTimeout);
		        }
		        this.dblTimeout = setTimeout(function () {
		            Global_1.Konva.inDblClickWindow = false;
		        }, Global_1.Konva.dblClickWindow);
		        if (shape && shape.isListening()) {
		            this.clickEndShape = shape;
		            shape._fireAndBubble(MOUSEUP, { evt: evt, pointerId: pointerId });
		            if (Global_1.Konva.listenClickTap &&
		                clickStartShape &&
		                clickStartShape._id === shape._id) {
		                shape._fireAndBubble(CLICK, { evt: evt, pointerId: pointerId });
		                if (fireDblClick && clickEndShape && clickEndShape === shape) {
		                    shape._fireAndBubble(DBL_CLICK, { evt: evt, pointerId: pointerId });
		                }
		            }
		        }
		        else {
		            this.clickEndShape = null;
		            this._fire(MOUSEUP, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		                pointerId: pointerId,
		            });
		            if (Global_1.Konva.listenClickTap) {
		                this._fire(CLICK, {
		                    evt: evt,
		                    target: this,
		                    currentTarget: this,
		                    pointerId: pointerId,
		                });
		            }
		            if (fireDblClick) {
		                this._fire(DBL_CLICK, {
		                    evt: evt,
		                    target: this,
		                    currentTarget: this,
		                    pointerId: pointerId,
		                });
		            }
		        }
		        this._fire(CONTENT_MOUSEUP, { evt: evt });
		        if (Global_1.Konva.listenClickTap) {
		            this._fire(CONTENT_CLICK, { evt: evt });
		            if (fireDblClick) {
		                this._fire(CONTENT_DBL_CLICK, { evt: evt });
		            }
		        }
		        Global_1.Konva.listenClickTap = false;
		        if (evt.cancelable) {
		            evt.preventDefault();
		        }
		    };
		    Stage.prototype._contextmenu = function (evt) {
		        this.setPointersPositions(evt);
		        var shape = this.getIntersection(this.getPointerPosition());
		        if (shape && shape.isListening()) {
		            shape._fireAndBubble(CONTEXTMENU, { evt: evt });
		        }
		        else {
		            this._fire(CONTEXTMENU, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		            });
		        }
		        this._fire(CONTENT_CONTEXTMENU, { evt: evt });
		    };
		    Stage.prototype._touchstart = function (evt) {
		        var _this = this;
		        this.setPointersPositions(evt);
		        var triggeredOnShape = false;
		        this._changedPointerPositions.forEach(function (pos) {
		            var shape = _this.getIntersection(pos);
		            Global_1.Konva.listenClickTap = true;
		            DragAndDrop_1.DD.justDragged = false;
		            var hasShape = shape && shape.isListening();
		            if (!hasShape) {
		                return;
		            }
		            if (Global_1.Konva.captureTouchEventsEnabled) {
		                shape.setPointerCapture(pos.id);
		            }
		            _this.tapStartShape = shape;
		            shape._fireAndBubble(TOUCHSTART, { evt: evt, pointerId: pos.id }, _this);
		            triggeredOnShape = true;
		            if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
		                evt.preventDefault();
		            }
		        });
		        if (!triggeredOnShape) {
		            this._fire(TOUCHSTART, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		                pointerId: this._changedPointerPositions[0].id,
		            });
		        }
		        this._fire(CONTENT_TOUCHSTART, { evt: evt });
		    };
		    Stage.prototype._touchmove = function (evt) {
		        var _this = this;
		        this.setPointersPositions(evt);
		        var eventsEnabled = !DragAndDrop_1.DD.isDragging || Global_1.Konva.hitOnDragEnabled;
		        if (eventsEnabled) {
		            var triggeredOnShape = false;
		            var processedShapesIds = {};
		            this._changedPointerPositions.forEach(function (pos) {
		                var shape = PointerEvents.getCapturedShape(pos.id) || _this.getIntersection(pos);
		                var hasShape = shape && shape.isListening();
		                if (!hasShape) {
		                    return;
		                }
		                if (processedShapesIds[shape._id]) {
		                    return;
		                }
		                processedShapesIds[shape._id] = true;
		                shape._fireAndBubble(TOUCHMOVE, { evt: evt, pointerId: pos.id });
		                triggeredOnShape = true;
		                if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
		                    evt.preventDefault();
		                }
		            });
		            if (!triggeredOnShape) {
		                this._fire(TOUCHMOVE, {
		                    evt: evt,
		                    target: this,
		                    currentTarget: this,
		                    pointerId: this._changedPointerPositions[0].id,
		                });
		            }
		            this._fire(CONTENT_TOUCHMOVE, { evt: evt });
		        }
		        if (DragAndDrop_1.DD.isDragging && DragAndDrop_1.DD.node.preventDefault() && evt.cancelable) {
		            evt.preventDefault();
		        }
		    };
		    Stage.prototype._touchend = function (evt) {
		        var _this = this;
		        this.setPointersPositions(evt);
		        var tapEndShape = this.tapEndShape, fireDblClick = false;
		        if (Global_1.Konva.inDblClickWindow) {
		            fireDblClick = true;
		            clearTimeout(this.dblTimeout);
		        }
		        else if (!DragAndDrop_1.DD.justDragged) {
		            Global_1.Konva.inDblClickWindow = true;
		            clearTimeout(this.dblTimeout);
		        }
		        this.dblTimeout = setTimeout(function () {
		            Global_1.Konva.inDblClickWindow = false;
		        }, Global_1.Konva.dblClickWindow);
		        var triggeredOnShape = false;
		        var processedShapesIds = {};
		        var tapTriggered = false;
		        var dblTapTriggered = false;
		        this._changedPointerPositions.forEach(function (pos) {
		            var shape = PointerEvents.getCapturedShape(pos.id) ||
		                _this.getIntersection(pos);
		            if (shape) {
		                shape.releaseCapture(pos.id);
		            }
		            var hasShape = shape && shape.isListening();
		            if (!hasShape) {
		                return;
		            }
		            if (processedShapesIds[shape._id]) {
		                return;
		            }
		            processedShapesIds[shape._id] = true;
		            _this.tapEndShape = shape;
		            shape._fireAndBubble(TOUCHEND, { evt: evt, pointerId: pos.id });
		            triggeredOnShape = true;
		            if (Global_1.Konva.listenClickTap && shape === _this.tapStartShape) {
		                tapTriggered = true;
		                shape._fireAndBubble(TAP, { evt: evt, pointerId: pos.id });
		                if (fireDblClick && tapEndShape && tapEndShape === shape) {
		                    dblTapTriggered = true;
		                    shape._fireAndBubble(DBL_TAP, { evt: evt, pointerId: pos.id });
		                }
		            }
		            if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
		                evt.preventDefault();
		            }
		        });
		        if (!triggeredOnShape) {
		            this._fire(TOUCHEND, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		                pointerId: this._changedPointerPositions[0].id,
		            });
		        }
		        if (Global_1.Konva.listenClickTap && !tapTriggered) {
		            this.tapEndShape = null;
		            this._fire(TAP, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		                pointerId: this._changedPointerPositions[0].id,
		            });
		        }
		        if (fireDblClick && !dblTapTriggered) {
		            this._fire(DBL_TAP, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		                pointerId: this._changedPointerPositions[0].id,
		            });
		        }
		        this._fire(CONTENT_TOUCHEND, { evt: evt });
		        if (Global_1.Konva.listenClickTap) {
		            this._fire(CONTENT_TAP, { evt: evt });
		            if (fireDblClick) {
		                this._fire(CONTENT_DBL_TAP, { evt: evt });
		            }
		        }
		        if (this.preventDefault() && evt.cancelable) {
		            evt.preventDefault();
		        }
		        Global_1.Konva.listenClickTap = false;
		    };
		    Stage.prototype._wheel = function (evt) {
		        this.setPointersPositions(evt);
		        var shape = this.getIntersection(this.getPointerPosition());
		        if (shape && shape.isListening()) {
		            shape._fireAndBubble(WHEEL, { evt: evt });
		        }
		        else {
		            this._fire(WHEEL, {
		                evt: evt,
		                target: this,
		                currentTarget: this,
		            });
		        }
		        this._fire(CONTENT_WHEEL, { evt: evt });
		    };
		    Stage.prototype._pointerdown = function (evt) {
		        if (!Global_1.Konva._pointerEventsEnabled) {
		            return;
		        }
		        this.setPointersPositions(evt);
		        var shape = PointerEvents.getCapturedShape(evt.pointerId) ||
		            this.getIntersection(this.getPointerPosition());
		        if (shape) {
		            shape._fireAndBubble(POINTERDOWN, PointerEvents.createEvent(evt));
		        }
		    };
		    Stage.prototype._pointermove = function (evt) {
		        if (!Global_1.Konva._pointerEventsEnabled) {
		            return;
		        }
		        this.setPointersPositions(evt);
		        var shape = PointerEvents.getCapturedShape(evt.pointerId) ||
		            this.getIntersection(this.getPointerPosition());
		        if (shape) {
		            shape._fireAndBubble(POINTERMOVE, PointerEvents.createEvent(evt));
		        }
		    };
		    Stage.prototype._pointerup = function (evt) {
		        if (!Global_1.Konva._pointerEventsEnabled) {
		            return;
		        }
		        this.setPointersPositions(evt);
		        var shape = PointerEvents.getCapturedShape(evt.pointerId) ||
		            this.getIntersection(this.getPointerPosition());
		        if (shape) {
		            shape._fireAndBubble(POINTERUP, PointerEvents.createEvent(evt));
		        }
		        PointerEvents.releaseCapture(evt.pointerId);
		    };
		    Stage.prototype._pointercancel = function (evt) {
		        if (!Global_1.Konva._pointerEventsEnabled) {
		            return;
		        }
		        this.setPointersPositions(evt);
		        var shape = PointerEvents.getCapturedShape(evt.pointerId) ||
		            this.getIntersection(this.getPointerPosition());
		        if (shape) {
		            shape._fireAndBubble(POINTERUP, PointerEvents.createEvent(evt));
		        }
		        PointerEvents.releaseCapture(evt.pointerId);
		    };
		    Stage.prototype._lostpointercapture = function (evt) {
		        PointerEvents.releaseCapture(evt.pointerId);
		    };
		    Stage.prototype.setPointersPositions = function (evt) {
		        var _this = this;
		        var contentPosition = this._getContentPosition(), x = null, y = null;
		        evt = evt ? evt : window.event;
		        if (evt.touches !== undefined) {
		            this._pointerPositions = [];
		            this._changedPointerPositions = [];
		            Util_1.Collection.prototype.each.call(evt.touches, function (touch) {
		                _this._pointerPositions.push({
		                    id: touch.identifier,
		                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
		                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY,
		                });
		            });
		            Util_1.Collection.prototype.each.call(evt.changedTouches || evt.touches, function (touch) {
		                _this._changedPointerPositions.push({
		                    id: touch.identifier,
		                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
		                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY,
		                });
		            });
		        }
		        else {
		            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
		            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
		            this.pointerPos = {
		                x: x,
		                y: y,
		            };
		            this._pointerPositions = [{ x: x, y: y, id: Util_1.Util._getFirstPointerId(evt) }];
		            this._changedPointerPositions = [
		                { x: x, y: y, id: Util_1.Util._getFirstPointerId(evt) },
		            ];
		        }
		    };
		    Stage.prototype._setPointerPosition = function (evt) {
		        Util_1.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
		        this.setPointersPositions(evt);
		    };
		    Stage.prototype._getContentPosition = function () {
		        if (!this.content || !this.content.getBoundingClientRect) {
		            return {
		                top: 0,
		                left: 0,
		                scaleX: 1,
		                scaleY: 1,
		            };
		        }
		        var rect = this.content.getBoundingClientRect();
		        return {
		            top: rect.top,
		            left: rect.left,
		            scaleX: rect.width / this.content.clientWidth || 1,
		            scaleY: rect.height / this.content.clientHeight || 1,
		        };
		    };
		    Stage.prototype._buildDOM = function () {
		        this.bufferCanvas = new Canvas_1.SceneCanvas({
		            width: this.width(),
		            height: this.height(),
		        });
		        this.bufferHitCanvas = new Canvas_1.HitCanvas({
		            pixelRatio: 1,
		            width: this.width(),
		            height: this.height(),
		        });
		        if (!Global_1.Konva.isBrowser) {
		            return;
		        }
		        var container = this.container();
		        if (!container) {
		            throw 'Stage has no container. A container is required.';
		        }
		        container.innerHTML = EMPTY_STRING;
		        this.content = document.createElement('div');
		        this.content.style.position = RELATIVE;
		        this.content.style.userSelect = 'none';
		        this.content.className = KONVA_CONTENT;
		        this.content.setAttribute('role', 'presentation');
		        container.appendChild(this.content);
		        this._resizeDOM();
		    };
		    Stage.prototype.cache = function () {
		        Util_1.Util.warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
		        return this;
		    };
		    Stage.prototype.clearCache = function () {
		        return this;
		    };
		    Stage.prototype.batchDraw = function () {
		        this.children.each(function (layer) {
		            layer.batchDraw();
		        });
		        return this;
		    };
		    return Stage;
		}(Container_1.Container));
		exports.Stage = Stage$1;
		Stage$1.prototype.nodeType = STAGE;
		Global_2._registerNode(Stage$1);
		Factory_1.Factory.addGetterSetter(Stage$1, 'container'); 
	} (Stage));
	return Stage;
}

var Layer = {};

var Shape = {};

var hasRequiredShape;

function requireShape () {
	if (hasRequiredShape) return Shape;
	hasRequiredShape = 1;
	(function (exports) {
		var __extends = (Shape && Shape.__extends) || (function () {
		    var extendStatics = function (d, b) {
		        extendStatics = Object.setPrototypeOf ||
		            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
		            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
		        return extendStatics(d, b);
		    };
		    return function (d, b) {
		        extendStatics(d, b);
		        function __() { this.constructor = d; }
		        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		    };
		})();
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Shape = exports.shapes = void 0;
		var Util_1 = requireUtil();
		var Factory_1 = requireFactory();
		var Node_1 = requireNode();
		var Validators_1 = requireValidators();
		var Global_1 = requireGlobal();
		var PointerEvents = requirePointerEvents();
		var HAS_SHADOW = 'hasShadow';
		var SHADOW_RGBA = 'shadowRGBA';
		var patternImage = 'patternImage';
		var linearGradient = 'linearGradient';
		var radialGradient = 'radialGradient';
		var dummyContext;
		function getDummyContext() {
		    if (dummyContext) {
		        return dummyContext;
		    }
		    dummyContext = Util_1.Util.createCanvasElement().getContext('2d');
		    return dummyContext;
		}
		exports.shapes = {};
		function _fillFunc(context) {
		    context.fill();
		}
		function _strokeFunc(context) {
		    context.stroke();
		}
		function _fillFuncHit(context) {
		    context.fill();
		}
		function _strokeFuncHit(context) {
		    context.stroke();
		}
		function _clearHasShadowCache() {
		    this._clearCache(HAS_SHADOW);
		}
		function _clearGetShadowRGBACache() {
		    this._clearCache(SHADOW_RGBA);
		}
		function _clearFillPatternCache() {
		    this._clearCache(patternImage);
		}
		function _clearLinearGradientCache() {
		    this._clearCache(linearGradient);
		}
		function _clearRadialGradientCache() {
		    this._clearCache(radialGradient);
		}
		var Shape$1 = (function (_super) {
		    __extends(Shape, _super);
		    function Shape(config) {
		        var _this = _super.call(this, config) || this;
		        var key;
		        while (true) {
		            key = Util_1.Util.getRandomColor();
		            if (key && !(key in exports.shapes)) {
		                break;
		            }
		        }
		        _this.colorKey = key;
		        exports.shapes[key] = _this;
		        return _this;
		    }
		    Shape.prototype.getContext = function () {
		        return this.getLayer().getContext();
		    };
		    Shape.prototype.getCanvas = function () {
		        return this.getLayer().getCanvas();
		    };
		    Shape.prototype.getSceneFunc = function () {
		        return this.attrs.sceneFunc || this['_sceneFunc'];
		    };
		    Shape.prototype.getHitFunc = function () {
		        return this.attrs.hitFunc || this['_hitFunc'];
		    };
		    Shape.prototype.hasShadow = function () {
		        return this._getCache(HAS_SHADOW, this._hasShadow);
		    };
		    Shape.prototype._hasShadow = function () {
		        return (this.shadowEnabled() &&
		            this.shadowOpacity() !== 0 &&
		            !!(this.shadowColor() ||
		                this.shadowBlur() ||
		                this.shadowOffsetX() ||
		                this.shadowOffsetY()));
		    };
		    Shape.prototype._getFillPattern = function () {
		        return this._getCache(patternImage, this.__getFillPattern);
		    };
		    Shape.prototype.__getFillPattern = function () {
		        if (this.fillPatternImage()) {
		            var ctx = getDummyContext();
		            var pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
		            if (pattern && pattern.setTransform) {
		                pattern.setTransform({
		                    a: this.fillPatternScaleX(),
		                    b: 0,
		                    c: 0,
		                    d: this.fillPatternScaleY(),
		                    e: 0,
		                    f: 0,
		                });
		            }
		            return pattern;
		        }
		    };
		    Shape.prototype._getLinearGradient = function () {
		        return this._getCache(linearGradient, this.__getLinearGradient);
		    };
		    Shape.prototype.__getLinearGradient = function () {
		        var colorStops = this.fillLinearGradientColorStops();
		        if (colorStops) {
		            var ctx = getDummyContext();
		            var start = this.fillLinearGradientStartPoint();
		            var end = this.fillLinearGradientEndPoint();
		            var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
		            for (var n = 0; n < colorStops.length; n += 2) {
		                grd.addColorStop(colorStops[n], colorStops[n + 1]);
		            }
		            return grd;
		        }
		    };
		    Shape.prototype._getRadialGradient = function () {
		        return this._getCache(radialGradient, this.__getRadialGradient);
		    };
		    Shape.prototype.__getRadialGradient = function () {
		        var colorStops = this.fillRadialGradientColorStops();
		        if (colorStops) {
		            var ctx = getDummyContext();
		            var start = this.fillRadialGradientStartPoint();
		            var end = this.fillRadialGradientEndPoint();
		            var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
		            for (var n = 0; n < colorStops.length; n += 2) {
		                grd.addColorStop(colorStops[n], colorStops[n + 1]);
		            }
		            return grd;
		        }
		    };
		    Shape.prototype.getShadowRGBA = function () {
		        return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
		    };
		    Shape.prototype._getShadowRGBA = function () {
		        if (this.hasShadow()) {
		            var rgba = Util_1.Util.colorToRGBA(this.shadowColor());
		            return ('rgba(' +
		                rgba.r +
		                ',' +
		                rgba.g +
		                ',' +
		                rgba.b +
		                ',' +
		                rgba.a * (this.shadowOpacity() || 1) +
		                ')');
		        }
		    };
		    Shape.prototype.hasFill = function () {
		        var _this = this;
		        return this._calculate('hasFill', [
		            'fillEnabled',
		            'fill',
		            'fillPatternImage',
		            'fillLinearGradientColorStops',
		            'fillRadialGradientColorStops',
		        ], function () {
		            return (_this.fillEnabled() &&
		                !!(_this.fill() ||
		                    _this.fillPatternImage() ||
		                    _this.fillLinearGradientColorStops() ||
		                    _this.fillRadialGradientColorStops()));
		        });
		    };
		    Shape.prototype.hasStroke = function () {
		        var _this = this;
		        return this._calculate('hasStroke', [
		            'strokeEnabled',
		            'strokeWidth',
		            'stroke',
		            'strokeLinearGradientColorStops',
		        ], function () {
		            return (_this.strokeEnabled() &&
		                _this.strokeWidth() &&
		                !!(_this.stroke() || _this.strokeLinearGradientColorStops()));
		        });
		    };
		    Shape.prototype.hasHitStroke = function () {
		        var width = this.hitStrokeWidth();
		        if (width === 'auto') {
		            return this.hasStroke();
		        }
		        return this.strokeEnabled() && !!width;
		    };
		    Shape.prototype.intersects = function (point) {
		        var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
		        bufferHitCanvas.getContext().clear();
		        this.drawHit(bufferHitCanvas, null, true);
		        p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
		        return p[3] > 0;
		    };
		    Shape.prototype.destroy = function () {
		        Node_1.Node.prototype.destroy.call(this);
		        delete exports.shapes[this.colorKey];
		        delete this.colorKey;
		        return this;
		    };
		    Shape.prototype._useBufferCanvas = function (forceFill) {
		        var _a;
		        if (!this.getStage()) {
		            return false;
		        }
		        var perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
		        if (!perfectDrawEnabled) {
		            return false;
		        }
		        var hasFill = forceFill || this.hasFill();
		        var hasStroke = this.hasStroke();
		        var isTransparent = this.getAbsoluteOpacity() !== 1;
		        if (hasFill && hasStroke && isTransparent) {
		            return true;
		        }
		        var hasShadow = this.hasShadow();
		        var strokeForShadow = this.shadowForStrokeEnabled();
		        if (hasFill && hasStroke && hasShadow && strokeForShadow) {
		            return true;
		        }
		        return false;
		    };
		    Shape.prototype.setStrokeHitEnabled = function (val) {
		        Util_1.Util.warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
		        if (val) {
		            this.hitStrokeWidth('auto');
		        }
		        else {
		            this.hitStrokeWidth(0);
		        }
		    };
		    Shape.prototype.getStrokeHitEnabled = function () {
		        if (this.hitStrokeWidth() === 0) {
		            return false;
		        }
		        else {
		            return true;
		        }
		    };
		    Shape.prototype.getSelfRect = function () {
		        var size = this.size();
		        return {
		            x: this._centroid ? -size.width / 2 : 0,
		            y: this._centroid ? -size.height / 2 : 0,
		            width: size.width,
		            height: size.height,
		        };
		    };
		    Shape.prototype.getClientRect = function (config) {
		        if (config === void 0) { config = {}; }
		        var skipTransform = config.skipTransform;
		        var relativeTo = config.relativeTo;
		        var fillRect = this.getSelfRect();
		        var applyStroke = !config.skipStroke && this.hasStroke();
		        var strokeWidth = (applyStroke && this.strokeWidth()) || 0;
		        var fillAndStrokeWidth = fillRect.width + strokeWidth;
		        var fillAndStrokeHeight = fillRect.height + strokeWidth;
		        var applyShadow = !config.skipShadow && this.hasShadow();
		        var shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
		        var shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
		        var preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
		        var preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
		        var blurRadius = (applyShadow && this.shadowBlur()) || 0;
		        var width = preWidth + blurRadius * 2;
		        var height = preHeight + blurRadius * 2;
		        var roundingOffset = 0;
		        if (Math.round(strokeWidth / 2) !== strokeWidth / 2) {
		            roundingOffset = 1;
		        }
		        var rect = {
		            width: width + roundingOffset,
		            height: height + roundingOffset,
		            x: -Math.round(strokeWidth / 2 + blurRadius) +
		                Math.min(shadowOffsetX, 0) +
		                fillRect.x,
		            y: -Math.round(strokeWidth / 2 + blurRadius) +
		                Math.min(shadowOffsetY, 0) +
		                fillRect.y,
		        };
		        if (!skipTransform) {
		            return this._transformedRect(rect, relativeTo);
		        }
		        return rect;
		    };
		    Shape.prototype.drawScene = function (can, top) {
		        var layer = this.getLayer(), canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferCanvas, bufferContext;
		        var caching = canvas.isCache;
		        var skipBuffer = canvas.isCache;
		        var cachingSelf = top === this;
		        if (!this.isVisible() && !caching) {
		            return this;
		        }
		        if (cachedCanvas) {
		            context.save();
		            var m = this.getAbsoluteTransform(top).getMatrix();
		            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		            this._drawCachedSceneCanvas(context);
		            context.restore();
		            return this;
		        }
		        if (!drawFunc) {
		            return this;
		        }
		        context.save();
		        if (this._useBufferCanvas() && !skipBuffer) {
		            stage = this.getStage();
		            bufferCanvas = stage.bufferCanvas;
		            bufferContext = bufferCanvas.getContext();
		            bufferContext.clear();
		            bufferContext.save();
		            bufferContext._applyLineJoin(this);
		            var o = this.getAbsoluteTransform(top).getMatrix();
		            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
		            drawFunc.call(this, bufferContext, this);
		            bufferContext.restore();
		            var ratio = bufferCanvas.pixelRatio;
		            if (hasShadow) {
		                context._applyShadow(this);
		            }
		            context._applyOpacity(this);
		            context._applyGlobalCompositeOperation(this);
		            context.drawImage(bufferCanvas._canvas, 0, 0, bufferCanvas.width / ratio, bufferCanvas.height / ratio);
		        }
		        else {
		            context._applyLineJoin(this);
		            if (!cachingSelf) {
		                var o = this.getAbsoluteTransform(top).getMatrix();
		                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
		                context._applyOpacity(this);
		                context._applyGlobalCompositeOperation(this);
		            }
		            if (hasShadow) {
		                context._applyShadow(this);
		            }
		            drawFunc.call(this, context, this);
		        }
		        context.restore();
		        return this;
		    };
		    Shape.prototype.drawHit = function (can, top, skipDragCheck) {
		        if (skipDragCheck === void 0) { skipDragCheck = false; }
		        if (!this.shouldDrawHit(top, skipDragCheck)) {
		            return this;
		        }
		        var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
		        if (!this.colorKey) {
		            console.log(this);
		            Util_1.Util.warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. See the shape in logs above. If you want to reuse shape you should call remove() instead of destroy()');
		        }
		        if (cachedHitCanvas) {
		            context.save();
		            var m = this.getAbsoluteTransform(top).getMatrix();
		            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		            this._drawCachedHitCanvas(context);
		            context.restore();
		            return this;
		        }
		        if (!drawFunc) {
		            return this;
		        }
		        context.save();
		        context._applyLineJoin(this);
		        var selfCache = this === top;
		        if (!selfCache) {
		            var o = this.getAbsoluteTransform(top).getMatrix();
		            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
		        }
		        drawFunc.call(this, context, this);
		        context.restore();
		        return this;
		    };
		    Shape.prototype.drawHitFromCache = function (alphaThreshold) {
		        if (alphaThreshold === void 0) { alphaThreshold = 0; }
		        var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
		        hitContext.clear();
		        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
		        try {
		            hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
		            hitData = hitImageData.data;
		            len = hitData.length;
		            rgbColorKey = Util_1.Util._hexToRgb(this.colorKey);
		            for (i = 0; i < len; i += 4) {
		                alpha = hitData[i + 3];
		                if (alpha > alphaThreshold) {
		                    hitData[i] = rgbColorKey.r;
		                    hitData[i + 1] = rgbColorKey.g;
		                    hitData[i + 2] = rgbColorKey.b;
		                    hitData[i + 3] = 255;
		                }
		                else {
		                    hitData[i + 3] = 0;
		                }
		            }
		            hitContext.putImageData(hitImageData, 0, 0);
		        }
		        catch (e) {
		            Util_1.Util.error('Unable to draw hit graph from cached scene canvas. ' + e.message);
		        }
		        return this;
		    };
		    Shape.prototype.hasPointerCapture = function (pointerId) {
		        return PointerEvents.hasPointerCapture(pointerId, this);
		    };
		    Shape.prototype.setPointerCapture = function (pointerId) {
		        PointerEvents.setPointerCapture(pointerId, this);
		    };
		    Shape.prototype.releaseCapture = function (pointerId) {
		        PointerEvents.releaseCapture(pointerId, this);
		    };
		    return Shape;
		}(Node_1.Node));
		exports.Shape = Shape$1;
		Shape$1.prototype._fillFunc = _fillFunc;
		Shape$1.prototype._strokeFunc = _strokeFunc;
		Shape$1.prototype._fillFuncHit = _fillFuncHit;
		Shape$1.prototype._strokeFuncHit = _strokeFuncHit;
		Shape$1.prototype._centroid = false;
		Shape$1.prototype.nodeType = 'Shape';
		Global_1._registerNode(Shape$1);
		Shape$1.prototype.eventListeners = {};
		Shape$1.prototype.on.call(Shape$1.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', _clearHasShadowCache);
		Shape$1.prototype.on.call(Shape$1.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', _clearGetShadowRGBACache);
		Shape$1.prototype.on.call(Shape$1.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva', _clearFillPatternCache);
		Shape$1.prototype.on.call(Shape$1.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', _clearLinearGradientCache);
		Shape$1.prototype.on.call(Shape$1.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', _clearRadialGradientCache);
		Factory_1.Factory.addGetterSetter(Shape$1, 'stroke', undefined, Validators_1.getStringOrGradientValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeWidth', 2, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillAfterStrokeEnabled', false);
		Factory_1.Factory.addGetterSetter(Shape$1, 'hitStrokeWidth', 'auto', Validators_1.getNumberOrAutoValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeHitEnabled', true, Validators_1.getBooleanValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'perfectDrawEnabled', true, Validators_1.getBooleanValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'shadowForStrokeEnabled', true, Validators_1.getBooleanValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'lineJoin');
		Factory_1.Factory.addGetterSetter(Shape$1, 'lineCap');
		Factory_1.Factory.addGetterSetter(Shape$1, 'sceneFunc');
		Factory_1.Factory.addGetterSetter(Shape$1, 'hitFunc');
		Factory_1.Factory.addGetterSetter(Shape$1, 'dash');
		Factory_1.Factory.addGetterSetter(Shape$1, 'dashOffset', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'shadowColor', undefined, Validators_1.getStringValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'shadowBlur', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'shadowOpacity', 1, Validators_1.getNumberValidator());
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'shadowOffset', ['x', 'y']);
		Factory_1.Factory.addGetterSetter(Shape$1, 'shadowOffsetX', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'shadowOffsetY', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternImage');
		Factory_1.Factory.addGetterSetter(Shape$1, 'fill', undefined, Validators_1.getStringOrGradientValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternX', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternY', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillLinearGradientColorStops');
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeLinearGradientColorStops');
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillRadialGradientStartRadius', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillRadialGradientEndRadius', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillRadialGradientColorStops');
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternRepeat', 'repeat');
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillEnabled', true);
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeEnabled', true);
		Factory_1.Factory.addGetterSetter(Shape$1, 'shadowEnabled', true);
		Factory_1.Factory.addGetterSetter(Shape$1, 'dashEnabled', true);
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeScaleEnabled', true);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPriority', 'color');
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'fillPatternOffset', ['x', 'y']);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternOffsetX', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternOffsetY', 0, Validators_1.getNumberValidator());
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'fillPatternScale', ['x', 'y']);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternScaleX', 1, Validators_1.getNumberValidator());
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternScaleY', 1, Validators_1.getNumberValidator());
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'fillLinearGradientStartPoint', [
		    'x',
		    'y',
		]);
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'strokeLinearGradientStartPoint', [
		    'x',
		    'y',
		]);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillLinearGradientStartPointX', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeLinearGradientStartPointX', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillLinearGradientStartPointY', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeLinearGradientStartPointY', 0);
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'fillLinearGradientEndPoint', [
		    'x',
		    'y',
		]);
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'strokeLinearGradientEndPoint', [
		    'x',
		    'y',
		]);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillLinearGradientEndPointX', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeLinearGradientEndPointX', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillLinearGradientEndPointY', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'strokeLinearGradientEndPointY', 0);
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'fillRadialGradientStartPoint', [
		    'x',
		    'y',
		]);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillRadialGradientStartPointX', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillRadialGradientStartPointY', 0);
		Factory_1.Factory.addComponentsGetterSetter(Shape$1, 'fillRadialGradientEndPoint', [
		    'x',
		    'y',
		]);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillRadialGradientEndPointX', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillRadialGradientEndPointY', 0);
		Factory_1.Factory.addGetterSetter(Shape$1, 'fillPatternRotation', 0);
		Factory_1.Factory.backCompat(Shape$1, {
		    dashArray: 'dash',
		    getDashArray: 'getDash',
		    setDashArray: 'getDash',
		    drawFunc: 'sceneFunc',
		    getDrawFunc: 'getSceneFunc',
		    setDrawFunc: 'setSceneFunc',
		    drawHitFunc: 'hitFunc',
		    getDrawHitFunc: 'getHitFunc',
		    setDrawHitFunc: 'setHitFunc',
		});
		Util_1.Collection.mapMethods(Shape$1); 
	} (Shape));
	return Shape;
}

var hasRequiredLayer;

function requireLayer () {
	if (hasRequiredLayer) return Layer;
	hasRequiredLayer = 1;
	var __extends = (Layer && Layer.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Layer, "__esModule", { value: true });
	Layer.Layer = void 0;
	var Util_1 = requireUtil();
	var Container_1 = requireContainer();
	var Node_1 = requireNode();
	var Factory_1 = requireFactory();
	var Canvas_1 = requireCanvas();
	var Validators_1 = requireValidators();
	var Shape_1 = requireShape();
	var Global_1 = requireGlobal();
	var HASH = '#', BEFORE_DRAW = 'beforeDraw', DRAW = 'draw', INTERSECTION_OFFSETS = [
	    { x: 0, y: 0 },
	    { x: -1, y: -1 },
	    { x: 1, y: -1 },
	    { x: 1, y: 1 },
	    { x: -1, y: 1 },
	], INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
	var Layer$1 = (function (_super) {
	    __extends(Layer, _super);
	    function Layer(config) {
	        var _this = _super.call(this, config) || this;
	        _this.canvas = new Canvas_1.SceneCanvas();
	        _this.hitCanvas = new Canvas_1.HitCanvas({
	            pixelRatio: 1,
	        });
	        _this._waitingForDraw = false;
	        _this.on('visibleChange.konva', _this._checkVisibility);
	        _this._checkVisibility();
	        _this.on('imageSmoothingEnabledChange.konva', _this._setSmoothEnabled);
	        _this._setSmoothEnabled();
	        return _this;
	    }
	    Layer.prototype.createPNGStream = function () {
	        var c = this.canvas._canvas;
	        return c.createPNGStream();
	    };
	    Layer.prototype.getCanvas = function () {
	        return this.canvas;
	    };
	    Layer.prototype.getHitCanvas = function () {
	        return this.hitCanvas;
	    };
	    Layer.prototype.getContext = function () {
	        return this.getCanvas().getContext();
	    };
	    Layer.prototype.clear = function (bounds) {
	        this.getContext().clear(bounds);
	        this.getHitCanvas().getContext().clear(bounds);
	        return this;
	    };
	    Layer.prototype.setZIndex = function (index) {
	        _super.prototype.setZIndex.call(this, index);
	        var stage = this.getStage();
	        if (stage) {
	            stage.content.removeChild(this.getCanvas()._canvas);
	            if (index < stage.children.length - 1) {
	                stage.content.insertBefore(this.getCanvas()._canvas, stage.children[index + 1].getCanvas()._canvas);
	            }
	            else {
	                stage.content.appendChild(this.getCanvas()._canvas);
	            }
	        }
	        return this;
	    };
	    Layer.prototype.moveToTop = function () {
	        Node_1.Node.prototype.moveToTop.call(this);
	        var stage = this.getStage();
	        if (stage) {
	            stage.content.removeChild(this.getCanvas()._canvas);
	            stage.content.appendChild(this.getCanvas()._canvas);
	        }
	        return true;
	    };
	    Layer.prototype.moveUp = function () {
	        var moved = Node_1.Node.prototype.moveUp.call(this);
	        if (!moved) {
	            return false;
	        }
	        var stage = this.getStage();
	        if (!stage) {
	            return false;
	        }
	        stage.content.removeChild(this.getCanvas()._canvas);
	        if (this.index < stage.children.length - 1) {
	            stage.content.insertBefore(this.getCanvas()._canvas, stage.children[this.index + 1].getCanvas()._canvas);
	        }
	        else {
	            stage.content.appendChild(this.getCanvas()._canvas);
	        }
	        return true;
	    };
	    Layer.prototype.moveDown = function () {
	        if (Node_1.Node.prototype.moveDown.call(this)) {
	            var stage = this.getStage();
	            if (stage) {
	                var children = stage.children;
	                stage.content.removeChild(this.getCanvas()._canvas);
	                stage.content.insertBefore(this.getCanvas()._canvas, children[this.index + 1].getCanvas()._canvas);
	            }
	            return true;
	        }
	        return false;
	    };
	    Layer.prototype.moveToBottom = function () {
	        if (Node_1.Node.prototype.moveToBottom.call(this)) {
	            var stage = this.getStage();
	            if (stage) {
	                var children = stage.children;
	                stage.content.removeChild(this.getCanvas()._canvas);
	                stage.content.insertBefore(this.getCanvas()._canvas, children[1].getCanvas()._canvas);
	            }
	            return true;
	        }
	        return false;
	    };
	    Layer.prototype.getLayer = function () {
	        return this;
	    };
	    Layer.prototype.remove = function () {
	        var _canvas = this.getCanvas()._canvas;
	        Node_1.Node.prototype.remove.call(this);
	        if (_canvas && _canvas.parentNode && Util_1.Util._isInDocument(_canvas)) {
	            _canvas.parentNode.removeChild(_canvas);
	        }
	        return this;
	    };
	    Layer.prototype.getStage = function () {
	        return this.parent;
	    };
	    Layer.prototype.setSize = function (_a) {
	        var width = _a.width, height = _a.height;
	        this.canvas.setSize(width, height);
	        this.hitCanvas.setSize(width, height);
	        this._setSmoothEnabled();
	        return this;
	    };
	    Layer.prototype._validateAdd = function (child) {
	        var type = child.getType();
	        if (type !== 'Group' && type !== 'Shape') {
	            Util_1.Util.throw('You may only add groups and shapes to a layer.');
	        }
	    };
	    Layer.prototype._toKonvaCanvas = function (config) {
	        config = config || {};
	        config.width = config.width || this.getWidth();
	        config.height = config.height || this.getHeight();
	        config.x = config.x !== undefined ? config.x : this.x();
	        config.y = config.y !== undefined ? config.y : this.y();
	        return Node_1.Node.prototype._toKonvaCanvas.call(this, config);
	    };
	    Layer.prototype._checkVisibility = function () {
	        var visible = this.visible();
	        if (visible) {
	            this.canvas._canvas.style.display = 'block';
	        }
	        else {
	            this.canvas._canvas.style.display = 'none';
	        }
	    };
	    Layer.prototype._setSmoothEnabled = function () {
	        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
	    };
	    Layer.prototype.getWidth = function () {
	        if (this.parent) {
	            return this.parent.width();
	        }
	    };
	    Layer.prototype.setWidth = function () {
	        Util_1.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
	    };
	    Layer.prototype.getHeight = function () {
	        if (this.parent) {
	            return this.parent.height();
	        }
	    };
	    Layer.prototype.setHeight = function () {
	        Util_1.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
	    };
	    Layer.prototype.batchDraw = function () {
	        var _this = this;
	        if (!this._waitingForDraw) {
	            this._waitingForDraw = true;
	            Util_1.Util.requestAnimFrame(function () {
	                _this.draw();
	                _this._waitingForDraw = false;
	            });
	        }
	        return this;
	    };
	    Layer.prototype.getIntersection = function (pos, selector) {
	        if (!this.isListening() || !this.isVisible()) {
	            return null;
	        }
	        var spiralSearchDistance = 1;
	        var continueSearch = false;
	        while (true) {
	            for (var i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
	                var intersectionOffset = INTERSECTION_OFFSETS[i];
	                var obj = this._getIntersection({
	                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
	                    y: pos.y + intersectionOffset.y * spiralSearchDistance,
	                });
	                var shape = obj.shape;
	                if (shape && selector) {
	                    return shape.findAncestor(selector, true);
	                }
	                else if (shape) {
	                    return shape;
	                }
	                continueSearch = !!obj.antialiased;
	                if (!obj.antialiased) {
	                    break;
	                }
	            }
	            if (continueSearch) {
	                spiralSearchDistance += 1;
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    Layer.prototype._getIntersection = function (pos) {
	        var ratio = this.hitCanvas.pixelRatio;
	        var p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
	        var p3 = p[3];
	        if (p3 === 255) {
	            var colorKey = Util_1.Util._rgbToHex(p[0], p[1], p[2]);
	            var shape = Shape_1.shapes[HASH + colorKey];
	            if (shape) {
	                return {
	                    shape: shape,
	                };
	            }
	            return {
	                antialiased: true,
	            };
	        }
	        else if (p3 > 0) {
	            return {
	                antialiased: true,
	            };
	        }
	        return {};
	    };
	    Layer.prototype.drawScene = function (can, top) {
	        var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas());
	        this._fire(BEFORE_DRAW, {
	            node: this,
	        });
	        if (this.clearBeforeDraw()) {
	            canvas.getContext().clear();
	        }
	        Container_1.Container.prototype.drawScene.call(this, canvas, top);
	        this._fire(DRAW, {
	            node: this,
	        });
	        return this;
	    };
	    Layer.prototype.drawHit = function (can, top) {
	        var layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas);
	        if (layer && layer.clearBeforeDraw()) {
	            layer.getHitCanvas().getContext().clear();
	        }
	        Container_1.Container.prototype.drawHit.call(this, canvas, top);
	        return this;
	    };
	    Layer.prototype.enableHitGraph = function () {
	        this.hitGraphEnabled(true);
	        return this;
	    };
	    Layer.prototype.disableHitGraph = function () {
	        this.hitGraphEnabled(false);
	        return this;
	    };
	    Layer.prototype.setHitGraphEnabled = function (val) {
	        Util_1.Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
	        this.listening(val);
	    };
	    Layer.prototype.getHitGraphEnabled = function (val) {
	        Util_1.Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
	        return this.listening();
	    };
	    Layer.prototype.toggleHitCanvas = function () {
	        if (!this.parent) {
	            return;
	        }
	        var parent = this.parent;
	        var added = !!this.hitCanvas._canvas.parentNode;
	        if (added) {
	            parent.content.removeChild(this.hitCanvas._canvas);
	        }
	        else {
	            parent.content.appendChild(this.hitCanvas._canvas);
	        }
	    };
	    return Layer;
	}(Container_1.Container));
	Layer.Layer = Layer$1;
	Layer$1.prototype.nodeType = 'Layer';
	Global_1._registerNode(Layer$1);
	Factory_1.Factory.addGetterSetter(Layer$1, 'imageSmoothingEnabled', true);
	Factory_1.Factory.addGetterSetter(Layer$1, 'clearBeforeDraw', true);
	Factory_1.Factory.addGetterSetter(Layer$1, 'hitGraphEnabled', true, Validators_1.getBooleanValidator());
	Util_1.Collection.mapMethods(Layer$1);
	return Layer;
}

var FastLayer = {};

var hasRequiredFastLayer;

function requireFastLayer () {
	if (hasRequiredFastLayer) return FastLayer;
	hasRequiredFastLayer = 1;
	var __extends = (FastLayer && FastLayer.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(FastLayer, "__esModule", { value: true });
	FastLayer.FastLayer = void 0;
	var Util_1 = requireUtil();
	var Layer_1 = requireLayer();
	var Global_1 = requireGlobal();
	var FastLayer$1 = (function (_super) {
	    __extends(FastLayer, _super);
	    function FastLayer(attrs) {
	        var _this = _super.call(this, attrs) || this;
	        _this.listening(false);
	        Util_1.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
	        return _this;
	    }
	    return FastLayer;
	}(Layer_1.Layer));
	FastLayer.FastLayer = FastLayer$1;
	FastLayer$1.prototype.nodeType = 'FastLayer';
	Global_1._registerNode(FastLayer$1);
	Util_1.Collection.mapMethods(FastLayer$1);
	return FastLayer;
}

var Group = {};

var hasRequiredGroup;

function requireGroup () {
	if (hasRequiredGroup) return Group;
	hasRequiredGroup = 1;
	var __extends = (Group && Group.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Group, "__esModule", { value: true });
	Group.Group = void 0;
	var Util_1 = requireUtil();
	var Container_1 = requireContainer();
	var Global_1 = requireGlobal();
	var Group$1 = (function (_super) {
	    __extends(Group, _super);
	    function Group() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Group.prototype._validateAdd = function (child) {
	        var type = child.getType();
	        if (type !== 'Group' && type !== 'Shape') {
	            Util_1.Util.throw('You may only add groups and shapes to groups.');
	        }
	    };
	    return Group;
	}(Container_1.Container));
	Group.Group = Group$1;
	Group$1.prototype.nodeType = 'Group';
	Global_1._registerNode(Group$1);
	Util_1.Collection.mapMethods(Group$1);
	return Group;
}

var Animation = {};

var hasRequiredAnimation;

function requireAnimation () {
	if (hasRequiredAnimation) return Animation;
	hasRequiredAnimation = 1;
	Object.defineProperty(Animation, "__esModule", { value: true });
	Animation.Animation = void 0;
	var Global_1 = requireGlobal();
	var now = (function () {
	    if (Global_1.glob.performance && Global_1.glob.performance.now) {
	        return function () {
	            return Global_1.glob.performance.now();
	        };
	    }
	    return function () {
	        return new Date().getTime();
	    };
	})();
	var Animation$1 = (function () {
	    function Animation(func, layers) {
	        this.id = Animation.animIdCounter++;
	        this.frame = {
	            time: 0,
	            timeDiff: 0,
	            lastTime: now(),
	            frameRate: 0
	        };
	        this.func = func;
	        this.setLayers(layers);
	    }
	    Animation.prototype.setLayers = function (layers) {
	        var lays = [];
	        if (!layers) {
	            lays = [];
	        }
	        else if (layers.length > 0) {
	            lays = layers;
	        }
	        else {
	            lays = [layers];
	        }
	        this.layers = lays;
	        return this;
	    };
	    Animation.prototype.getLayers = function () {
	        return this.layers;
	    };
	    Animation.prototype.addLayer = function (layer) {
	        var layers = this.layers, len = layers.length, n;
	        for (n = 0; n < len; n++) {
	            if (layers[n]._id === layer._id) {
	                return false;
	            }
	        }
	        this.layers.push(layer);
	        return true;
	    };
	    Animation.prototype.isRunning = function () {
	        var a = Animation, animations = a.animations, len = animations.length, n;
	        for (n = 0; n < len; n++) {
	            if (animations[n].id === this.id) {
	                return true;
	            }
	        }
	        return false;
	    };
	    Animation.prototype.start = function () {
	        this.stop();
	        this.frame.timeDiff = 0;
	        this.frame.lastTime = now();
	        Animation._addAnimation(this);
	        return this;
	    };
	    Animation.prototype.stop = function () {
	        Animation._removeAnimation(this);
	        return this;
	    };
	    Animation.prototype._updateFrameObject = function (time) {
	        this.frame.timeDiff = time - this.frame.lastTime;
	        this.frame.lastTime = time;
	        this.frame.time += this.frame.timeDiff;
	        this.frame.frameRate = 1000 / this.frame.timeDiff;
	    };
	    Animation._addAnimation = function (anim) {
	        this.animations.push(anim);
	        this._handleAnimation();
	    };
	    Animation._removeAnimation = function (anim) {
	        var id = anim.id, animations = this.animations, len = animations.length, n;
	        for (n = 0; n < len; n++) {
	            if (animations[n].id === id) {
	                this.animations.splice(n, 1);
	                break;
	            }
	        }
	    };
	    Animation._runFrames = function () {
	        var layerHash = {}, animations = this.animations, anim, layers, func, n, i, layersLen, layer, key, needRedraw;
	        for (n = 0; n < animations.length; n++) {
	            anim = animations[n];
	            layers = anim.layers;
	            func = anim.func;
	            anim._updateFrameObject(now());
	            layersLen = layers.length;
	            if (func) {
	                needRedraw = func.call(anim, anim.frame) !== false;
	            }
	            else {
	                needRedraw = true;
	            }
	            if (!needRedraw) {
	                continue;
	            }
	            for (i = 0; i < layersLen; i++) {
	                layer = layers[i];
	                if (layer._id !== undefined) {
	                    layerHash[layer._id] = layer;
	                }
	            }
	        }
	        for (key in layerHash) {
	            if (!layerHash.hasOwnProperty(key)) {
	                continue;
	            }
	            layerHash[key].draw();
	        }
	    };
	    Animation._animationLoop = function () {
	        var Anim = Animation;
	        if (Anim.animations.length) {
	            Anim._runFrames();
	            requestAnimationFrame(Anim._animationLoop);
	        }
	        else {
	            Anim.animRunning = false;
	        }
	    };
	    Animation._handleAnimation = function () {
	        if (!this.animRunning) {
	            this.animRunning = true;
	            requestAnimationFrame(this._animationLoop);
	        }
	    };
	    Animation.animations = [];
	    Animation.animIdCounter = 0;
	    Animation.animRunning = false;
	    return Animation;
	}());
	Animation.Animation = Animation$1;
	return Animation;
}

var Tween$1 = {};

var hasRequiredTween;

function requireTween () {
	if (hasRequiredTween) return Tween$1;
	hasRequiredTween = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Easings = exports.Tween = void 0;
		var Util_1 = requireUtil();
		var Animation_1 = requireAnimation();
		var Node_1 = requireNode();
		var Global_1 = requireGlobal();
		var blacklist = {
		    node: 1,
		    duration: 1,
		    easing: 1,
		    onFinish: 1,
		    yoyo: 1,
		}, PAUSED = 1, PLAYING = 2, REVERSING = 3, idCounter = 0, colorAttrs = ['fill', 'stroke', 'shadowColor'];
		var TweenEngine = (function () {
		    function TweenEngine(prop, propFunc, func, begin, finish, duration, yoyo) {
		        this.prop = prop;
		        this.propFunc = propFunc;
		        this.begin = begin;
		        this._pos = begin;
		        this.duration = duration;
		        this._change = 0;
		        this.prevPos = 0;
		        this.yoyo = yoyo;
		        this._time = 0;
		        this._position = 0;
		        this._startTime = 0;
		        this._finish = 0;
		        this.func = func;
		        this._change = finish - this.begin;
		        this.pause();
		    }
		    TweenEngine.prototype.fire = function (str) {
		        var handler = this[str];
		        if (handler) {
		            handler();
		        }
		    };
		    TweenEngine.prototype.setTime = function (t) {
		        if (t > this.duration) {
		            if (this.yoyo) {
		                this._time = this.duration;
		                this.reverse();
		            }
		            else {
		                this.finish();
		            }
		        }
		        else if (t < 0) {
		            if (this.yoyo) {
		                this._time = 0;
		                this.play();
		            }
		            else {
		                this.reset();
		            }
		        }
		        else {
		            this._time = t;
		            this.update();
		        }
		    };
		    TweenEngine.prototype.getTime = function () {
		        return this._time;
		    };
		    TweenEngine.prototype.setPosition = function (p) {
		        this.prevPos = this._pos;
		        this.propFunc(p);
		        this._pos = p;
		    };
		    TweenEngine.prototype.getPosition = function (t) {
		        if (t === undefined) {
		            t = this._time;
		        }
		        return this.func(t, this.begin, this._change, this.duration);
		    };
		    TweenEngine.prototype.play = function () {
		        this.state = PLAYING;
		        this._startTime = this.getTimer() - this._time;
		        this.onEnterFrame();
		        this.fire('onPlay');
		    };
		    TweenEngine.prototype.reverse = function () {
		        this.state = REVERSING;
		        this._time = this.duration - this._time;
		        this._startTime = this.getTimer() - this._time;
		        this.onEnterFrame();
		        this.fire('onReverse');
		    };
		    TweenEngine.prototype.seek = function (t) {
		        this.pause();
		        this._time = t;
		        this.update();
		        this.fire('onSeek');
		    };
		    TweenEngine.prototype.reset = function () {
		        this.pause();
		        this._time = 0;
		        this.update();
		        this.fire('onReset');
		    };
		    TweenEngine.prototype.finish = function () {
		        this.pause();
		        this._time = this.duration;
		        this.update();
		        this.fire('onFinish');
		    };
		    TweenEngine.prototype.update = function () {
		        this.setPosition(this.getPosition(this._time));
		        this.fire('onUpdate');
		    };
		    TweenEngine.prototype.onEnterFrame = function () {
		        var t = this.getTimer() - this._startTime;
		        if (this.state === PLAYING) {
		            this.setTime(t);
		        }
		        else if (this.state === REVERSING) {
		            this.setTime(this.duration - t);
		        }
		    };
		    TweenEngine.prototype.pause = function () {
		        this.state = PAUSED;
		        this.fire('onPause');
		    };
		    TweenEngine.prototype.getTimer = function () {
		        return new Date().getTime();
		    };
		    return TweenEngine;
		}());
		var Tween = (function () {
		    function Tween(config) {
		        var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || exports.Easings.Linear, yoyo = !!config.yoyo, key;
		        if (typeof config.duration === 'undefined') {
		            duration = 0.3;
		        }
		        else if (config.duration === 0) {
		            duration = 0.001;
		        }
		        else {
		            duration = config.duration;
		        }
		        this.node = node;
		        this._id = idCounter++;
		        var layers = node.getLayer() ||
		            (node instanceof Global_1.Konva['Stage'] ? node.getLayers() : null);
		        if (!layers) {
		            Util_1.Util.error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
		        }
		        this.anim = new Animation_1.Animation(function () {
		            that.tween.onEnterFrame();
		        }, layers);
		        this.tween = new TweenEngine(key, function (i) {
		            that._tweenFunc(i);
		        }, easing, 0, 1, duration * 1000, yoyo);
		        this._addListeners();
		        if (!Tween.attrs[nodeId]) {
		            Tween.attrs[nodeId] = {};
		        }
		        if (!Tween.attrs[nodeId][this._id]) {
		            Tween.attrs[nodeId][this._id] = {};
		        }
		        if (!Tween.tweens[nodeId]) {
		            Tween.tweens[nodeId] = {};
		        }
		        for (key in config) {
		            if (blacklist[key] === undefined) {
		                this._addAttr(key, config[key]);
		            }
		        }
		        this.reset();
		        this.onFinish = config.onFinish;
		        this.onReset = config.onReset;
		        this.onUpdate = config.onUpdate;
		    }
		    Tween.prototype._addAttr = function (key, end) {
		        var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
		        tweenId = Tween.tweens[nodeId][key];
		        if (tweenId) {
		            delete Tween.attrs[nodeId][tweenId][key];
		        }
		        start = node.getAttr(key);
		        if (Util_1.Util._isArray(end)) {
		            diff = [];
		            len = Math.max(end.length, start.length);
		            if (key === 'points' && end.length !== start.length) {
		                if (end.length > start.length) {
		                    trueStart = start;
		                    start = Util_1.Util._prepareArrayForTween(start, end, node.closed());
		                }
		                else {
		                    trueEnd = end;
		                    end = Util_1.Util._prepareArrayForTween(end, start, node.closed());
		                }
		            }
		            if (key.indexOf('fill') === 0) {
		                for (n = 0; n < len; n++) {
		                    if (n % 2 === 0) {
		                        diff.push(end[n] - start[n]);
		                    }
		                    else {
		                        var startRGBA = Util_1.Util.colorToRGBA(start[n]);
		                        endRGBA = Util_1.Util.colorToRGBA(end[n]);
		                        start[n] = startRGBA;
		                        diff.push({
		                            r: endRGBA.r - startRGBA.r,
		                            g: endRGBA.g - startRGBA.g,
		                            b: endRGBA.b - startRGBA.b,
		                            a: endRGBA.a - startRGBA.a,
		                        });
		                    }
		                }
		            }
		            else {
		                for (n = 0; n < len; n++) {
		                    diff.push(end[n] - start[n]);
		                }
		            }
		        }
		        else if (colorAttrs.indexOf(key) !== -1) {
		            start = Util_1.Util.colorToRGBA(start);
		            endRGBA = Util_1.Util.colorToRGBA(end);
		            diff = {
		                r: endRGBA.r - start.r,
		                g: endRGBA.g - start.g,
		                b: endRGBA.b - start.b,
		                a: endRGBA.a - start.a,
		            };
		        }
		        else {
		            diff = end - start;
		        }
		        Tween.attrs[nodeId][this._id][key] = {
		            start: start,
		            diff: diff,
		            end: end,
		            trueEnd: trueEnd,
		            trueStart: trueStart,
		        };
		        Tween.tweens[nodeId][key] = this._id;
		    };
		    Tween.prototype._tweenFunc = function (i) {
		        var node = this.node, attrs = Tween.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
		        for (key in attrs) {
		            attr = attrs[key];
		            start = attr.start;
		            diff = attr.diff;
		            end = attr.end;
		            if (Util_1.Util._isArray(start)) {
		                newVal = [];
		                len = Math.max(start.length, end.length);
		                if (key.indexOf('fill') === 0) {
		                    for (n = 0; n < len; n++) {
		                        if (n % 2 === 0) {
		                            newVal.push((start[n] || 0) + diff[n] * i);
		                        }
		                        else {
		                            newVal.push('rgba(' +
		                                Math.round(start[n].r + diff[n].r * i) +
		                                ',' +
		                                Math.round(start[n].g + diff[n].g * i) +
		                                ',' +
		                                Math.round(start[n].b + diff[n].b * i) +
		                                ',' +
		                                (start[n].a + diff[n].a * i) +
		                                ')');
		                        }
		                    }
		                }
		                else {
		                    for (n = 0; n < len; n++) {
		                        newVal.push((start[n] || 0) + diff[n] * i);
		                    }
		                }
		            }
		            else if (colorAttrs.indexOf(key) !== -1) {
		                newVal =
		                    'rgba(' +
		                        Math.round(start.r + diff.r * i) +
		                        ',' +
		                        Math.round(start.g + diff.g * i) +
		                        ',' +
		                        Math.round(start.b + diff.b * i) +
		                        ',' +
		                        (start.a + diff.a * i) +
		                        ')';
		            }
		            else {
		                newVal = start + diff * i;
		            }
		            node.setAttr(key, newVal);
		        }
		    };
		    Tween.prototype._addListeners = function () {
		        var _this = this;
		        this.tween.onPlay = function () {
		            _this.anim.start();
		        };
		        this.tween.onReverse = function () {
		            _this.anim.start();
		        };
		        this.tween.onPause = function () {
		            _this.anim.stop();
		        };
		        this.tween.onFinish = function () {
		            var node = _this.node;
		            var attrs = Tween.attrs[node._id][_this._id];
		            if (attrs.points && attrs.points.trueEnd) {
		                node.setAttr('points', attrs.points.trueEnd);
		            }
		            if (_this.onFinish) {
		                _this.onFinish.call(_this);
		            }
		        };
		        this.tween.onReset = function () {
		            var node = _this.node;
		            var attrs = Tween.attrs[node._id][_this._id];
		            if (attrs.points && attrs.points.trueStart) {
		                node.points(attrs.points.trueStart);
		            }
		            if (_this.onReset) {
		                _this.onReset();
		            }
		        };
		        this.tween.onUpdate = function () {
		            if (_this.onUpdate) {
		                _this.onUpdate.call(_this);
		            }
		        };
		    };
		    Tween.prototype.play = function () {
		        this.tween.play();
		        return this;
		    };
		    Tween.prototype.reverse = function () {
		        this.tween.reverse();
		        return this;
		    };
		    Tween.prototype.reset = function () {
		        this.tween.reset();
		        return this;
		    };
		    Tween.prototype.seek = function (t) {
		        this.tween.seek(t * 1000);
		        return this;
		    };
		    Tween.prototype.pause = function () {
		        this.tween.pause();
		        return this;
		    };
		    Tween.prototype.finish = function () {
		        this.tween.finish();
		        return this;
		    };
		    Tween.prototype.destroy = function () {
		        var nodeId = this.node._id, thisId = this._id, attrs = Tween.tweens[nodeId], key;
		        this.pause();
		        for (key in attrs) {
		            delete Tween.tweens[nodeId][key];
		        }
		        delete Tween.attrs[nodeId][thisId];
		    };
		    Tween.attrs = {};
		    Tween.tweens = {};
		    return Tween;
		}());
		exports.Tween = Tween;
		Node_1.Node.prototype.to = function (params) {
		    var onFinish = params.onFinish;
		    params.node = this;
		    params.onFinish = function () {
		        this.destroy();
		        if (onFinish) {
		            onFinish();
		        }
		    };
		    var tween = new Tween(params);
		    tween.play();
		};
		exports.Easings = {
		    BackEaseIn: function (t, b, c, d) {
		        var s = 1.70158;
		        return c * (t /= d) * t * ((s + 1) * t - s) + b;
		    },
		    BackEaseOut: function (t, b, c, d) {
		        var s = 1.70158;
		        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
		    },
		    BackEaseInOut: function (t, b, c, d) {
		        var s = 1.70158;
		        if ((t /= d / 2) < 1) {
		            return (c / 2) * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
		        }
		        return (c / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
		    },
		    ElasticEaseIn: function (t, b, c, d, a, p) {
		        var s = 0;
		        if (t === 0) {
		            return b;
		        }
		        if ((t /= d) === 1) {
		            return b + c;
		        }
		        if (!p) {
		            p = d * 0.3;
		        }
		        if (!a || a < Math.abs(c)) {
		            a = c;
		            s = p / 4;
		        }
		        else {
		            s = (p / (2 * Math.PI)) * Math.asin(c / a);
		        }
		        return (-(a *
		            Math.pow(2, 10 * (t -= 1)) *
		            Math.sin(((t * d - s) * (2 * Math.PI)) / p)) + b);
		    },
		    ElasticEaseOut: function (t, b, c, d, a, p) {
		        var s = 0;
		        if (t === 0) {
		            return b;
		        }
		        if ((t /= d) === 1) {
		            return b + c;
		        }
		        if (!p) {
		            p = d * 0.3;
		        }
		        if (!a || a < Math.abs(c)) {
		            a = c;
		            s = p / 4;
		        }
		        else {
		            s = (p / (2 * Math.PI)) * Math.asin(c / a);
		        }
		        return (a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
		            c +
		            b);
		    },
		    ElasticEaseInOut: function (t, b, c, d, a, p) {
		        var s = 0;
		        if (t === 0) {
		            return b;
		        }
		        if ((t /= d / 2) === 2) {
		            return b + c;
		        }
		        if (!p) {
		            p = d * (0.3 * 1.5);
		        }
		        if (!a || a < Math.abs(c)) {
		            a = c;
		            s = p / 4;
		        }
		        else {
		            s = (p / (2 * Math.PI)) * Math.asin(c / a);
		        }
		        if (t < 1) {
		            return (-0.5 *
		                (a *
		                    Math.pow(2, 10 * (t -= 1)) *
		                    Math.sin(((t * d - s) * (2 * Math.PI)) / p)) +
		                b);
		        }
		        return (a *
		            Math.pow(2, -10 * (t -= 1)) *
		            Math.sin(((t * d - s) * (2 * Math.PI)) / p) *
		            0.5 +
		            c +
		            b);
		    },
		    BounceEaseOut: function (t, b, c, d) {
		        if ((t /= d) < 1 / 2.75) {
		            return c * (7.5625 * t * t) + b;
		        }
		        else if (t < 2 / 2.75) {
		            return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
		        }
		        else if (t < 2.5 / 2.75) {
		            return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
		        }
		        else {
		            return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
		        }
		    },
		    BounceEaseIn: function (t, b, c, d) {
		        return c - exports.Easings.BounceEaseOut(d - t, 0, c, d) + b;
		    },
		    BounceEaseInOut: function (t, b, c, d) {
		        if (t < d / 2) {
		            return exports.Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
		        }
		        else {
		            return exports.Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
		        }
		    },
		    EaseIn: function (t, b, c, d) {
		        return c * (t /= d) * t + b;
		    },
		    EaseOut: function (t, b, c, d) {
		        return -c * (t /= d) * (t - 2) + b;
		    },
		    EaseInOut: function (t, b, c, d) {
		        if ((t /= d / 2) < 1) {
		            return (c / 2) * t * t + b;
		        }
		        return (-c / 2) * (--t * (t - 2) - 1) + b;
		    },
		    StrongEaseIn: function (t, b, c, d) {
		        return c * (t /= d) * t * t * t * t + b;
		    },
		    StrongEaseOut: function (t, b, c, d) {
		        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
		    },
		    StrongEaseInOut: function (t, b, c, d) {
		        if ((t /= d / 2) < 1) {
		            return (c / 2) * t * t * t * t * t + b;
		        }
		        return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
		    },
		    Linear: function (t, b, c, d) {
		        return (c * t) / d + b;
		    },
		}; 
	} (Tween$1));
	return Tween$1;
}

var hasRequired_CoreInternals;

function require_CoreInternals () {
	if (hasRequired_CoreInternals) return _CoreInternals;
	hasRequired_CoreInternals = 1;
	Object.defineProperty(_CoreInternals, "__esModule", { value: true });
	_CoreInternals.Konva = void 0;
	var Global_1 = requireGlobal();
	var Util_1 = requireUtil();
	var Node_1 = requireNode();
	var Container_1 = requireContainer();
	var Stage_1 = requireStage();
	var Layer_1 = requireLayer();
	var FastLayer_1 = requireFastLayer();
	var Group_1 = requireGroup();
	var DragAndDrop_1 = requireDragAndDrop();
	var Shape_1 = requireShape();
	var Animation_1 = requireAnimation();
	var Tween_1 = requireTween();
	var Context_1 = requireContext();
	var Canvas_1 = requireCanvas();
	_CoreInternals.Konva = Util_1.Util._assign(Global_1.Konva, {
	    Collection: Util_1.Collection,
	    Util: Util_1.Util,
	    Transform: Util_1.Transform,
	    Node: Node_1.Node,
	    ids: Node_1.ids,
	    names: Node_1.names,
	    Container: Container_1.Container,
	    Stage: Stage_1.Stage,
	    stages: Stage_1.stages,
	    Layer: Layer_1.Layer,
	    FastLayer: FastLayer_1.FastLayer,
	    Group: Group_1.Group,
	    DD: DragAndDrop_1.DD,
	    Shape: Shape_1.Shape,
	    shapes: Shape_1.shapes,
	    Animation: Animation_1.Animation,
	    Tween: Tween_1.Tween,
	    Easings: Tween_1.Easings,
	    Context: Context_1.Context,
	    Canvas: Canvas_1.Canvas
	});
	return _CoreInternals;
}

var Arc = {};

var hasRequiredArc;

function requireArc () {
	if (hasRequiredArc) return Arc;
	hasRequiredArc = 1;
	var __extends = (Arc && Arc.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Arc, "__esModule", { value: true });
	Arc.Arc = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Global_1 = requireGlobal();
	var Validators_1 = requireValidators();
	var Global_2 = requireGlobal();
	var Arc$1 = (function (_super) {
	    __extends(Arc, _super);
	    function Arc() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Arc.prototype._sceneFunc = function (context) {
	        var angle = Global_1.Konva.getAngle(this.angle()), clockwise = this.clockwise();
	        context.beginPath();
	        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
	        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Arc.prototype.getWidth = function () {
	        return this.outerRadius() * 2;
	    };
	    Arc.prototype.getHeight = function () {
	        return this.outerRadius() * 2;
	    };
	    Arc.prototype.setWidth = function (width) {
	        this.outerRadius(width / 2);
	    };
	    Arc.prototype.setHeight = function (height) {
	        this.outerRadius(height / 2);
	    };
	    return Arc;
	}(Shape_1.Shape));
	Arc.Arc = Arc$1;
	Arc$1.prototype._centroid = true;
	Arc$1.prototype.className = 'Arc';
	Arc$1.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
	Global_2._registerNode(Arc$1);
	Factory_1.Factory.addGetterSetter(Arc$1, 'innerRadius', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Arc$1, 'outerRadius', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Arc$1, 'angle', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Arc$1, 'clockwise', false, Validators_1.getBooleanValidator());
	Util_1.Collection.mapMethods(Arc$1);
	return Arc;
}

var Arrow = {};

var Line = {};

var hasRequiredLine;

function requireLine () {
	if (hasRequiredLine) return Line;
	hasRequiredLine = 1;
	var __extends = (Line && Line.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __spreadArrays = (Line && Line.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(Line, "__esModule", { value: true });
	Line.Line = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var Line$1 = (function (_super) {
	    __extends(Line, _super);
	    function Line(config) {
	        var _this = _super.call(this, config) || this;
	        _this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function () {
	            this._clearCache('tensionPoints');
	        });
	        return _this;
	    }
	    Line.prototype._sceneFunc = function (context) {
	        var points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier(), tp, len, n;
	        if (!length) {
	            return;
	        }
	        context.beginPath();
	        context.moveTo(points[0], points[1]);
	        if (tension !== 0 && length > 4) {
	            tp = this.getTensionPoints();
	            len = tp.length;
	            n = closed ? 0 : 4;
	            if (!closed) {
	                context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
	            }
	            while (n < len - 2) {
	                context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
	            }
	            if (!closed) {
	                context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
	            }
	        }
	        else if (bezier) {
	            n = 2;
	            while (n < length) {
	                context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
	            }
	        }
	        else {
	            for (n = 2; n < length; n += 2) {
	                context.lineTo(points[n], points[n + 1]);
	            }
	        }
	        if (closed) {
	            context.closePath();
	            context.fillStrokeShape(this);
	        }
	        else {
	            context.strokeShape(this);
	        }
	    };
	    Line.prototype.getTensionPoints = function () {
	        return this._getCache('tensionPoints', this._getTensionPoints);
	    };
	    Line.prototype._getTensionPoints = function () {
	        if (this.closed()) {
	            return this._getTensionPointsClosed();
	        }
	        else {
	            return Util_1.Util._expandPoints(this.points(), this.tension());
	        }
	    };
	    Line.prototype._getTensionPointsClosed = function () {
	        var p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = Util_1.Util._getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = Util_1.Util._getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = Util_1.Util._expandPoints(p, tension), tp = [firstControlPoints[2], firstControlPoints[3]]
	            .concat(middle)
	            .concat([
	            lastControlPoints[0],
	            lastControlPoints[1],
	            p[len - 2],
	            p[len - 1],
	            lastControlPoints[2],
	            lastControlPoints[3],
	            firstControlPoints[0],
	            firstControlPoints[1],
	            p[0],
	            p[1]
	        ]);
	        return tp;
	    };
	    Line.prototype.getWidth = function () {
	        return this.getSelfRect().width;
	    };
	    Line.prototype.getHeight = function () {
	        return this.getSelfRect().height;
	    };
	    Line.prototype.getSelfRect = function () {
	        var points = this.points();
	        if (points.length < 4) {
	            return {
	                x: points[0] || 0,
	                y: points[1] || 0,
	                width: 0,
	                height: 0
	            };
	        }
	        if (this.tension() !== 0) {
	            points = __spreadArrays([
	                points[0],
	                points[1]
	            ], this._getTensionPoints(), [
	                points[points.length - 2],
	                points[points.length - 1]
	            ]);
	        }
	        else {
	            points = this.points();
	        }
	        var minX = points[0];
	        var maxX = points[0];
	        var minY = points[1];
	        var maxY = points[1];
	        var x, y;
	        for (var i = 0; i < points.length / 2; i++) {
	            x = points[i * 2];
	            y = points[i * 2 + 1];
	            minX = Math.min(minX, x);
	            maxX = Math.max(maxX, x);
	            minY = Math.min(minY, y);
	            maxY = Math.max(maxY, y);
	        }
	        return {
	            x: minX,
	            y: minY,
	            width: maxX - minX,
	            height: maxY - minY
	        };
	    };
	    return Line;
	}(Shape_1.Shape));
	Line.Line = Line$1;
	Line$1.prototype.className = 'Line';
	Line$1.prototype._attrsAffectingSize = ['points', 'bezier', 'tension'];
	Global_1._registerNode(Line$1);
	Factory_1.Factory.addGetterSetter(Line$1, 'closed', false);
	Factory_1.Factory.addGetterSetter(Line$1, 'bezier', false);
	Factory_1.Factory.addGetterSetter(Line$1, 'tension', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Line$1, 'points', [], Validators_1.getNumberArrayValidator());
	Util_1.Collection.mapMethods(Line$1);
	return Line;
}

var hasRequiredArrow;

function requireArrow () {
	if (hasRequiredArrow) return Arrow;
	hasRequiredArrow = 1;
	var __extends = (Arrow && Arrow.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Arrow, "__esModule", { value: true });
	Arrow.Arrow = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Line_1 = requireLine();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var Arrow$1 = (function (_super) {
	    __extends(Arrow, _super);
	    function Arrow() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Arrow.prototype._sceneFunc = function (ctx) {
	        _super.prototype._sceneFunc.call(this, ctx);
	        var PI2 = Math.PI * 2;
	        var points = this.points();
	        var tp = points;
	        var fromTension = this.tension() !== 0 && points.length > 4;
	        if (fromTension) {
	            tp = this.getTensionPoints();
	        }
	        var n = points.length;
	        var dx, dy;
	        if (fromTension) {
	            dx = points[n - 2] - (tp[tp.length - 2] + tp[tp.length - 4]) / 2;
	            dy = points[n - 1] - (tp[tp.length - 1] + tp[tp.length - 3]) / 2;
	        }
	        else {
	            dx = points[n - 2] - points[n - 4];
	            dy = points[n - 1] - points[n - 3];
	        }
	        var radians = (Math.atan2(dy, dx) + PI2) % PI2;
	        var length = this.pointerLength();
	        var width = this.pointerWidth();
	        ctx.save();
	        ctx.beginPath();
	        ctx.translate(points[n - 2], points[n - 1]);
	        ctx.rotate(radians);
	        ctx.moveTo(0, 0);
	        ctx.lineTo(-length, width / 2);
	        ctx.lineTo(-length, -width / 2);
	        ctx.closePath();
	        ctx.restore();
	        if (this.pointerAtBeginning()) {
	            ctx.save();
	            ctx.translate(points[0], points[1]);
	            if (fromTension) {
	                dx = (tp[0] + tp[2]) / 2 - points[0];
	                dy = (tp[1] + tp[3]) / 2 - points[1];
	            }
	            else {
	                dx = points[2] - points[0];
	                dy = points[3] - points[1];
	            }
	            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
	            ctx.moveTo(0, 0);
	            ctx.lineTo(-length, width / 2);
	            ctx.lineTo(-length, -width / 2);
	            ctx.closePath();
	            ctx.restore();
	        }
	        var isDashEnabled = this.dashEnabled();
	        if (isDashEnabled) {
	            this.attrs.dashEnabled = false;
	            ctx.setLineDash([]);
	        }
	        ctx.fillStrokeShape(this);
	        if (isDashEnabled) {
	            this.attrs.dashEnabled = true;
	        }
	    };
	    Arrow.prototype.getSelfRect = function () {
	        var lineRect = _super.prototype.getSelfRect.call(this);
	        var offset = this.pointerWidth() / 2;
	        return {
	            x: lineRect.x - offset,
	            y: lineRect.y - offset,
	            width: lineRect.width + offset * 2,
	            height: lineRect.height + offset * 2
	        };
	    };
	    return Arrow;
	}(Line_1.Line));
	Arrow.Arrow = Arrow$1;
	Arrow$1.prototype.className = 'Arrow';
	Global_1._registerNode(Arrow$1);
	Factory_1.Factory.addGetterSetter(Arrow$1, 'pointerLength', 10, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Arrow$1, 'pointerWidth', 10, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Arrow$1, 'pointerAtBeginning', false);
	Util_1.Collection.mapMethods(Arrow$1);
	return Arrow;
}

var Circle = {};

var hasRequiredCircle;

function requireCircle () {
	if (hasRequiredCircle) return Circle;
	hasRequiredCircle = 1;
	var __extends = (Circle && Circle.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Circle, "__esModule", { value: true });
	Circle.Circle = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var Circle$1 = (function (_super) {
	    __extends(Circle, _super);
	    function Circle() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Circle.prototype._sceneFunc = function (context) {
	        context.beginPath();
	        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Circle.prototype.getWidth = function () {
	        return this.radius() * 2;
	    };
	    Circle.prototype.getHeight = function () {
	        return this.radius() * 2;
	    };
	    Circle.prototype.setWidth = function (width) {
	        if (this.radius() !== width / 2) {
	            this.radius(width / 2);
	        }
	    };
	    Circle.prototype.setHeight = function (height) {
	        if (this.radius() !== height / 2) {
	            this.radius(height / 2);
	        }
	    };
	    return Circle;
	}(Shape_1.Shape));
	Circle.Circle = Circle$1;
	Circle$1.prototype._centroid = true;
	Circle$1.prototype.className = 'Circle';
	Circle$1.prototype._attrsAffectingSize = ['radius'];
	Global_1._registerNode(Circle$1);
	Factory_1.Factory.addGetterSetter(Circle$1, 'radius', 0, Validators_1.getNumberValidator());
	Util_1.Collection.mapMethods(Circle$1);
	return Circle;
}

var Ellipse = {};

var hasRequiredEllipse;

function requireEllipse () {
	if (hasRequiredEllipse) return Ellipse;
	hasRequiredEllipse = 1;
	var __extends = (Ellipse && Ellipse.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Ellipse, "__esModule", { value: true });
	Ellipse.Ellipse = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var Ellipse$1 = (function (_super) {
	    __extends(Ellipse, _super);
	    function Ellipse() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Ellipse.prototype._sceneFunc = function (context) {
	        var rx = this.radiusX(), ry = this.radiusY();
	        context.beginPath();
	        context.save();
	        if (rx !== ry) {
	            context.scale(1, ry / rx);
	        }
	        context.arc(0, 0, rx, 0, Math.PI * 2, false);
	        context.restore();
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Ellipse.prototype.getWidth = function () {
	        return this.radiusX() * 2;
	    };
	    Ellipse.prototype.getHeight = function () {
	        return this.radiusY() * 2;
	    };
	    Ellipse.prototype.setWidth = function (width) {
	        this.radiusX(width / 2);
	    };
	    Ellipse.prototype.setHeight = function (height) {
	        this.radiusY(height / 2);
	    };
	    return Ellipse;
	}(Shape_1.Shape));
	Ellipse.Ellipse = Ellipse$1;
	Ellipse$1.prototype.className = 'Ellipse';
	Ellipse$1.prototype._centroid = true;
	Ellipse$1.prototype._attrsAffectingSize = ['radiusX', 'radiusY'];
	Global_1._registerNode(Ellipse$1);
	Factory_1.Factory.addComponentsGetterSetter(Ellipse$1, 'radius', ['x', 'y']);
	Factory_1.Factory.addGetterSetter(Ellipse$1, 'radiusX', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Ellipse$1, 'radiusY', 0, Validators_1.getNumberValidator());
	Util_1.Collection.mapMethods(Ellipse$1);
	return Ellipse;
}

var Image = {};

var hasRequiredImage;

function requireImage () {
	if (hasRequiredImage) return Image;
	hasRequiredImage = 1;
	var __extends = (Image && Image.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Image, "__esModule", { value: true });
	Image.Image = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var Image$1 = (function (_super) {
	    __extends(Image, _super);
	    function Image() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Image.prototype._useBufferCanvas = function () {
	        return _super.prototype._useBufferCanvas.call(this, true);
	    };
	    Image.prototype._sceneFunc = function (context) {
	        var width = this.getWidth();
	        var height = this.getHeight();
	        var image = this.attrs.image;
	        var params;
	        if (image) {
	            var cropWidth = this.attrs.cropWidth;
	            var cropHeight = this.attrs.cropHeight;
	            if (cropWidth && cropHeight) {
	                params = [
	                    image,
	                    this.cropX(),
	                    this.cropY(),
	                    cropWidth,
	                    cropHeight,
	                    0,
	                    0,
	                    width,
	                    height,
	                ];
	            }
	            else {
	                params = [image, 0, 0, width, height];
	            }
	        }
	        if (this.hasFill() || this.hasStroke()) {
	            context.beginPath();
	            context.rect(0, 0, width, height);
	            context.closePath();
	            context.fillStrokeShape(this);
	        }
	        if (image) {
	            context.drawImage.apply(context, params);
	        }
	    };
	    Image.prototype._hitFunc = function (context) {
	        var width = this.width(), height = this.height();
	        context.beginPath();
	        context.rect(0, 0, width, height);
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Image.prototype.getWidth = function () {
	        var _a, _b;
	        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (((_b = this.image()) === null || _b === void 0 ? void 0 : _b.width) || 0);
	    };
	    Image.prototype.getHeight = function () {
	        var _a, _b;
	        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (((_b = this.image()) === null || _b === void 0 ? void 0 : _b.height) || 0);
	    };
	    Image.fromURL = function (url, callback) {
	        var img = Util_1.Util.createImageElement();
	        img.onload = function () {
	            var image = new Image({
	                image: img,
	            });
	            callback(image);
	        };
	        img.crossOrigin = 'Anonymous';
	        img.src = url;
	    };
	    return Image;
	}(Shape_1.Shape));
	Image.Image = Image$1;
	Image$1.prototype.className = 'Image';
	Global_1._registerNode(Image$1);
	Factory_1.Factory.addGetterSetter(Image$1, 'image');
	Factory_1.Factory.addComponentsGetterSetter(Image$1, 'crop', ['x', 'y', 'width', 'height']);
	Factory_1.Factory.addGetterSetter(Image$1, 'cropX', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Image$1, 'cropY', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Image$1, 'cropWidth', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Image$1, 'cropHeight', 0, Validators_1.getNumberValidator());
	Util_1.Collection.mapMethods(Image$1);
	return Image;
}

var Label = {};

var hasRequiredLabel;

function requireLabel () {
	if (hasRequiredLabel) return Label;
	hasRequiredLabel = 1;
	var __extends = (Label && Label.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Label, "__esModule", { value: true });
	Label.Tag = Label.Label = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Group_1 = requireGroup();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var ATTR_CHANGE_LIST = [
	    'fontFamily',
	    'fontSize',
	    'fontStyle',
	    'padding',
	    'lineHeight',
	    'text',
	    'width',
	    'height',
	], CHANGE_KONVA = 'Change.konva', NONE = 'none', UP = 'up', RIGHT = 'right', DOWN = 'down', LEFT = 'left', attrChangeListLen = ATTR_CHANGE_LIST.length;
	var Label$1 = (function (_super) {
	    __extends(Label, _super);
	    function Label(config) {
	        var _this = _super.call(this, config) || this;
	        _this.on('add.konva', function (evt) {
	            this._addListeners(evt.child);
	            this._sync();
	        });
	        return _this;
	    }
	    Label.prototype.getText = function () {
	        return this.find('Text')[0];
	    };
	    Label.prototype.getTag = function () {
	        return this.find('Tag')[0];
	    };
	    Label.prototype._addListeners = function (text) {
	        var that = this, n;
	        var func = function () {
	            that._sync();
	        };
	        for (n = 0; n < attrChangeListLen; n++) {
	            text.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, func);
	        }
	    };
	    Label.prototype.getWidth = function () {
	        return this.getText().width();
	    };
	    Label.prototype.getHeight = function () {
	        return this.getText().height();
	    };
	    Label.prototype._sync = function () {
	        var text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
	        if (text && tag) {
	            width = text.width();
	            height = text.height();
	            pointerDirection = tag.pointerDirection();
	            pointerWidth = tag.pointerWidth();
	            pointerHeight = tag.pointerHeight();
	            x = 0;
	            y = 0;
	            switch (pointerDirection) {
	                case UP:
	                    x = width / 2;
	                    y = -1 * pointerHeight;
	                    break;
	                case RIGHT:
	                    x = width + pointerWidth;
	                    y = height / 2;
	                    break;
	                case DOWN:
	                    x = width / 2;
	                    y = height + pointerHeight;
	                    break;
	                case LEFT:
	                    x = -1 * pointerWidth;
	                    y = height / 2;
	                    break;
	            }
	            tag.setAttrs({
	                x: -1 * x,
	                y: -1 * y,
	                width: width,
	                height: height,
	            });
	            text.setAttrs({
	                x: -1 * x,
	                y: -1 * y,
	            });
	        }
	    };
	    return Label;
	}(Group_1.Group));
	Label.Label = Label$1;
	Label$1.prototype.className = 'Label';
	Global_1._registerNode(Label$1);
	Util_1.Collection.mapMethods(Label$1);
	var Tag = (function (_super) {
	    __extends(Tag, _super);
	    function Tag() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Tag.prototype._sceneFunc = function (context) {
	        var width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
	        var topLeft = 0;
	        var topRight = 0;
	        var bottomLeft = 0;
	        var bottomRight = 0;
	        if (typeof cornerRadius === 'number') {
	            topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
	        }
	        else {
	            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
	            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
	            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
	            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
	        }
	        context.beginPath();
	        context.moveTo(topLeft, 0);
	        if (pointerDirection === UP) {
	            context.lineTo((width - pointerWidth) / 2, 0);
	            context.lineTo(width / 2, -1 * pointerHeight);
	            context.lineTo((width + pointerWidth) / 2, 0);
	        }
	        context.lineTo(width - topRight, 0);
	        context.arc(width - topRight, topRight, topRight, (Math.PI * 3) / 2, 0, false);
	        if (pointerDirection === RIGHT) {
	            context.lineTo(width, (height - pointerHeight) / 2);
	            context.lineTo(width + pointerWidth, height / 2);
	            context.lineTo(width, (height + pointerHeight) / 2);
	        }
	        context.lineTo(width, height - bottomRight);
	        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
	        if (pointerDirection === DOWN) {
	            context.lineTo((width + pointerWidth) / 2, height);
	            context.lineTo(width / 2, height + pointerHeight);
	            context.lineTo((width - pointerWidth) / 2, height);
	        }
	        context.lineTo(bottomLeft, height);
	        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
	        if (pointerDirection === LEFT) {
	            context.lineTo(0, (height + pointerHeight) / 2);
	            context.lineTo(-1 * pointerWidth, height / 2);
	            context.lineTo(0, (height - pointerHeight) / 2);
	        }
	        context.lineTo(0, topLeft);
	        context.arc(topLeft, topLeft, topLeft, Math.PI, (Math.PI * 3) / 2, false);
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Tag.prototype.getSelfRect = function () {
	        var x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
	        if (direction === UP) {
	            y -= pointerHeight;
	            height += pointerHeight;
	        }
	        else if (direction === DOWN) {
	            height += pointerHeight;
	        }
	        else if (direction === LEFT) {
	            x -= pointerWidth * 1.5;
	            width += pointerWidth;
	        }
	        else if (direction === RIGHT) {
	            width += pointerWidth * 1.5;
	        }
	        return {
	            x: x,
	            y: y,
	            width: width,
	            height: height,
	        };
	    };
	    return Tag;
	}(Shape_1.Shape));
	Label.Tag = Tag;
	Tag.prototype.className = 'Tag';
	Global_1._registerNode(Tag);
	Factory_1.Factory.addGetterSetter(Tag, 'pointerDirection', NONE);
	Factory_1.Factory.addGetterSetter(Tag, 'pointerWidth', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Tag, 'pointerHeight', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Tag, 'cornerRadius', 0, Validators_1.getNumberOrArrayOfNumbersValidator(4));
	Util_1.Collection.mapMethods(Tag);
	return Label;
}

var Path = {};

var hasRequiredPath;

function requirePath () {
	if (hasRequiredPath) return Path;
	hasRequiredPath = 1;
	var __extends = (Path && Path.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Path, "__esModule", { value: true });
	Path.Path = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Global_1 = requireGlobal();
	var Path$1 = (function (_super) {
	    __extends(Path, _super);
	    function Path(config) {
	        var _this = _super.call(this, config) || this;
	        _this.dataArray = [];
	        _this.pathLength = 0;
	        _this.dataArray = Path.parsePathData(_this.data());
	        _this.pathLength = 0;
	        for (var i = 0; i < _this.dataArray.length; ++i) {
	            _this.pathLength += _this.dataArray[i].pathLength;
	        }
	        _this.on('dataChange.konva', function () {
	            this.dataArray = Path.parsePathData(this.data());
	            this.pathLength = 0;
	            for (var i = 0; i < this.dataArray.length; ++i) {
	                this.pathLength += this.dataArray[i].pathLength;
	            }
	        });
	        return _this;
	    }
	    Path.prototype._sceneFunc = function (context) {
	        var ca = this.dataArray;
	        context.beginPath();
	        var isClosed = false;
	        for (var n = 0; n < ca.length; n++) {
	            var c = ca[n].command;
	            var p = ca[n].points;
	            switch (c) {
	                case 'L':
	                    context.lineTo(p[0], p[1]);
	                    break;
	                case 'M':
	                    context.moveTo(p[0], p[1]);
	                    break;
	                case 'C':
	                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
	                    break;
	                case 'Q':
	                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
	                    break;
	                case 'A':
	                    var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
	                    var r = rx > ry ? rx : ry;
	                    var scaleX = rx > ry ? 1 : rx / ry;
	                    var scaleY = rx > ry ? ry / rx : 1;
	                    context.translate(cx, cy);
	                    context.rotate(psi);
	                    context.scale(scaleX, scaleY);
	                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
	                    context.scale(1 / scaleX, 1 / scaleY);
	                    context.rotate(-psi);
	                    context.translate(-cx, -cy);
	                    break;
	                case 'z':
	                    isClosed = true;
	                    context.closePath();
	                    break;
	            }
	        }
	        if (!isClosed && !this.hasFill()) {
	            context.strokeShape(this);
	        }
	        else {
	            context.fillStrokeShape(this);
	        }
	    };
	    Path.prototype.getSelfRect = function () {
	        var points = [];
	        this.dataArray.forEach(function (data) {
	            if (data.command === 'A') {
	                var start = data.points[4];
	                var dTheta = data.points[5];
	                var end = data.points[4] + dTheta;
	                var inc = Math.PI / 180.0;
	                if (Math.abs(start - end) < inc) {
	                    inc = Math.abs(start - end);
	                }
	                if (dTheta < 0) {
	                    for (var t = start - inc; t > end; t -= inc) {
	                        var point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
	                        points.push(point.x, point.y);
	                    }
	                }
	                else {
	                    for (var t = start + inc; t < end; t += inc) {
	                        var point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
	                        points.push(point.x, point.y);
	                    }
	                }
	            }
	            else if (data.command === 'C') {
	                for (var t = 0.0; t <= 1; t += 0.01) {
	                    var point = Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
	                    points.push(point.x, point.y);
	                }
	            }
	            else {
	                points = points.concat(data.points);
	            }
	        });
	        var minX = points[0];
	        var maxX = points[0];
	        var minY = points[1];
	        var maxY = points[1];
	        var x, y;
	        for (var i = 0; i < points.length / 2; i++) {
	            x = points[i * 2];
	            y = points[i * 2 + 1];
	            if (!isNaN(x)) {
	                minX = Math.min(minX, x);
	                maxX = Math.max(maxX, x);
	            }
	            if (!isNaN(y)) {
	                minY = Math.min(minY, y);
	                maxY = Math.max(maxY, y);
	            }
	        }
	        return {
	            x: Math.round(minX),
	            y: Math.round(minY),
	            width: Math.round(maxX - minX),
	            height: Math.round(maxY - minY),
	        };
	    };
	    Path.prototype.getLength = function () {
	        return this.pathLength;
	    };
	    Path.prototype.getPointAtLength = function (length) {
	        var point, i = 0, ii = this.dataArray.length;
	        if (!ii) {
	            return null;
	        }
	        while (i < ii && length > this.dataArray[i].pathLength) {
	            length -= this.dataArray[i].pathLength;
	            ++i;
	        }
	        if (i === ii) {
	            point = this.dataArray[i - 1].points.slice(-2);
	            return {
	                x: point[0],
	                y: point[1],
	            };
	        }
	        if (length < 0.01) {
	            point = this.dataArray[i].points.slice(0, 2);
	            return {
	                x: point[0],
	                y: point[1],
	            };
	        }
	        var cp = this.dataArray[i];
	        var p = cp.points;
	        switch (cp.command) {
	            case 'L':
	                return Path.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
	            case 'C':
	                return Path.getPointOnCubicBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
	            case 'Q':
	                return Path.getPointOnQuadraticBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
	            case 'A':
	                var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
	                theta += (dTheta * length) / cp.pathLength;
	                return Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
	        }
	        return null;
	    };
	    Path.getLineLength = function (x1, y1, x2, y2) {
	        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	    };
	    Path.getPointOnLine = function (dist, P1x, P1y, P2x, P2y, fromX, fromY) {
	        if (fromX === undefined) {
	            fromX = P1x;
	        }
	        if (fromY === undefined) {
	            fromY = P1y;
	        }
	        var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
	        var run = Math.sqrt((dist * dist) / (1 + m * m));
	        if (P2x < P1x) {
	            run *= -1;
	        }
	        var rise = m * run;
	        var pt;
	        if (P2x === P1x) {
	            pt = {
	                x: fromX,
	                y: fromY + rise,
	            };
	        }
	        else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) {
	            pt = {
	                x: fromX + run,
	                y: fromY + rise,
	            };
	        }
	        else {
	            var ix, iy;
	            var len = this.getLineLength(P1x, P1y, P2x, P2y);
	            var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
	            u = u / (len * len);
	            ix = P1x + u * (P2x - P1x);
	            iy = P1y + u * (P2y - P1y);
	            var pRise = this.getLineLength(fromX, fromY, ix, iy);
	            var pRun = Math.sqrt(dist * dist - pRise * pRise);
	            run = Math.sqrt((pRun * pRun) / (1 + m * m));
	            if (P2x < P1x) {
	                run *= -1;
	            }
	            rise = m * run;
	            pt = {
	                x: ix + run,
	                y: iy + rise,
	            };
	        }
	        return pt;
	    };
	    Path.getPointOnCubicBezier = function (pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
	        function CB1(t) {
	            return t * t * t;
	        }
	        function CB2(t) {
	            return 3 * t * t * (1 - t);
	        }
	        function CB3(t) {
	            return 3 * t * (1 - t) * (1 - t);
	        }
	        function CB4(t) {
	            return (1 - t) * (1 - t) * (1 - t);
	        }
	        var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
	        var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
	        return {
	            x: x,
	            y: y,
	        };
	    };
	    Path.getPointOnQuadraticBezier = function (pct, P1x, P1y, P2x, P2y, P3x, P3y) {
	        function QB1(t) {
	            return t * t;
	        }
	        function QB2(t) {
	            return 2 * t * (1 - t);
	        }
	        function QB3(t) {
	            return (1 - t) * (1 - t);
	        }
	        var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
	        var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
	        return {
	            x: x,
	            y: y,
	        };
	    };
	    Path.getPointOnEllipticalArc = function (cx, cy, rx, ry, theta, psi) {
	        var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
	        var pt = {
	            x: rx * Math.cos(theta),
	            y: ry * Math.sin(theta),
	        };
	        return {
	            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
	            y: cy + (pt.x * sinPsi + pt.y * cosPsi),
	        };
	    };
	    Path.parsePathData = function (data) {
	        if (!data) {
	            return [];
	        }
	        var cs = data;
	        var cc = [
	            'm',
	            'M',
	            'l',
	            'L',
	            'v',
	            'V',
	            'h',
	            'H',
	            'z',
	            'Z',
	            'c',
	            'C',
	            'q',
	            'Q',
	            't',
	            'T',
	            's',
	            'S',
	            'a',
	            'A',
	        ];
	        cs = cs.replace(new RegExp(' ', 'g'), ',');
	        for (var n = 0; n < cc.length; n++) {
	            cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
	        }
	        var arr = cs.split('|');
	        var ca = [];
	        var coords = [];
	        var cpx = 0;
	        var cpy = 0;
	        var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
	        var match;
	        for (n = 1; n < arr.length; n++) {
	            var str = arr[n];
	            var c = str.charAt(0);
	            str = str.slice(1);
	            coords.length = 0;
	            while ((match = re.exec(str))) {
	                coords.push(match[0]);
	            }
	            var p = [];
	            for (var j = 0, jlen = coords.length; j < jlen; j++) {
	                var parsed = parseFloat(coords[j]);
	                if (!isNaN(parsed)) {
	                    p.push(parsed);
	                }
	                else {
	                    p.push(0);
	                }
	            }
	            while (p.length > 0) {
	                if (isNaN(p[0])) {
	                    break;
	                }
	                var cmd = null;
	                var points = [];
	                var startX = cpx, startY = cpy;
	                var prevCmd, ctlPtx, ctlPty;
	                var rx, ry, psi, fa, fs, x1, y1;
	                switch (c) {
	                    case 'l':
	                        cpx += p.shift();
	                        cpy += p.shift();
	                        cmd = 'L';
	                        points.push(cpx, cpy);
	                        break;
	                    case 'L':
	                        cpx = p.shift();
	                        cpy = p.shift();
	                        points.push(cpx, cpy);
	                        break;
	                    case 'm':
	                        var dx = p.shift();
	                        var dy = p.shift();
	                        cpx += dx;
	                        cpy += dy;
	                        cmd = 'M';
	                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
	                            for (var idx = ca.length - 2; idx >= 0; idx--) {
	                                if (ca[idx].command === 'M') {
	                                    cpx = ca[idx].points[0] + dx;
	                                    cpy = ca[idx].points[1] + dy;
	                                    break;
	                                }
	                            }
	                        }
	                        points.push(cpx, cpy);
	                        c = 'l';
	                        break;
	                    case 'M':
	                        cpx = p.shift();
	                        cpy = p.shift();
	                        cmd = 'M';
	                        points.push(cpx, cpy);
	                        c = 'L';
	                        break;
	                    case 'h':
	                        cpx += p.shift();
	                        cmd = 'L';
	                        points.push(cpx, cpy);
	                        break;
	                    case 'H':
	                        cpx = p.shift();
	                        cmd = 'L';
	                        points.push(cpx, cpy);
	                        break;
	                    case 'v':
	                        cpy += p.shift();
	                        cmd = 'L';
	                        points.push(cpx, cpy);
	                        break;
	                    case 'V':
	                        cpy = p.shift();
	                        cmd = 'L';
	                        points.push(cpx, cpy);
	                        break;
	                    case 'C':
	                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
	                        cpx = p.shift();
	                        cpy = p.shift();
	                        points.push(cpx, cpy);
	                        break;
	                    case 'c':
	                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
	                        cpx += p.shift();
	                        cpy += p.shift();
	                        cmd = 'C';
	                        points.push(cpx, cpy);
	                        break;
	                    case 'S':
	                        ctlPtx = cpx;
	                        ctlPty = cpy;
	                        prevCmd = ca[ca.length - 1];
	                        if (prevCmd.command === 'C') {
	                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
	                            ctlPty = cpy + (cpy - prevCmd.points[3]);
	                        }
	                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
	                        cpx = p.shift();
	                        cpy = p.shift();
	                        cmd = 'C';
	                        points.push(cpx, cpy);
	                        break;
	                    case 's':
	                        ctlPtx = cpx;
	                        ctlPty = cpy;
	                        prevCmd = ca[ca.length - 1];
	                        if (prevCmd.command === 'C') {
	                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
	                            ctlPty = cpy + (cpy - prevCmd.points[3]);
	                        }
	                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
	                        cpx += p.shift();
	                        cpy += p.shift();
	                        cmd = 'C';
	                        points.push(cpx, cpy);
	                        break;
	                    case 'Q':
	                        points.push(p.shift(), p.shift());
	                        cpx = p.shift();
	                        cpy = p.shift();
	                        points.push(cpx, cpy);
	                        break;
	                    case 'q':
	                        points.push(cpx + p.shift(), cpy + p.shift());
	                        cpx += p.shift();
	                        cpy += p.shift();
	                        cmd = 'Q';
	                        points.push(cpx, cpy);
	                        break;
	                    case 'T':
	                        ctlPtx = cpx;
	                        ctlPty = cpy;
	                        prevCmd = ca[ca.length - 1];
	                        if (prevCmd.command === 'Q') {
	                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
	                            ctlPty = cpy + (cpy - prevCmd.points[1]);
	                        }
	                        cpx = p.shift();
	                        cpy = p.shift();
	                        cmd = 'Q';
	                        points.push(ctlPtx, ctlPty, cpx, cpy);
	                        break;
	                    case 't':
	                        ctlPtx = cpx;
	                        ctlPty = cpy;
	                        prevCmd = ca[ca.length - 1];
	                        if (prevCmd.command === 'Q') {
	                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
	                            ctlPty = cpy + (cpy - prevCmd.points[1]);
	                        }
	                        cpx += p.shift();
	                        cpy += p.shift();
	                        cmd = 'Q';
	                        points.push(ctlPtx, ctlPty, cpx, cpy);
	                        break;
	                    case 'A':
	                        rx = p.shift();
	                        ry = p.shift();
	                        psi = p.shift();
	                        fa = p.shift();
	                        fs = p.shift();
	                        x1 = cpx;
	                        y1 = cpy;
	                        cpx = p.shift();
	                        cpy = p.shift();
	                        cmd = 'A';
	                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
	                        break;
	                    case 'a':
	                        rx = p.shift();
	                        ry = p.shift();
	                        psi = p.shift();
	                        fa = p.shift();
	                        fs = p.shift();
	                        x1 = cpx;
	                        y1 = cpy;
	                        cpx += p.shift();
	                        cpy += p.shift();
	                        cmd = 'A';
	                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
	                        break;
	                }
	                ca.push({
	                    command: cmd || c,
	                    points: points,
	                    start: {
	                        x: startX,
	                        y: startY,
	                    },
	                    pathLength: this.calcLength(startX, startY, cmd || c, points),
	                });
	            }
	            if (c === 'z' || c === 'Z') {
	                ca.push({
	                    command: 'z',
	                    points: [],
	                    start: undefined,
	                    pathLength: 0,
	                });
	            }
	        }
	        return ca;
	    };
	    Path.calcLength = function (x, y, cmd, points) {
	        var len, p1, p2, t;
	        var path = Path;
	        switch (cmd) {
	            case 'L':
	                return path.getLineLength(x, y, points[0], points[1]);
	            case 'C':
	                len = 0.0;
	                p1 = path.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
	                for (t = 0.01; t <= 1; t += 0.01) {
	                    p2 = path.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
	                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	                    p1 = p2;
	                }
	                return len;
	            case 'Q':
	                len = 0.0;
	                p1 = path.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);
	                for (t = 0.01; t <= 1; t += 0.01) {
	                    p2 = path.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
	                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	                    p1 = p2;
	                }
	                return len;
	            case 'A':
	                len = 0.0;
	                var start = points[4];
	                var dTheta = points[5];
	                var end = points[4] + dTheta;
	                var inc = Math.PI / 180.0;
	                if (Math.abs(start - end) < inc) {
	                    inc = Math.abs(start - end);
	                }
	                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
	                if (dTheta < 0) {
	                    for (t = start - inc; t > end; t -= inc) {
	                        p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
	                        len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	                        p1 = p2;
	                    }
	                }
	                else {
	                    for (t = start + inc; t < end; t += inc) {
	                        p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
	                        len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	                        p1 = p2;
	                    }
	                }
	                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
	                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	                return len;
	        }
	        return 0;
	    };
	    Path.convertEndpointToCenterParameterization = function (x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
	        var psi = psiDeg * (Math.PI / 180.0);
	        var xp = (Math.cos(psi) * (x1 - x2)) / 2.0 + (Math.sin(psi) * (y1 - y2)) / 2.0;
	        var yp = (-1 * Math.sin(psi) * (x1 - x2)) / 2.0 +
	            (Math.cos(psi) * (y1 - y2)) / 2.0;
	        var lambda = (xp * xp) / (rx * rx) + (yp * yp) / (ry * ry);
	        if (lambda > 1) {
	            rx *= Math.sqrt(lambda);
	            ry *= Math.sqrt(lambda);
	        }
	        var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) /
	            (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
	        if (fa === fs) {
	            f *= -1;
	        }
	        if (isNaN(f)) {
	            f = 0;
	        }
	        var cxp = (f * rx * yp) / ry;
	        var cyp = (f * -ry * xp) / rx;
	        var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
	        var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
	        var vMag = function (v) {
	            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	        };
	        var vRatio = function (u, v) {
	            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	        };
	        var vAngle = function (u, v) {
	            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
	        };
	        var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	        var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	        var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	        var dTheta = vAngle(u, v);
	        if (vRatio(u, v) <= -1) {
	            dTheta = Math.PI;
	        }
	        if (vRatio(u, v) >= 1) {
	            dTheta = 0;
	        }
	        if (fs === 0 && dTheta > 0) {
	            dTheta = dTheta - 2 * Math.PI;
	        }
	        if (fs === 1 && dTheta < 0) {
	            dTheta = dTheta + 2 * Math.PI;
	        }
	        return [cx, cy, rx, ry, theta, dTheta, psi, fs];
	    };
	    return Path;
	}(Shape_1.Shape));
	Path.Path = Path$1;
	Path$1.prototype.className = 'Path';
	Path$1.prototype._attrsAffectingSize = ['data'];
	Global_1._registerNode(Path$1);
	Factory_1.Factory.addGetterSetter(Path$1, 'data');
	Util_1.Collection.mapMethods(Path$1);
	return Path;
}

var Rect = {};

var hasRequiredRect;

function requireRect () {
	if (hasRequiredRect) return Rect;
	hasRequiredRect = 1;
	var __extends = (Rect && Rect.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Rect, "__esModule", { value: true });
	Rect.Rect = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Global_1 = requireGlobal();
	var Validators_1 = requireValidators();
	var Rect$1 = (function (_super) {
	    __extends(Rect, _super);
	    function Rect() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Rect.prototype._sceneFunc = function (context) {
	        var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
	        context.beginPath();
	        if (!cornerRadius) {
	            context.rect(0, 0, width, height);
	        }
	        else {
	            var topLeft = 0;
	            var topRight = 0;
	            var bottomLeft = 0;
	            var bottomRight = 0;
	            if (typeof cornerRadius === 'number') {
	                topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
	            }
	            else {
	                topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
	                topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
	                bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
	                bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
	            }
	            context.moveTo(topLeft, 0);
	            context.lineTo(width - topRight, 0);
	            context.arc(width - topRight, topRight, topRight, (Math.PI * 3) / 2, 0, false);
	            context.lineTo(width, height - bottomRight);
	            context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
	            context.lineTo(bottomLeft, height);
	            context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
	            context.lineTo(0, topLeft);
	            context.arc(topLeft, topLeft, topLeft, Math.PI, (Math.PI * 3) / 2, false);
	        }
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    return Rect;
	}(Shape_1.Shape));
	Rect.Rect = Rect$1;
	Rect$1.prototype.className = 'Rect';
	Global_1._registerNode(Rect$1);
	Factory_1.Factory.addGetterSetter(Rect$1, 'cornerRadius', 0, Validators_1.getNumberOrArrayOfNumbersValidator(4));
	Util_1.Collection.mapMethods(Rect$1);
	return Rect;
}

var RegularPolygon = {};

var hasRequiredRegularPolygon;

function requireRegularPolygon () {
	if (hasRequiredRegularPolygon) return RegularPolygon;
	hasRequiredRegularPolygon = 1;
	var __extends = (RegularPolygon && RegularPolygon.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(RegularPolygon, "__esModule", { value: true });
	RegularPolygon.RegularPolygon = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var RegularPolygon$1 = (function (_super) {
	    __extends(RegularPolygon, _super);
	    function RegularPolygon() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    RegularPolygon.prototype._sceneFunc = function (context) {
	        var points = this._getPoints();
	        context.beginPath();
	        context.moveTo(points[0].x, points[0].y);
	        for (var n = 1; n < points.length; n++) {
	            context.lineTo(points[n].x, points[n].y);
	        }
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    RegularPolygon.prototype._getPoints = function () {
	        var sides = this.attrs.sides;
	        var radius = this.attrs.radius || 0;
	        var points = [];
	        for (var n = 0; n < sides; n++) {
	            points.push({
	                x: radius * Math.sin((n * 2 * Math.PI) / sides),
	                y: -1 * radius * Math.cos((n * 2 * Math.PI) / sides),
	            });
	        }
	        return points;
	    };
	    RegularPolygon.prototype.getSelfRect = function () {
	        var points = this._getPoints();
	        var minX = points[0].x;
	        var maxX = points[0].y;
	        var minY = points[0].x;
	        var maxY = points[0].y;
	        points.forEach(function (point) {
	            minX = Math.min(minX, point.x);
	            maxX = Math.max(maxX, point.x);
	            minY = Math.min(minY, point.y);
	            maxY = Math.max(maxY, point.y);
	        });
	        return {
	            x: minX,
	            y: minY,
	            width: maxX - minX,
	            height: maxY - minY,
	        };
	    };
	    RegularPolygon.prototype.getWidth = function () {
	        return this.radius() * 2;
	    };
	    RegularPolygon.prototype.getHeight = function () {
	        return this.radius() * 2;
	    };
	    RegularPolygon.prototype.setWidth = function (width) {
	        this.radius(width / 2);
	    };
	    RegularPolygon.prototype.setHeight = function (height) {
	        this.radius(height / 2);
	    };
	    return RegularPolygon;
	}(Shape_1.Shape));
	RegularPolygon.RegularPolygon = RegularPolygon$1;
	RegularPolygon$1.prototype.className = 'RegularPolygon';
	RegularPolygon$1.prototype._centroid = true;
	RegularPolygon$1.prototype._attrsAffectingSize = ['radius'];
	Global_1._registerNode(RegularPolygon$1);
	Factory_1.Factory.addGetterSetter(RegularPolygon$1, 'radius', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(RegularPolygon$1, 'sides', 0, Validators_1.getNumberValidator());
	Util_1.Collection.mapMethods(RegularPolygon$1);
	return RegularPolygon;
}

var Ring = {};

var hasRequiredRing;

function requireRing () {
	if (hasRequiredRing) return Ring;
	hasRequiredRing = 1;
	var __extends = (Ring && Ring.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Ring, "__esModule", { value: true });
	Ring.Ring = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var PIx2 = Math.PI * 2;
	var Ring$1 = (function (_super) {
	    __extends(Ring, _super);
	    function Ring() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Ring.prototype._sceneFunc = function (context) {
	        context.beginPath();
	        context.arc(0, 0, this.innerRadius(), 0, PIx2, false);
	        context.moveTo(this.outerRadius(), 0);
	        context.arc(0, 0, this.outerRadius(), PIx2, 0, true);
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Ring.prototype.getWidth = function () {
	        return this.outerRadius() * 2;
	    };
	    Ring.prototype.getHeight = function () {
	        return this.outerRadius() * 2;
	    };
	    Ring.prototype.setWidth = function (width) {
	        this.outerRadius(width / 2);
	    };
	    Ring.prototype.setHeight = function (height) {
	        this.outerRadius(height / 2);
	    };
	    return Ring;
	}(Shape_1.Shape));
	Ring.Ring = Ring$1;
	Ring$1.prototype.className = 'Ring';
	Ring$1.prototype._centroid = true;
	Ring$1.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
	Global_1._registerNode(Ring$1);
	Factory_1.Factory.addGetterSetter(Ring$1, 'innerRadius', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Ring$1, 'outerRadius', 0, Validators_1.getNumberValidator());
	Util_1.Collection.mapMethods(Ring$1);
	return Ring;
}

var Sprite = {};

var hasRequiredSprite;

function requireSprite () {
	if (hasRequiredSprite) return Sprite;
	hasRequiredSprite = 1;
	var __extends = (Sprite && Sprite.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Sprite, "__esModule", { value: true });
	Sprite.Sprite = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Animation_1 = requireAnimation();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var Sprite$1 = (function (_super) {
	    __extends(Sprite, _super);
	    function Sprite(config) {
	        var _this = _super.call(this, config) || this;
	        _this._updated = true;
	        _this.anim = new Animation_1.Animation(function () {
	            var updated = _this._updated;
	            _this._updated = false;
	            return updated;
	        });
	        _this.on('animationChange.konva', function () {
	            this.frameIndex(0);
	        });
	        _this.on('frameIndexChange.konva', function () {
	            this._updated = true;
	        });
	        _this.on('frameRateChange.konva', function () {
	            if (!this.anim.isRunning()) {
	                return;
	            }
	            clearInterval(this.interval);
	            this._setInterval();
	        });
	        return _this;
	    }
	    Sprite.prototype._sceneFunc = function (context) {
	        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
	        if (this.hasFill() || this.hasStroke()) {
	            context.beginPath();
	            context.rect(0, 0, width, height);
	            context.closePath();
	            context.fillStrokeShape(this);
	        }
	        if (image) {
	            if (offsets) {
	                var offset = offsets[anim], ix2 = index * 2;
	                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
	            }
	            else {
	                context.drawImage(image, x, y, width, height, 0, 0, width, height);
	            }
	        }
	    };
	    Sprite.prototype._hitFunc = function (context) {
	        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
	        context.beginPath();
	        if (offsets) {
	            var offset = offsets[anim];
	            var ix2 = index * 2;
	            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
	        }
	        else {
	            context.rect(0, 0, width, height);
	        }
	        context.closePath();
	        context.fillShape(this);
	    };
	    Sprite.prototype._useBufferCanvas = function () {
	        return _super.prototype._useBufferCanvas.call(this, true);
	    };
	    Sprite.prototype._setInterval = function () {
	        var that = this;
	        this.interval = setInterval(function () {
	            that._updateIndex();
	        }, 1000 / this.frameRate());
	    };
	    Sprite.prototype.start = function () {
	        if (this.isRunning()) {
	            return;
	        }
	        var layer = this.getLayer();
	        this.anim.setLayers(layer);
	        this._setInterval();
	        this.anim.start();
	    };
	    Sprite.prototype.stop = function () {
	        this.anim.stop();
	        clearInterval(this.interval);
	    };
	    Sprite.prototype.isRunning = function () {
	        return this.anim.isRunning();
	    };
	    Sprite.prototype._updateIndex = function () {
	        var index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
	        if (index < len - 1) {
	            this.frameIndex(index + 1);
	        }
	        else {
	            this.frameIndex(0);
	        }
	    };
	    return Sprite;
	}(Shape_1.Shape));
	Sprite.Sprite = Sprite$1;
	Sprite$1.prototype.className = 'Sprite';
	Global_1._registerNode(Sprite$1);
	Factory_1.Factory.addGetterSetter(Sprite$1, 'animation');
	Factory_1.Factory.addGetterSetter(Sprite$1, 'animations');
	Factory_1.Factory.addGetterSetter(Sprite$1, 'frameOffsets');
	Factory_1.Factory.addGetterSetter(Sprite$1, 'image');
	Factory_1.Factory.addGetterSetter(Sprite$1, 'frameIndex', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Sprite$1, 'frameRate', 17, Validators_1.getNumberValidator());
	Factory_1.Factory.backCompat(Sprite$1, {
	    index: 'frameIndex',
	    getIndex: 'getFrameIndex',
	    setIndex: 'setFrameIndex',
	});
	Util_1.Collection.mapMethods(Sprite$1);
	return Sprite;
}

var Star = {};

var hasRequiredStar;

function requireStar () {
	if (hasRequiredStar) return Star;
	hasRequiredStar = 1;
	var __extends = (Star && Star.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Star, "__esModule", { value: true });
	Star.Star = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var Star$1 = (function (_super) {
	    __extends(Star, _super);
	    function Star() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Star.prototype._sceneFunc = function (context) {
	        var innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
	        context.beginPath();
	        context.moveTo(0, 0 - outerRadius);
	        for (var n = 1; n < numPoints * 2; n++) {
	            var radius = n % 2 === 0 ? outerRadius : innerRadius;
	            var x = radius * Math.sin((n * Math.PI) / numPoints);
	            var y = -1 * radius * Math.cos((n * Math.PI) / numPoints);
	            context.lineTo(x, y);
	        }
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Star.prototype.getWidth = function () {
	        return this.outerRadius() * 2;
	    };
	    Star.prototype.getHeight = function () {
	        return this.outerRadius() * 2;
	    };
	    Star.prototype.setWidth = function (width) {
	        this.outerRadius(width / 2);
	    };
	    Star.prototype.setHeight = function (height) {
	        this.outerRadius(height / 2);
	    };
	    return Star;
	}(Shape_1.Shape));
	Star.Star = Star$1;
	Star$1.prototype.className = 'Star';
	Star$1.prototype._centroid = true;
	Star$1.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
	Global_1._registerNode(Star$1);
	Factory_1.Factory.addGetterSetter(Star$1, 'numPoints', 5, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Star$1, 'innerRadius', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Star$1, 'outerRadius', 0, Validators_1.getNumberValidator());
	Util_1.Collection.mapMethods(Star$1);
	return Star;
}

var Text = {};

var hasRequiredText;

function requireText () {
	if (hasRequiredText) return Text;
	hasRequiredText = 1;
	var __extends = (Text && Text.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Text, "__esModule", { value: true });
	Text.Text = Text.stringToArray = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Global_1 = requireGlobal();
	var Validators_1 = requireValidators();
	var Global_2 = requireGlobal();
	function stringToArray(string) {
	    return Array.from(string);
	}
	Text.stringToArray = stringToArray;
	var AUTO = 'auto', CENTER = 'center', JUSTIFY = 'justify', CHANGE_KONVA = 'Change.konva', CONTEXT_2D = '2d', DASH = '-', LEFT = 'left', TEXT = 'text', TEXT_UPPER = 'Text', TOP = 'top', BOTTOM = 'bottom', MIDDLE = 'middle', NORMAL = 'normal', PX_SPACE = 'px ', SPACE = ' ', RIGHT = 'right', WORD = 'word', CHAR = 'char', NONE = 'none', ELLIPSIS = '…', ATTR_CHANGE_LIST = [
	    'fontFamily',
	    'fontSize',
	    'fontStyle',
	    'fontVariant',
	    'padding',
	    'align',
	    'verticalAlign',
	    'lineHeight',
	    'text',
	    'width',
	    'height',
	    'wrap',
	    'ellipsis',
	    'letterSpacing',
	], attrChangeListLen = ATTR_CHANGE_LIST.length;
	function normalizeFontFamily(fontFamily) {
	    return fontFamily
	        .split(',')
	        .map(function (family) {
	        family = family.trim();
	        var hasSpace = family.indexOf(' ') >= 0;
	        var hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
	        if (hasSpace && !hasQuotes) {
	            family = "\"" + family + "\"";
	        }
	        return family;
	    })
	        .join(', ');
	}
	var dummyContext;
	function getDummyContext() {
	    if (dummyContext) {
	        return dummyContext;
	    }
	    dummyContext = Util_1.Util.createCanvasElement().getContext(CONTEXT_2D);
	    return dummyContext;
	}
	function _fillFunc(context) {
	    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
	}
	function _strokeFunc(context) {
	    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
	}
	function checkDefaultFill(config) {
	    config = config || {};
	    if (!config.fillLinearGradientColorStops &&
	        !config.fillRadialGradientColorStops &&
	        !config.fillPatternImage) {
	        config.fill = config.fill || 'black';
	    }
	    return config;
	}
	var Text$1 = (function (_super) {
	    __extends(Text, _super);
	    function Text(config) {
	        var _this = _super.call(this, checkDefaultFill(config)) || this;
	        _this._partialTextX = 0;
	        _this._partialTextY = 0;
	        for (var n = 0; n < attrChangeListLen; n++) {
	            _this.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, _this._setTextData);
	        }
	        _this._setTextData();
	        return _this;
	    }
	    Text.prototype._sceneFunc = function (context) {
	        var textArr = this.textArr, textArrLen = textArr.length;
	        if (!this.text()) {
	            return;
	        }
	        var padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
	        var translateY = 0;
	        var translateY = lineHeightPx / 2;
	        var lineTranslateX = 0;
	        var lineTranslateY = 0;
	        context.setAttr('font', this._getContextFont());
	        context.setAttr('textBaseline', MIDDLE);
	        context.setAttr('textAlign', LEFT);
	        if (verticalAlign === MIDDLE) {
	            alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
	        }
	        else if (verticalAlign === BOTTOM) {
	            alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
	        }
	        context.translate(padding, alignY + padding);
	        for (n = 0; n < textArrLen; n++) {
	            var lineTranslateX = 0;
	            var lineTranslateY = 0;
	            var obj = textArr[n], text = obj.text, width = obj.width, lastLine = n !== textArrLen - 1, spacesNumber, oneWord, lineWidth;
	            context.save();
	            if (align === RIGHT) {
	                lineTranslateX += totalWidth - width - padding * 2;
	            }
	            else if (align === CENTER) {
	                lineTranslateX += (totalWidth - width - padding * 2) / 2;
	            }
	            if (shouldUnderline) {
	                context.save();
	                context.beginPath();
	                context.moveTo(lineTranslateX, translateY + lineTranslateY + Math.round(fontSize / 2));
	                spacesNumber = text.split(' ').length - 1;
	                oneWord = spacesNumber === 0;
	                lineWidth =
	                    align === JUSTIFY && lastLine && !oneWord
	                        ? totalWidth - padding * 2
	                        : width;
	                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + Math.round(fontSize / 2));
	                context.lineWidth = fontSize / 15;
	                context.strokeStyle = fill;
	                context.stroke();
	                context.restore();
	            }
	            if (shouldLineThrough) {
	                context.save();
	                context.beginPath();
	                context.moveTo(lineTranslateX, translateY + lineTranslateY);
	                spacesNumber = text.split(' ').length - 1;
	                oneWord = spacesNumber === 0;
	                lineWidth =
	                    align === JUSTIFY && lastLine && !oneWord
	                        ? totalWidth - padding * 2
	                        : width;
	                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
	                context.lineWidth = fontSize / 15;
	                context.strokeStyle = fill;
	                context.stroke();
	                context.restore();
	            }
	            if (letterSpacing !== 0 || align === JUSTIFY) {
	                spacesNumber = text.split(' ').length - 1;
	                var array = stringToArray(text);
	                for (var li = 0; li < array.length; li++) {
	                    var letter = array[li];
	                    if (letter === ' ' && n !== textArrLen - 1 && align === JUSTIFY) {
	                        lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
	                    }
	                    this._partialTextX = lineTranslateX;
	                    this._partialTextY = translateY + lineTranslateY;
	                    this._partialText = letter;
	                    context.fillStrokeShape(this);
	                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
	                }
	            }
	            else {
	                this._partialTextX = lineTranslateX;
	                this._partialTextY = translateY + lineTranslateY;
	                this._partialText = text;
	                context.fillStrokeShape(this);
	            }
	            context.restore();
	            if (textArrLen > 1) {
	                translateY += lineHeightPx;
	            }
	        }
	    };
	    Text.prototype._hitFunc = function (context) {
	        var width = this.getWidth(), height = this.getHeight();
	        context.beginPath();
	        context.rect(0, 0, width, height);
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Text.prototype.setText = function (text) {
	        var str = Util_1.Util._isString(text)
	            ? text
	            : text === null || text === undefined
	                ? ''
	                : text + '';
	        this._setAttr(TEXT, str);
	        return this;
	    };
	    Text.prototype.getWidth = function () {
	        var isAuto = this.attrs.width === AUTO || this.attrs.width === undefined;
	        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
	    };
	    Text.prototype.getHeight = function () {
	        var isAuto = this.attrs.height === AUTO || this.attrs.height === undefined;
	        return isAuto
	            ? this.fontSize() * this.textArr.length * this.lineHeight() +
	                this.padding() * 2
	            : this.attrs.height;
	    };
	    Text.prototype.getTextWidth = function () {
	        return this.textWidth;
	    };
	    Text.prototype.getTextHeight = function () {
	        Util_1.Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
	        return this.textHeight;
	    };
	    Text.prototype.measureSize = function (text) {
	        var _context = getDummyContext(), fontSize = this.fontSize(), metrics;
	        _context.save();
	        _context.font = this._getContextFont();
	        metrics = _context.measureText(text);
	        _context.restore();
	        return {
	            width: metrics.width,
	            height: fontSize,
	        };
	    };
	    Text.prototype._getContextFont = function () {
	        if (Global_1.Konva.UA.isIE) {
	            return (this.fontStyle() +
	                SPACE +
	                this.fontSize() +
	                PX_SPACE +
	                this.fontFamily());
	        }
	        return (this.fontStyle() +
	            SPACE +
	            this.fontVariant() +
	            SPACE +
	            (this.fontSize() + PX_SPACE) +
	            normalizeFontFamily(this.fontFamily()));
	    };
	    Text.prototype._addTextLine = function (line) {
	        if (this.align() === JUSTIFY) {
	            line = line.trim();
	        }
	        var width = this._getTextWidth(line);
	        return this.textArr.push({ text: line, width: width });
	    };
	    Text.prototype._getTextWidth = function (text) {
	        var letterSpacing = this.letterSpacing();
	        var length = text.length;
	        return (getDummyContext().measureText(text).width +
	            (length ? letterSpacing * (length - 1) : 0));
	    };
	    Text.prototype._setTextData = function () {
	        var lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== AUTO && width !== undefined, fixedHeight = height !== AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== NONE, wrapAtWord = wrap !== CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
	        this.textArr = [];
	        getDummyContext().font = this._getContextFont();
	        var additionalWidth = shouldAddEllipsis ? this._getTextWidth(ELLIPSIS) : 0;
	        for (var i = 0, max = lines.length; i < max; ++i) {
	            var line = lines[i];
	            var lineWidth = this._getTextWidth(line);
	            if (fixedWidth && lineWidth > maxWidth) {
	                while (line.length > 0) {
	                    var low = 0, high = line.length, match = '', matchWidth = 0;
	                    while (low < high) {
	                        var mid = (low + high) >>> 1, substr = line.slice(0, mid + 1), substrWidth = this._getTextWidth(substr) + additionalWidth;
	                        if (substrWidth <= maxWidth) {
	                            low = mid + 1;
	                            match = substr;
	                            matchWidth = substrWidth;
	                        }
	                        else {
	                            high = mid;
	                        }
	                    }
	                    if (match) {
	                        if (wrapAtWord) {
	                            var wrapIndex;
	                            var nextChar = line[match.length];
	                            var nextIsSpaceOrDash = nextChar === SPACE || nextChar === DASH;
	                            if (nextIsSpaceOrDash && matchWidth <= maxWidth) {
	                                wrapIndex = match.length;
	                            }
	                            else {
	                                wrapIndex =
	                                    Math.max(match.lastIndexOf(SPACE), match.lastIndexOf(DASH)) +
	                                        1;
	                            }
	                            if (wrapIndex > 0) {
	                                low = wrapIndex;
	                                match = match.slice(0, low);
	                                matchWidth = this._getTextWidth(match);
	                            }
	                        }
	                        match = match.trimRight();
	                        this._addTextLine(match);
	                        textWidth = Math.max(textWidth, matchWidth);
	                        currentHeightPx += lineHeightPx;
	                        if (!shouldWrap ||
	                            (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx)) {
	                            var lastLine = this.textArr[this.textArr.length - 1];
	                            if (lastLine) {
	                                if (shouldAddEllipsis) {
	                                    var haveSpace = this._getTextWidth(lastLine.text + ELLIPSIS) < maxWidth;
	                                    if (!haveSpace) {
	                                        lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
	                                    }
	                                    this.textArr.splice(this.textArr.length - 1, 1);
	                                    this._addTextLine(lastLine.text + ELLIPSIS);
	                                }
	                            }
	                            break;
	                        }
	                        line = line.slice(low);
	                        line = line.trimLeft();
	                        if (line.length > 0) {
	                            lineWidth = this._getTextWidth(line);
	                            if (lineWidth <= maxWidth) {
	                                this._addTextLine(line);
	                                currentHeightPx += lineHeightPx;
	                                textWidth = Math.max(textWidth, lineWidth);
	                                break;
	                            }
	                        }
	                    }
	                    else {
	                        break;
	                    }
	                }
	            }
	            else {
	                this._addTextLine(line);
	                currentHeightPx += lineHeightPx;
	                textWidth = Math.max(textWidth, lineWidth);
	            }
	            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
	                break;
	            }
	        }
	        this.textHeight = fontSize;
	        this.textWidth = textWidth;
	    };
	    Text.prototype.getStrokeScaleEnabled = function () {
	        return true;
	    };
	    return Text;
	}(Shape_1.Shape));
	Text.Text = Text$1;
	Text$1.prototype._fillFunc = _fillFunc;
	Text$1.prototype._strokeFunc = _strokeFunc;
	Text$1.prototype.className = TEXT_UPPER;
	Text$1.prototype._attrsAffectingSize = [
	    'text',
	    'fontSize',
	    'padding',
	    'wrap',
	    'lineHeight',
	    'letterSpacing',
	];
	Global_2._registerNode(Text$1);
	Factory_1.Factory.overWriteSetter(Text$1, 'width', Validators_1.getNumberOrAutoValidator());
	Factory_1.Factory.overWriteSetter(Text$1, 'height', Validators_1.getNumberOrAutoValidator());
	Factory_1.Factory.addGetterSetter(Text$1, 'fontFamily', 'Arial');
	Factory_1.Factory.addGetterSetter(Text$1, 'fontSize', 12, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Text$1, 'fontStyle', NORMAL);
	Factory_1.Factory.addGetterSetter(Text$1, 'fontVariant', NORMAL);
	Factory_1.Factory.addGetterSetter(Text$1, 'padding', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Text$1, 'align', LEFT);
	Factory_1.Factory.addGetterSetter(Text$1, 'verticalAlign', TOP);
	Factory_1.Factory.addGetterSetter(Text$1, 'lineHeight', 1, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Text$1, 'wrap', WORD);
	Factory_1.Factory.addGetterSetter(Text$1, 'ellipsis', false, Validators_1.getBooleanValidator());
	Factory_1.Factory.addGetterSetter(Text$1, 'letterSpacing', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Text$1, 'text', '', Validators_1.getStringValidator());
	Factory_1.Factory.addGetterSetter(Text$1, 'textDecoration', '');
	Util_1.Collection.mapMethods(Text$1);
	return Text;
}

var TextPath = {};

var hasRequiredTextPath;

function requireTextPath () {
	if (hasRequiredTextPath) return TextPath;
	hasRequiredTextPath = 1;
	var __extends = (TextPath && TextPath.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(TextPath, "__esModule", { value: true });
	TextPath.TextPath = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Path_1 = requirePath();
	var Text_1 = requireText();
	var Validators_1 = requireValidators();
	var Global_1 = requireGlobal();
	var EMPTY_STRING = '', NORMAL = 'normal';
	function _fillFunc(context) {
	    context.fillText(this.partialText, 0, 0);
	}
	function _strokeFunc(context) {
	    context.strokeText(this.partialText, 0, 0);
	}
	var TextPath$1 = (function (_super) {
	    __extends(TextPath, _super);
	    function TextPath(config) {
	        var _this = _super.call(this, config) || this;
	        _this.dummyCanvas = Util_1.Util.createCanvasElement();
	        _this.dataArray = [];
	        _this.dataArray = Path_1.Path.parsePathData(_this.attrs.data);
	        _this.on('dataChange.konva', function () {
	            this.dataArray = Path_1.Path.parsePathData(this.attrs.data);
	            this._setTextData();
	        });
	        _this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva', _this._setTextData);
	        if (config && config['getKerning']) {
	            Util_1.Util.warn('getKerning TextPath API is deprecated. Please use "kerningFunc" instead.');
	            _this.kerningFunc(config['getKerning']);
	        }
	        _this._setTextData();
	        return _this;
	    }
	    TextPath.prototype._sceneFunc = function (context) {
	        context.setAttr('font', this._getContextFont());
	        context.setAttr('textBaseline', this.textBaseline());
	        context.setAttr('textAlign', 'left');
	        context.save();
	        var textDecoration = this.textDecoration();
	        var fill = this.fill();
	        var fontSize = this.fontSize();
	        var glyphInfo = this.glyphInfo;
	        if (textDecoration === 'underline') {
	            context.beginPath();
	        }
	        for (var i = 0; i < glyphInfo.length; i++) {
	            context.save();
	            var p0 = glyphInfo[i].p0;
	            context.translate(p0.x, p0.y);
	            context.rotate(glyphInfo[i].rotation);
	            this.partialText = glyphInfo[i].text;
	            context.fillStrokeShape(this);
	            if (textDecoration === 'underline') {
	                if (i === 0) {
	                    context.moveTo(0, fontSize / 2 + 1);
	                }
	                context.lineTo(fontSize, fontSize / 2 + 1);
	            }
	            context.restore();
	        }
	        if (textDecoration === 'underline') {
	            context.strokeStyle = fill;
	            context.lineWidth = fontSize / 20;
	            context.stroke();
	        }
	        context.restore();
	    };
	    TextPath.prototype._hitFunc = function (context) {
	        context.beginPath();
	        var glyphInfo = this.glyphInfo;
	        if (glyphInfo.length >= 1) {
	            var p0 = glyphInfo[0].p0;
	            context.moveTo(p0.x, p0.y);
	        }
	        for (var i = 0; i < glyphInfo.length; i++) {
	            var p1 = glyphInfo[i].p1;
	            context.lineTo(p1.x, p1.y);
	        }
	        context.setAttr('lineWidth', this.fontSize());
	        context.setAttr('strokeStyle', this.colorKey);
	        context.stroke();
	    };
	    TextPath.prototype.getTextWidth = function () {
	        return this.textWidth;
	    };
	    TextPath.prototype.getTextHeight = function () {
	        Util_1.Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
	        return this.textHeight;
	    };
	    TextPath.prototype.setText = function (text) {
	        return Text_1.Text.prototype.setText.call(this, text);
	    };
	    TextPath.prototype._getContextFont = function () {
	        return Text_1.Text.prototype._getContextFont.call(this);
	    };
	    TextPath.prototype._getTextSize = function (text) {
	        var dummyCanvas = this.dummyCanvas;
	        var _context = dummyCanvas.getContext('2d');
	        _context.save();
	        _context.font = this._getContextFont();
	        var metrics = _context.measureText(text);
	        _context.restore();
	        return {
	            width: metrics.width,
	            height: parseInt(this.attrs.fontSize, 10),
	        };
	    };
	    TextPath.prototype._setTextData = function () {
	        var that = this;
	        var size = this._getTextSize(this.attrs.text);
	        var letterSpacing = this.letterSpacing();
	        var align = this.align();
	        var kerningFunc = this.kerningFunc();
	        this.textWidth = size.width;
	        this.textHeight = size.height;
	        var textFullWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
	        this.glyphInfo = [];
	        var fullPathWidth = 0;
	        for (var l = 0; l < that.dataArray.length; l++) {
	            if (that.dataArray[l].pathLength > 0) {
	                fullPathWidth += that.dataArray[l].pathLength;
	            }
	        }
	        var offset = 0;
	        if (align === 'center') {
	            offset = Math.max(0, fullPathWidth / 2 - textFullWidth / 2);
	        }
	        if (align === 'right') {
	            offset = Math.max(0, fullPathWidth - textFullWidth);
	        }
	        var charArr = Text_1.stringToArray(this.text());
	        var spacesNumber = this.text().split(' ').length - 1;
	        var p0, p1, pathCmd;
	        var pIndex = -1;
	        var currentT = 0;
	        var getNextPathSegment = function () {
	            currentT = 0;
	            var pathData = that.dataArray;
	            for (var j = pIndex + 1; j < pathData.length; j++) {
	                if (pathData[j].pathLength > 0) {
	                    pIndex = j;
	                    return pathData[j];
	                }
	                else if (pathData[j].command === 'M') {
	                    p0 = {
	                        x: pathData[j].points[0],
	                        y: pathData[j].points[1],
	                    };
	                }
	            }
	            return {};
	        };
	        var findSegmentToFitCharacter = function (c) {
	            var glyphWidth = that._getTextSize(c).width + letterSpacing;
	            if (c === ' ' && align === 'justify') {
	                glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
	            }
	            var currLen = 0;
	            var attempts = 0;
	            p1 = undefined;
	            while (Math.abs(glyphWidth - currLen) / glyphWidth > 0.01 &&
	                attempts < 20) {
	                attempts++;
	                var cumulativePathLength = currLen;
	                while (pathCmd === undefined) {
	                    pathCmd = getNextPathSegment();
	                    if (pathCmd &&
	                        cumulativePathLength + pathCmd.pathLength < glyphWidth) {
	                        cumulativePathLength += pathCmd.pathLength;
	                        pathCmd = undefined;
	                    }
	                }
	                if (pathCmd === {} || p0 === undefined) {
	                    return undefined;
	                }
	                var needNewSegment = false;
	                switch (pathCmd.command) {
	                    case 'L':
	                        if (Path_1.Path.getLineLength(p0.x, p0.y, pathCmd.points[0], pathCmd.points[1]) > glyphWidth) {
	                            p1 = Path_1.Path.getPointOnLine(glyphWidth, p0.x, p0.y, pathCmd.points[0], pathCmd.points[1], p0.x, p0.y);
	                        }
	                        else {
	                            pathCmd = undefined;
	                        }
	                        break;
	                    case 'A':
	                        var start = pathCmd.points[4];
	                        var dTheta = pathCmd.points[5];
	                        var end = pathCmd.points[4] + dTheta;
	                        if (currentT === 0) {
	                            currentT = start + 0.00000001;
	                        }
	                        else if (glyphWidth > currLen) {
	                            currentT += ((Math.PI / 180.0) * dTheta) / Math.abs(dTheta);
	                        }
	                        else {
	                            currentT -= ((Math.PI / 360.0) * dTheta) / Math.abs(dTheta);
	                        }
	                        if ((dTheta < 0 && currentT < end) ||
	                            (dTheta >= 0 && currentT > end)) {
	                            currentT = end;
	                            needNewSegment = true;
	                        }
	                        p1 = Path_1.Path.getPointOnEllipticalArc(pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], currentT, pathCmd.points[6]);
	                        break;
	                    case 'C':
	                        if (currentT === 0) {
	                            if (glyphWidth > pathCmd.pathLength) {
	                                currentT = 0.00000001;
	                            }
	                            else {
	                                currentT = glyphWidth / pathCmd.pathLength;
	                            }
	                        }
	                        else if (glyphWidth > currLen) {
	                            currentT += (glyphWidth - currLen) / pathCmd.pathLength / 2;
	                        }
	                        else {
	                            currentT = Math.max(currentT - (currLen - glyphWidth) / pathCmd.pathLength / 2, 0);
	                        }
	                        if (currentT > 1.0) {
	                            currentT = 1.0;
	                            needNewSegment = true;
	                        }
	                        p1 = Path_1.Path.getPointOnCubicBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], pathCmd.points[4], pathCmd.points[5]);
	                        break;
	                    case 'Q':
	                        if (currentT === 0) {
	                            currentT = glyphWidth / pathCmd.pathLength;
	                        }
	                        else if (glyphWidth > currLen) {
	                            currentT += (glyphWidth - currLen) / pathCmd.pathLength;
	                        }
	                        else {
	                            currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
	                        }
	                        if (currentT > 1.0) {
	                            currentT = 1.0;
	                            needNewSegment = true;
	                        }
	                        p1 = Path_1.Path.getPointOnQuadraticBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3]);
	                        break;
	                }
	                if (p1 !== undefined) {
	                    currLen = Path_1.Path.getLineLength(p0.x, p0.y, p1.x, p1.y);
	                }
	                if (needNewSegment) {
	                    needNewSegment = false;
	                    pathCmd = undefined;
	                }
	            }
	        };
	        var testChar = 'C';
	        var glyphWidth = that._getTextSize(testChar).width + letterSpacing;
	        var lettersInOffset = offset / glyphWidth - 1;
	        for (var k = 0; k < lettersInOffset; k++) {
	            findSegmentToFitCharacter(testChar);
	            if (p0 === undefined || p1 === undefined) {
	                break;
	            }
	            p0 = p1;
	        }
	        for (var i = 0; i < charArr.length; i++) {
	            findSegmentToFitCharacter(charArr[i]);
	            if (p0 === undefined || p1 === undefined) {
	                break;
	            }
	            var width = Path_1.Path.getLineLength(p0.x, p0.y, p1.x, p1.y);
	            var kern = 0;
	            if (kerningFunc) {
	                try {
	                    kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
	                }
	                catch (e) {
	                    kern = 0;
	                }
	            }
	            p0.x += kern;
	            p1.x += kern;
	            this.textWidth += kern;
	            var midpoint = Path_1.Path.getPointOnLine(kern + width / 2.0, p0.x, p0.y, p1.x, p1.y);
	            var rotation = Math.atan2(p1.y - p0.y, p1.x - p0.x);
	            this.glyphInfo.push({
	                transposeX: midpoint.x,
	                transposeY: midpoint.y,
	                text: charArr[i],
	                rotation: rotation,
	                p0: p0,
	                p1: p1,
	            });
	            p0 = p1;
	        }
	    };
	    TextPath.prototype.getSelfRect = function () {
	        if (!this.glyphInfo.length) {
	            return {
	                x: 0,
	                y: 0,
	                width: 0,
	                height: 0,
	            };
	        }
	        var points = [];
	        this.glyphInfo.forEach(function (info) {
	            points.push(info.p0.x);
	            points.push(info.p0.y);
	            points.push(info.p1.x);
	            points.push(info.p1.y);
	        });
	        var minX = points[0] || 0;
	        var maxX = points[0] || 0;
	        var minY = points[1] || 0;
	        var maxY = points[1] || 0;
	        var x, y;
	        for (var i = 0; i < points.length / 2; i++) {
	            x = points[i * 2];
	            y = points[i * 2 + 1];
	            minX = Math.min(minX, x);
	            maxX = Math.max(maxX, x);
	            minY = Math.min(minY, y);
	            maxY = Math.max(maxY, y);
	        }
	        var fontSize = this.fontSize();
	        return {
	            x: minX - fontSize / 2,
	            y: minY - fontSize / 2,
	            width: maxX - minX + fontSize,
	            height: maxY - minY + fontSize,
	        };
	    };
	    return TextPath;
	}(Shape_1.Shape));
	TextPath.TextPath = TextPath$1;
	TextPath$1.prototype._fillFunc = _fillFunc;
	TextPath$1.prototype._strokeFunc = _strokeFunc;
	TextPath$1.prototype._fillFuncHit = _fillFunc;
	TextPath$1.prototype._strokeFuncHit = _strokeFunc;
	TextPath$1.prototype.className = 'TextPath';
	TextPath$1.prototype._attrsAffectingSize = ['text', 'fontSize', 'data'];
	Global_1._registerNode(TextPath$1);
	Factory_1.Factory.addGetterSetter(TextPath$1, 'data');
	Factory_1.Factory.addGetterSetter(TextPath$1, 'fontFamily', 'Arial');
	Factory_1.Factory.addGetterSetter(TextPath$1, 'fontSize', 12, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(TextPath$1, 'fontStyle', NORMAL);
	Factory_1.Factory.addGetterSetter(TextPath$1, 'align', 'left');
	Factory_1.Factory.addGetterSetter(TextPath$1, 'letterSpacing', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(TextPath$1, 'textBaseline', 'middle');
	Factory_1.Factory.addGetterSetter(TextPath$1, 'fontVariant', NORMAL);
	Factory_1.Factory.addGetterSetter(TextPath$1, 'text', EMPTY_STRING);
	Factory_1.Factory.addGetterSetter(TextPath$1, 'textDecoration', null);
	Factory_1.Factory.addGetterSetter(TextPath$1, 'kerningFunc', null);
	Util_1.Collection.mapMethods(TextPath$1);
	return TextPath;
}

var Transformer = {};

var hasRequiredTransformer;

function requireTransformer () {
	if (hasRequiredTransformer) return Transformer;
	hasRequiredTransformer = 1;
	var __extends = (Transformer && Transformer.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (Transformer && Transformer.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(Transformer, "__esModule", { value: true });
	Transformer.Transformer = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Shape_1 = requireShape();
	var Rect_1 = requireRect();
	var Group_1 = requireGroup();
	var Global_1 = requireGlobal();
	var Validators_1 = requireValidators();
	var Global_2 = requireGlobal();
	var EVENTS_NAME = 'tr-konva';
	var ATTR_CHANGE_LIST = [
	    'resizeEnabledChange',
	    'rotateAnchorOffsetChange',
	    'rotateEnabledChange',
	    'enabledAnchorsChange',
	    'anchorSizeChange',
	    'borderEnabledChange',
	    'borderStrokeChange',
	    'borderStrokeWidthChange',
	    'borderDashChange',
	    'anchorStrokeChange',
	    'anchorStrokeWidthChange',
	    'anchorFillChange',
	    'anchorCornerRadiusChange',
	    'ignoreStrokeChange',
	]
	    .map(function (e) { return e + ("." + EVENTS_NAME); })
	    .join(' ');
	var NODES_RECT = 'nodesRect';
	var TRANSFORM_CHANGE_STR = [
	    'widthChange',
	    'heightChange',
	    'scaleXChange',
	    'scaleYChange',
	    'skewXChange',
	    'skewYChange',
	    'rotationChange',
	    'offsetXChange',
	    'offsetYChange',
	    'transformsEnabledChange',
	    'strokeWidthChange',
	]
	    .map(function (e) { return e + ("." + EVENTS_NAME); })
	    .join(' ');
	var ANGLES = {
	    'top-left': -45,
	    'top-center': 0,
	    'top-right': 45,
	    'middle-right': -90,
	    'middle-left': 90,
	    'bottom-left': -135,
	    'bottom-center': 180,
	    'bottom-right': 135,
	};
	var TOUCH_DEVICE = 'ontouchstart' in Global_1.Konva._global;
	function getCursor(anchorName, rad) {
	    if (anchorName === 'rotater') {
	        return 'crosshair';
	    }
	    rad += Util_1.Util._degToRad(ANGLES[anchorName] || 0);
	    var angle = ((Util_1.Util._radToDeg(rad) % 360) + 360) % 360;
	    if (Util_1.Util._inRange(angle, 315 + 22.5, 360) || Util_1.Util._inRange(angle, 0, 22.5)) {
	        return 'ns-resize';
	    }
	    else if (Util_1.Util._inRange(angle, 45 - 22.5, 45 + 22.5)) {
	        return 'nesw-resize';
	    }
	    else if (Util_1.Util._inRange(angle, 90 - 22.5, 90 + 22.5)) {
	        return 'ew-resize';
	    }
	    else if (Util_1.Util._inRange(angle, 135 - 22.5, 135 + 22.5)) {
	        return 'nwse-resize';
	    }
	    else if (Util_1.Util._inRange(angle, 180 - 22.5, 180 + 22.5)) {
	        return 'ns-resize';
	    }
	    else if (Util_1.Util._inRange(angle, 225 - 22.5, 225 + 22.5)) {
	        return 'nesw-resize';
	    }
	    else if (Util_1.Util._inRange(angle, 270 - 22.5, 270 + 22.5)) {
	        return 'ew-resize';
	    }
	    else if (Util_1.Util._inRange(angle, 315 - 22.5, 315 + 22.5)) {
	        return 'nwse-resize';
	    }
	    else {
	        Util_1.Util.error('Transformer has unknown angle for cursor detection: ' + angle);
	        return 'pointer';
	    }
	}
	var ANCHORS_NAMES = [
	    'top-left',
	    'top-center',
	    'top-right',
	    'middle-right',
	    'middle-left',
	    'bottom-left',
	    'bottom-center',
	    'bottom-right',
	];
	function getCenter(shape) {
	    return {
	        x: shape.x +
	            (shape.width / 2) * Math.cos(shape.rotation) +
	            (shape.height / 2) * Math.sin(-shape.rotation),
	        y: shape.y +
	            (shape.height / 2) * Math.cos(shape.rotation) +
	            (shape.width / 2) * Math.sin(shape.rotation),
	    };
	}
	function rotateAroundPoint(shape, angleRad, point) {
	    var x = point.x +
	        (shape.x - point.x) * Math.cos(angleRad) -
	        (shape.y - point.y) * Math.sin(angleRad);
	    var y = point.y +
	        (shape.x - point.x) * Math.sin(angleRad) +
	        (shape.y - point.y) * Math.cos(angleRad);
	    return __assign(__assign({}, shape), { rotation: shape.rotation + angleRad, x: x,
	        y: y });
	}
	function rotateAroundCenter(shape, deltaRad) {
	    var center = getCenter(shape);
	    return rotateAroundPoint(shape, deltaRad, center);
	}
	function getSnap(snaps, newRotationRad, tol) {
	    var snapped = newRotationRad;
	    for (var i = 0; i < snaps.length; i++) {
	        var angle = Global_1.Konva.getAngle(snaps[i]);
	        var absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
	        var dif = Math.min(absDiff, Math.PI * 2 - absDiff);
	        if (dif < tol) {
	            snapped = angle;
	        }
	    }
	    return snapped;
	}
	var Transformer$1 = (function (_super) {
	    __extends(Transformer, _super);
	    function Transformer(config) {
	        var _this = _super.call(this, config) || this;
	        _this._transforming = false;
	        _this._createElements();
	        _this._handleMouseMove = _this._handleMouseMove.bind(_this);
	        _this._handleMouseUp = _this._handleMouseUp.bind(_this);
	        _this.update = _this.update.bind(_this);
	        _this.on(ATTR_CHANGE_LIST, _this.update);
	        if (_this.getNode()) {
	            _this.update();
	        }
	        return _this;
	    }
	    Transformer.prototype.attachTo = function (node) {
	        this.setNode(node);
	        return this;
	    };
	    Transformer.prototype.setNode = function (node) {
	        Util_1.Util.warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
	        return this.setNodes([node]);
	    };
	    Transformer.prototype.getNode = function () {
	        return this._nodes && this._nodes[0];
	    };
	    Transformer.prototype.setNodes = function (nodes) {
	        var _this = this;
	        if (nodes === void 0) { nodes = []; }
	        if (this._nodes && this._nodes.length) {
	            this.detach();
	        }
	        this._nodes = nodes;
	        if (nodes.length === 1) {
	            this.rotation(nodes[0].getAbsoluteRotation());
	        }
	        else {
	            this.rotation(0);
	        }
	        this._nodes.forEach(function (node) {
	            var additionalEvents = node._attrsAffectingSize
	                .map(function (prop) { return prop + 'Change.' + EVENTS_NAME; })
	                .join(' ');
	            var onChange = function () {
	                if (_this.nodes().length === 1) {
	                    _this.rotation(_this.nodes()[0].getAbsoluteRotation());
	                }
	                _this._resetTransformCache();
	                if (!_this._transforming && !_this.isDragging()) {
	                    _this.update();
	                }
	            };
	            node.on(additionalEvents, onChange);
	            node.on(TRANSFORM_CHANGE_STR, onChange);
	            node.on("_clearTransformCache." + EVENTS_NAME, onChange);
	            node.on("xChange." + EVENTS_NAME + " yChange." + EVENTS_NAME, onChange);
	            _this._proxyDrag(node);
	        });
	        this._resetTransformCache();
	        var elementsCreated = !!this.findOne('.top-left');
	        if (elementsCreated) {
	            this.update();
	        }
	        return this;
	    };
	    Transformer.prototype._proxyDrag = function (node) {
	        var _this = this;
	        var lastPos;
	        node.on("dragstart." + EVENTS_NAME, function (e) {
	            lastPos = node.getAbsolutePosition();
	            if (!_this.isDragging() && node !== _this.findOne('.back')) {
	                _this.startDrag(e, false);
	            }
	        });
	        node.on("dragmove." + EVENTS_NAME, function (e) {
	            if (!lastPos) {
	                return;
	            }
	            var abs = node.getAbsolutePosition();
	            var dx = abs.x - lastPos.x;
	            var dy = abs.y - lastPos.y;
	            _this.nodes().forEach(function (otherNode) {
	                if (otherNode === node) {
	                    return;
	                }
	                if (otherNode.isDragging()) {
	                    return;
	                }
	                var otherAbs = otherNode.getAbsolutePosition();
	                otherNode.setAbsolutePosition({
	                    x: otherAbs.x + dx,
	                    y: otherAbs.y + dy,
	                });
	                otherNode.startDrag(e);
	            });
	            lastPos = null;
	        });
	    };
	    Transformer.prototype.getNodes = function () {
	        return this._nodes || [];
	    };
	    Transformer.prototype.getActiveAnchor = function () {
	        return this._movingAnchorName;
	    };
	    Transformer.prototype.detach = function () {
	        if (this._nodes) {
	            this._nodes.forEach(function (node) {
	                node.off('.' + EVENTS_NAME);
	            });
	        }
	        this._nodes = [];
	        this._resetTransformCache();
	    };
	    Transformer.prototype._resetTransformCache = function () {
	        this._clearCache(NODES_RECT);
	        this._clearCache('transform');
	        this._clearSelfAndDescendantCache('absoluteTransform');
	    };
	    Transformer.prototype._getNodeRect = function () {
	        return this._getCache(NODES_RECT, this.__getNodeRect);
	    };
	    Transformer.prototype.__getNodeShape = function (node, rot, relative) {
	        if (rot === void 0) { rot = this.rotation(); }
	        var rect = node.getClientRect({
	            skipTransform: true,
	            skipShadow: true,
	            skipStroke: this.ignoreStroke(),
	        });
	        var absScale = node.getAbsoluteScale(relative);
	        var absPos = node.getAbsolutePosition(relative);
	        var dx = rect.x * absScale.x - node.offsetX() * absScale.x;
	        var dy = rect.y * absScale.y - node.offsetY() * absScale.y;
	        var rotation = (Global_1.Konva.getAngle(node.getAbsoluteRotation()) + Math.PI * 2) %
	            (Math.PI * 2);
	        var box = {
	            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
	            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
	            width: rect.width * absScale.x,
	            height: rect.height * absScale.y,
	            rotation: rotation,
	        };
	        return rotateAroundPoint(box, -Global_1.Konva.getAngle(rot), {
	            x: 0,
	            y: 0,
	        });
	    };
	    Transformer.prototype.__getNodeRect = function () {
	        var _this = this;
	        var node = this.getNode();
	        if (!node) {
	            return {
	                x: -1e8,
	                y: -1e8,
	                width: 0,
	                height: 0,
	                rotation: 0,
	            };
	        }
	        var totalPoints = [];
	        this.nodes().map(function (node) {
	            var box = node.getClientRect({
	                skipTransform: true,
	                skipShadow: true,
	                skipStroke: _this.ignoreStroke(),
	            });
	            var points = [
	                { x: box.x, y: box.y },
	                { x: box.x + box.width, y: box.y },
	                { x: box.x + box.width, y: box.y + box.height },
	                { x: box.x, y: box.y + box.height },
	            ];
	            var trans = node.getAbsoluteTransform();
	            points.forEach(function (point) {
	                var transformed = trans.point(point);
	                totalPoints.push(transformed);
	            });
	        });
	        var tr = new Util_1.Transform();
	        tr.rotate(-Global_1.Konva.getAngle(this.rotation()));
	        var minX, minY, maxX, maxY;
	        totalPoints.forEach(function (point) {
	            var transformed = tr.point(point);
	            if (minX === undefined) {
	                minX = maxX = transformed.x;
	                minY = maxY = transformed.y;
	            }
	            minX = Math.min(minX, transformed.x);
	            minY = Math.min(minY, transformed.y);
	            maxX = Math.max(maxX, transformed.x);
	            maxY = Math.max(maxY, transformed.y);
	        });
	        tr.invert();
	        var p = tr.point({ x: minX, y: minY });
	        return {
	            x: p.x,
	            y: p.y,
	            width: maxX - minX,
	            height: maxY - minY,
	            rotation: Global_1.Konva.getAngle(this.rotation()),
	        };
	    };
	    Transformer.prototype.getX = function () {
	        return this._getNodeRect().x;
	    };
	    Transformer.prototype.getY = function () {
	        return this._getNodeRect().y;
	    };
	    Transformer.prototype.getWidth = function () {
	        return this._getNodeRect().width;
	    };
	    Transformer.prototype.getHeight = function () {
	        return this._getNodeRect().height;
	    };
	    Transformer.prototype._createElements = function () {
	        this._createBack();
	        ANCHORS_NAMES.forEach(function (name) {
	            this._createAnchor(name);
	        }.bind(this));
	        this._createAnchor('rotater');
	    };
	    Transformer.prototype._createAnchor = function (name) {
	        var _this = this;
	        var anchor = new Rect_1.Rect({
	            stroke: 'rgb(0, 161, 255)',
	            fill: 'white',
	            strokeWidth: 1,
	            name: name + ' _anchor',
	            dragDistance: 0,
	            draggable: true,
	            hitStrokeWidth: TOUCH_DEVICE ? 10 : 'auto',
	        });
	        var self = this;
	        anchor.on('mousedown touchstart', function (e) {
	            self._handleMouseDown(e);
	        });
	        anchor.on('dragstart', function (e) {
	            anchor.stopDrag();
	            e.cancelBubble = true;
	        });
	        anchor.on('dragend', function (e) {
	            e.cancelBubble = true;
	        });
	        anchor.on('mouseenter', function () {
	            var rad = Global_1.Konva.getAngle(_this.rotation());
	            var cursor = getCursor(name, rad);
	            anchor.getStage().content.style.cursor = cursor;
	            _this._cursorChange = true;
	        });
	        anchor.on('mouseout', function () {
	            anchor.getStage().content.style.cursor = '';
	            _this._cursorChange = false;
	        });
	        this.add(anchor);
	    };
	    Transformer.prototype._createBack = function () {
	        var _this = this;
	        var back = new Shape_1.Shape({
	            name: 'back',
	            width: 0,
	            height: 0,
	            draggable: true,
	            sceneFunc: function (ctx) {
	                var tr = this.getParent();
	                var padding = tr.padding();
	                ctx.beginPath();
	                ctx.rect(-padding, -padding, this.width() + padding * 2, this.height() + padding * 2);
	                ctx.moveTo(this.width() / 2, -padding);
	                if (tr.rotateEnabled()) {
	                    ctx.lineTo(this.width() / 2, -tr.rotateAnchorOffset() * Util_1.Util._sign(this.height()) - padding);
	                }
	                ctx.fillStrokeShape(this);
	            },
	            hitFunc: function (ctx, shape) {
	                if (!_this.shouldOverdrawWholeArea()) {
	                    return;
	                }
	                var padding = _this.padding();
	                ctx.beginPath();
	                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
	                ctx.fillStrokeShape(shape);
	            },
	        });
	        this.add(back);
	        this._proxyDrag(back);
	        back.on('dragstart', function (e) {
	            e.cancelBubble = true;
	        });
	        back.on('dragmove', function (e) {
	            e.cancelBubble = true;
	        });
	        back.on('dragend', function (e) {
	            e.cancelBubble = true;
	        });
	    };
	    Transformer.prototype._handleMouseDown = function (e) {
	        this._movingAnchorName = e.target.name().split(' ')[0];
	        var attrs = this._getNodeRect();
	        var width = attrs.width;
	        var height = attrs.height;
	        var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
	        this.sin = Math.abs(height / hypotenuse);
	        this.cos = Math.abs(width / hypotenuse);
	        window.addEventListener('mousemove', this._handleMouseMove);
	        window.addEventListener('touchmove', this._handleMouseMove);
	        window.addEventListener('mouseup', this._handleMouseUp, true);
	        window.addEventListener('touchend', this._handleMouseUp, true);
	        this._transforming = true;
	        var ap = e.target.getAbsolutePosition();
	        var pos = e.target.getStage().getPointerPosition();
	        this._anchorDragOffset = {
	            x: pos.x - ap.x,
	            y: pos.y - ap.y,
	        };
	        this._fire('transformstart', { evt: e, target: this.getNode() });
	        this._nodes.forEach(function (target) {
	            target._fire('transformstart', { evt: e, target: target });
	        });
	    };
	    Transformer.prototype._handleMouseMove = function (e) {
	        var x, y, newHypotenuse;
	        var anchorNode = this.findOne('.' + this._movingAnchorName);
	        var stage = anchorNode.getStage();
	        stage.setPointersPositions(e);
	        var pp = stage.getPointerPosition();
	        var newNodePos = {
	            x: pp.x - this._anchorDragOffset.x,
	            y: pp.y - this._anchorDragOffset.y,
	        };
	        var oldAbs = anchorNode.getAbsolutePosition();
	        anchorNode.setAbsolutePosition(newNodePos);
	        var newAbs = anchorNode.getAbsolutePosition();
	        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) {
	            return;
	        }
	        if (this._movingAnchorName === 'rotater') {
	            var attrs = this._getNodeRect();
	            x = anchorNode.x() - attrs.width / 2;
	            y = -anchorNode.y() + attrs.height / 2;
	            var delta = Math.atan2(-y, x) + Math.PI / 2;
	            if (attrs.height < 0) {
	                delta -= Math.PI;
	            }
	            var oldRotation = Global_1.Konva.getAngle(this.rotation());
	            var newRotation = oldRotation + delta;
	            var tol = Global_1.Konva.getAngle(this.rotationSnapTolerance());
	            var snappedRot = getSnap(this.rotationSnaps(), newRotation, tol);
	            var diff = snappedRot - attrs.rotation;
	            var shape = rotateAroundCenter(attrs, diff);
	            this._fitNodesInto(shape, e);
	            return;
	        }
	        var keepProportion = this.keepRatio() || e.shiftKey;
	        var centeredScaling = this.centeredScaling() || e.altKey;
	        if (this._movingAnchorName === 'top-left') {
	            if (keepProportion) {
	                var comparePoint = centeredScaling
	                    ? {
	                        x: this.width() / 2,
	                        y: this.height() / 2,
	                    }
	                    : {
	                        x: this.findOne('.bottom-right').x(),
	                        y: this.findOne('.bottom-right').y(),
	                    };
	                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) +
	                    Math.pow(comparePoint.y - anchorNode.y(), 2));
	                var reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
	                var reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
	                x = newHypotenuse * this.cos * reverseX;
	                y = newHypotenuse * this.sin * reverseY;
	                this.findOne('.top-left').x(comparePoint.x - x);
	                this.findOne('.top-left').y(comparePoint.y - y);
	            }
	        }
	        else if (this._movingAnchorName === 'top-center') {
	            this.findOne('.top-left').y(anchorNode.y());
	        }
	        else if (this._movingAnchorName === 'top-right') {
	            if (keepProportion) {
	                var comparePoint = centeredScaling
	                    ? {
	                        x: this.width() / 2,
	                        y: this.height() / 2,
	                    }
	                    : {
	                        x: this.findOne('.bottom-left').x(),
	                        y: this.findOne('.bottom-left').y(),
	                    };
	                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) +
	                    Math.pow(comparePoint.y - anchorNode.y(), 2));
	                var reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
	                var reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
	                x = newHypotenuse * this.cos * reverseX;
	                y = newHypotenuse * this.sin * reverseY;
	                this.findOne('.top-right').x(comparePoint.x + x);
	                this.findOne('.top-right').y(comparePoint.y - y);
	            }
	            var pos = anchorNode.position();
	            this.findOne('.top-left').y(pos.y);
	            this.findOne('.bottom-right').x(pos.x);
	        }
	        else if (this._movingAnchorName === 'middle-left') {
	            this.findOne('.top-left').x(anchorNode.x());
	        }
	        else if (this._movingAnchorName === 'middle-right') {
	            this.findOne('.bottom-right').x(anchorNode.x());
	        }
	        else if (this._movingAnchorName === 'bottom-left') {
	            if (keepProportion) {
	                var comparePoint = centeredScaling
	                    ? {
	                        x: this.width() / 2,
	                        y: this.height() / 2,
	                    }
	                    : {
	                        x: this.findOne('.top-right').x(),
	                        y: this.findOne('.top-right').y(),
	                    };
	                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) +
	                    Math.pow(anchorNode.y() - comparePoint.y, 2));
	                var reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
	                var reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
	                x = newHypotenuse * this.cos * reverseX;
	                y = newHypotenuse * this.sin * reverseY;
	                anchorNode.x(comparePoint.x - x);
	                anchorNode.y(comparePoint.y + y);
	            }
	            pos = anchorNode.position();
	            this.findOne('.top-left').x(pos.x);
	            this.findOne('.bottom-right').y(pos.y);
	        }
	        else if (this._movingAnchorName === 'bottom-center') {
	            this.findOne('.bottom-right').y(anchorNode.y());
	        }
	        else if (this._movingAnchorName === 'bottom-right') {
	            if (keepProportion) {
	                var comparePoint = centeredScaling
	                    ? {
	                        x: this.width() / 2,
	                        y: this.height() / 2,
	                    }
	                    : {
	                        x: this.findOne('.top-left').x(),
	                        y: this.findOne('.top-left').y(),
	                    };
	                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) +
	                    Math.pow(anchorNode.y() - comparePoint.y, 2));
	                var reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
	                var reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
	                x = newHypotenuse * this.cos * reverseX;
	                y = newHypotenuse * this.sin * reverseY;
	                this.findOne('.bottom-right').x(comparePoint.x + x);
	                this.findOne('.bottom-right').y(comparePoint.y + y);
	            }
	        }
	        else {
	            console.error(new Error('Wrong position argument of selection resizer: ' +
	                this._movingAnchorName));
	        }
	        var centeredScaling = this.centeredScaling() || e.altKey;
	        if (centeredScaling) {
	            var topLeft = this.findOne('.top-left');
	            var bottomRight = this.findOne('.bottom-right');
	            var topOffsetX = topLeft.x();
	            var topOffsetY = topLeft.y();
	            var bottomOffsetX = this.getWidth() - bottomRight.x();
	            var bottomOffsetY = this.getHeight() - bottomRight.y();
	            bottomRight.move({
	                x: -topOffsetX,
	                y: -topOffsetY,
	            });
	            topLeft.move({
	                x: bottomOffsetX,
	                y: bottomOffsetY,
	            });
	        }
	        var absPos = this.findOne('.top-left').getAbsolutePosition();
	        x = absPos.x;
	        y = absPos.y;
	        var width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
	        var height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
	        this._fitNodesInto({
	            x: x,
	            y: y,
	            width: width,
	            height: height,
	            rotation: Global_1.Konva.getAngle(this.rotation()),
	        }, e);
	    };
	    Transformer.prototype._handleMouseUp = function (e) {
	        this._removeEvents(e);
	    };
	    Transformer.prototype.getAbsoluteTransform = function () {
	        return this.getTransform();
	    };
	    Transformer.prototype._removeEvents = function (e) {
	        if (this._transforming) {
	            this._transforming = false;
	            window.removeEventListener('mousemove', this._handleMouseMove);
	            window.removeEventListener('touchmove', this._handleMouseMove);
	            window.removeEventListener('mouseup', this._handleMouseUp, true);
	            window.removeEventListener('touchend', this._handleMouseUp, true);
	            var node = this.getNode();
	            this._fire('transformend', { evt: e, target: node });
	            if (node) {
	                this._nodes.forEach(function (target) {
	                    target._fire('transformend', { evt: e, target: target });
	                });
	            }
	            this._movingAnchorName = null;
	        }
	    };
	    Transformer.prototype._fitNodesInto = function (newAttrs, evt) {
	        var _this = this;
	        var oldAttrs = this._getNodeRect();
	        var minSize = 1;
	        if (Util_1.Util._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
	            this.update();
	            return;
	        }
	        if (Util_1.Util._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
	            this.update();
	            return;
	        }
	        var t = new Util_1.Transform();
	        t.rotate(Global_1.Konva.getAngle(this.rotation()));
	        if (this._movingAnchorName &&
	            newAttrs.width < 0 &&
	            this._movingAnchorName.indexOf('left') >= 0) {
	            var offset = t.point({
	                x: -this.padding() * 2,
	                y: 0,
	            });
	            newAttrs.x += offset.x;
	            newAttrs.y += offset.y;
	            newAttrs.width += this.padding() * 2;
	            this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
	            this._anchorDragOffset.x -= offset.x;
	            this._anchorDragOffset.y -= offset.y;
	        }
	        else if (this._movingAnchorName &&
	            newAttrs.width < 0 &&
	            this._movingAnchorName.indexOf('right') >= 0) {
	            var offset = t.point({
	                x: this.padding() * 2,
	                y: 0,
	            });
	            this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
	            this._anchorDragOffset.x -= offset.x;
	            this._anchorDragOffset.y -= offset.y;
	            newAttrs.width += this.padding() * 2;
	        }
	        if (this._movingAnchorName &&
	            newAttrs.height < 0 &&
	            this._movingAnchorName.indexOf('top') >= 0) {
	            var offset = t.point({
	                x: 0,
	                y: -this.padding() * 2,
	            });
	            newAttrs.x += offset.x;
	            newAttrs.y += offset.y;
	            this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
	            this._anchorDragOffset.x -= offset.x;
	            this._anchorDragOffset.y -= offset.y;
	            newAttrs.height += this.padding() * 2;
	        }
	        else if (this._movingAnchorName &&
	            newAttrs.height < 0 &&
	            this._movingAnchorName.indexOf('bottom') >= 0) {
	            var offset = t.point({
	                x: 0,
	                y: this.padding() * 2,
	            });
	            this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
	            this._anchorDragOffset.x -= offset.x;
	            this._anchorDragOffset.y -= offset.y;
	            newAttrs.height += this.padding() * 2;
	        }
	        if (this.boundBoxFunc()) {
	            var bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
	            if (bounded) {
	                newAttrs = bounded;
	            }
	            else {
	                Util_1.Util.warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
	            }
	        }
	        var baseSize = 10000000;
	        var oldTr = new Util_1.Transform();
	        oldTr.translate(oldAttrs.x, oldAttrs.y);
	        oldTr.rotate(oldAttrs.rotation);
	        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
	        var newTr = new Util_1.Transform();
	        newTr.translate(newAttrs.x, newAttrs.y);
	        newTr.rotate(newAttrs.rotation);
	        newTr.scale(newAttrs.width / baseSize, newAttrs.height / baseSize);
	        var delta = newTr.multiply(oldTr.invert());
	        this._nodes.forEach(function (node) {
	            var _a;
	            var parentTransform = node.getParent().getAbsoluteTransform();
	            var localTransform = node.getTransform().copy();
	            localTransform.translate(node.offsetX(), node.offsetY());
	            var newLocalTransform = new Util_1.Transform();
	            newLocalTransform
	                .multiply(parentTransform.copy().invert())
	                .multiply(delta)
	                .multiply(parentTransform)
	                .multiply(localTransform);
	            var attrs = newLocalTransform.decompose();
	            node.setAttrs(attrs);
	            _this._fire('transform', { evt: evt, target: node });
	            node._fire('transform', { evt: evt, target: node });
	            (_a = node.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
	        });
	        this.rotation(Util_1.Util._getRotation(newAttrs.rotation));
	        this._resetTransformCache();
	        this.update();
	        this.getLayer().batchDraw();
	    };
	    Transformer.prototype.forceUpdate = function () {
	        this._resetTransformCache();
	        this.update();
	    };
	    Transformer.prototype._batchChangeChild = function (selector, attrs) {
	        var anchor = this.findOne(selector);
	        anchor.setAttrs(attrs);
	    };
	    Transformer.prototype.update = function () {
	        var _this = this;
	        var _a;
	        var attrs = this._getNodeRect();
	        this.rotation(Util_1.Util._getRotation(attrs.rotation));
	        var width = attrs.width;
	        var height = attrs.height;
	        var enabledAnchors = this.enabledAnchors();
	        var resizeEnabled = this.resizeEnabled();
	        var padding = this.padding();
	        var anchorSize = this.anchorSize();
	        this.find('._anchor').each(function (node) {
	            node.setAttrs({
	                width: anchorSize,
	                height: anchorSize,
	                offsetX: anchorSize / 2,
	                offsetY: anchorSize / 2,
	                stroke: _this.anchorStroke(),
	                strokeWidth: _this.anchorStrokeWidth(),
	                fill: _this.anchorFill(),
	                cornerRadius: _this.anchorCornerRadius(),
	            });
	        });
	        this._batchChangeChild('.top-left', {
	            x: 0,
	            y: 0,
	            offsetX: anchorSize / 2 + padding,
	            offsetY: anchorSize / 2 + padding,
	            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0,
	        });
	        this._batchChangeChild('.top-center', {
	            x: width / 2,
	            y: 0,
	            offsetY: anchorSize / 2 + padding,
	            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0,
	        });
	        this._batchChangeChild('.top-right', {
	            x: width,
	            y: 0,
	            offsetX: anchorSize / 2 - padding,
	            offsetY: anchorSize / 2 + padding,
	            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0,
	        });
	        this._batchChangeChild('.middle-left', {
	            x: 0,
	            y: height / 2,
	            offsetX: anchorSize / 2 + padding,
	            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0,
	        });
	        this._batchChangeChild('.middle-right', {
	            x: width,
	            y: height / 2,
	            offsetX: anchorSize / 2 - padding,
	            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0,
	        });
	        this._batchChangeChild('.bottom-left', {
	            x: 0,
	            y: height,
	            offsetX: anchorSize / 2 + padding,
	            offsetY: anchorSize / 2 - padding,
	            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0,
	        });
	        this._batchChangeChild('.bottom-center', {
	            x: width / 2,
	            y: height,
	            offsetY: anchorSize / 2 - padding,
	            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0,
	        });
	        this._batchChangeChild('.bottom-right', {
	            x: width,
	            y: height,
	            offsetX: anchorSize / 2 - padding,
	            offsetY: anchorSize / 2 - padding,
	            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0,
	        });
	        this._batchChangeChild('.rotater', {
	            x: width / 2,
	            y: -this.rotateAnchorOffset() * Util_1.Util._sign(height) - padding,
	            visible: this.rotateEnabled(),
	        });
	        this._batchChangeChild('.back', {
	            width: width,
	            height: height,
	            visible: this.borderEnabled(),
	            stroke: this.borderStroke(),
	            strokeWidth: this.borderStrokeWidth(),
	            dash: this.borderDash(),
	            x: 0,
	            y: 0,
	        });
	        (_a = this.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
	    };
	    Transformer.prototype.isTransforming = function () {
	        return this._transforming;
	    };
	    Transformer.prototype.stopTransform = function () {
	        if (this._transforming) {
	            this._removeEvents();
	            var anchorNode = this.findOne('.' + this._movingAnchorName);
	            if (anchorNode) {
	                anchorNode.stopDrag();
	            }
	        }
	    };
	    Transformer.prototype.destroy = function () {
	        if (this.getStage() && this._cursorChange) {
	            this.getStage().content.style.cursor = '';
	        }
	        Group_1.Group.prototype.destroy.call(this);
	        this.detach();
	        this._removeEvents();
	        return this;
	    };
	    Transformer.prototype.toObject = function () {
	        return Node_1.Node.prototype.toObject.call(this);
	    };
	    return Transformer;
	}(Group_1.Group));
	Transformer.Transformer = Transformer$1;
	function validateAnchors(val) {
	    if (!(val instanceof Array)) {
	        Util_1.Util.warn('enabledAnchors value should be an array');
	    }
	    if (val instanceof Array) {
	        val.forEach(function (name) {
	            if (ANCHORS_NAMES.indexOf(name) === -1) {
	                Util_1.Util.warn('Unknown anchor name: ' +
	                    name +
	                    '. Available names are: ' +
	                    ANCHORS_NAMES.join(', '));
	            }
	        });
	    }
	    return val || [];
	}
	Transformer$1.prototype.className = 'Transformer';
	Global_2._registerNode(Transformer$1);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'enabledAnchors', ANCHORS_NAMES, validateAnchors);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'resizeEnabled', true);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'anchorSize', 10, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Transformer$1, 'rotateEnabled', true);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'rotationSnaps', []);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'rotateAnchorOffset', 50, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Transformer$1, 'rotationSnapTolerance', 5, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Transformer$1, 'borderEnabled', true);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'anchorStroke', 'rgb(0, 161, 255)');
	Factory_1.Factory.addGetterSetter(Transformer$1, 'anchorStrokeWidth', 1, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Transformer$1, 'anchorFill', 'white');
	Factory_1.Factory.addGetterSetter(Transformer$1, 'anchorCornerRadius', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Transformer$1, 'borderStroke', 'rgb(0, 161, 255)');
	Factory_1.Factory.addGetterSetter(Transformer$1, 'borderStrokeWidth', 1, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Transformer$1, 'borderDash');
	Factory_1.Factory.addGetterSetter(Transformer$1, 'keepRatio', true);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'centeredScaling', false);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'ignoreStroke', false);
	Factory_1.Factory.addGetterSetter(Transformer$1, 'padding', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Transformer$1, 'node');
	Factory_1.Factory.addGetterSetter(Transformer$1, 'nodes');
	Factory_1.Factory.addGetterSetter(Transformer$1, 'boundBoxFunc');
	Factory_1.Factory.addGetterSetter(Transformer$1, 'shouldOverdrawWholeArea', false);
	Factory_1.Factory.backCompat(Transformer$1, {
	    lineEnabled: 'borderEnabled',
	    rotateHandlerOffset: 'rotateAnchorOffset',
	    enabledHandlers: 'enabledAnchors',
	});
	Util_1.Collection.mapMethods(Transformer$1);
	return Transformer;
}

var Wedge = {};

var hasRequiredWedge;

function requireWedge () {
	if (hasRequiredWedge) return Wedge;
	hasRequiredWedge = 1;
	var __extends = (Wedge && Wedge.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(Wedge, "__esModule", { value: true });
	Wedge.Wedge = void 0;
	var Util_1 = requireUtil();
	var Factory_1 = requireFactory();
	var Shape_1 = requireShape();
	var Global_1 = requireGlobal();
	var Validators_1 = requireValidators();
	var Global_2 = requireGlobal();
	var Wedge$1 = (function (_super) {
	    __extends(Wedge, _super);
	    function Wedge() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Wedge.prototype._sceneFunc = function (context) {
	        context.beginPath();
	        context.arc(0, 0, this.radius(), 0, Global_1.Konva.getAngle(this.angle()), this.clockwise());
	        context.lineTo(0, 0);
	        context.closePath();
	        context.fillStrokeShape(this);
	    };
	    Wedge.prototype.getWidth = function () {
	        return this.radius() * 2;
	    };
	    Wedge.prototype.getHeight = function () {
	        return this.radius() * 2;
	    };
	    Wedge.prototype.setWidth = function (width) {
	        this.radius(width / 2);
	    };
	    Wedge.prototype.setHeight = function (height) {
	        this.radius(height / 2);
	    };
	    return Wedge;
	}(Shape_1.Shape));
	Wedge.Wedge = Wedge$1;
	Wedge$1.prototype.className = 'Wedge';
	Wedge$1.prototype._centroid = true;
	Wedge$1.prototype._attrsAffectingSize = ['radius'];
	Global_2._registerNode(Wedge$1);
	Factory_1.Factory.addGetterSetter(Wedge$1, 'radius', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Wedge$1, 'angle', 0, Validators_1.getNumberValidator());
	Factory_1.Factory.addGetterSetter(Wedge$1, 'clockwise', false);
	Factory_1.Factory.backCompat(Wedge$1, {
	    angleDeg: 'angle',
	    getAngleDeg: 'getAngle',
	    setAngleDeg: 'setAngle'
	});
	Util_1.Collection.mapMethods(Wedge$1);
	return Wedge;
}

var Blur = {};

var hasRequiredBlur;

function requireBlur () {
	if (hasRequiredBlur) return Blur;
	hasRequiredBlur = 1;
	Object.defineProperty(Blur, "__esModule", { value: true });
	Blur.Blur = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	function BlurStack() {
	    this.r = 0;
	    this.g = 0;
	    this.b = 0;
	    this.a = 0;
	    this.next = null;
	}
	var mul_table = [
	    512,
	    512,
	    456,
	    512,
	    328,
	    456,
	    335,
	    512,
	    405,
	    328,
	    271,
	    456,
	    388,
	    335,
	    292,
	    512,
	    454,
	    405,
	    364,
	    328,
	    298,
	    271,
	    496,
	    456,
	    420,
	    388,
	    360,
	    335,
	    312,
	    292,
	    273,
	    512,
	    482,
	    454,
	    428,
	    405,
	    383,
	    364,
	    345,
	    328,
	    312,
	    298,
	    284,
	    271,
	    259,
	    496,
	    475,
	    456,
	    437,
	    420,
	    404,
	    388,
	    374,
	    360,
	    347,
	    335,
	    323,
	    312,
	    302,
	    292,
	    282,
	    273,
	    265,
	    512,
	    497,
	    482,
	    468,
	    454,
	    441,
	    428,
	    417,
	    405,
	    394,
	    383,
	    373,
	    364,
	    354,
	    345,
	    337,
	    328,
	    320,
	    312,
	    305,
	    298,
	    291,
	    284,
	    278,
	    271,
	    265,
	    259,
	    507,
	    496,
	    485,
	    475,
	    465,
	    456,
	    446,
	    437,
	    428,
	    420,
	    412,
	    404,
	    396,
	    388,
	    381,
	    374,
	    367,
	    360,
	    354,
	    347,
	    341,
	    335,
	    329,
	    323,
	    318,
	    312,
	    307,
	    302,
	    297,
	    292,
	    287,
	    282,
	    278,
	    273,
	    269,
	    265,
	    261,
	    512,
	    505,
	    497,
	    489,
	    482,
	    475,
	    468,
	    461,
	    454,
	    447,
	    441,
	    435,
	    428,
	    422,
	    417,
	    411,
	    405,
	    399,
	    394,
	    389,
	    383,
	    378,
	    373,
	    368,
	    364,
	    359,
	    354,
	    350,
	    345,
	    341,
	    337,
	    332,
	    328,
	    324,
	    320,
	    316,
	    312,
	    309,
	    305,
	    301,
	    298,
	    294,
	    291,
	    287,
	    284,
	    281,
	    278,
	    274,
	    271,
	    268,
	    265,
	    262,
	    259,
	    257,
	    507,
	    501,
	    496,
	    491,
	    485,
	    480,
	    475,
	    470,
	    465,
	    460,
	    456,
	    451,
	    446,
	    442,
	    437,
	    433,
	    428,
	    424,
	    420,
	    416,
	    412,
	    408,
	    404,
	    400,
	    396,
	    392,
	    388,
	    385,
	    381,
	    377,
	    374,
	    370,
	    367,
	    363,
	    360,
	    357,
	    354,
	    350,
	    347,
	    344,
	    341,
	    338,
	    335,
	    332,
	    329,
	    326,
	    323,
	    320,
	    318,
	    315,
	    312,
	    310,
	    307,
	    304,
	    302,
	    299,
	    297,
	    294,
	    292,
	    289,
	    287,
	    285,
	    282,
	    280,
	    278,
	    275,
	    273,
	    271,
	    269,
	    267,
	    265,
	    263,
	    261,
	    259
	];
	var shg_table = [
	    9,
	    11,
	    12,
	    13,
	    13,
	    14,
	    14,
	    15,
	    15,
	    15,
	    15,
	    16,
	    16,
	    16,
	    16,
	    17,
	    17,
	    17,
	    17,
	    17,
	    17,
	    17,
	    18,
	    18,
	    18,
	    18,
	    18,
	    18,
	    18,
	    18,
	    18,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24
	];
	function filterGaussBlurRGBA(imageData, radius) {
	    var pixels = imageData.data, width = imageData.width, height = imageData.height;
	    var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
	    var div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = (radiusPlus1 * (radiusPlus1 + 1)) / 2, stackStart = new BlurStack(), stackEnd = null, stack = stackStart, stackIn = null, stackOut = null, mul_sum = mul_table[radius], shg_sum = shg_table[radius];
	    for (i = 1; i < div; i++) {
	        stack = stack.next = new BlurStack();
	        if (i === radiusPlus1) {
	            stackEnd = stack;
	        }
	    }
	    stack.next = stackStart;
	    yw = yi = 0;
	    for (y = 0; y < height; y++) {
	        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
	        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
	        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
	        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
	        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
	        r_sum += sumFactor * pr;
	        g_sum += sumFactor * pg;
	        b_sum += sumFactor * pb;
	        a_sum += sumFactor * pa;
	        stack = stackStart;
	        for (i = 0; i < radiusPlus1; i++) {
	            stack.r = pr;
	            stack.g = pg;
	            stack.b = pb;
	            stack.a = pa;
	            stack = stack.next;
	        }
	        for (i = 1; i < radiusPlus1; i++) {
	            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
	            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
	            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
	            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
	            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
	            r_in_sum += pr;
	            g_in_sum += pg;
	            b_in_sum += pb;
	            a_in_sum += pa;
	            stack = stack.next;
	        }
	        stackIn = stackStart;
	        stackOut = stackEnd;
	        for (x = 0; x < width; x++) {
	            pixels[yi + 3] = pa = (a_sum * mul_sum) >> shg_sum;
	            if (pa !== 0) {
	                pa = 255 / pa;
	                pixels[yi] = ((r_sum * mul_sum) >> shg_sum) * pa;
	                pixels[yi + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
	                pixels[yi + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
	            }
	            else {
	                pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
	            }
	            r_sum -= r_out_sum;
	            g_sum -= g_out_sum;
	            b_sum -= b_out_sum;
	            a_sum -= a_out_sum;
	            r_out_sum -= stackIn.r;
	            g_out_sum -= stackIn.g;
	            b_out_sum -= stackIn.b;
	            a_out_sum -= stackIn.a;
	            p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;
	            r_in_sum += stackIn.r = pixels[p];
	            g_in_sum += stackIn.g = pixels[p + 1];
	            b_in_sum += stackIn.b = pixels[p + 2];
	            a_in_sum += stackIn.a = pixels[p + 3];
	            r_sum += r_in_sum;
	            g_sum += g_in_sum;
	            b_sum += b_in_sum;
	            a_sum += a_in_sum;
	            stackIn = stackIn.next;
	            r_out_sum += pr = stackOut.r;
	            g_out_sum += pg = stackOut.g;
	            b_out_sum += pb = stackOut.b;
	            a_out_sum += pa = stackOut.a;
	            r_in_sum -= pr;
	            g_in_sum -= pg;
	            b_in_sum -= pb;
	            a_in_sum -= pa;
	            stackOut = stackOut.next;
	            yi += 4;
	        }
	        yw += width;
	    }
	    for (x = 0; x < width; x++) {
	        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
	        yi = x << 2;
	        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
	        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
	        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
	        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
	        r_sum += sumFactor * pr;
	        g_sum += sumFactor * pg;
	        b_sum += sumFactor * pb;
	        a_sum += sumFactor * pa;
	        stack = stackStart;
	        for (i = 0; i < radiusPlus1; i++) {
	            stack.r = pr;
	            stack.g = pg;
	            stack.b = pb;
	            stack.a = pa;
	            stack = stack.next;
	        }
	        yp = width;
	        for (i = 1; i <= radius; i++) {
	            yi = (yp + x) << 2;
	            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
	            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
	            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
	            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
	            r_in_sum += pr;
	            g_in_sum += pg;
	            b_in_sum += pb;
	            a_in_sum += pa;
	            stack = stack.next;
	            if (i < heightMinus1) {
	                yp += width;
	            }
	        }
	        yi = x;
	        stackIn = stackStart;
	        stackOut = stackEnd;
	        for (y = 0; y < height; y++) {
	            p = yi << 2;
	            pixels[p + 3] = pa = (a_sum * mul_sum) >> shg_sum;
	            if (pa > 0) {
	                pa = 255 / pa;
	                pixels[p] = ((r_sum * mul_sum) >> shg_sum) * pa;
	                pixels[p + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
	                pixels[p + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
	            }
	            else {
	                pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
	            }
	            r_sum -= r_out_sum;
	            g_sum -= g_out_sum;
	            b_sum -= b_out_sum;
	            a_sum -= a_out_sum;
	            r_out_sum -= stackIn.r;
	            g_out_sum -= stackIn.g;
	            b_out_sum -= stackIn.b;
	            a_out_sum -= stackIn.a;
	            p =
	                (x +
	                    ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width) <<
	                    2;
	            r_sum += r_in_sum += stackIn.r = pixels[p];
	            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
	            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
	            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
	            stackIn = stackIn.next;
	            r_out_sum += pr = stackOut.r;
	            g_out_sum += pg = stackOut.g;
	            b_out_sum += pb = stackOut.b;
	            a_out_sum += pa = stackOut.a;
	            r_in_sum -= pr;
	            g_in_sum -= pg;
	            b_in_sum -= pb;
	            a_in_sum -= pa;
	            stackOut = stackOut.next;
	            yi += width;
	        }
	    }
	}
	var Blur$1 = function Blur(imageData) {
	    var radius = Math.round(this.blurRadius());
	    if (radius > 0) {
	        filterGaussBlurRGBA(imageData, radius);
	    }
	};
	Blur.Blur = Blur$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'blurRadius', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Blur;
}

var Brighten = {};

var hasRequiredBrighten;

function requireBrighten () {
	if (hasRequiredBrighten) return Brighten;
	hasRequiredBrighten = 1;
	Object.defineProperty(Brighten, "__esModule", { value: true });
	Brighten.Brighten = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var Brighten$1 = function (imageData) {
	    var brightness = this.brightness() * 255, data = imageData.data, len = data.length, i;
	    for (i = 0; i < len; i += 4) {
	        data[i] += brightness;
	        data[i + 1] += brightness;
	        data[i + 2] += brightness;
	    }
	};
	Brighten.Brighten = Brighten$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'brightness', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Brighten;
}

var Contrast = {};

var hasRequiredContrast;

function requireContrast () {
	if (hasRequiredContrast) return Contrast;
	hasRequiredContrast = 1;
	Object.defineProperty(Contrast, "__esModule", { value: true });
	Contrast.Contrast = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var Contrast$1 = function (imageData) {
	    var adjust = Math.pow((this.contrast() + 100) / 100, 2);
	    var data = imageData.data, nPixels = data.length, red = 150, green = 150, blue = 150, i;
	    for (i = 0; i < nPixels; i += 4) {
	        red = data[i];
	        green = data[i + 1];
	        blue = data[i + 2];
	        red /= 255;
	        red -= 0.5;
	        red *= adjust;
	        red += 0.5;
	        red *= 255;
	        green /= 255;
	        green -= 0.5;
	        green *= adjust;
	        green += 0.5;
	        green *= 255;
	        blue /= 255;
	        blue -= 0.5;
	        blue *= adjust;
	        blue += 0.5;
	        blue *= 255;
	        red = red < 0 ? 0 : red > 255 ? 255 : red;
	        green = green < 0 ? 0 : green > 255 ? 255 : green;
	        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
	        data[i] = red;
	        data[i + 1] = green;
	        data[i + 2] = blue;
	    }
	};
	Contrast.Contrast = Contrast$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'contrast', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Contrast;
}

var Emboss = {};

var hasRequiredEmboss;

function requireEmboss () {
	if (hasRequiredEmboss) return Emboss;
	hasRequiredEmboss = 1;
	Object.defineProperty(Emboss, "__esModule", { value: true });
	Emboss.Emboss = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Util_1 = requireUtil();
	var Validators_1 = requireValidators();
	var Emboss$1 = function (imageData) {
	    var strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), dirY = 0, dirX = 0, data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
	    switch (direction) {
	        case 'top-left':
	            dirY = -1;
	            dirX = -1;
	            break;
	        case 'top':
	            dirY = -1;
	            dirX = 0;
	            break;
	        case 'top-right':
	            dirY = -1;
	            dirX = 1;
	            break;
	        case 'right':
	            dirY = 0;
	            dirX = 1;
	            break;
	        case 'bottom-right':
	            dirY = 1;
	            dirX = 1;
	            break;
	        case 'bottom':
	            dirY = 1;
	            dirX = 0;
	            break;
	        case 'bottom-left':
	            dirY = 1;
	            dirX = -1;
	            break;
	        case 'left':
	            dirY = 0;
	            dirX = -1;
	            break;
	        default:
	            Util_1.Util.error('Unknown emboss direction: ' + direction);
	    }
	    do {
	        var offsetY = (y - 1) * w4;
	        var otherY = dirY;
	        if (y + otherY < 1) {
	            otherY = 0;
	        }
	        if (y + otherY > h) {
	            otherY = 0;
	        }
	        var offsetYOther = (y - 1 + otherY) * w * 4;
	        var x = w;
	        do {
	            var offset = offsetY + (x - 1) * 4;
	            var otherX = dirX;
	            if (x + otherX < 1) {
	                otherX = 0;
	            }
	            if (x + otherX > w) {
	                otherX = 0;
	            }
	            var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
	            var dR = data[offset] - data[offsetOther];
	            var dG = data[offset + 1] - data[offsetOther + 1];
	            var dB = data[offset + 2] - data[offsetOther + 2];
	            var dif = dR;
	            var absDif = dif > 0 ? dif : -dif;
	            var absG = dG > 0 ? dG : -dG;
	            var absB = dB > 0 ? dB : -dB;
	            if (absG > absDif) {
	                dif = dG;
	            }
	            if (absB > absDif) {
	                dif = dB;
	            }
	            dif *= strength;
	            if (blend) {
	                var r = data[offset] + dif;
	                var g = data[offset + 1] + dif;
	                var b = data[offset + 2] + dif;
	                data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
	                data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
	                data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
	            }
	            else {
	                var grey = greyLevel - dif;
	                if (grey < 0) {
	                    grey = 0;
	                }
	                else if (grey > 255) {
	                    grey = 255;
	                }
	                data[offset] = data[offset + 1] = data[offset + 2] = grey;
	            }
	        } while (--x);
	    } while (--y);
	};
	Emboss.Emboss = Emboss$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'embossStrength', 0.5, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'embossWhiteLevel', 0.5, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'embossDirection', 'top-left', null, Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'embossBlend', false, null, Factory_1.Factory.afterSetFilter);
	return Emboss;
}

var Enhance = {};

var hasRequiredEnhance;

function requireEnhance () {
	if (hasRequiredEnhance) return Enhance;
	hasRequiredEnhance = 1;
	Object.defineProperty(Enhance, "__esModule", { value: true });
	Enhance.Enhance = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	function remap(fromValue, fromMin, fromMax, toMin, toMax) {
	    var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
	    if (fromRange === 0) {
	        return toMin + toRange / 2;
	    }
	    if (toRange === 0) {
	        return toMin;
	    }
	    toValue = (fromValue - fromMin) / fromRange;
	    toValue = toRange * toValue + toMin;
	    return toValue;
	}
	var Enhance$1 = function (imageData) {
	    var data = imageData.data, nSubPixels = data.length, rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b, i;
	    var enhanceAmount = this.enhance();
	    if (enhanceAmount === 0) {
	        return;
	    }
	    for (i = 0; i < nSubPixels; i += 4) {
	        r = data[i + 0];
	        if (r < rMin) {
	            rMin = r;
	        }
	        else if (r > rMax) {
	            rMax = r;
	        }
	        g = data[i + 1];
	        if (g < gMin) {
	            gMin = g;
	        }
	        else if (g > gMax) {
	            gMax = g;
	        }
	        b = data[i + 2];
	        if (b < bMin) {
	            bMin = b;
	        }
	        else if (b > bMax) {
	            bMax = b;
	        }
	    }
	    if (rMax === rMin) {
	        rMax = 255;
	        rMin = 0;
	    }
	    if (gMax === gMin) {
	        gMax = 255;
	        gMin = 0;
	    }
	    if (bMax === bMin) {
	        bMax = 255;
	        bMin = 0;
	    }
	    var rMid, rGoalMax, rGoalMin, gMid, gGoalMax, gGoalMin, bMid, bGoalMax, bGoalMin;
	    if (enhanceAmount > 0) {
	        rGoalMax = rMax + enhanceAmount * (255 - rMax);
	        rGoalMin = rMin - enhanceAmount * (rMin - 0);
	        gGoalMax = gMax + enhanceAmount * (255 - gMax);
	        gGoalMin = gMin - enhanceAmount * (gMin - 0);
	        bGoalMax = bMax + enhanceAmount * (255 - bMax);
	        bGoalMin = bMin - enhanceAmount * (bMin - 0);
	    }
	    else {
	        rMid = (rMax + rMin) * 0.5;
	        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
	        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
	        gMid = (gMax + gMin) * 0.5;
	        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
	        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
	        bMid = (bMax + bMin) * 0.5;
	        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
	        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
	    }
	    for (i = 0; i < nSubPixels; i += 4) {
	        data[i + 0] = remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
	        data[i + 1] = remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
	        data[i + 2] = remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
	    }
	};
	Enhance.Enhance = Enhance$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'enhance', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Enhance;
}

var Grayscale = {};

var hasRequiredGrayscale;

function requireGrayscale () {
	if (hasRequiredGrayscale) return Grayscale;
	hasRequiredGrayscale = 1;
	Object.defineProperty(Grayscale, "__esModule", { value: true });
	Grayscale.Grayscale = void 0;
	var Grayscale$1 = function (imageData) {
	    var data = imageData.data, len = data.length, i, brightness;
	    for (i = 0; i < len; i += 4) {
	        brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
	        data[i] = brightness;
	        data[i + 1] = brightness;
	        data[i + 2] = brightness;
	    }
	};
	Grayscale.Grayscale = Grayscale$1;
	return Grayscale;
}

var HSL = {};

var hasRequiredHSL;

function requireHSL () {
	if (hasRequiredHSL) return HSL;
	hasRequiredHSL = 1;
	Object.defineProperty(HSL, "__esModule", { value: true });
	HSL.HSL = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'hue', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'saturation', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'luminance', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	var HSL$1 = function (imageData) {
	    var data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127, i;
	    var vsu = v * s * Math.cos((h * Math.PI) / 180), vsw = v * s * Math.sin((h * Math.PI) / 180);
	    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
	    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
	    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
	    var r, g, b, a;
	    for (i = 0; i < nPixels; i += 4) {
	        r = data[i + 0];
	        g = data[i + 1];
	        b = data[i + 2];
	        a = data[i + 3];
	        data[i + 0] = rr * r + rg * g + rb * b + l;
	        data[i + 1] = gr * r + gg * g + gb * b + l;
	        data[i + 2] = br * r + bg * g + bb * b + l;
	        data[i + 3] = a;
	    }
	};
	HSL.HSL = HSL$1;
	return HSL;
}

var HSV = {};

var hasRequiredHSV;

function requireHSV () {
	if (hasRequiredHSV) return HSV;
	hasRequiredHSV = 1;
	Object.defineProperty(HSV, "__esModule", { value: true });
	HSV.HSV = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var HSV$1 = function (imageData) {
	    var data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, i;
	    var vsu = v * s * Math.cos((h * Math.PI) / 180), vsw = v * s * Math.sin((h * Math.PI) / 180);
	    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
	    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
	    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
	    var r, g, b, a;
	    for (i = 0; i < nPixels; i += 4) {
	        r = data[i + 0];
	        g = data[i + 1];
	        b = data[i + 2];
	        a = data[i + 3];
	        data[i + 0] = rr * r + rg * g + rb * b;
	        data[i + 1] = gr * r + gg * g + gb * b;
	        data[i + 2] = br * r + bg * g + bb * b;
	        data[i + 3] = a;
	    }
	};
	HSV.HSV = HSV$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'hue', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'saturation', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'value', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return HSV;
}

var Invert = {};

var hasRequiredInvert;

function requireInvert () {
	if (hasRequiredInvert) return Invert;
	hasRequiredInvert = 1;
	Object.defineProperty(Invert, "__esModule", { value: true });
	Invert.Invert = void 0;
	var Invert$1 = function (imageData) {
	    var data = imageData.data, len = data.length, i;
	    for (i = 0; i < len; i += 4) {
	        data[i] = 255 - data[i];
	        data[i + 1] = 255 - data[i + 1];
	        data[i + 2] = 255 - data[i + 2];
	    }
	};
	Invert.Invert = Invert$1;
	return Invert;
}

var Kaleidoscope = {};

var hasRequiredKaleidoscope;

function requireKaleidoscope () {
	if (hasRequiredKaleidoscope) return Kaleidoscope;
	hasRequiredKaleidoscope = 1;
	Object.defineProperty(Kaleidoscope, "__esModule", { value: true });
	Kaleidoscope.Kaleidoscope = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Util_1 = requireUtil();
	var Validators_1 = requireValidators();
	var ToPolar = function (src, dst, opt) {
	    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, r = 0, g = 0, b = 0, a = 0;
	    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
	    x = xSize - xMid;
	    y = ySize - yMid;
	    rad = Math.sqrt(x * x + y * y);
	    rMax = rad > rMax ? rad : rMax;
	    var rSize = ySize, tSize = xSize, radius, theta;
	    var conversion = ((360 / tSize) * Math.PI) / 180, sin, cos;
	    for (theta = 0; theta < tSize; theta += 1) {
	        sin = Math.sin(theta * conversion);
	        cos = Math.cos(theta * conversion);
	        for (radius = 0; radius < rSize; radius += 1) {
	            x = Math.floor(xMid + ((rMax * radius) / rSize) * cos);
	            y = Math.floor(yMid + ((rMax * radius) / rSize) * sin);
	            i = (y * xSize + x) * 4;
	            r = srcPixels[i + 0];
	            g = srcPixels[i + 1];
	            b = srcPixels[i + 2];
	            a = srcPixels[i + 3];
	            i = (theta + radius * xSize) * 4;
	            dstPixels[i + 0] = r;
	            dstPixels[i + 1] = g;
	            dstPixels[i + 2] = b;
	            dstPixels[i + 3] = a;
	        }
	    }
	};
	var FromPolar = function (src, dst, opt) {
	    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, dx, dy, r = 0, g = 0, b = 0, a = 0;
	    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
	    x = xSize - xMid;
	    y = ySize - yMid;
	    rad = Math.sqrt(x * x + y * y);
	    rMax = rad > rMax ? rad : rMax;
	    var rSize = ySize, tSize = xSize, radius, theta, phaseShift = 0;
	    var x1, y1;
	    for (x = 0; x < xSize; x += 1) {
	        for (y = 0; y < ySize; y += 1) {
	            dx = x - xMid;
	            dy = y - yMid;
	            radius = (Math.sqrt(dx * dx + dy * dy) * rSize) / rMax;
	            theta = ((Math.atan2(dy, dx) * 180) / Math.PI + 360 + phaseShift) % 360;
	            theta = (theta * tSize) / 360;
	            x1 = Math.floor(theta);
	            y1 = Math.floor(radius);
	            i = (y1 * xSize + x1) * 4;
	            r = srcPixels[i + 0];
	            g = srcPixels[i + 1];
	            b = srcPixels[i + 2];
	            a = srcPixels[i + 3];
	            i = (y * xSize + x) * 4;
	            dstPixels[i + 0] = r;
	            dstPixels[i + 1] = g;
	            dstPixels[i + 2] = b;
	            dstPixels[i + 3] = a;
	        }
	    }
	};
	var Kaleidoscope$1 = function (imageData) {
	    var xSize = imageData.width, ySize = imageData.height;
	    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
	    var power = Math.round(this.kaleidoscopePower());
	    var angle = Math.round(this.kaleidoscopeAngle());
	    var offset = Math.floor((xSize * (angle % 360)) / 360);
	    if (power < 1) {
	        return;
	    }
	    var tempCanvas = Util_1.Util.createCanvasElement();
	    tempCanvas.width = xSize;
	    tempCanvas.height = ySize;
	    var scratchData = tempCanvas
	        .getContext('2d')
	        .getImageData(0, 0, xSize, ySize);
	    ToPolar(imageData, scratchData, {
	        polarCenterX: xSize / 2,
	        polarCenterY: ySize / 2
	    });
	    var minSectionSize = xSize / Math.pow(2, power);
	    while (minSectionSize <= 8) {
	        minSectionSize = minSectionSize * 2;
	        power -= 1;
	    }
	    minSectionSize = Math.ceil(minSectionSize);
	    var sectionSize = minSectionSize;
	    var xStart = 0, xEnd = sectionSize, xDelta = 1;
	    if (offset + minSectionSize > xSize) {
	        xStart = sectionSize;
	        xEnd = 0;
	        xDelta = -1;
	    }
	    for (y = 0; y < ySize; y += 1) {
	        for (x = xStart; x !== xEnd; x += xDelta) {
	            xoff = Math.round(x + offset) % xSize;
	            srcPos = (xSize * y + xoff) * 4;
	            r = scratchData.data[srcPos + 0];
	            g = scratchData.data[srcPos + 1];
	            b = scratchData.data[srcPos + 2];
	            a = scratchData.data[srcPos + 3];
	            dstPos = (xSize * y + x) * 4;
	            scratchData.data[dstPos + 0] = r;
	            scratchData.data[dstPos + 1] = g;
	            scratchData.data[dstPos + 2] = b;
	            scratchData.data[dstPos + 3] = a;
	        }
	    }
	    for (y = 0; y < ySize; y += 1) {
	        sectionSize = Math.floor(minSectionSize);
	        for (i = 0; i < power; i += 1) {
	            for (x = 0; x < sectionSize + 1; x += 1) {
	                srcPos = (xSize * y + x) * 4;
	                r = scratchData.data[srcPos + 0];
	                g = scratchData.data[srcPos + 1];
	                b = scratchData.data[srcPos + 2];
	                a = scratchData.data[srcPos + 3];
	                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
	                scratchData.data[dstPos + 0] = r;
	                scratchData.data[dstPos + 1] = g;
	                scratchData.data[dstPos + 2] = b;
	                scratchData.data[dstPos + 3] = a;
	            }
	            sectionSize *= 2;
	        }
	    }
	    FromPolar(scratchData, imageData, { });
	};
	Kaleidoscope.Kaleidoscope = Kaleidoscope$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'kaleidoscopePower', 2, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'kaleidoscopeAngle', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Kaleidoscope;
}

var Mask = {};

var hasRequiredMask;

function requireMask () {
	if (hasRequiredMask) return Mask;
	hasRequiredMask = 1;
	Object.defineProperty(Mask, "__esModule", { value: true });
	Mask.Mask = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	function pixelAt(idata, x, y) {
	    var idx = (y * idata.width + x) * 4;
	    var d = [];
	    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
	    return d;
	}
	function rgbDistance(p1, p2) {
	    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) +
	        Math.pow(p1[1] - p2[1], 2) +
	        Math.pow(p1[2] - p2[2], 2));
	}
	function rgbMean(pTab) {
	    var m = [0, 0, 0];
	    for (var i = 0; i < pTab.length; i++) {
	        m[0] += pTab[i][0];
	        m[1] += pTab[i][1];
	        m[2] += pTab[i][2];
	    }
	    m[0] /= pTab.length;
	    m[1] /= pTab.length;
	    m[2] /= pTab.length;
	    return m;
	}
	function backgroundMask(idata, threshold) {
	    var rgbv_no = pixelAt(idata, 0, 0);
	    var rgbv_ne = pixelAt(idata, idata.width - 1, 0);
	    var rgbv_so = pixelAt(idata, 0, idata.height - 1);
	    var rgbv_se = pixelAt(idata, idata.width - 1, idata.height - 1);
	    var thres = threshold || 10;
	    if (rgbDistance(rgbv_no, rgbv_ne) < thres &&
	        rgbDistance(rgbv_ne, rgbv_se) < thres &&
	        rgbDistance(rgbv_se, rgbv_so) < thres &&
	        rgbDistance(rgbv_so, rgbv_no) < thres) {
	        var mean = rgbMean([rgbv_ne, rgbv_no, rgbv_se, rgbv_so]);
	        var mask = [];
	        for (var i = 0; i < idata.width * idata.height; i++) {
	            var d = rgbDistance(mean, [
	                idata.data[i * 4],
	                idata.data[i * 4 + 1],
	                idata.data[i * 4 + 2]
	            ]);
	            mask[i] = d < thres ? 0 : 255;
	        }
	        return mask;
	    }
	}
	function applyMask(idata, mask) {
	    for (var i = 0; i < idata.width * idata.height; i++) {
	        idata.data[4 * i + 3] = mask[i];
	    }
	}
	function erodeMask(mask, sw, sh) {
	    var weights = [1, 1, 1, 1, 0, 1, 1, 1, 1];
	    var side = Math.round(Math.sqrt(weights.length));
	    var halfSide = Math.floor(side / 2);
	    var maskResult = [];
	    for (var y = 0; y < sh; y++) {
	        for (var x = 0; x < sw; x++) {
	            var so = y * sw + x;
	            var a = 0;
	            for (var cy = 0; cy < side; cy++) {
	                for (var cx = 0; cx < side; cx++) {
	                    var scy = y + cy - halfSide;
	                    var scx = x + cx - halfSide;
	                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
	                        var srcOff = scy * sw + scx;
	                        var wt = weights[cy * side + cx];
	                        a += mask[srcOff] * wt;
	                    }
	                }
	            }
	            maskResult[so] = a === 255 * 8 ? 255 : 0;
	        }
	    }
	    return maskResult;
	}
	function dilateMask(mask, sw, sh) {
	    var weights = [1, 1, 1, 1, 1, 1, 1, 1, 1];
	    var side = Math.round(Math.sqrt(weights.length));
	    var halfSide = Math.floor(side / 2);
	    var maskResult = [];
	    for (var y = 0; y < sh; y++) {
	        for (var x = 0; x < sw; x++) {
	            var so = y * sw + x;
	            var a = 0;
	            for (var cy = 0; cy < side; cy++) {
	                for (var cx = 0; cx < side; cx++) {
	                    var scy = y + cy - halfSide;
	                    var scx = x + cx - halfSide;
	                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
	                        var srcOff = scy * sw + scx;
	                        var wt = weights[cy * side + cx];
	                        a += mask[srcOff] * wt;
	                    }
	                }
	            }
	            maskResult[so] = a >= 255 * 4 ? 255 : 0;
	        }
	    }
	    return maskResult;
	}
	function smoothEdgeMask(mask, sw, sh) {
	    var weights = [1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9];
	    var side = Math.round(Math.sqrt(weights.length));
	    var halfSide = Math.floor(side / 2);
	    var maskResult = [];
	    for (var y = 0; y < sh; y++) {
	        for (var x = 0; x < sw; x++) {
	            var so = y * sw + x;
	            var a = 0;
	            for (var cy = 0; cy < side; cy++) {
	                for (var cx = 0; cx < side; cx++) {
	                    var scy = y + cy - halfSide;
	                    var scx = x + cx - halfSide;
	                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
	                        var srcOff = scy * sw + scx;
	                        var wt = weights[cy * side + cx];
	                        a += mask[srcOff] * wt;
	                    }
	                }
	            }
	            maskResult[so] = a;
	        }
	    }
	    return maskResult;
	}
	var Mask$1 = function (imageData) {
	    var threshold = this.threshold(), mask = backgroundMask(imageData, threshold);
	    if (mask) {
	        mask = erodeMask(mask, imageData.width, imageData.height);
	        mask = dilateMask(mask, imageData.width, imageData.height);
	        mask = smoothEdgeMask(mask, imageData.width, imageData.height);
	        applyMask(imageData, mask);
	    }
	    return imageData;
	};
	Mask.Mask = Mask$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'threshold', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Mask;
}

var Noise = {};

var hasRequiredNoise;

function requireNoise () {
	if (hasRequiredNoise) return Noise;
	hasRequiredNoise = 1;
	Object.defineProperty(Noise, "__esModule", { value: true });
	Noise.Noise = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var Noise$1 = function (imageData) {
	    var amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2, i;
	    for (i = 0; i < nPixels; i += 4) {
	        data[i + 0] += half - 2 * half * Math.random();
	        data[i + 1] += half - 2 * half * Math.random();
	        data[i + 2] += half - 2 * half * Math.random();
	    }
	};
	Noise.Noise = Noise$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'noise', 0.2, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Noise;
}

var Pixelate = {};

var hasRequiredPixelate;

function requirePixelate () {
	if (hasRequiredPixelate) return Pixelate;
	hasRequiredPixelate = 1;
	Object.defineProperty(Pixelate, "__esModule", { value: true });
	Pixelate.Pixelate = void 0;
	var Factory_1 = requireFactory();
	var Util_1 = requireUtil();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var Pixelate$1 = function (imageData) {
	    var pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, x, y, i, red, green, blue, alpha, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), xBinStart, xBinEnd, yBinStart, yBinEnd, xBin, yBin, pixelsInBin, data = imageData.data;
	    if (pixelSize <= 0) {
	        Util_1.Util.error('pixelSize value can not be <= 0');
	        return;
	    }
	    for (xBin = 0; xBin < nBinsX; xBin += 1) {
	        for (yBin = 0; yBin < nBinsY; yBin += 1) {
	            red = 0;
	            green = 0;
	            blue = 0;
	            alpha = 0;
	            xBinStart = xBin * pixelSize;
	            xBinEnd = xBinStart + pixelSize;
	            yBinStart = yBin * pixelSize;
	            yBinEnd = yBinStart + pixelSize;
	            pixelsInBin = 0;
	            for (x = xBinStart; x < xBinEnd; x += 1) {
	                if (x >= width) {
	                    continue;
	                }
	                for (y = yBinStart; y < yBinEnd; y += 1) {
	                    if (y >= height) {
	                        continue;
	                    }
	                    i = (width * y + x) * 4;
	                    red += data[i + 0];
	                    green += data[i + 1];
	                    blue += data[i + 2];
	                    alpha += data[i + 3];
	                    pixelsInBin += 1;
	                }
	            }
	            red = red / pixelsInBin;
	            green = green / pixelsInBin;
	            blue = blue / pixelsInBin;
	            alpha = alpha / pixelsInBin;
	            for (x = xBinStart; x < xBinEnd; x += 1) {
	                if (x >= width) {
	                    continue;
	                }
	                for (y = yBinStart; y < yBinEnd; y += 1) {
	                    if (y >= height) {
	                        continue;
	                    }
	                    i = (width * y + x) * 4;
	                    data[i + 0] = red;
	                    data[i + 1] = green;
	                    data[i + 2] = blue;
	                    data[i + 3] = alpha;
	                }
	            }
	        }
	    }
	};
	Pixelate.Pixelate = Pixelate$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'pixelSize', 8, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Pixelate;
}

var Posterize = {};

var hasRequiredPosterize;

function requirePosterize () {
	if (hasRequiredPosterize) return Posterize;
	hasRequiredPosterize = 1;
	Object.defineProperty(Posterize, "__esModule", { value: true });
	Posterize.Posterize = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var Posterize$1 = function (imageData) {
	    var levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels, i;
	    for (i = 0; i < len; i += 1) {
	        data[i] = Math.floor(data[i] / scale) * scale;
	    }
	};
	Posterize.Posterize = Posterize$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'levels', 0.5, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Posterize;
}

var RGB = {};

var hasRequiredRGB;

function requireRGB () {
	if (hasRequiredRGB) return RGB;
	hasRequiredRGB = 1;
	Object.defineProperty(RGB, "__esModule", { value: true });
	RGB.RGB = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var RGB$1 = function (imageData) {
	    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), i, brightness;
	    for (i = 0; i < nPixels; i += 4) {
	        brightness =
	            (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
	        data[i] = brightness * red;
	        data[i + 1] = brightness * green;
	        data[i + 2] = brightness * blue;
	        data[i + 3] = data[i + 3];
	    }
	};
	RGB.RGB = RGB$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'red', 0, function (val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	        return 255;
	    }
	    else if (val < 0) {
	        return 0;
	    }
	    else {
	        return Math.round(val);
	    }
	});
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'green', 0, function (val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	        return 255;
	    }
	    else if (val < 0) {
	        return 0;
	    }
	    else {
	        return Math.round(val);
	    }
	});
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'blue', 0, Validators_1.RGBComponent, Factory_1.Factory.afterSetFilter);
	return RGB;
}

var RGBA = {};

var hasRequiredRGBA;

function requireRGBA () {
	if (hasRequiredRGBA) return RGBA;
	hasRequiredRGBA = 1;
	Object.defineProperty(RGBA, "__esModule", { value: true });
	RGBA.RGBA = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var RGBA$1 = function (imageData) {
	    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha(), i, ia;
	    for (i = 0; i < nPixels; i += 4) {
	        ia = 1 - alpha;
	        data[i] = red * alpha + data[i] * ia;
	        data[i + 1] = green * alpha + data[i + 1] * ia;
	        data[i + 2] = blue * alpha + data[i + 2] * ia;
	    }
	};
	RGBA.RGBA = RGBA$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'red', 0, function (val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	        return 255;
	    }
	    else if (val < 0) {
	        return 0;
	    }
	    else {
	        return Math.round(val);
	    }
	});
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'green', 0, function (val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	        return 255;
	    }
	    else if (val < 0) {
	        return 0;
	    }
	    else {
	        return Math.round(val);
	    }
	});
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'blue', 0, Validators_1.RGBComponent, Factory_1.Factory.afterSetFilter);
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'alpha', 1, function (val) {
	    this._filterUpToDate = false;
	    if (val > 1) {
	        return 1;
	    }
	    else if (val < 0) {
	        return 0;
	    }
	    else {
	        return val;
	    }
	});
	return RGBA;
}

var Sepia = {};

var hasRequiredSepia;

function requireSepia () {
	if (hasRequiredSepia) return Sepia;
	hasRequiredSepia = 1;
	Object.defineProperty(Sepia, "__esModule", { value: true });
	Sepia.Sepia = void 0;
	var Sepia$1 = function (imageData) {
	    var data = imageData.data, nPixels = data.length, i, r, g, b;
	    for (i = 0; i < nPixels; i += 4) {
	        r = data[i + 0];
	        g = data[i + 1];
	        b = data[i + 2];
	        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
	        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
	        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
	    }
	};
	Sepia.Sepia = Sepia$1;
	return Sepia;
}

var Solarize = {};

var hasRequiredSolarize;

function requireSolarize () {
	if (hasRequiredSolarize) return Solarize;
	hasRequiredSolarize = 1;
	Object.defineProperty(Solarize, "__esModule", { value: true });
	Solarize.Solarize = void 0;
	var Solarize$1 = function (imageData) {
	    var data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
	    do {
	        var offsetY = (y - 1) * w4;
	        var x = w;
	        do {
	            var offset = offsetY + (x - 1) * 4;
	            var r = data[offset];
	            var g = data[offset + 1];
	            var b = data[offset + 2];
	            if (r > 127) {
	                r = 255 - r;
	            }
	            if (g > 127) {
	                g = 255 - g;
	            }
	            if (b > 127) {
	                b = 255 - b;
	            }
	            data[offset] = r;
	            data[offset + 1] = g;
	            data[offset + 2] = b;
	        } while (--x);
	    } while (--y);
	};
	Solarize.Solarize = Solarize$1;
	return Solarize;
}

var Threshold = {};

var hasRequiredThreshold;

function requireThreshold () {
	if (hasRequiredThreshold) return Threshold;
	hasRequiredThreshold = 1;
	Object.defineProperty(Threshold, "__esModule", { value: true });
	Threshold.Threshold = void 0;
	var Factory_1 = requireFactory();
	var Node_1 = requireNode();
	var Validators_1 = requireValidators();
	var Threshold$1 = function (imageData) {
	    var level = this.threshold() * 255, data = imageData.data, len = data.length, i;
	    for (i = 0; i < len; i += 1) {
	        data[i] = data[i] < level ? 0 : 255;
	    }
	};
	Threshold.Threshold = Threshold$1;
	Factory_1.Factory.addGetterSetter(Node_1.Node, 'threshold', 0.5, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
	return Threshold;
}

var hasRequired_FullInternals;

function require_FullInternals () {
	if (hasRequired_FullInternals) return _FullInternals;
	hasRequired_FullInternals = 1;
	Object.defineProperty(_FullInternals, "__esModule", { value: true });
	_FullInternals.Konva = void 0;
	var _CoreInternals_1 = require_CoreInternals();
	var Arc_1 = requireArc();
	var Arrow_1 = requireArrow();
	var Circle_1 = requireCircle();
	var Ellipse_1 = requireEllipse();
	var Image_1 = requireImage();
	var Label_1 = requireLabel();
	var Line_1 = requireLine();
	var Path_1 = requirePath();
	var Rect_1 = requireRect();
	var RegularPolygon_1 = requireRegularPolygon();
	var Ring_1 = requireRing();
	var Sprite_1 = requireSprite();
	var Star_1 = requireStar();
	var Text_1 = requireText();
	var TextPath_1 = requireTextPath();
	var Transformer_1 = requireTransformer();
	var Wedge_1 = requireWedge();
	var Blur_1 = requireBlur();
	var Brighten_1 = requireBrighten();
	var Contrast_1 = requireContrast();
	var Emboss_1 = requireEmboss();
	var Enhance_1 = requireEnhance();
	var Grayscale_1 = requireGrayscale();
	var HSL_1 = requireHSL();
	var HSV_1 = requireHSV();
	var Invert_1 = requireInvert();
	var Kaleidoscope_1 = requireKaleidoscope();
	var Mask_1 = requireMask();
	var Noise_1 = requireNoise();
	var Pixelate_1 = requirePixelate();
	var Posterize_1 = requirePosterize();
	var RGB_1 = requireRGB();
	var RGBA_1 = requireRGBA();
	var Sepia_1 = requireSepia();
	var Solarize_1 = requireSolarize();
	var Threshold_1 = requireThreshold();
	_FullInternals.Konva = _CoreInternals_1.Konva.Util._assign(_CoreInternals_1.Konva, {
	    Arc: Arc_1.Arc,
	    Arrow: Arrow_1.Arrow,
	    Circle: Circle_1.Circle,
	    Ellipse: Ellipse_1.Ellipse,
	    Image: Image_1.Image,
	    Label: Label_1.Label,
	    Tag: Label_1.Tag,
	    Line: Line_1.Line,
	    Path: Path_1.Path,
	    Rect: Rect_1.Rect,
	    RegularPolygon: RegularPolygon_1.RegularPolygon,
	    Ring: Ring_1.Ring,
	    Sprite: Sprite_1.Sprite,
	    Star: Star_1.Star,
	    Text: Text_1.Text,
	    TextPath: TextPath_1.TextPath,
	    Transformer: Transformer_1.Transformer,
	    Wedge: Wedge_1.Wedge,
	    Filters: {
	        Blur: Blur_1.Blur,
	        Brighten: Brighten_1.Brighten,
	        Contrast: Contrast_1.Contrast,
	        Emboss: Emboss_1.Emboss,
	        Enhance: Enhance_1.Enhance,
	        Grayscale: Grayscale_1.Grayscale,
	        HSL: HSL_1.HSL,
	        HSV: HSV_1.HSV,
	        Invert: Invert_1.Invert,
	        Kaleidoscope: Kaleidoscope_1.Kaleidoscope,
	        Mask: Mask_1.Mask,
	        Noise: Noise_1.Noise,
	        Pixelate: Pixelate_1.Pixelate,
	        Posterize: Posterize_1.Posterize,
	        RGB: RGB_1.RGB,
	        RGBA: RGBA_1.RGBA,
	        Sepia: Sepia_1.Sepia,
	        Solarize: Solarize_1.Solarize,
	        Threshold: Threshold_1.Threshold,
	    },
	});
	return _FullInternals;
}

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib.exports;
	hasRequiredLib = 1;
	(function (module, exports) {
		var Konva = require_FullInternals().Konva;
		Konva._injectGlobal(Konva);
		exports['default'] = Konva;
		module.exports = exports['default']; 
	} (lib, lib.exports));
	return lib.exports;
}

var libExports = requireLib();
var Konva$1 = /*@__PURE__*/getDefaultExportFromCjs(libExports);

class KonvaObjectContainerPusher {
    /**
     * @param {object[]} objects an array of json objects containing Konva object data in json form
     * @param {Konva.Node} container reference to the layer or group to manipulate
     * @returns {Konva.Node} reference to the layer or group that has been manipulated
     */
    execute(objects, container) {
        objects.forEach((object) => {
            Konva.Node.create(JSON.stringify(object)).moveTo(container);
        });
        return container;
    }
    ;
}

class SequenceLayerBuilder {
    /**
     * @param {SequenceBuilder} sequenceBuilder
     * @param {KonvaObjectContainerPusher} konvaObjectContainerPusher
     * @param {object} sequences_json A json object containing data to build Konva sequences from
     * @param {Konva.Layer} sequenceLayer reference to the sequence layer
     */
    constructor(sequenceBuilder, konvaObjectContainerPusher, sequences_json, sequenceLayer) {
        this.sequenceBuilder = sequenceBuilder;
        this.konvaObjectContainerPusher = konvaObjectContainerPusher;
        this.sequencesJson = sequences_json;
        this.sequenceLayer = sequenceLayer;
    }
    /**
     * @returns {Konva.Layer} reference to the layer built
     */
    build() {
        const builtSequences = this.buildSequences();
        return this.konvaObjectContainerPusher.execute(builtSequences, this.sequenceLayer);
    }
    buildSequences() {
        const builtSequences = [];
        for (const key in this.sequencesJson) {
            builtSequences.push(this.sequenceBuilder.build(this.sequencesJson[key].slides, key));
        }
        return builtSequences;
    }
}

/** */
class Interactions {
    constructor(json) {
        this.json = json;
    }
    getCommands(entityId, action) {
        try {
            return this.json[entityId][action];
        }
        catch (e) {
            return null;
        }
    }
}

class Music {
    musicJson;
    audioFactory;
    current_audio;
    current_audio_source;
    current_audio_fade_out;
    constructor(musicJson, audioFactory, uiEventEmitter) {
        this.musicJson = musicJson;
        this.audioFactory = audioFactory;
        this.current_audio = null;
        this.current_audio_source = null;
        this.current_audio_fade_out = false;
        uiEventEmitter.on('play_sequence_started', (sequenceId) => {
            this.playMusicById(sequenceId);
        });
        // Assumes room music is in musicJson with the roomId
        uiEventEmitter.on('arrived_in_room', (roomId) => {
            this.playMusicById(roomId);
        });
    }
    /**
     * Get music by id from music.json data and play it. Backwards compatibility method.
     * @param {string} id Object id; looks for music for this room/sequence/other from music.json data
     */
    playMusicById(id) {
        if (id == undefined) {
            return;
        }
        var data = this.musicJson[id];
        this.playMusic(data);
    }
    /**
     * Play music based on data object with file name, fade and loop properties.
     *
     * Stops previous music if no music is found for this id. Note that moving to a room and
     * playing a sequence always call this; if you want the music to continue, it needs to be
     * the same as in previous room/sequence.
     */
    playMusic(data) {
        // If no new music is to be played, stop the old music.
        if (!data || !data.music) {
            this.stopMusic(this.current_audio, this.current_audio_fade_out);
            return;
        }
        // If not already playing music or old/new songs are different
        if (!this.current_audio || this.current_audio_source != data.music) {
            this.stopMusic(this.current_audio, this.current_audio_fade_out);
            this.current_audio = this.audioFactory.create(data.music);
            // Fade music in if it's new and fade_in is set
            if (data.fade_in === true) {
                this.current_audio.volume = 0;
                const fade_interval = setInterval(() => {
                    if (!this.current_audio) {
                        return;
                    }
                    // Audio API will throw exception when volume is maxed
                    try {
                        this.current_audio.volume += 0.05;
                    }
                    catch (e) {
                        this.current_audio.volume = 1;
                        clearInterval(fade_interval);
                    }
                    // Some additional safety
                    if (this.current_audio.volume >= 1) {
                        this.current_audio.volume = 1;
                        clearInterval(fade_interval);
                    }
                }, 200);
            }
            else {
                this.current_audio.volume = 1;
            }
            this.current_audio.play();
            this.current_audio_source = data.music;
        }
        // Loop and fade settings may change when playing the same music in different rooms
        this.current_audio.loop = data.loop === true ? true : false;
        this.current_audio_fade_out = data.fade_out === true ? true : false;
    }
    stopMusic(audio, fade_out) {
        if (!audio) {
            return;
        }
        // Fade music out if fade is set to true
        if (fade_out === true) {
            const fade_interval = setInterval((audio) => {
                // Audio API will throw exception when volume is maxed
                // or an crossfade interval may still be running
                try {
                    audio.volume -= 0.05;
                }
                catch (e) {
                    clearInterval(fade_interval);
                    audio.pause();
                }
                // Some additional safety
                if (audio.volume <= 0) {
                    clearInterval(fade_interval);
                    audio.pause();
                }
            }, 100, audio);
        }
        else {
            audio.pause();
        }
        audio = null;
    }
}

class AudioFactory {
    create(filename) {
        return new Audio(filename);
    }
}

const { Tween } = Konva$1;
class RoomAnimationBuilder {
    /**
     * @param {*} object Konva Image object which has some extra data to create a Tween from
     * @returns {Tween}
     */
    createRoomAnimation(object) {
        const attrs = object.getAttr("animation");
        const animation = new Tween({
            node: object,
            x: attrs.x ? object.x() + attrs.x : object.x(),
            y: attrs.y ? object.y() + attrs.y : object.y(),
            easing: Konva$1.Easings.EaseInOut,
            duration: attrs.duration,
            onFinish: () => {
                animation.reverse();
                setTimeout(() => {
                    animation.play();
                }, attrs.duration * 1000);
            }
        });
        return animation;
    }
}

class StageObjectGetter {
    stage;
    constructor(stage) {
        this.stage = stage;
    }
    /**
     * Get an object from stage by it's id. Gives an error message in console with
     * the looked up name if it is not found. Basically, a wrapper for
     * stage.find(id) with error messaging, helpful with typos in jsons,
     * and also gives some warnings if an object required by the kiigame.js script
     * itself is missing.
     *
     * @param {string} id name of the object to look up
     * @returns {Konva.Node} @see Konva.Container::find
     */
    getObject(id) {
        const object = this.stage.find('#' + id)[0];
        if (object == null) {
            console.warn("Could not find object from stage with id " + id);
        }
        return object;
    }
}

class RoomAnimationsBuilder {
    /**
     * @param {RoomAnimationBuilder} roomAnimationBuilder
     * @param {StageObjectGetter} stageObjectGetter
     */
    constructor(roomAnimationBuilder, stageObjectGetter) {
        this.roomAnimationBuilder = roomAnimationBuilder;
        this.stageObjectGetter = stageObjectGetter;
    }
    /**
     * @param {Konva.Group[]} rooms
     * @returns {Konva.Tween[]}
     */
    build(rooms) {
        const animatedObjects = [];
        rooms.forEach((room) => {
            const newAnimations = this.prepareRoomAnimations(room);
            newAnimations.forEach((animation) => {
                animatedObjects.push(animation);
            });
        });
        return animatedObjects;
    }
    /**
     * Prepare the animations for a room
     * @param {Konva.Group} room
     * @returns {Konva.Tween[]} An array of room animations
     */
    prepareRoomAnimations(room) {
        const roomAnimations = [];
        for (const object of room.children) {
            if (object.className == 'Image' && object.attrs.animated) {
                const animation = this.roomAnimationBuilder.createRoomAnimation(this.stageObjectGetter.getObject(object.attrs.id));
                roomAnimations.push(animation);
            }
        }
        return roomAnimations;
    }
}

class RoomAnimations {
    /**
     * @param {EventEmitter} gameEventEmitter
     * @param {EventEmitter} uiEventEmitter
     * @param {Konva.Tween[]} animatedObjects
     */
    constructor(gameEventEmitter, uiEventEmitter, animatedObjects) {
        this.animatedObjects = animatedObjects;
        this.runningAnimations = new Set();
        gameEventEmitter.on('removed_objects', ({ objectList: _objectList, objectsRemoved }) => {
            this.removeAnimations(objectsRemoved);
        });
        uiEventEmitter.on('arrived_in_room', (roomId) => {
            this.playRoomAnimations(roomId);
        });
    }
    /**
     * @param {string} roomId
     */
    playRoomAnimations(roomId) {
        this.runningAnimations.forEach(anim => anim.stop());
        this.runningAnimations.clear();
        this.animatedObjects.forEach(animatedObject => {
            if (animatedObject.node.getParent().id() === roomId) {
                animatedObject.play();
                this.runningAnimations.add(animatedObject.anim);
            }
        });
    }
    /**
     * Removes objects from the list of animated objects
     * @param {string[]} ids The ids of the object to be de-animated
     */
    removeAnimations(ids) {
        this.animatedObjects = this.animatedObjects.filter((animatedObject) => {
            return !ids.includes(animatedObject.node.id());
        });
    }
}

class RoomFaderBuilder {
    /**
     * @returns {object} JSON object with the konva data for the room fader Group
     */
    buildRoomFader() {
        return {
            "attrs": {
                "id": "fader_room",
                "opacity": 0,
                "visible": false
            },
            "children": [
                {
                    "attrs": {
                        "id": "black_screen_room",
                        "src": "data/images/black.png",
                    },
                    "className": "Image"
                }
            ],
            "className": "Group"
        };
    }
}

class RoomFader {
    constructor(faderNode, uiEventEmitter) {
        this.faderNode = faderNode;
        // Should we have a Tween factory?
        this.animation = new Konva.Tween({
            node: this.faderNode,
            duration: 0.7,
            opacity: 1
        });
        this.uiEventEmitter = uiEventEmitter;
        this.uiEventEmitter.on('leaving_room', () => {
            this.roomFadeOut();
        });
        this.uiEventEmitter.on('arriving_in_room', () => {
            this.roomFadeIn();
        });
    }
    roomFadeOut() {
        this.faderNode.show();
        this.animation.play();
        setTimeout(() => {
            this.uiEventEmitter.emit('room_fade_out_done');
        }, this.animation.tween.duration);
    }
    roomFadeIn() {
        this.animation.reverse();
        setTimeout(() => {
            this.faderNode.hide();
            this.uiEventEmitter.emit('room_fade_in_done');
        }, this.animation.tween.duration);
    }
}

class CharacterFramesBuilder {
    constructor(position) {
        this.position = position;
    }
    build(characterFramesJson) {
        const builtFrames = [];
        for (const frameData of characterFramesJson) {
            builtFrames.push(this.buildFrame(frameData));
        }
        return builtFrames;
    }
    buildFrame(frameData) {
        const frame = {
            attrs: {
                "id": frameData.id,
                "src": frameData.src,
                "visible": false,
                "x": this.position.x,
                "y": this.position.y,
            },
            className: "Image"
        };
        return frame;
    }
}

class CharacterAnimationsBuilder {
    /**
     * @param {StageObjectGetter} stageObjectGetter
     */
    constructor(stageObjectGetter) {
        this.stageObjectGetter = stageObjectGetter;
    }
    /**
     * @param {object} characterAnimationData JSON object with animation data
     * @returns {object} JSON object with key, Konva.Tween pairs
     */
    build(characterAnimationData) {
        const characterAnimations = {};
        Object.entries(characterAnimationData).forEach(([id, animationDatum]) => {
            const frames = [];
            // Build Konva.Tween objects
            for (const frameDatum of animationDatum.frames) {
                // TODO: Refactor into a factory?
                const frame = new Konva.Tween({
                    node: this.stageObjectGetter.getObject(frameDatum.node),
                    duration: frameDatum.duration
                });
                frames.push(frame);
            }
            // Set up onFinish functions for each frame to show the next frame
            frames.forEach((frame) => {
                // Last frame loops back to the first frame
                const nextFrame = frames.length > frames.indexOf(frame) + 1
                    ? frames[frames.indexOf(frame) + 1]
                    : frames[0];
                frame.nextFrame = nextFrame;
                frame.onFinish = function () {
                    this.node.hide();
                    this.nextFrame.node.show();
                    this.reset();
                    this.nextFrame.play();
                };
            });
            characterAnimations[id] = frames;
        });
        return characterAnimations;
    }
}

class CharacterAnimations {
    /**
     * @param {object} animations a list of character animations (Konva.Tween objects) by name
     * @param {object} postureMapping a mapping of character postures to animation names
     * @param {object} monologuePostureMapping a mapping of character postures to animation names for monologues
     * @param {object} npcMonologuePostureMapping a mapping of character postures to animation names for NPC monologues
     * @param {EventEmitter} uiEventEmitter
     * @param {EventEmitter} gameEventEmitter
     */
    constructor(animations, postureMapping, monologuePostureMapping, npcMonologuePostureMapping, uiEventEmitter, gameEventEmitter) {
        // List of character animations.
        this.animations = animations;
        // Posture mapping for character animations
        this.postureMapping = postureMapping;
        this.monologuePostureMapping = monologuePostureMapping;
        this.npcMonologuePostureMapping = npcMonologuePostureMapping;
        // Timeout event for showing character animation for certain duration
        this.timeout;
        // Default character animations
        this.speakAnimationName = "speak";
        this.idleAnimationName = "idle";
        this.uiEventEmitter = uiEventEmitter;
        gameEventEmitter = gameEventEmitter;
        gameEventEmitter.on('monologue', ({ text: _text, posture }) => {
            const defaultAnimationLength = 3000; // hardcoded default
            if (!posture) {
                this.playCharacterAnimation(this.speakAnimationName, defaultAnimationLength);
                return;
            }
            const animationName = this.monologuePostureMapping[posture] || this.speakAnimationName;
            this.playCharacterAnimation(animationName, defaultAnimationLength);
        });
        gameEventEmitter.on('npc_monologue', ({ _npc, _text, characterPosture }) => {
            if (!characterPosture) {
                return;
            }
            const defaultAnimationLength = 3000; // hardcoded default
            const animationName = this.npcMonologuePostureMapping[characterPosture] || this.idleAnimationName;
            this.playCharacterAnimation(animationName, defaultAnimationLength);
        });
        this.uiEventEmitter.on('clicked_on_stage', () => {
            this.resetCharacterAnimations();
        });
        this.uiEventEmitter.on('inventory_item_drag_start', ({ draggedItem: _draggedItem }) => {
            this.resetCharacterAnimations();
        });
        gameEventEmitter.on('character_posture_changed', (posture) => {
            const idleAnimationName = this.postureMapping[posture].idle || this.idleAnimationName;
            this.setIdleAnimation(idleAnimationName);
            const speakAnimationName = this.postureMapping[posture].speak || this.speakAnimationName;
            this.setSpeakAnimation(speakAnimationName);
        });
    }
    /**
     * A little helper function for semantic clarity. Reset character animation to the idle animation.
     */
    resetCharacterAnimations() {
        this.startCharacterAnimation(this.idleAnimationName);
    }
    /**
     * A helper function to reset a single animation frame; for ease of unit testing.
     * @param {Konva.Tween} frame
     */
    resetAnimationFrame(frame) {
        frame.node.hide();
        frame.reset();
    }
    /**
     * A helper function to play the first frame of an animation; for ease of unit testing.
     * @param {Konva.Tween} frame
     */
    playAnimationFrame(frame) {
        frame.node.show();
        frame.play();
    }
    /**
     * Start a character animation by name.
     * @param {string} animationName
     */
    startCharacterAnimation(animationName) {
        // Hide and reset all character animations
        Object.values(this.animations).forEach((frames) => {
            frames.forEach((frame) => {
                this.resetAnimationFrame(frame);
            });
        });
        const animation = this.animations[animationName];
        this.playAnimationFrame(animation[0]);
        this.uiEventEmitter.emit('character_animation_started');
    }
    /**
     * Play a character animation once and reset to idle.
     * @param {string} animationName The name of the animation to play.
     * @param {int} duration The time in ms until the character returns to idle animation.
     */
    playCharacterAnimation(animationName, duration) {
        this.startCharacterAnimation(animationName);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.startCharacterAnimation(this.idleAnimationName);
        }, duration);
    }
    /**
     * Change the idle animation, so that character graphics can be changed mid-game.
     * @param {string} animationName
     */
    setIdleAnimation(animationName) {
        this.idleAnimationName = animationName;
        this.startCharacterAnimation(this.idleAnimationName);
    }
    /**
     * Change the speak animation, so that character graphics can be changed mid-game.
     * @param {string} animationName
     */
    setSpeakAnimation(animationName) {
        this.speakAnimationName = animationName;
        this.startCharacterAnimation(this.idleAnimationName);
    }
}

class InventoryItemsView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {EventEmitter} gameEventEmitter
     * @param {Konva.Group} inventoryItems
     * @param {int} offsetFromTop
     */
    constructor(uiEventEmitter, gameEventEmitter, inventoryItems, offsetFromTop) {
        this.uiEventEmitter = uiEventEmitter;
        this.gameEventEmitter = gameEventEmitter;
        this.inventoryItems = inventoryItems;
        // Offset from top for drawing inventory items starting from proper position
        this.offsetFromTop = offsetFromTop;
        // Offset from left for drawing inventory items starting from proper position
        this.offsetFromLeft = 50;
        // Handle drags and clicks on inventory items
        this.inventoryItems.getChildren().each((child) => {
            child.on('click tap', (event) => {
                this.uiEventEmitter.emit('inventory_click', event.target);
            });
            child.on('dragstart', (event) => {
                this.uiEventEmitter.emit('inventory_item_drag_start', { draggedItem: event.target });
            });
        });
        this.uiEventEmitter.on('inventory_item_drag_end_wrapped_up', ({ draggedItem }) => {
            this.moveDraggedItemBackToInventory(draggedItem);
        });
    }
    resetItems() {
        this.inventoryItems.getChildren().each((shape) => {
            shape.setAttr('visible', false);
        });
    }
    handleInventoryItemVisibility(visibleInventoryItems) {
        visibleInventoryItems.forEach((visibleItemName, index) => {
            let shape = this.inventoryItems.findOne((item) => {
                return item.attrs.id === visibleItemName;
            });
            if (shape) {
                shape.x(this.offsetFromLeft + (index * 100));
                shape.y(this.offsetFromTop);
                shape.setAttr('visible', true);
            }
        });
    }
    show() {
        this.inventoryItems.show();
    }
    hide() {
        this.inventoryItems.hide();
    }
    draw() {
        this.inventoryItems.draw();
    }
    clearInventoryItemBlur() {
        this.inventoryItems.getChildren().each((shape) => {
            shape.shadowBlur(0);
        });
    }
    glowInventoryItem(target) {
        // check that target is in inventory
        if (!this.inventoryItems.findOne((item) => item === target)) {
            return;
        }
        target.clearCache();
        target.shadowColor('purple');
        target.shadowOffset({ x: 0, y: 0 });
        target.shadowBlur(20);
    }
    getVisibleInventoryItems() {
        return this.inventoryItems.find((item) => item.attrs.visible === true);
    }
    moveDraggedItemBackToInventory(draggedItem) {
        if (!draggedItem) {
            return;
        }
        draggedItem.moveTo(this.inventoryItems);
    }
}

class InventoryArrowsView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {Konva.Group} inventoryArrows
     */
    constructor(uiEventEmitter, inventoryArrows) {
        this.uiEventEmitter = uiEventEmitter;
        this.inventoryArrows = inventoryArrows;
        this.leftArrow = this.inventoryArrows.find('#inventory_left_arrow')[0];
        this.rightArrow = this.inventoryArrows.find('#inventory_right_arrow')[0];
        // Handle arrow clicks and hovers
        this.leftArrow.on('click tap', () => {
            this.uiEventEmitter.emit('inventory_left_arrow_engaged');
        });
        this.rightArrow.on('click tap', () => {
            this.uiEventEmitter.emit('inventory_right_arrow_engaged');
        });
        this.uiEventEmitter.on('inventory_left_arrow_draghovered', () => {
            this.uiEventEmitter.emit('inventory_left_arrow_engaged');
        });
        this.uiEventEmitter.on('inventory_right_arrow_draghovered', () => {
            this.uiEventEmitter.emit('inventory_right_arrow_engaged');
        });
    }
    /**
     * @param {boolean} isInventoryLeftArrowVisible
     * @param {boolean} isInventoryRightArrowVisible
     */
    toggleArrowVisibility(isInventoryLeftArrowVisible, isInventoryRightArrowVisible) {
        if (isInventoryLeftArrowVisible) {
            this.leftArrow.show();
        }
        else {
            this.leftArrow.hide();
        }
        if (isInventoryRightArrowVisible) {
            this.rightArrow.show();
        }
        else {
            this.rightArrow.hide();
        }
    }
    show() {
        this.inventoryArrows.show();
    }
    hide() {
        this.inventoryArrows.hide();
    }
    draw() {
        this.inventoryArrows.draw();
    }
}

class InventoryView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {StageObjectGetter} stageObjectGetter
     * @param {Konva.Layer} inventoryBarLayer
     * @param {InventoryItemsView} inventoryItemsView
     * @param {InventoryArrowsView} inventoryArrowsView
     */
    constructor(uiEventEmitter, stageObjectGetter, inventoryBarLayer, inventoryItemsView, inventoryArrowsView) {
        this.uiEventEmitter = uiEventEmitter;
        this.stageObjectGetter = stageObjectGetter;
        this.inventoryBarLayer = inventoryBarLayer;
        this.inventoryItemsView = inventoryItemsView;
        this.inventoryArrowsView = inventoryArrowsView;
        this.uiEventEmitter.on('inventory_view_model_updated', ({ visibleInventoryItems, isLeftArrowVisible, isRightArrowVisible }) => {
            this.redrawInventory(visibleInventoryItems, isLeftArrowVisible, isRightArrowVisible);
        });
        this.uiEventEmitter.on('arrived_in_room', (roomId) => {
            this.handleArrivedInRoom(roomId);
        });
        this.uiEventEmitter.on('first_sequence_slide_shown', () => {
            this.hideInventory();
        });
        this.uiEventEmitter.on('item_moved_to_room_layer', () => {
            this.drawInventoryLayer();
        });
        this.uiEventEmitter.on('dragmove_hover_on_object', ({ target, draggedItem: _draggedItem, targetName: _targetName }) => {
            this.handleDragMoveHoverOnObject(target);
        });
        this.uiEventEmitter.on('dragmove_hover_on_nothing', () => {
            this.handleDragMoveHoverOnNothing();
        });
    }
    /**
     * Show given items and inventory arrows.
     *
     * @param {string[]} visibleInventoryItems in order from left to right
     * @param {boolean} isInventoryLeftArrowVisible
     * @param {boolean} isInventoryRightArrowVisible
     */
    redrawInventory(visibleInventoryItems, isInventoryLeftArrowVisible, isInventoryRightArrowVisible) {
        this.inventoryItemsView.resetItems();
        this.inventoryItemsView.handleInventoryItemVisibility(visibleInventoryItems);
        this.inventoryArrowsView.toggleArrowVisibility(isInventoryLeftArrowVisible, isInventoryRightArrowVisible);
        this.inventoryItemsView.clearInventoryItemBlur();
        this.drawInventoryLayer();
        this.uiEventEmitter.emit('inventory_redrawn');
    }
    showInventory() {
        this.inventoryBarLayer.show();
        this.inventoryItemsView.show();
        this.inventoryArrowsView.show();
        this.drawInventoryLayer();
    }
    hideInventory() {
        this.inventoryItemsView.hide();
        this.inventoryArrowsView.hide();
        this.inventoryBarLayer.hide();
    }
    drawInventoryLayer() {
        this.inventoryItemsView.draw();
        this.inventoryArrowsView.draw();
        this.inventoryBarLayer.draw();
    }
    handleArrivedInRoom(roomId) {
        // Slightly kludgy way of checking if we want to show inventory
        if (this.stageObjectGetter.getObject(roomId).attrs.fullScreen) {
            return;
        }
        this.showInventory();
    }
    handleDragMoveHoverOnObject(target) {
        this.inventoryItemsView.clearInventoryItemBlur();
        this.inventoryItemsView.glowInventoryItem(target);
        this.drawInventoryLayer();
    }
    handleDragMoveHoverOnNothing() {
        this.inventoryItemsView.clearInventoryItemBlur();
        this.drawInventoryLayer();
    }
}

class RoomView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {EventEmitter} gameEventEmitter
     * @param {HitRegionInitializer} hitRegionInitializer
     * @param {Konva.Layer} roomLayer
     * @param {string[]} roomObjectCategories
     */
    constructor(uiEventEmitter, gameEventEmitter, hitRegionInitializer, roomLayer, roomObjectCategories = ['furniture']) {
        this.uiEventEmitter = uiEventEmitter;
        this.gameEventEmitter = gameEventEmitter;
        this.hitRegionInitializer = hitRegionInitializer;
        // The Konva room layer
        this.roomLayer = roomLayer;
        this.roomObjectCategories = roomObjectCategories;
        // The current room view
        this.currentRoom = null;
        // On window load we create image hit regions for furniture in rooms
        window.onload = () => {
            this.hitRegionInitializer.initHitRegions(this.roomLayer);
            this.uiEventEmitter.emit('room_hit_regions_initialized');
        };
        this.uiEventEmitter.on('inventory_item_drag_start', ({ draggedItem }) => {
            this.moveItemToRoomLayer(draggedItem);
        });
        this.uiEventEmitter.on('dragmove_hover_on_object', ({ target, draggedItem: _draggedItem, targetName: _targetName }) => {
            this.clearRoomObjectBlur();
            this.glowRoomObject(target);
            this.drawRoomLayer();
        });
        this.uiEventEmitter.on('dragmove_hover_on_nothing', () => {
            this.clearRoomObjectBlur();
            this.drawRoomLayer();
        });
        this.uiEventEmitter.on('inventory_item_drag_end_wrapped_up', (_draggedItem) => {
            this.clearRoomObjectBlur();
        });
        this.uiEventEmitter.on('room_fade_in_done', () => {
            this.drawRoomLayer();
        });
        this.uiEventEmitter.on('inventory_redrawn', () => {
            this.drawRoomLayer();
        });
        this.uiEventEmitter.on('left_room', (from) => {
            this.hidePreviousRoom(from);
        });
        this.uiEventEmitter.on('arrived_in_room', (roomId) => {
            this.showRoom(roomId);
        });
        this.uiEventEmitter.on('npc_monologue_set', () => {
            this.drawRoomLayer();
        });
        this.uiEventEmitter.on('npc_monologue_cleared', () => {
            this.drawRoomLayer();
        });
        this.gameEventEmitter.on('removed_objects', ({ objectList: _objectList, objectsRemoved }) => {
            this.removeObject(objectsRemoved);
        });
        this.gameEventEmitter.on('added_objects', ({ objectList: _objectList, objectsAdded }) => {
            this.addObject(objectsAdded);
        });
    }
    /**
     * @param {Konva.Node} node
     * @param {string[]} categories
     * @returns {boolean}
     */
    matchNodeByCategories(node, categories) {
        return categories.includes(node.attrs.category);
    }
    matchNodeById(node, id) {
        return node.attrs.id === id;
    }
    /**
     * @returns {Konva.Group[]} rooms as Konva objects
     */
    getRooms() {
        return this.roomLayer.getChildren((child) => this.matchNodeByCategories(child, ['room']));
    }
    /**
     * Return room by room id.
     *
     * @param {string} roomId
     * @returns  {Konva.Group} room as Konva object
     */
    getRoom(roomId) {
        const result = this.roomLayer.findOne((child) => this.matchNodeByCategories(child, ['room']) && this.matchNodeById(child, roomId));
        return result;
    }
    /**
     * @param {Konva.Group} room
     * @param {string} id
     * @returns {Konva.Shape} furniture
     */
    getObjectFromRoom(room, id) {
        return room.findOne((child) => this.matchNodeByCategories(child, this.roomObjectCategories) && this.matchNodeById(child, id));
    }
    /**
     * @param {Konva.Group} room
     * @returns {Konva.Shape[]} all furniture in the room
     */
    getObjectsFromRoom(room) {
        return room.find((child) => this.matchNodeByCategories(child, this.roomObjectCategories));
    }
    /**
     * @returns {Konva.Shape[]} all furniture in the current room
     */
    getObjectsFromCurrentRoom() {
        return this.getObjectsFromRoom(this.currentRoom);
    }
    /**
     * @param {Konva.Group} room
     * @returns {Konva.Shape[]} visible objects in the room
     */
    getVisibleObjectsFromRoom(room) {
        return room.find((child) => this.matchNodeByCategories(child, this.roomObjectCategories) && child.isVisible());
    }
    /**
     * @returns {Konva.Shape[]} visible objects in the current room
     */
    getVisibleObjectsFromCurrentRoom() {
        return this.getVisibleObjectsFromRoom(this.currentRoom);
    }
    /**
     * @param {name} objectId
     * @returns {Konva.Image} furniture
     */
    getObject(objectId) {
        const objectFromCurrentRoom = this.getObjectFromRoom(this.currentRoom);
        if (objectFromCurrentRoom) {
            return objectFromCurrentRoom;
        }
        const object = this.roomLayer.findOne((child) => this.matchNodeByCategories(child, this.roomObjectCategories) && this.matchNodeById(child, objectId));
        return object;
    }
    /**
     * Move item to room layer, for example on drag start, so that it can be "hidden" from inventory.
     * @param {Konva.Image} item
     */
    moveItemToRoomLayer(item) {
        item.moveTo(this.roomLayer);
        this.uiEventEmitter.emit('item_moved_to_room_layer');
    }
    /**
     * Not sure if we can commit to hiding _previous_ room, or should this just be "hideRoom"
     * @param {string} from room id of the room we have faded out
     */
    hidePreviousRoom(from) {
        const room = this.getRoom(from);
        room.hide();
    }
    /**
     * @param {string} roomId room to make visible
     */
    showRoom(roomId) {
        const room = this.getRoom(roomId);
        room.show();
        this.currentRoom = room;
        this.drawRoomLayer();
        this.uiEventEmitter.emit('current_room_changed', room);
    }
    drawRoomLayer() {
        this.roomLayer.draw();
    }
    /**
     * Add an object to the stage. Currently, this means setting its visibility to true.
     * TODO: Add animations & related parts.
     * @param {string[]} objectNames
     */
    addObject(objectNames) {
        objectNames.forEach((objectName) => {
            const object = this.getObject(objectName);
            object.clearCache();
            object.show();
            object.cache();
        });
        this.drawRoomLayer();
    }
    /**
     * Remove an object from stage. Called after interactions that remove objects.
     * The removed object is simply hidden.
     *
     * @param {string[]} objectNames
     */
    removeObject(objectNames) {
        objectNames.forEach((objectName) => {
            const object = this.getObject(objectName);
            object.hide();
        });
        this.drawRoomLayer();
    }
    clearRoomObjectBlur() {
        this.getObjectsFromCurrentRoom().each((shape, _i) => {
            shape.shadowBlur(0);
        });
    }
    /**
     * @param {*} target
     * @returns {void}
     */
    glowRoomObject(target) {
        if (!this.getObjectsFromCurrentRoom((object) => { return object === target; })) {
            return;
        }
        target.clearCache();
        target.shadowColor('purple');
        target.shadowOffset({ x: 0, y: 0 });
        target.shadowBlur(20);
    }
}

class CharacterView {
    /**
     * @param {Konva.Layer} characterLayer
     * @param {EventEmitter} uiEventEmitter
     */
    constructor(characterLayer, uiEventEmitter) {
        this.characterLayer = characterLayer;
        uiEventEmitter.on('character_animation_started', () => {
            this.drawCharacterLayer();
        });
        uiEventEmitter.on('first_sequence_slide_shown', () => {
            this.hideCharacter();
        });
        uiEventEmitter.on('current_room_changed', (room) => {
            // Slightly kludgy way of checking if we want to show character
            if (room.attrs.fullScreen) {
                return;
            }
            this.showCharacter();
        });
        uiEventEmitter.on('character_monologue_cleared', () => {
            this.drawCharacterLayer();
        });
        uiEventEmitter.on('character_monologue_set', () => {
            this.drawCharacterLayer();
        });
    }
    showCharacter() {
        this.characterLayer.show();
        this.drawCharacterLayer();
    }
    hideCharacter() {
        this.characterLayer.hide();
    }
    drawCharacterLayer() {
        this.characterLayer.draw();
    }
}

class InventoryViewModel {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {EventEmitter} gameEventEmitter
     * @param {int} inventoryMax How many items the inventory can show at a time
     */
    constructor(uiEventEmitter, gameEventEmitter, inventoryMax) {
        this.uiEventEmitter = uiEventEmitter;
        this.gameEventEmitter = gameEventEmitter;
        this.inventoryMax = inventoryMax;
        // List of items in the inventory. inventoryList.length gives the item amount.
        this.inventoryList = []; // string[], just the names
        // The item number where the shown items start from (how many items from the beginning are not shown)
        this.inventoryIndex = 0;
        this.gameEventEmitter.on('inventory_items_added', ({ itemList, itemNamesAdded }) => {
            this.handleInventoryItemsAdded(itemList, itemNamesAdded);
        });
        this.gameEventEmitter.on('inventory_items_removed', ({ itemList }) => {
            this.handleInventoryItemsRemoved(itemList);
        });
        this.uiEventEmitter.on('inventory_left_arrow_engaged', () => {
            this.handleInventoryLeftArrowEngaged();
        });
        this.uiEventEmitter.on('inventory_right_arrow_engaged', () => {
            this.handleInventoryRightArrowEngaged();
        });
        this.uiEventEmitter.on('inventory_item_drag_end_wrapped_up', ({ draggedItem }) => {
            this.handleDragEnd(draggedItem);
        });
    }
    scrollInventoryToItem(itemName) {
        if (this.inventoryList.indexOf(itemName) > this.inventoryIndex + this.inventoryMax - 1) {
            this.inventoryIndex = Math.max(this.inventoryList.indexOf(itemName) + 1 - this.inventoryMax, 0);
        }
    }
    /**
     * @param {object[]} modelItemList Object { name, category }
     * @returns {string[]} the viewModelItemList
     */
    modelItemListToViewModelItemList(modelItemList) {
        const viewModelItemList = [];
        modelItemList.forEach((modelItem) => {
            viewModelItemList.push(modelItem.name);
        });
        return viewModelItemList;
    }
    /**
     * Handle item having been added to the inventory. Updates which items should be visible in UI.
     *
     * @param {string[]} itemList Current inventory model status (list of items in inventory, Object { name, category })
     * @param {string[]} itemNamesAdded The names of the items added to the inventory.
     */
    handleInventoryItemsAdded(itemList, itemNamesAdded) {
        this.inventoryList = this.modelItemListToViewModelItemList(itemList);
        // The last picked up item should be visible in the inventory. Scroll inventory to the right if necessary.
        this.scrollInventoryToItem(itemNamesAdded.at(-1));
        this.calculateVisibleItems();
    }
    /**
     * Handles item having been removed from the inventory. Updates which items should be visible in the UI.
     *
     * @param {string[]} itemList
     */
    handleInventoryItemsRemoved(itemList) {
        this.inventoryList = this.modelItemListToViewModelItemList(itemList);
        // If there's empty room on the right, move index to the left
        if (this.inventoryIndex + this.inventoryMax > this.inventoryList.length) {
            this.inventoryIndex = Math.max(this.inventoryList.length - this.inventoryMax, 0);
        }
        this.calculateVisibleItems();
    }
    handleInventoryLeftArrowEngaged() {
        this.inventoryIndex--;
        this.calculateVisibleItems();
    }
    handleInventoryRightArrowEngaged() {
        this.inventoryIndex++;
        this.calculateVisibleItems();
    }
    ;
    handleDragEnd(draggedItem) {
        if (draggedItem) {
            this.scrollInventoryToItem(draggedItem.attrs.id);
        }
        this.calculateVisibleItems();
    }
    calculateVisibleItems() {
        const visibleInventoryItems = [];
        for (let i = this.inventoryIndex; i < this.inventoryIndex + this.inventoryMax && i < (this.inventoryList.length); i++) {
            visibleInventoryItems.push(this.inventoryList[i]);
        }
        this.uiEventEmitter.emit('inventory_view_model_updated', {
            visibleInventoryItems,
            isLeftArrowVisible: this.isLeftAwrrowVisible(),
            isRightArrowVisible: this.isRightArrowVisible()
        });
    }
    isLeftAwrrowVisible() {
        return this.inventoryIndex > 0;
    }
    isRightArrowVisible() {
        return this.inventoryIndex + this.inventoryMax < this.inventoryList.length;
    }
}

class StageInitializer {
    /**
     * Bootstraps Konva stage so that the rest of the stage contents can be built.
     *
     * @param {object} layersJson json data to define Konva layers from
     * @returns {Konva.Stage}
     */
    initialize(layersJson) {
        return Konva.Node.create(JSON.stringify(layersJson), 'container');
    }
}

/**
 * "Abstract" class that builds an array of one type of room children as Konva objects, and pushes them to the
 * "children" array of the room Group.
 *
 * You should be able to implement a new RoomChildrenBuilder for a new type of a room child, add it to the list
 * of RoomChildrenTypeBuilders for RoomBuilder and have the Konva view implementation for awesome new room features
 * up in no time at all.
 */
class RoomChildrenTypeBuilder {
    /**
     * @param {string} type name of the type of children - key in rooms.json
     * @param {*} roomChildrenBuilder implementation for a specific type of room children
     */
    constructor(type, roomChildrenBuilder) {
        this.type = type;
        this.roomChildrenBuilder = roomChildrenBuilder;
    }
    /**
     * Prepares room child data from rooms.json by key.
     * @param {string} key
     * @param {object} roomJson room from rooms.json
     * @returns json of child data
     */
    prepareChildData(key, roomJson) {
        if (!Object.keys(roomJson).includes(key)) {
            return undefined;
        }
        const json = JSON.parse(JSON.stringify(roomJson[key]));
        delete roomJson[key];
        if (!json || !Object.keys(json).length) {
            return undefined;
        }
        return json;
    }
    /**
     * Adds children to the Konva room data.
     * @param {object} roomJson room from rooms.json
     * @returns {object} the modified room json
     */
    addChildren(roomJson) {
        const json = this.prepareChildData(this.type, roomJson);
        if (json) {
            const objectArray = this.roomChildrenBuilder.buildRoomChildren(json);
            objectArray.forEach((object) => {
                if (Object.keys(object).length > 0) {
                    roomJson.children.push(object);
                }
            });
        }
        return roomJson;
    }
}

class RoomBuilder {
    /**
     * @param {RoomChildrenTypeBuilder[]} roomChildrenBuilders
     */
    constructor(roomChildrenBuilders) {
        this.roomChildrenBuilders = roomChildrenBuilders;
    }
    /**
     * @param {string} name the name of the room
     * @param {object} roomJson room data to prepare
     * @returns {object} room data prepared for Konva to add to the rooms layer
     */
    build(name, roomJson) {
        roomJson.attrs = {};
        roomJson.attrs.id = name;
        roomJson.attrs.category = "room";
        roomJson.attrs.visible = false;
        if (Object.keys(roomJson).includes('fullScreen')) {
            roomJson.attrs.fullScreen = roomJson.fullScreen;
            delete roomJson.fullScreen;
        }
        if (!roomJson.children) {
            roomJson.children = [];
        }
        this.roomChildrenBuilders.forEach((builder) => {
            roomJson = builder.addChildren(roomJson);
        });
        roomJson.className = "Group";
        return roomJson;
    }
}

class RoomsBuilder {
    /**
     * @param {RoomBuilder} roomBuilder
     */
    constructor(roomBuilder) {
        this.roomBuilder = roomBuilder;
    }
    /**
     * @param {object} roomsJson rooms data in json object
     * @returns {object[]} rooms data prepared for Konva to add to the rooms layer
     */
    build(roomsJson) {
        const konvaRoomData = [];
        for (const [name, room] of Object.entries(roomsJson)) {
            konvaRoomData.push(this.roomBuilder.build(name, room));
        }
        return konvaRoomData;
    }
}

class RoomLayerBuilder {
    /**
     * @param {RoomsBuilder} roomsBuilder
     * @param {KonvaObjectContainerPusher} konvaObjectContainerPusher
     * @param {RoomFaderBuilder} roomFaderBuilder
     * @param {ImagePreparer} imagePreparer
     * @param {object} rooms_json
     * @param {Konva.Layer} roomLayer
     */
    constructor(roomsBuilder, konvaObjectContainerPusher, roomFaderBuilder, imagePreparer, rooms_json, roomLayer) {
        this.roomsBuilder = roomsBuilder;
        this.konvaObjectContainerPusher = konvaObjectContainerPusher;
        this.roomFaderBuilder = roomFaderBuilder;
        this.imagePreparer = imagePreparer;
        this.roomsJson = rooms_json;
        this.roomLayer = roomLayer;
    }
    /**
     * @param {int} width stage width in pixels
     * @param {int} height stage height in pixels
     */
    build(width, height) {
        const konvaRoomsJson = this.roomsBuilder.build(this.roomsJson);
        this.konvaObjectContainerPusher.execute(konvaRoomsJson, this.roomLayer);
        this.konvaObjectContainerPusher.execute([this.roomFaderBuilder.buildRoomFader()], this.roomLayer);
        for (const child of this.roomLayer.toObject().children) {
            this.imagePreparer.prepareImages(child);
        }
        // Scale room fader UI
        this.roomLayer.find('#black_screen_room').size({ width, height: height - 100 });
        // Move npc speec bubble on top of rooms so it's visible
        this.roomLayer.find('#npc_speech_bubble').moveToTop();
    }
}

class FullFaderPreparer {
    /**
     * @param {Konva.Layer} fullScreenLayer
     * @param {ImagePreparer} imagePreparer
     */
    constructor(fullScreenLayer, imagePreparer) {
        this.fullScreenLayer = fullScreenLayer;
        this.imagePreparer = imagePreparer;
    }
    /**
     * @param {int} width
     * @param {int} height
     */
    prepare(width, height) {
        this.imagePreparer.prepareImages(this.fullScreenLayer);
        // Prepare the full screen fader
        const fadeShape = this.fullScreenLayer.find('#black_screen_full');
        // Scale
        fadeShape.size({ width, height });
        // Stop blocking clicks through the fader (.hide() in FullFadeView should do this, but seems inconsistent)
        fadeShape.listening(false);
        fadeShape.drawHit();
    }
}

class StageBuilder {
    /**
     * @param {Konva.Stage} stage
     * @param {FullFaderPreparer} fullFaderPerparer
     * @param {SequenceLayerBuilder} sequenceLayerBuilder
     * @param {RoomLayerBuilder} roomLayerBuilder
     * @param {ImagePreparer} imagePreparer
     */
    constructor(stage, fullFaderPerparer, sequenceLayerBuilder, roomLayerBuilder, imagePreparer) {
        this.stage = stage;
        this.fullFaderPreparer = fullFaderPerparer;
        this.sequenceLayerBuilder = sequenceLayerBuilder;
        this.roomLayerBuilder = roomLayerBuilder;
        this.imagePreparer = imagePreparer;
    }
    build() {
        this.fullFaderPreparer.prepare(this.stage.width(), this.stage.height());
        const sequenceLayer = this.sequenceLayerBuilder.build();
        for (const child of sequenceLayer.toObject().children) {
            this.imagePreparer.prepareImages(child);
        }
        this.roomLayerBuilder.build(this.stage.width(), this.stage.height());
    }
}

/**
 * Quacks like a "RoomChildrenBuilder" (for RoomChildrenTypeBuilder) - implements a buildRoomChildren method
 */
class BackgroundsBuilder {
    /**
     * Build Konva-ready json data from background data in rooms.json. The engine only supports one backgorund
     * image for a room, but from data we technically can build multiple.
     *
     * @param {object} backgroundsJson background json objects from rooms.json
     * @returns {object[]} array of backgrounds as Konva object jsons
     */
    buildRoomChildren(backgroundsJson) {
        // TODO: make configurable / responsive / etc / etc
        const bgWidth = 981;
        const bgHeight = 543;
        const backgrounds = [];
        for (const [key, backgroundJson] of Object.entries(backgroundsJson)) {
            const background = {};
            background.attrs = {
                "category": "room_background",
                "id": key,
                "src": backgroundJson.src,
                "visible": true,
                "width": bgWidth,
                "height": bgHeight
            };
            background.className = "Image";
            backgrounds.push(background);
        }
        return backgrounds;
    }
}

/**
 * Allow fairly freely adding "pure" Konva objects as children to the room (very flexible!)
 */
class OtherChildrenBuilder {
    /**
     * @param {any[]} otherJson other child objects from room.json
     * @returns {any[]} an array of other child objects as Konva objects
     */
    buildRoomChildren(otherJson) {
        const otherResult = [];
        for (const [key, other] of Object.entries(otherJson)) {
            if (!other.attrs) {
                other.attrs = {};
            }
            other.attrs.id = key;
            otherResult.push(other);
        }
        return otherResult;
    }
}

class ObjectsInRoomsBuilder {
    objectsInRoomBuilder;
    constructor(objectsInRoomBuilder) {
        this.objectsInRoomBuilder = objectsInRoomBuilder;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    build(roomsJson) {
        const objectsInRoomsData = {};
        for (const [name, room] of Object.entries(roomsJson)) {
            objectsInRoomsData[name] = this.objectsInRoomBuilder.build(room);
        }
        return objectsInRoomsData;
    }
}

class ObjectsInRoomBuilder {
    roomObjectCategories;
    constructor(roomObjectCategories) {
        this.roomObjectCategories = roomObjectCategories;
    }
    ;
    build(roomJson) {
        const objectsInRoom = [];
        for (const [category, objects] of Object.entries(roomJson)) {
            if (this.roomObjectCategories.includes(category)) {
                for (const [name, objectData] of Object.entries(objects)) {
                    if (objectData.initiallyVisible === false) {
                        continue;
                    }
                    const objectResult = { name };
                    objectsInRoom.push(objectResult);
                }
            }
        }
        return objectsInRoom;
    }
}

class CharacterInRoomViewModel {
    constructor(uiEventEmitter, gameEventEmitter) {
        this.uiEventEmitter = uiEventEmitter;
        this.gameEventEmitter = gameEventEmitter;
        this.state = {
            mode: 'NOT_IN_ROOM'
        };
        this.uiEventEmitter.on('room_fade_out_done', () => {
            this.moveCharacterFromTransitToRoom();
        });
        this.uiEventEmitter.on('ready_transition', ({ type, roomId }) => {
            this.readyTransition(type, roomId);
        });
        this.gameEventEmitter.on('character_moved_to_room', ({ roomId }) => {
            this.resolveCharacterMovedToRoom(roomId);
        });
    }
    readyTransition(type, roomId) {
        if (this.state.mode !== 'NOT_IN_ROOM' && this.state.mode !== 'IN_ROOM') {
            throw new Error('Resolving ready_transition with incompatible CharacterInRoom mode ' + this.state.mode);
        }
        const transitionType = this.state.mode === 'NOT_IN_ROOM' ? 'instant' : type;
        const from = this.state.mode === 'IN_ROOM' ? this.state.room : null;
        this.state = {
            mode: 'READY_TO_LEAVE',
            transitionType,
            from,
            to: roomId
        };
    }
    resolveCharacterMovedToRoom(roomId) {
        if (this.state.mode !== 'READY_TO_LEAVE') {
            throw new Error('Resolving character_moved_to_room with incompatible CharacterInRoom mode ' + this.state.mode);
        }
        if (this.state.transitionType === 'instant') {
            this.doInstantTransition(roomId);
            return;
        }
        this.startTransitionToRoom(roomId);
    }
    /**
     * Transition to a room.
     * @param {string} roomId The id of the room to transition to.
     */
    startTransitionToRoom(roomId) {
        if (this.state.mode !== 'READY_TO_LEAVE') {
            throw new Error('Starting transition with incompatible CharacterInRoom mode ' + this.state.mode);
        }
        const from = this.state.from;
        this.state = {
            mode: 'IN_TRANSITION',
            from,
            to: roomId
        };
        this.uiEventEmitter.emit('leaving_room');
    }
    /**
     * Transition to a room without ... transitioning.
     * @param {string} roomId room id to move instantly to
     */
    doInstantTransition(roomId) {
        if (this.state.mode !== 'READY_TO_LEAVE') {
            throw new Error('Starting instant transition with incompatible CharacterInRoom mode ' + this.state.mode);
        }
        if (this.state.from) {
            this.uiEventEmitter.emit('left_room', this.state.from);
        }
        this.state = {
            mode: 'IN_ROOM',
            room: roomId
        };
        this.uiEventEmitter.emit('arrived_in_room', roomId);
    }
    /**
     * Move the character from "in transition" state to the room.
     * @returns {void}
     */
    moveCharacterFromTransitToRoom() {
        if (this.state.mode !== 'IN_TRANSITION') {
            throw new Error('Moving character from in transition to room with incompatible mode ' + this.state.mode);
        }
        const from = this.state.from;
        const room = this.state.to;
        this.state = {
            mode: 'IN_ROOM',
            room
        };
        this.uiEventEmitter.emit('left_room', from);
        this.uiEventEmitter.emit('arriving_in_room');
        this.uiEventEmitter.emit('arrived_in_room', room);
        return;
    }
}

class InventoryArrowsViewModel {
    /**
     * @param {EventEmitter} uiEventEmitter
     */
    constructor(uiEventEmitter) {
        this.uiEventEmitter = uiEventEmitter;
        // For limiting the speed of inventory browsing when dragging an item
        this.inventoryScrollDelay = 500;
        this.inventoryScrollDelayEnabled = false;
        this.uiEventEmitter.on('dragmove_hover_on_left_arrow', () => {
            this.handleDragMoveHoverOnLeftArrow();
        });
        this.uiEventEmitter.on('dragmove_hover_on_right_arrow', () => {
            this.handleDragMoveOnRightArrow();
        });
    }
    handleDragMoveHoverOnLeftArrow() {
        if (!this.inventoryScrollDelayEnabled) {
            this.inventoryScrollDelayEnabled = true;
            this.uiEventEmitter.emit('inventory_left_arrow_draghovered');
            setTimeout(() => this.inventoryScrollDelayEnabled = false, this.inventoryScrollDelay);
        }
    }
    handleDragMoveOnRightArrow() {
        if (!this.inventoryScrollDelayEnabled) {
            this.inventoryScrollDelayEnabled = true;
            this.uiEventEmitter.emit('inventory_right_arrow_draghovered');
            setTimeout(() => this.inventoryScrollDelayEnabled = false, this.inventoryScrollDelay);
        }
    }
}

class ClickHandler {
    uiEventEmitter;
    commandsHandler;
    clickResolvers;
    interactions;
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {CommandsHandler} commandsHandler
     * @param {DefaultInteractionResolver[]} clickResolvers
     * @param {Interactions} interactions
     */
    constructor(uiEventEmitter, commandsHandler, clickResolvers, interactions) {
        this.uiEventEmitter = uiEventEmitter;
        this.commandsHandler = commandsHandler;
        this.clickResolvers = clickResolvers;
        this.interactions = interactions;
        this.uiEventEmitter.on('furniture_clicked', (target) => {
            this.handleClick(target);
        });
        this.uiEventEmitter.on('inventory_click', (target) => {
            this.handleClick(target);
        });
    }
    /**
     * Handle click interactions on room objects, inventory items & any resolver category ...
     */
    handleClick(target) {
        const targetCategory = target.getAttr('category');
        const clickResolver = this.clickResolvers.find((clickResolver) => {
            return clickResolver.getTargetCategory() === targetCategory;
        });
        if (clickResolver) {
            this.commandsHandler.handleCommands(clickResolver.resolveCommands(this.interactions, target.id()));
        }
    }
}

class DragEndHandler {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {CommandsHandler} commandsHandler
     * @param {DefaultInteractionResolver[]} dragResolvers
     * @param {Interactions} interactions
     */
    constructor(uiEventEmitter, commandsHandler, dragResolvers, interactions) {
        this.uiEventEmitter = uiEventEmitter;
        this.commandsHandler = commandsHandler;
        this.dragResolvers = dragResolvers;
        this.interactions = interactions;
        this.uiEventEmitter.on('inventory_item_drag_end_on_target', ({ target, draggedItem }) => {
            this.handleDragEnd(target, draggedItem);
        });
    }
    /**
     * @param {Konva.Shape} target
     * @param {Konva.Shape} draggedItem
     */
    handleDragEnd(target, draggedItem) {
        const targetCategory = target.getAttr('category');
        const dragResolver = this.dragResolvers.find((dragResolver) => dragResolver.getTargetCategory() === targetCategory);
        if (dragResolver) {
            this.commandsHandler.handleCommands(dragResolver.resolveCommands(this.interactions, draggedItem.id(), target.id(), target.id()));
        }
        this.uiEventEmitter.emit('inventory_item_drag_end_interactions_handled');
    }
}

class DragTargetFinder {
    /**
     * @param {Intersection} intersection
     * @param {RoomView} roomView
     * @param {InventoryItemsView} inventoryItemsView
     * @param {InventoryArrowsView} inventoryArrowsView
     */
    constructor(intersection, roomView, inventoryItemsView, inventoryArrowsView) {
        this.intersection = intersection;
        this.roomView = roomView;
        this.inventoryItemsView = inventoryItemsView;
        this.inventoryArrowsView = inventoryArrowsView;
    }
    /**
     * @param {Konva.Shape} draggedItem
     * @param {Konva.Shape|undefined} previousTarget
     * @returns {Konva.Shape|undefined}
     */
    findDragTarget(draggedItem, previousTarget = undefined) {
        const candidates = [
            ...[this.inventoryArrowsView.leftArrow, this.inventoryArrowsView.rightArrow],
            ...[previousTarget],
            ...this.roomView.getVisibleObjectsFromCurrentRoom(),
            ...this.inventoryItemsView.getVisibleInventoryItems()
        ];
        let target = undefined;
        for (let i = 0; i < candidates.length; i++) {
            const object = candidates[i];
            if (object !== undefined && this.intersection.check(draggedItem, object)) {
                target = object;
                break;
            }
        }
        return target;
    }
}

class DraggedItemViewModel {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {DragTargetFinder} dragTargetFinder
     * @param {TextModel} text
     */
    constructor(uiEventEmitter, dragTargetFinder, text) {
        this.uiEventEmitter = uiEventEmitter;
        this.dragTargetFinder = dragTargetFinder;
        this.text = text;
        // For limiting the amount of intersection checks
        this.intersectionDelayEnabled = false;
        // Currently dragged item
        this.draggedItem = undefined;
        // Intersection target (object below dragged item)
        this.target = undefined;
        this.uiEventEmitter.on('inventory_item_drag_start', ({ draggedItem }) => {
            this.handleInventoryItemDragStart(draggedItem);
        });
        this.uiEventEmitter.on('inventory_item_drag_end_interactions_handled', () => {
            this.wrapUpDragEnd();
        });
    }
    /**
     * @param {Konva.Shape} draggedItem
     */
    handleInventoryItemDragStart(draggedItem) {
        this.draggedItem = draggedItem;
        this.draggedItem.on('dragmove', (_event) => {
            this.handleInventoryItemDragMove();
        });
        this.draggedItem.on('dragend', (_event) => {
            this.handleInventoryItemDragEnd();
        });
    }
    handleInventoryItemDragMove() {
        if (!this.intersectionDelayEnabled) {
            // Setting a small delay to not spam intersection check on every moved pixel
            this.setIntersectionDelay(10);
            this.target = this.dragTargetFinder.findDragTarget(this.draggedItem, this.target);
            if (this.target && this.target.category !== 'invArrow') {
                this.targetName = this.text.getName(this.target.id());
            }
            else {
                this.targetName = undefined;
            }
            if (this.target === undefined) {
                this.uiEventEmitter.emit('dragmove_hover_on_nothing');
                return;
            }
            if (this.target.attrs.category !== 'invArrow') {
                this.uiEventEmitter.emit('dragmove_hover_on_object', {
                    target: this.target,
                    draggedItem: this.draggedItem,
                    targetName: this.targetName
                });
                return;
            }
            if (this.target.attrs.id === 'inventory_left_arrow') {
                this.uiEventEmitter.emit('dragmove_hover_on_left_arrow');
                return;
            }
            if (this.target.attrs.id === 'inventory_right_arrow') {
                this.uiEventEmitter.emit('dragmove_hover_on_right_arrow');
                return;
            }
        }
    }
    handleInventoryItemDragEnd() {
        // Ending the drag on an inventory arrow does nothing
        if (this.target !== undefined && this.target.attrs.category === 'invArrow') {
            this.wrapUpDragEnd();
            return;
        }
        // If we are already hovering a target, use it
        if (this.target !== undefined) {
            this.uiEventEmitter.emit('inventory_item_drag_end_on_target', { target: this.target, draggedItem: this.draggedItem });
            return;
        }
        // In case we didn't yet get the target set during hover (for example during intersection delay), check now
        const target = this.dragTargetFinder.findDragTarget(this.draggedItem);
        if (target === undefined || target.attrs.category === 'invArrow') {
            this.wrapUpDragEnd();
            return;
        }
        this.uiEventEmitter.emit('inventory_item_drag_end_on_target', { target, draggedItem: this.draggedItem });
    }
    /**
     * Delay to be set after each intersection check
     * @param {int} delay
     */
    setIntersectionDelay(delay) {
        this.intersectionDelayEnabled = true;
        setTimeout(() => this.intersectionDelayEnabled = false, delay);
    }
    /**
     * Unsubscribe listeners, clean up view model.
     */
    wrapUpDragEnd() {
        const draggedItem = this.draggedItem;
        draggedItem.off('dragmove');
        draggedItem.off('dragend');
        this.draggedItem = undefined;
        this.target = undefined;
        this.uiEventEmitter.emit('inventory_item_drag_end_wrapped_up', { draggedItem });
    }
}

class SequenceView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {EventEmitter} gameEventEmitter
     * @param {StageObjectGetter} stageObjectGetter
     * @param {any} sequencesJson
     * @param {Konva.Layer} sequenceLayer
     */
    constructor(uiEventEmitter, gameEventEmitter, stageObjectGetter, sequencesJson, sequenceLayer) {
        this.uiEventEmitter = uiEventEmitter;
        this.stageObjectGetter = stageObjectGetter;
        this.sequencesJson = sequencesJson;
        this.sequenceLayer = sequenceLayer;
        this.uiEventEmitter.on('arrived_in_room', (_roomId) => {
            this.sequenceLayer.hide();
        });
        gameEventEmitter.on('play_sequence', (sequenceId) => {
            this.playSequence(sequenceId);
        });
    }
    /**
     * Playes a sequence definied in sequences.json by id.
     * @param {string} id The Sequence id in sequences.json
     */
    playSequence(id) {
        let delay = 700;
        this.uiEventEmitter.emit('play_sequence_started', id);
        const currentSequence = this.stageObjectGetter.getObject(id);
        const sequenceData = this.sequencesJson[id];
        const final_fade_duration = sequenceData.transition_length != null ? sequenceData.transition_length : 0;
        let currentSlide = null;
        setTimeout(() => {
            this.sequenceLayer.show();
            currentSequence.show();
            this.uiEventEmitter.emit('first_sequence_slide_shown');
        }, delay);
        for (let i in sequenceData.slides) {
            let previousSlide = currentSlide;
            currentSlide = this.stageObjectGetter.getObject(sequenceData.slides[i].id);
            const displaySlide = (i, currentSlide, previousSlide) => {
                setTimeout(() => {
                    if (previousSlide) {
                        previousSlide.hide();
                        this.uiEventEmitter.emit('sequence_hid_previous_slide');
                    }
                    // Show current slide (note stage.draw only below)
                    currentSlide.show();
                    // Fade in?
                    const slideFade = sequenceData.slides[i].do_fade;
                    if (slideFade === true) {
                        this.uiEventEmitter.emit('sequence_show_next_slide_fade');
                    }
                    else {
                        this.uiEventEmitter.emit('sequence_show_next_slide_immediate');
                    }
                }, delay);
            };
            displaySlide(i, currentSlide, previousSlide);
            delay = delay + sequenceData.slides[i].show_time;
        }
        // After last slide, do the final fade
        if (final_fade_duration > 0) {
            setTimeout(() => {
                this.uiEventEmitter.emit('sequence_last_slide_fade_out', final_fade_duration);
            }, delay);
            // Doesn't include the fade-in!
            delay = delay + final_fade_duration;
        }
        else {
            setTimeout(() => {
                this.uiEventEmitter.emit('sequence_last_slide_immediate');
            }, delay);
        }
    }
}

class DraggedItemView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {Konva.Layer} fullScreenLayer
     * @param {Konva.Text} interactionText
     */
    constructor(uiEventEmitter, fullScreenLayer, interactionText) {
        this.uiEventEmitter = uiEventEmitter;
        this.fullScreenLayer = fullScreenLayer;
        this.interactionText = interactionText;
        this.uiEventEmitter.on('dragmove_hover_on_object', ({ target: _target, draggedItem, targetName }) => {
            this.showTextOnDragMove(targetName, draggedItem);
        });
        this.uiEventEmitter.on('dragmove_hover_on_nothing', () => {
            this.clearInteractionText();
        });
        this.uiEventEmitter.on('inventory_left_arrow_draghovered', () => {
            this.clearInteractionText();
        });
        this.uiEventEmitter.on('inventory_right_arrow_draghovered', () => {
            this.clearInteractionText();
        });
        this.uiEventEmitter.on('inventory_item_drag_end_wrapped_up', (_draggedItem) => {
            this.clearInteractionText();
        });
    }
    clearInteractionText() {
        this.interactionText.text("");
        this.fullScreenLayer.draw();
    }
    /**
     * @param {string} targetName
     * @param {Konva.Shape} draggedItem
     */
    showTextOnDragMove(targetName, draggedItem) {
        this.interactionText.text(targetName);
        this.interactionText.x(draggedItem.x() + (draggedItem.width() / 2));
        this.interactionText.y(draggedItem.y() - 30);
        this.interactionText.offset({
            x: this.interactionText.width() / 2
        });
        this.fullScreenLayer.draw();
    }
}

class CharacterSpeechView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {EventEmitter} gameEventEmitter
     * @param {Konva.Text} monologue
     * @param {Konva.Label} characterSpeechBubble
     * @param {int} stageHeight
     */
    constructor(uiEventEmitter, gameEventEmitter, monologue, characterSpeechBubble, stageHeight) {
        this.uiEventEmitter = uiEventEmitter;
        this.monologue = monologue;
        this.characterSpeechBubble = characterSpeechBubble;
        this.stageHeight = stageHeight;
        gameEventEmitter.on('monologue', ({ text, _posture }) => {
            this.clearMonologue();
            this.setMonologue(text);
        });
        gameEventEmitter.on('npc_monologue', ({ _npc, _text, _characterPosture }) => {
            this.clearMonologue();
        });
        this.uiEventEmitter.on('clicked_on_stage', () => {
            this.clearMonologue();
        });
        this.uiEventEmitter.on('inventory_item_drag_start', ({ draggedItem: _draggedItem }) => {
            this.clearMonologue();
        });
    }
    /**
     * Set character speech text
     * @param {string} text The text to be shown in the monologue bubble.
     */
    setMonologue(text) {
        this.monologue.setWidth('auto');
        this.characterSpeechBubble.show();
        this.monologue.text(text);
        if (this.monologue.width() > 524) {
            this.monologue.width(524);
            this.monologue.text(text);
        }
        this.characterSpeechBubble.y(this.stageHeight - 100 - 15 - this.monologue.height() / 2);
        this.uiEventEmitter.emit('character_monologue_set');
    }
    clearMonologue() {
        this.monologue.text("");
        this.characterSpeechBubble.hide();
        this.uiEventEmitter.emit('character_monologue_cleared');
    }
}

class StageView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {Konva.Stage} stage
     */
    constructor(uiEventEmitter, stage) {
        this.stage = stage;
        // Capture Konva's UI events and transform to KiiGame UI event
        this.stage.on('touchstart mousedown', () => {
            uiEventEmitter.emit('clicked_on_stage');
        });
        // Respond to other UI events
        uiEventEmitter.on('fader_total_occultation_ended', () => {
            this.drawStage();
        });
        uiEventEmitter.on('room_hit_regions_initialized', () => {
            this.drawStage();
        });
        uiEventEmitter.on('first_sequence_slide_shown', () => {
            this.drawStage();
        });
    }
    drawStage() {
        this.stage.draw();
    }
}

class FullFadeView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {Konva.Tween} fadeFull
     */
    constructor(uiEventEmitter, fadeFull) {
        this.uiEventEmitter = uiEventEmitter;
        this.fadeFull = fadeFull;
        // These can be fired via interactions
        this.uiEventEmitter.on('play_full_fade_out', () => {
            this.playFullFadeOut();
        });
        this.uiEventEmitter.on('play_full_fade_in', () => {
            this.playFullFadeIn();
        });
        // Respond to other UI events
        this.uiEventEmitter.on('play_sequence_started', (_id) => {
            this.playFullFadeOut();
        });
        this.uiEventEmitter.on('sequence_hid_previous_slide', () => {
            this.playFullFadeOut();
        });
        this.uiEventEmitter.on('sequence_last_slide_fade_out', (finalFadeDuration) => {
            this.playFullFadeCycleWithDuration(finalFadeDuration);
        });
        this.uiEventEmitter.on('sequence_last_slide_immediate', () => {
            this.handleSequenceLastSlideImmediate();
        });
        this.uiEventEmitter.on('sequence_show_next_slide_fade', () => {
            this.handleSequenceShowNextSlideFade();
        });
        this.uiEventEmitter.on('sequence_show_next_slide_immediate', () => {
            this.handleSequenceShowNextSlideImmediate();
        });
    }
    playFullFadeIn() {
        // Assumes fade_full has first faded out
        this.fadeFull.reverse();
        this.uiEventEmitter.emit('fader_total_occultation_ended');
        setTimeout(() => {
            this.fadeFull.node.hide();
            this.fadeFull.reset();
        }, this.fadeFull.tween.duration);
    }
    playFullFadeCycleWithDuration(duration) {
        this.fadeFull.tween.duration = duration;
        this.playFullFadeOut();
        setTimeout(() => {
            this.playFullFadeIn();
            setTimeout(() => {
                this.fadeFull.tween.duration = 600; // reset to default
            }, duration);
        }, duration);
    }
    handleSequenceShowNextSlideImmediate() {
        this.fadeFull.reset();
        this.uiEventEmitter.emit('fader_total_occultation_ended');
    }
    playFullFadeOut() {
        this.fadeFull.reset();
        this.fadeFull.node.show();
        this.fadeFull.play();
    }
    handleSequenceLastSlideImmediate() {
        this.fadeFull.node.hide();
        this.uiEventEmitter.emit('fader_total_occultation_ended');
    }
    handleSequenceShowNextSlideFade() {
        setTimeout(() => {
            this.playFullFadeIn();
        }, this.fadeFull.tween.duration);
    }
}

class NpcMonologueView {
    /**
     * @param {EventEmitter} uiEventEmitter
     * @param {EventEmitter} gameEventEmitter
     * @param {StageObjectGetter} stageObjectGetter
     * @param {Konva.Text} npcMonologueText
     * @param {Konva.Label} npcSpeechBubble
     * @param {int} stageWidth
     */
    constructor(uiEventEmitter, gameEventEmitter, stageObjectGetter, npcSpeechBubble, stageWidth) {
        this.uiEventEmitter = uiEventEmitter;
        this.stageObjectGetter = stageObjectGetter;
        this.npcSpeechBubble = npcSpeechBubble;
        this.npcMonologueText = npcSpeechBubble.getText();
        this.npcTag = npcSpeechBubble.getTag();
        this.stageWidth = stageWidth;
        gameEventEmitter.on('monologue', ({ text, _posture }) => {
            this.clearNpcMonologue();
        });
        gameEventEmitter.on('npc_monologue', ({ npc, text, _characterPosture }) => {
            this.clearNpcMonologue();
            const npcObject = this.stageObjectGetter.getObject(npc);
            this.npcMonologue(npcObject, text);
        });
        this.uiEventEmitter.on('clicked_on_stage', () => {
            this.clearNpcMonologue();
        });
        this.uiEventEmitter.on('inventory_item_drag_start', ({ draggedItem: _draggedItem }) => {
            this.clearNpcMonologue();
        });
    }
    /**
     * Set NPC monologue text and position the NPC speech bubble to the
     * desired NPC.
     * @param {Konva.Shape} npc The object in the stage that will have the speech bubble.
     * @param {string} text The text to be shown in the speech bubble.
     */
    npcMonologue(npc, text) {
        const pointerDirection = npc.x() + npc.width() > (this.stageWidth / 2) ? "right" : "left";
        this.npcTag.pointerDirection(pointerDirection);
        this.npcMonologueText.text(text);
        this.npcMonologueText.width(Math.round(this.npcMonologueText.width()));
        if (pointerDirection === "right") {
            if (this.npcMonologueText.width() > npc.x() - 100) {
                this.npcMonologueText.width(npc.x() - 100);
            }
            this.npcSpeechBubble.x(npc.x());
        }
        else {
            if (this.npcMonologueText.width() > this.stageWidth - (npc.x() + npc.width() + 100)) {
                this.npcMonologueText.width(this.stageWidth - (npc.x() + npc.width() + 100));
            }
            this.npcSpeechBubble.x(npc.x() + npc.width());
        }
        this.npcSpeechBubble.y(Math.round(npc.y() + (npc.height() / 3)));
        this.npcSpeechBubble.show();
        this.uiEventEmitter.emit('npc_monologue_set');
    }
    clearNpcMonologue() {
        this.npcMonologueText.text("");
        this.npcSpeechBubble.hide();
        this.uiEventEmitter.emit('npc_monologue_cleared');
    }
}

var _Reflect = {};

/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var hasRequired_Reflect;

function require_Reflect () {
	if (hasRequired_Reflect) return _Reflect;
	hasRequired_Reflect = 1;
	var Reflect;
	(function (Reflect) {
	    // Metadata Proposal
	    // https://rbuckton.github.io/reflect-metadata/
	    (function (factory) {
	        var root = typeof globalThis === "object" ? globalThis :
	            typeof commonjsGlobal === "object" ? commonjsGlobal :
	                typeof self === "object" ? self :
	                    typeof this === "object" ? this :
	                        sloppyModeThis();
	        var exporter = makeExporter(Reflect);
	        if (typeof root.Reflect !== "undefined") {
	            exporter = makeExporter(root.Reflect, exporter);
	        }
	        factory(exporter, root);
	        if (typeof root.Reflect === "undefined") {
	            root.Reflect = Reflect;
	        }
	        function makeExporter(target, previous) {
	            return function (key, value) {
	                Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
	                if (previous)
	                    previous(key, value);
	            };
	        }
	        function functionThis() {
	            try {
	                return Function("return this;")();
	            }
	            catch (_) { }
	        }
	        function indirectEvalThis() {
	            try {
	                return (void 0, eval)("(function() { return this; })()");
	            }
	            catch (_) { }
	        }
	        function sloppyModeThis() {
	            return functionThis() || indirectEvalThis();
	        }
	    })(function (exporter, root) {
	        var hasOwn = Object.prototype.hasOwnProperty;
	        // feature test for Symbol support
	        var supportsSymbol = typeof Symbol === "function";
	        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
	        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
	        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
	        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
	        var downLevel = !supportsCreate && !supportsProto;
	        var HashMap = {
	            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
	            create: supportsCreate
	                ? function () { return MakeDictionary(Object.create(null)); }
	                : supportsProto
	                    ? function () { return MakeDictionary({ __proto__: null }); }
	                    : function () { return MakeDictionary({}); },
	            has: downLevel
	                ? function (map, key) { return hasOwn.call(map, key); }
	                : function (map, key) { return key in map; },
	            get: downLevel
	                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
	                : function (map, key) { return map[key]; },
	        };
	        // Load global or shim versions of Map, Set, and WeakMap
	        var functionPrototype = Object.getPrototypeOf(Function);
	        var _Map = typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
	        var _Set = typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
	        var _WeakMap = typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
	        var registrySymbol = supportsSymbol ? Symbol.for("@reflect-metadata:registry") : undefined;
	        var metadataRegistry = GetOrCreateMetadataRegistry();
	        var metadataProvider = CreateMetadataProvider(metadataRegistry);
	        /**
	         * Applies a set of decorators to a property of a target object.
	         * @param decorators An array of decorators.
	         * @param target The target object.
	         * @param propertyKey (Optional) The property key to decorate.
	         * @param attributes (Optional) The property descriptor for the target key.
	         * @remarks Decorators are applied in reverse order.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     Example = Reflect.decorate(decoratorsArray, Example);
	         *
	         *     // property (on constructor)
	         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     Object.defineProperty(Example, "staticMethod",
	         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
	         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
	         *
	         *     // method (on prototype)
	         *     Object.defineProperty(Example.prototype, "method",
	         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
	         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
	         *
	         */
	        function decorate(decorators, target, propertyKey, attributes) {
	            if (!IsUndefined(propertyKey)) {
	                if (!IsArray(decorators))
	                    throw new TypeError();
	                if (!IsObject(target))
	                    throw new TypeError();
	                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
	                    throw new TypeError();
	                if (IsNull(attributes))
	                    attributes = undefined;
	                propertyKey = ToPropertyKey(propertyKey);
	                return DecorateProperty(decorators, target, propertyKey, attributes);
	            }
	            else {
	                if (!IsArray(decorators))
	                    throw new TypeError();
	                if (!IsConstructor(target))
	                    throw new TypeError();
	                return DecorateConstructor(decorators, target);
	            }
	        }
	        exporter("decorate", decorate);
	        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
	        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
	        /**
	         * A default metadata decorator factory that can be used on a class, class member, or parameter.
	         * @param metadataKey The key for the metadata entry.
	         * @param metadataValue The value for the metadata entry.
	         * @returns A decorator function.
	         * @remarks
	         * If `metadataKey` is already defined for the target and target key, the
	         * metadataValue for that key will be overwritten.
	         * @example
	         *
	         *     // constructor
	         *     @Reflect.metadata(key, value)
	         *     class Example {
	         *     }
	         *
	         *     // property (on constructor, TypeScript only)
	         *     class Example {
	         *         @Reflect.metadata(key, value)
	         *         static staticProperty;
	         *     }
	         *
	         *     // property (on prototype, TypeScript only)
	         *     class Example {
	         *         @Reflect.metadata(key, value)
	         *         property;
	         *     }
	         *
	         *     // method (on constructor)
	         *     class Example {
	         *         @Reflect.metadata(key, value)
	         *         static staticMethod() { }
	         *     }
	         *
	         *     // method (on prototype)
	         *     class Example {
	         *         @Reflect.metadata(key, value)
	         *         method() { }
	         *     }
	         *
	         */
	        function metadata(metadataKey, metadataValue) {
	            function decorator(target, propertyKey) {
	                if (!IsObject(target))
	                    throw new TypeError();
	                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
	                    throw new TypeError();
	                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
	            }
	            return decorator;
	        }
	        exporter("metadata", metadata);
	        /**
	         * Define a unique metadata entry on the target.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param metadataValue A value that contains attached metadata.
	         * @param target The target object on which to define metadata.
	         * @param propertyKey (Optional) The property key for the target.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     Reflect.defineMetadata("custom:annotation", options, Example);
	         *
	         *     // property (on constructor)
	         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
	         *
	         *     // decorator factory as metadata-producing annotation.
	         *     function MyAnnotation(options): Decorator {
	         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
	         *     }
	         *
	         */
	        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
	        }
	        exporter("defineMetadata", defineMetadata);
	        /**
	         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.hasMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function hasMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("hasMetadata", hasMetadata);
	        /**
	         * Gets a value indicating whether the target object has the provided metadata key defined.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function hasOwnMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("hasOwnMetadata", hasOwnMetadata);
	        /**
	         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.getMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function getMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("getMetadata", getMetadata);
	        /**
	         * Gets the metadata value for the provided metadata key on the target object.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function getOwnMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("getOwnMetadata", getOwnMetadata);
	        /**
	         * Gets the metadata keys defined on the target object or its prototype chain.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns An array of unique metadata keys.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.getMetadataKeys(Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
	         *
	         */
	        function getMetadataKeys(target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryMetadataKeys(target, propertyKey);
	        }
	        exporter("getMetadataKeys", getMetadataKeys);
	        /**
	         * Gets the unique metadata keys defined on the target object.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns An array of unique metadata keys.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.getOwnMetadataKeys(Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
	         *
	         */
	        function getOwnMetadataKeys(target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryOwnMetadataKeys(target, propertyKey);
	        }
	        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
	        /**
	         * Deletes the metadata entry from the target object with the provided key.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.deleteMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function deleteMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            var provider = GetMetadataProvider(target, propertyKey, /*Create*/ false);
	            if (IsUndefined(provider))
	                return false;
	            return provider.OrdinaryDeleteMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("deleteMetadata", deleteMetadata);
	        function DecorateConstructor(decorators, target) {
	            for (var i = decorators.length - 1; i >= 0; --i) {
	                var decorator = decorators[i];
	                var decorated = decorator(target);
	                if (!IsUndefined(decorated) && !IsNull(decorated)) {
	                    if (!IsConstructor(decorated))
	                        throw new TypeError();
	                    target = decorated;
	                }
	            }
	            return target;
	        }
	        function DecorateProperty(decorators, target, propertyKey, descriptor) {
	            for (var i = decorators.length - 1; i >= 0; --i) {
	                var decorator = decorators[i];
	                var decorated = decorator(target, propertyKey, descriptor);
	                if (!IsUndefined(decorated) && !IsNull(decorated)) {
	                    if (!IsObject(decorated))
	                        throw new TypeError();
	                    descriptor = decorated;
	                }
	            }
	            return descriptor;
	        }
	        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
	        function OrdinaryHasMetadata(MetadataKey, O, P) {
	            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
	            if (hasOwn)
	                return true;
	            var parent = OrdinaryGetPrototypeOf(O);
	            if (!IsNull(parent))
	                return OrdinaryHasMetadata(MetadataKey, parent, P);
	            return false;
	        }
	        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
	        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
	            var provider = GetMetadataProvider(O, P, /*Create*/ false);
	            if (IsUndefined(provider))
	                return false;
	            return ToBoolean(provider.OrdinaryHasOwnMetadata(MetadataKey, O, P));
	        }
	        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
	        function OrdinaryGetMetadata(MetadataKey, O, P) {
	            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
	            if (hasOwn)
	                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
	            var parent = OrdinaryGetPrototypeOf(O);
	            if (!IsNull(parent))
	                return OrdinaryGetMetadata(MetadataKey, parent, P);
	            return undefined;
	        }
	        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
	        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
	            var provider = GetMetadataProvider(O, P, /*Create*/ false);
	            if (IsUndefined(provider))
	                return;
	            return provider.OrdinaryGetOwnMetadata(MetadataKey, O, P);
	        }
	        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
	        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
	            var provider = GetMetadataProvider(O, P, /*Create*/ true);
	            provider.OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P);
	        }
	        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
	        function OrdinaryMetadataKeys(O, P) {
	            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
	            var parent = OrdinaryGetPrototypeOf(O);
	            if (parent === null)
	                return ownKeys;
	            var parentKeys = OrdinaryMetadataKeys(parent, P);
	            if (parentKeys.length <= 0)
	                return ownKeys;
	            if (ownKeys.length <= 0)
	                return parentKeys;
	            var set = new _Set();
	            var keys = [];
	            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
	                var key = ownKeys_1[_i];
	                var hasKey = set.has(key);
	                if (!hasKey) {
	                    set.add(key);
	                    keys.push(key);
	                }
	            }
	            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
	                var key = parentKeys_1[_a];
	                var hasKey = set.has(key);
	                if (!hasKey) {
	                    set.add(key);
	                    keys.push(key);
	                }
	            }
	            return keys;
	        }
	        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
	        function OrdinaryOwnMetadataKeys(O, P) {
	            var provider = GetMetadataProvider(O, P, /*create*/ false);
	            if (!provider) {
	                return [];
	            }
	            return provider.OrdinaryOwnMetadataKeys(O, P);
	        }
	        // 6 ECMAScript Data Types and Values
	        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
	        function Type(x) {
	            if (x === null)
	                return 1 /* Null */;
	            switch (typeof x) {
	                case "undefined": return 0 /* Undefined */;
	                case "boolean": return 2 /* Boolean */;
	                case "string": return 3 /* String */;
	                case "symbol": return 4 /* Symbol */;
	                case "number": return 5 /* Number */;
	                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
	                default: return 6 /* Object */;
	            }
	        }
	        // 6.1.1 The Undefined Type
	        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
	        function IsUndefined(x) {
	            return x === undefined;
	        }
	        // 6.1.2 The Null Type
	        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
	        function IsNull(x) {
	            return x === null;
	        }
	        // 6.1.5 The Symbol Type
	        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
	        function IsSymbol(x) {
	            return typeof x === "symbol";
	        }
	        // 6.1.7 The Object Type
	        // https://tc39.github.io/ecma262/#sec-object-type
	        function IsObject(x) {
	            return typeof x === "object" ? x !== null : typeof x === "function";
	        }
	        // 7.1 Type Conversion
	        // https://tc39.github.io/ecma262/#sec-type-conversion
	        // 7.1.1 ToPrimitive(input [, PreferredType])
	        // https://tc39.github.io/ecma262/#sec-toprimitive
	        function ToPrimitive(input, PreferredType) {
	            switch (Type(input)) {
	                case 0 /* Undefined */: return input;
	                case 1 /* Null */: return input;
	                case 2 /* Boolean */: return input;
	                case 3 /* String */: return input;
	                case 4 /* Symbol */: return input;
	                case 5 /* Number */: return input;
	            }
	            var hint = "string" ;
	            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
	            if (exoticToPrim !== undefined) {
	                var result = exoticToPrim.call(input, hint);
	                if (IsObject(result))
	                    throw new TypeError();
	                return result;
	            }
	            return OrdinaryToPrimitive(input);
	        }
	        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
	        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
	        function OrdinaryToPrimitive(O, hint) {
	            var valueOf, result; {
	                var toString_1 = O.toString;
	                if (IsCallable(toString_1)) {
	                    var result = toString_1.call(O);
	                    if (!IsObject(result))
	                        return result;
	                }
	                var valueOf = O.valueOf;
	                if (IsCallable(valueOf)) {
	                    var result = valueOf.call(O);
	                    if (!IsObject(result))
	                        return result;
	                }
	            }
	            throw new TypeError();
	        }
	        // 7.1.2 ToBoolean(argument)
	        // https://tc39.github.io/ecma262/2016/#sec-toboolean
	        function ToBoolean(argument) {
	            return !!argument;
	        }
	        // 7.1.12 ToString(argument)
	        // https://tc39.github.io/ecma262/#sec-tostring
	        function ToString(argument) {
	            return "" + argument;
	        }
	        // 7.1.14 ToPropertyKey(argument)
	        // https://tc39.github.io/ecma262/#sec-topropertykey
	        function ToPropertyKey(argument) {
	            var key = ToPrimitive(argument);
	            if (IsSymbol(key))
	                return key;
	            return ToString(key);
	        }
	        // 7.2 Testing and Comparison Operations
	        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
	        // 7.2.2 IsArray(argument)
	        // https://tc39.github.io/ecma262/#sec-isarray
	        function IsArray(argument) {
	            return Array.isArray
	                ? Array.isArray(argument)
	                : argument instanceof Object
	                    ? argument instanceof Array
	                    : Object.prototype.toString.call(argument) === "[object Array]";
	        }
	        // 7.2.3 IsCallable(argument)
	        // https://tc39.github.io/ecma262/#sec-iscallable
	        function IsCallable(argument) {
	            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
	            return typeof argument === "function";
	        }
	        // 7.2.4 IsConstructor(argument)
	        // https://tc39.github.io/ecma262/#sec-isconstructor
	        function IsConstructor(argument) {
	            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
	            return typeof argument === "function";
	        }
	        // 7.2.7 IsPropertyKey(argument)
	        // https://tc39.github.io/ecma262/#sec-ispropertykey
	        function IsPropertyKey(argument) {
	            switch (Type(argument)) {
	                case 3 /* String */: return true;
	                case 4 /* Symbol */: return true;
	                default: return false;
	            }
	        }
	        function SameValueZero(x, y) {
	            return x === y || x !== x && y !== y;
	        }
	        // 7.3 Operations on Objects
	        // https://tc39.github.io/ecma262/#sec-operations-on-objects
	        // 7.3.9 GetMethod(V, P)
	        // https://tc39.github.io/ecma262/#sec-getmethod
	        function GetMethod(V, P) {
	            var func = V[P];
	            if (func === undefined || func === null)
	                return undefined;
	            if (!IsCallable(func))
	                throw new TypeError();
	            return func;
	        }
	        // 7.4 Operations on Iterator Objects
	        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
	        function GetIterator(obj) {
	            var method = GetMethod(obj, iteratorSymbol);
	            if (!IsCallable(method))
	                throw new TypeError(); // from Call
	            var iterator = method.call(obj);
	            if (!IsObject(iterator))
	                throw new TypeError();
	            return iterator;
	        }
	        // 7.4.4 IteratorValue(iterResult)
	        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
	        function IteratorValue(iterResult) {
	            return iterResult.value;
	        }
	        // 7.4.5 IteratorStep(iterator)
	        // https://tc39.github.io/ecma262/#sec-iteratorstep
	        function IteratorStep(iterator) {
	            var result = iterator.next();
	            return result.done ? false : result;
	        }
	        // 7.4.6 IteratorClose(iterator, completion)
	        // https://tc39.github.io/ecma262/#sec-iteratorclose
	        function IteratorClose(iterator) {
	            var f = iterator["return"];
	            if (f)
	                f.call(iterator);
	        }
	        // 9.1 Ordinary Object Internal Methods and Internal Slots
	        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
	        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
	        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
	        function OrdinaryGetPrototypeOf(O) {
	            var proto = Object.getPrototypeOf(O);
	            if (typeof O !== "function" || O === functionPrototype)
	                return proto;
	            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
	            // Try to determine the superclass constructor. Compatible implementations
	            // must either set __proto__ on a subclass constructor to the superclass constructor,
	            // or ensure each class has a valid `constructor` property on its prototype that
	            // points back to the constructor.
	            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
	            // This is the case when in ES6 or when using __proto__ in a compatible browser.
	            if (proto !== functionPrototype)
	                return proto;
	            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
	            var prototype = O.prototype;
	            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
	            if (prototypeProto == null || prototypeProto === Object.prototype)
	                return proto;
	            // If the constructor was not a function, then we cannot determine the heritage.
	            var constructor = prototypeProto.constructor;
	            if (typeof constructor !== "function")
	                return proto;
	            // If we have some kind of self-reference, then we cannot determine the heritage.
	            if (constructor === O)
	                return proto;
	            // we have a pretty good guess at the heritage.
	            return constructor;
	        }
	        // Global metadata registry
	        // - Allows `import "reflect-metadata"` and `import "reflect-metadata/no-conflict"` to interoperate.
	        // - Uses isolated metadata if `Reflect` is frozen before the registry can be installed.
	        /**
	         * Creates a registry used to allow multiple `reflect-metadata` providers.
	         */
	        function CreateMetadataRegistry() {
	            var fallback;
	            if (!IsUndefined(registrySymbol) &&
	                typeof root.Reflect !== "undefined" &&
	                !(registrySymbol in root.Reflect) &&
	                typeof root.Reflect.defineMetadata === "function") {
	                // interoperate with older version of `reflect-metadata` that did not support a registry.
	                fallback = CreateFallbackProvider(root.Reflect);
	            }
	            var first;
	            var second;
	            var rest;
	            var targetProviderMap = new _WeakMap();
	            var registry = {
	                registerProvider: registerProvider,
	                getProvider: getProvider,
	                setProvider: setProvider,
	            };
	            return registry;
	            function registerProvider(provider) {
	                if (!Object.isExtensible(registry)) {
	                    throw new Error("Cannot add provider to a frozen registry.");
	                }
	                switch (true) {
	                    case fallback === provider: break;
	                    case IsUndefined(first):
	                        first = provider;
	                        break;
	                    case first === provider: break;
	                    case IsUndefined(second):
	                        second = provider;
	                        break;
	                    case second === provider: break;
	                    default:
	                        if (rest === undefined)
	                            rest = new _Set();
	                        rest.add(provider);
	                        break;
	                }
	            }
	            function getProviderNoCache(O, P) {
	                if (!IsUndefined(first)) {
	                    if (first.isProviderFor(O, P))
	                        return first;
	                    if (!IsUndefined(second)) {
	                        if (second.isProviderFor(O, P))
	                            return first;
	                        if (!IsUndefined(rest)) {
	                            var iterator = GetIterator(rest);
	                            while (true) {
	                                var next = IteratorStep(iterator);
	                                if (!next) {
	                                    return undefined;
	                                }
	                                var provider = IteratorValue(next);
	                                if (provider.isProviderFor(O, P)) {
	                                    IteratorClose(iterator);
	                                    return provider;
	                                }
	                            }
	                        }
	                    }
	                }
	                if (!IsUndefined(fallback) && fallback.isProviderFor(O, P)) {
	                    return fallback;
	                }
	                return undefined;
	            }
	            function getProvider(O, P) {
	                var providerMap = targetProviderMap.get(O);
	                var provider;
	                if (!IsUndefined(providerMap)) {
	                    provider = providerMap.get(P);
	                }
	                if (!IsUndefined(provider)) {
	                    return provider;
	                }
	                provider = getProviderNoCache(O, P);
	                if (!IsUndefined(provider)) {
	                    if (IsUndefined(providerMap)) {
	                        providerMap = new _Map();
	                        targetProviderMap.set(O, providerMap);
	                    }
	                    providerMap.set(P, provider);
	                }
	                return provider;
	            }
	            function hasProvider(provider) {
	                if (IsUndefined(provider))
	                    throw new TypeError();
	                return first === provider || second === provider || !IsUndefined(rest) && rest.has(provider);
	            }
	            function setProvider(O, P, provider) {
	                if (!hasProvider(provider)) {
	                    throw new Error("Metadata provider not registered.");
	                }
	                var existingProvider = getProvider(O, P);
	                if (existingProvider !== provider) {
	                    if (!IsUndefined(existingProvider)) {
	                        return false;
	                    }
	                    var providerMap = targetProviderMap.get(O);
	                    if (IsUndefined(providerMap)) {
	                        providerMap = new _Map();
	                        targetProviderMap.set(O, providerMap);
	                    }
	                    providerMap.set(P, provider);
	                }
	                return true;
	            }
	        }
	        /**
	         * Gets or creates the shared registry of metadata providers.
	         */
	        function GetOrCreateMetadataRegistry() {
	            var metadataRegistry;
	            if (!IsUndefined(registrySymbol) && IsObject(root.Reflect) && Object.isExtensible(root.Reflect)) {
	                metadataRegistry = root.Reflect[registrySymbol];
	            }
	            if (IsUndefined(metadataRegistry)) {
	                metadataRegistry = CreateMetadataRegistry();
	            }
	            if (!IsUndefined(registrySymbol) && IsObject(root.Reflect) && Object.isExtensible(root.Reflect)) {
	                Object.defineProperty(root.Reflect, registrySymbol, {
	                    enumerable: false,
	                    configurable: false,
	                    writable: false,
	                    value: metadataRegistry
	                });
	            }
	            return metadataRegistry;
	        }
	        function CreateMetadataProvider(registry) {
	            // [[Metadata]] internal slot
	            // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
	            var metadata = new _WeakMap();
	            var provider = {
	                isProviderFor: function (O, P) {
	                    var targetMetadata = metadata.get(O);
	                    if (IsUndefined(targetMetadata))
	                        return false;
	                    return targetMetadata.has(P);
	                },
	                OrdinaryDefineOwnMetadata: OrdinaryDefineOwnMetadata,
	                OrdinaryHasOwnMetadata: OrdinaryHasOwnMetadata,
	                OrdinaryGetOwnMetadata: OrdinaryGetOwnMetadata,
	                OrdinaryOwnMetadataKeys: OrdinaryOwnMetadataKeys,
	                OrdinaryDeleteMetadata: OrdinaryDeleteMetadata,
	            };
	            metadataRegistry.registerProvider(provider);
	            return provider;
	            function GetOrCreateMetadataMap(O, P, Create) {
	                var targetMetadata = metadata.get(O);
	                var createdTargetMetadata = false;
	                if (IsUndefined(targetMetadata)) {
	                    if (!Create)
	                        return undefined;
	                    targetMetadata = new _Map();
	                    metadata.set(O, targetMetadata);
	                    createdTargetMetadata = true;
	                }
	                var metadataMap = targetMetadata.get(P);
	                if (IsUndefined(metadataMap)) {
	                    if (!Create)
	                        return undefined;
	                    metadataMap = new _Map();
	                    targetMetadata.set(P, metadataMap);
	                    if (!registry.setProvider(O, P, provider)) {
	                        targetMetadata.delete(P);
	                        if (createdTargetMetadata) {
	                            metadata.delete(O);
	                        }
	                        throw new Error("Wrong provider for target.");
	                    }
	                }
	                return metadataMap;
	            }
	            // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
	            // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
	            function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
	                if (IsUndefined(metadataMap))
	                    return false;
	                return ToBoolean(metadataMap.has(MetadataKey));
	            }
	            // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
	            // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
	            function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
	                if (IsUndefined(metadataMap))
	                    return undefined;
	                return metadataMap.get(MetadataKey);
	            }
	            // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
	            // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
	            function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
	                metadataMap.set(MetadataKey, MetadataValue);
	            }
	            // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
	            // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
	            function OrdinaryOwnMetadataKeys(O, P) {
	                var keys = [];
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
	                if (IsUndefined(metadataMap))
	                    return keys;
	                var keysObj = metadataMap.keys();
	                var iterator = GetIterator(keysObj);
	                var k = 0;
	                while (true) {
	                    var next = IteratorStep(iterator);
	                    if (!next) {
	                        keys.length = k;
	                        return keys;
	                    }
	                    var nextValue = IteratorValue(next);
	                    try {
	                        keys[k] = nextValue;
	                    }
	                    catch (e) {
	                        try {
	                            IteratorClose(iterator);
	                        }
	                        finally {
	                            throw e;
	                        }
	                    }
	                    k++;
	                }
	            }
	            function OrdinaryDeleteMetadata(MetadataKey, O, P) {
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
	                if (IsUndefined(metadataMap))
	                    return false;
	                if (!metadataMap.delete(MetadataKey))
	                    return false;
	                if (metadataMap.size === 0) {
	                    var targetMetadata = metadata.get(O);
	                    if (!IsUndefined(targetMetadata)) {
	                        targetMetadata.delete(P);
	                        if (targetMetadata.size === 0) {
	                            metadata.delete(targetMetadata);
	                        }
	                    }
	                }
	                return true;
	            }
	        }
	        function CreateFallbackProvider(reflect) {
	            var defineMetadata = reflect.defineMetadata, hasOwnMetadata = reflect.hasOwnMetadata, getOwnMetadata = reflect.getOwnMetadata, getOwnMetadataKeys = reflect.getOwnMetadataKeys, deleteMetadata = reflect.deleteMetadata;
	            var metadataOwner = new _WeakMap();
	            var provider = {
	                isProviderFor: function (O, P) {
	                    var metadataPropertySet = metadataOwner.get(O);
	                    if (!IsUndefined(metadataPropertySet) && metadataPropertySet.has(P)) {
	                        return true;
	                    }
	                    if (getOwnMetadataKeys(O, P).length) {
	                        if (IsUndefined(metadataPropertySet)) {
	                            metadataPropertySet = new _Set();
	                            metadataOwner.set(O, metadataPropertySet);
	                        }
	                        metadataPropertySet.add(P);
	                        return true;
	                    }
	                    return false;
	                },
	                OrdinaryDefineOwnMetadata: defineMetadata,
	                OrdinaryHasOwnMetadata: hasOwnMetadata,
	                OrdinaryGetOwnMetadata: getOwnMetadata,
	                OrdinaryOwnMetadataKeys: getOwnMetadataKeys,
	                OrdinaryDeleteMetadata: deleteMetadata,
	            };
	            return provider;
	        }
	        /**
	         * Gets the metadata provider for an object. If the object has no metadata provider and this is for a create operation,
	         * then this module's metadata provider is assigned to the object.
	         */
	        function GetMetadataProvider(O, P, Create) {
	            var registeredProvider = metadataRegistry.getProvider(O, P);
	            if (!IsUndefined(registeredProvider)) {
	                return registeredProvider;
	            }
	            if (Create) {
	                if (metadataRegistry.setProvider(O, P, metadataProvider)) {
	                    return metadataProvider;
	                }
	                throw new Error("Illegal state.");
	            }
	            return undefined;
	        }
	        // naive Map shim
	        function CreateMapPolyfill() {
	            var cacheSentinel = {};
	            var arraySentinel = [];
	            var MapIterator = /** @class */ (function () {
	                function MapIterator(keys, values, selector) {
	                    this._index = 0;
	                    this._keys = keys;
	                    this._values = values;
	                    this._selector = selector;
	                }
	                MapIterator.prototype["@@iterator"] = function () { return this; };
	                MapIterator.prototype[iteratorSymbol] = function () { return this; };
	                MapIterator.prototype.next = function () {
	                    var index = this._index;
	                    if (index >= 0 && index < this._keys.length) {
	                        var result = this._selector(this._keys[index], this._values[index]);
	                        if (index + 1 >= this._keys.length) {
	                            this._index = -1;
	                            this._keys = arraySentinel;
	                            this._values = arraySentinel;
	                        }
	                        else {
	                            this._index++;
	                        }
	                        return { value: result, done: false };
	                    }
	                    return { value: undefined, done: true };
	                };
	                MapIterator.prototype.throw = function (error) {
	                    if (this._index >= 0) {
	                        this._index = -1;
	                        this._keys = arraySentinel;
	                        this._values = arraySentinel;
	                    }
	                    throw error;
	                };
	                MapIterator.prototype.return = function (value) {
	                    if (this._index >= 0) {
	                        this._index = -1;
	                        this._keys = arraySentinel;
	                        this._values = arraySentinel;
	                    }
	                    return { value: value, done: true };
	                };
	                return MapIterator;
	            }());
	            var Map = /** @class */ (function () {
	                function Map() {
	                    this._keys = [];
	                    this._values = [];
	                    this._cacheKey = cacheSentinel;
	                    this._cacheIndex = -2;
	                }
	                Object.defineProperty(Map.prototype, "size", {
	                    get: function () { return this._keys.length; },
	                    enumerable: true,
	                    configurable: true
	                });
	                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
	                Map.prototype.get = function (key) {
	                    var index = this._find(key, /*insert*/ false);
	                    return index >= 0 ? this._values[index] : undefined;
	                };
	                Map.prototype.set = function (key, value) {
	                    var index = this._find(key, /*insert*/ true);
	                    this._values[index] = value;
	                    return this;
	                };
	                Map.prototype.delete = function (key) {
	                    var index = this._find(key, /*insert*/ false);
	                    if (index >= 0) {
	                        var size = this._keys.length;
	                        for (var i = index + 1; i < size; i++) {
	                            this._keys[i - 1] = this._keys[i];
	                            this._values[i - 1] = this._values[i];
	                        }
	                        this._keys.length--;
	                        this._values.length--;
	                        if (SameValueZero(key, this._cacheKey)) {
	                            this._cacheKey = cacheSentinel;
	                            this._cacheIndex = -2;
	                        }
	                        return true;
	                    }
	                    return false;
	                };
	                Map.prototype.clear = function () {
	                    this._keys.length = 0;
	                    this._values.length = 0;
	                    this._cacheKey = cacheSentinel;
	                    this._cacheIndex = -2;
	                };
	                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
	                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
	                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
	                Map.prototype["@@iterator"] = function () { return this.entries(); };
	                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
	                Map.prototype._find = function (key, insert) {
	                    if (!SameValueZero(this._cacheKey, key)) {
	                        this._cacheIndex = -1;
	                        for (var i = 0; i < this._keys.length; i++) {
	                            if (SameValueZero(this._keys[i], key)) {
	                                this._cacheIndex = i;
	                                break;
	                            }
	                        }
	                    }
	                    if (this._cacheIndex < 0 && insert) {
	                        this._cacheIndex = this._keys.length;
	                        this._keys.push(key);
	                        this._values.push(undefined);
	                    }
	                    return this._cacheIndex;
	                };
	                return Map;
	            }());
	            return Map;
	            function getKey(key, _) {
	                return key;
	            }
	            function getValue(_, value) {
	                return value;
	            }
	            function getEntry(key, value) {
	                return [key, value];
	            }
	        }
	        // naive Set shim
	        function CreateSetPolyfill() {
	            var Set = /** @class */ (function () {
	                function Set() {
	                    this._map = new _Map();
	                }
	                Object.defineProperty(Set.prototype, "size", {
	                    get: function () { return this._map.size; },
	                    enumerable: true,
	                    configurable: true
	                });
	                Set.prototype.has = function (value) { return this._map.has(value); };
	                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
	                Set.prototype.delete = function (value) { return this._map.delete(value); };
	                Set.prototype.clear = function () { this._map.clear(); };
	                Set.prototype.keys = function () { return this._map.keys(); };
	                Set.prototype.values = function () { return this._map.keys(); };
	                Set.prototype.entries = function () { return this._map.entries(); };
	                Set.prototype["@@iterator"] = function () { return this.keys(); };
	                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
	                return Set;
	            }());
	            return Set;
	        }
	        // naive WeakMap shim
	        function CreateWeakMapPolyfill() {
	            var UUID_SIZE = 16;
	            var keys = HashMap.create();
	            var rootKey = CreateUniqueKey();
	            return /** @class */ (function () {
	                function WeakMap() {
	                    this._key = CreateUniqueKey();
	                }
	                WeakMap.prototype.has = function (target) {
	                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
	                    return table !== undefined ? HashMap.has(table, this._key) : false;
	                };
	                WeakMap.prototype.get = function (target) {
	                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
	                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
	                };
	                WeakMap.prototype.set = function (target, value) {
	                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
	                    table[this._key] = value;
	                    return this;
	                };
	                WeakMap.prototype.delete = function (target) {
	                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
	                    return table !== undefined ? delete table[this._key] : false;
	                };
	                WeakMap.prototype.clear = function () {
	                    // NOTE: not a real clear, just makes the previous data unreachable
	                    this._key = CreateUniqueKey();
	                };
	                return WeakMap;
	            }());
	            function CreateUniqueKey() {
	                var key;
	                do
	                    key = "@@WeakMap@@" + CreateUUID();
	                while (HashMap.has(keys, key));
	                keys[key] = true;
	                return key;
	            }
	            function GetOrCreateWeakMapTable(target, create) {
	                if (!hasOwn.call(target, rootKey)) {
	                    if (!create)
	                        return undefined;
	                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
	                }
	                return target[rootKey];
	            }
	            function FillRandomBytes(buffer, size) {
	                for (var i = 0; i < size; ++i)
	                    buffer[i] = Math.random() * 0xff | 0;
	                return buffer;
	            }
	            function GenRandomBytes(size) {
	                if (typeof Uint8Array === "function") {
	                    var array = new Uint8Array(size);
	                    if (typeof crypto !== "undefined") {
	                        crypto.getRandomValues(array);
	                    }
	                    else if (typeof msCrypto !== "undefined") {
	                        msCrypto.getRandomValues(array);
	                    }
	                    else {
	                        FillRandomBytes(array, size);
	                    }
	                    return array;
	                }
	                return FillRandomBytes(new Array(size), size);
	            }
	            function CreateUUID() {
	                var data = GenRandomBytes(UUID_SIZE);
	                // mark as random - RFC 4122 § 4.4
	                data[6] = data[6] & 0x4f | 0x40;
	                data[8] = data[8] & 0xbf | 0x80;
	                var result = "";
	                for (var offset = 0; offset < UUID_SIZE; ++offset) {
	                    var byte = data[offset];
	                    if (offset === 4 || offset === 6 || offset === 8)
	                        result += "-";
	                    if (byte < 16)
	                        result += "0";
	                    result += byte.toString(16).toLowerCase();
	                }
	                return result;
	            }
	        }
	        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
	        function MakeDictionary(obj) {
	            obj.__ = undefined;
	            delete obj.__;
	            return obj;
	        }
	    });
	})(Reflect || (Reflect = {}));
	return _Reflect;
}

require_Reflect();

class KiiGame {
    inventory;
    text;
    stage;
    stageObjectGetter;
    interactions;
    constructor(clickResolvers = [], dragResolvers = [], hitRegionFilter = new HitRegionFilter([], ['Image']), intersection = new Intersection([
        new VisibilityValidator(),
        new CategoryValidator([])
    ]), roomObjectCategories, gameData = {}) {
        if (clickResolvers.length == 0) {
            clickResolvers.push(new DefaultInteractionResolver('furniture'), new DefaultInteractionResolver('item'));
        }
        if (dragResolvers.length == 0) {
            dragResolvers.push(new DefaultInteractionResolver('furniture'), new DefaultInteractionResolver('item'));
        }
        if (!roomObjectCategories) {
            roomObjectCategories = {
                furniture: {
                    roomChildrenTypeBuilder: new FurnitureBuilder()
                }
            };
        }
        const hitRegionInitializer = new HitRegionInitializer(hitRegionFilter, container.get(UiEventEmitter));
        // Model start
        // "Objects in rooms" model
        // Build the initial "objects in rooms" state
        const initialObjectsInRoomsState = new ObjectsInRoomsBuilder(new ObjectsInRoomBuilder(Object.keys(roomObjectCategories))).build(gameData.rooms_json);
        new ObjectsInRooms(initialObjectsInRoomsState, container.get(GameEventEmitter));
        // "Player character in room" model
        new CharacterInRoom(container.get(GameEventEmitter));
        // Character posture model
        new CharacterPosture('idle', container.get(GameEventEmitter));
        // Inventory model
        this.inventory = new Inventory(container.get(GameEventEmitter));
        // Text model(?)
        this.text = new TextModel(gameData.text_json);
        // Model end
        // View builder start
        // Bootstrap
        this.stage = new StageInitializer().initialize(gameData.layersJson);
        this.stageObjectGetter = new StageObjectGetter(this.stage);
        const imagePreparer = new ImagePreparer(this.stageObjectGetter);
        const konvaObjectContainerPusher = new KonvaObjectContainerPusher();
        // Build stage
        const fullFadeBuilder = new FullFaderPreparer(this.stageObjectGetter.getObject('full_screen_layer'), imagePreparer);
        const sequenceLayerBuilder = new SequenceLayerBuilder(container.get(SequenceBuilder), konvaObjectContainerPusher, gameData.sequences_json, this.stageObjectGetter.getObject("sequence_layer"));
        // Read room children type builders from the config given to the constructor
        const roomObjectCategoryBuilders = [];
        for (const [key, roomObjectCategory] of Object.entries(roomObjectCategories)) {
            if (roomObjectCategory.roomChildrenTypeBuilder) {
                roomObjectCategoryBuilders.push(new RoomChildrenTypeBuilder(key, roomObjectCategory.roomChildrenTypeBuilder));
            }
        }
        const roomLayerBuilder = new RoomLayerBuilder(new RoomsBuilder(new RoomBuilder([
            // Order may be important - for example, backgrounds should go in first so
            // they don't overlap furniture
            new RoomChildrenTypeBuilder('backgrounds', new BackgroundsBuilder()),
            ...roomObjectCategoryBuilders, // consider using inversify for DI here
            new RoomChildrenTypeBuilder('other', new OtherChildrenBuilder())
        ])), konvaObjectContainerPusher, new RoomFaderBuilder(), imagePreparer, gameData.rooms_json, this.stageObjectGetter.getObject("room_layer"));
        const stageBuilder = new StageBuilder(this.stage, fullFadeBuilder, sequenceLayerBuilder, roomLayerBuilder, imagePreparer);
        stageBuilder.build();
        // Build items and push them to the inventory item cache layer
        const itemsBuilder = container.get(ItemsBuilder);
        const items = itemsBuilder.build(gameData.items_json);
        const inventoryItems = this.stageObjectGetter.getObject('inventory_items');
        konvaObjectContainerPusher.execute(items, inventoryItems);
        // Creating all item image objects from json
        imagePreparer.prepareImages(inventoryItems.toObject());
        // Build items end
        // Build inventory
        const inventoryBarLayer = this.stageObjectGetter.getObject('inventory_bar_layer');
        imagePreparer.prepareImages(inventoryBarLayer.toObject());
        // Scale inventory bar to stage
        this.stageObjectGetter.getObject("inventory_bar").y(this.stage.height() - 100);
        this.stageObjectGetter.getObject("inventory_bar").width(this.stage.width());
        // Build inventory end
        // Build character layer
        // Push character animation frames to correct layer.
        const characterLayer = this.stageObjectGetter.getObject("character_layer");
        const characterFrames = new CharacterFramesBuilder({ x: 764, y: 443 }).build(gameData.character_json.frames);
        konvaObjectContainerPusher.execute(characterFrames, characterLayer);
        // Creating all image objects from json
        imagePreparer.prepareImages(characterLayer.toObject());
        // Build character layer end
        // View builder end
        // View start
        // Stage view start
        new StageView(container.get(UiEventEmitter), this.stage);
        // Stage view end
        // Animation for fading the whole screen
        const fadeFull = new Konva$1.Tween({
            node: this.stageObjectGetter.getObject('black_screen_full'),
            duration: 0.6,
            opacity: 1
        });
        new FullFadeView(container.get(UiEventEmitter), fadeFull);
        // Full fader view end
        // Sequences view start
        new SequenceView(container.get(UiEventEmitter), container.get(GameEventEmitter), this.stageObjectGetter, gameData.sequences_json, this.stageObjectGetter.getObject('sequence_layer'));
        // Sequences end
        // Rooms view start
        const roomLayer = this.stageObjectGetter.getObject('room_layer');
        // Room view component
        const roomView = new RoomView(container.get(UiEventEmitter), container.get(GameEventEmitter), hitRegionInitializer, roomLayer, Object.keys(roomObjectCategories));
        // Build room object animations and set up RoomAnimations view component
        const animatedRoomObjects = new RoomAnimationsBuilder(new RoomAnimationBuilder(), this.stageObjectGetter).build(roomView.getRooms());
        new RoomAnimations(container.get(GameEventEmitter), container.get(UiEventEmitter), animatedRoomObjects);
        // NPC Monologue View
        new NpcMonologueView(container.get(UiEventEmitter), container.get(GameEventEmitter), this.stageObjectGetter, this.stageObjectGetter.getObject("npc_speech_bubble"), this.stage.width());
        // Animation for fading the room portion of the screen
        const roomFaderNode = this.stageObjectGetter.getObject("fader_room");
        new RoomFader(roomFaderNode, container.get(UiEventEmitter));
        // Character in room view model
        new CharacterInRoomViewModel(container.get(UiEventEmitter), container.get(GameEventEmitter));
        // Rooms view end
        // Inventory & items view start
        // Inventory items view component
        const inventoryItemsView = new InventoryItemsView(container.get(UiEventEmitter), container.get(GameEventEmitter), inventoryItems, this.stage.height() - 90);
        // Inventory arrows view component
        const inventoryArrowsView = new InventoryArrowsView(container.get(UiEventEmitter), inventoryBarLayer.find('#inventory_arrows')[0]);
        // Inventory view component
        new InventoryView(container.get(UiEventEmitter), this.stageObjectGetter, inventoryBarLayer, inventoryItemsView, inventoryArrowsView);
        new InventoryViewModel(container.get(UiEventEmitter), container.get(GameEventEmitter), 7 // inventoryMax, TODO make configurable/responsive
        );
        // Inventory arrows view model
        new InventoryArrowsViewModel(container.get(UiEventEmitter));
        // Dragged item view
        new DraggedItemView(container.get(UiEventEmitter), this.stageObjectGetter.getObject('full_screen_layer'), this.stageObjectGetter.getObject("interaction_text"));
        // Dragged item view model
        new DraggedItemViewModel(container.get(UiEventEmitter), new DragTargetFinder(intersection, roomView, inventoryItemsView, inventoryArrowsView), this.text);
        // Inventory & items view end
        // Character view start
        // Load up frames from json and set up CharacterAnimations view component
        const characterAnimationData = gameData.character_json.animations;
        const characterAnimations = new CharacterAnimationsBuilder(this.stageObjectGetter).build(characterAnimationData);
        new CharacterAnimations(characterAnimations, gameData.character_json.posture_mapping, gameData.character_json.monologue_posture_mapping, gameData.character_json.npc_monologue_posture_mapping, container.get(UiEventEmitter), container.get(GameEventEmitter));
        // Character view component
        new CharacterView(characterLayer, container.get(UiEventEmitter));
        new CharacterSpeechView(container.get(UiEventEmitter), container.get(GameEventEmitter), this.stageObjectGetter.getObject("monologue"), this.stageObjectGetter.getObject("character_speech_bubble"), this.stage.height());
        // Character view end
        // Music view
        new Music(gameData.music_json, new AudioFactory(), container.get(UiEventEmitter));
        // Music view end
        // View end
        // Controller start
        this.interactions = new Interactions(gameData.interactions_json);
        const commandHandler = new CommandHandler(container.get(GameEventEmitter), container.get(UiEventEmitter), this.text, gameData.items_json);
        const commandsHandler = new CommandsHandler(commandHandler);
        new ClickHandler(container.get(UiEventEmitter), commandsHandler, clickResolvers, this.interactions);
        new DragEndHandler(container.get(UiEventEmitter), commandsHandler, dragResolvers, this.interactions);
        // Controller end
        // Preparation done, final steps:
        this.stage.draw();
        commandsHandler.handleCommands(new DefaultInteractionResolver('start').resolveCommands(this.interactions, gameData.startInteraction, 'start'));
    }
    getStage() {
        return this.stage;
    }
    getInventory() {
        return this.inventory;
    }
    getStageObjectGetter() {
        return this.stageObjectGetter;
    }
    getText() {
        return this.text;
    }
    getInteractions() {
        return this.interactions;
    }
}

export { KiiGame };
//# sourceMappingURL=kiigame.js.map
